
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $605b91011dda62b7$var$BASE_URL = "https://www.strava.com/api/v3";
const $605b91011dda62b7$var$CALLBACK_URL = window.location.origin;
const $605b91011dda62b7$var$CLIENT_ID = "39609";
const $605b91011dda62b7$var$SCOPE = "activity:read";
const $605b91011dda62b7$var$AUTH_URL = `http://www.strava.com/oauth/authorize?client_id=${$605b91011dda62b7$var$CLIENT_ID}&response_type=code&redirect_uri=${$605b91011dda62b7$var$CALLBACK_URL}&approval_prompt=auto&scope=${$605b91011dda62b7$var$SCOPE}`;
const $605b91011dda62b7$var$TOKEN_URL = "https://strava-auth.antoine-53b.workers.dev";
function $605b91011dda62b7$var$hasStravaAccess() {
    const scope = localStorage.getItem("strava_scope");
    const keys = [
        "strava_access_token",
        "strava_refresh_token",
        "strava_expires_at"
    ];
    return keys.every((k)=>localStorage.getItem(k)) && !!scope && scope.includes($605b91011dda62b7$var$SCOPE);
}
function $605b91011dda62b7$var$askStravaAccess() {
    // FIXME: maybe use an iframe?
    window.location.assign($605b91011dda62b7$var$AUTH_URL);
}
function $605b91011dda62b7$var$disconnectStrava() {
    localStorage.removeItem("strava_access_token");
    localStorage.removeItem("strava_refresh_token");
    localStorage.removeItem("strava_expires_at");
    localStorage.removeItem("strava_scope");
}
function $605b91011dda62b7$var$getAccessToken() {
    const accessToken = localStorage.getItem("strava_access_token");
    if (accessToken) {
        const expiresAtStr = localStorage.getItem("strava_expires_at");
        const expiresAt = expiresAtStr === null ? null : parseInt(expiresAtStr);
        if (expiresAt && new Date().getTime() / 1000 < expiresAt - 60) return Promise.resolve(accessToken);
        const token = localStorage.getItem("strava_refresh_token");
        if (token) return $605b91011dda62b7$var$refreshToken(token);
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("code") && urlParams.get("scope")) // If we have code and scope in the URL that means we are in the
    // middle of auth, so no token available yet and the page will
    // be reloaded when one is ready.
    return Promise.reject(new Error("Authentification \xe0 Strava en cours"));
    $605b91011dda62b7$var$askStravaAccess();
    return Promise.reject(new Error("This code should never be reached"));
}
function $605b91011dda62b7$var$auth() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const scope = urlParams.get("scope");
    if (code && scope) {
        const request = new Request(`${$605b91011dda62b7$var$TOKEN_URL}?code=${code}&grant_type=authorization_code`, {
            method: "POST"
        });
        fetch(request).then((response)=>response.json()).then((response)=>{
            localStorage.setItem("strava_access_token", response.access_token);
            localStorage.setItem("strava_refresh_token", response.refresh_token);
            localStorage.setItem("strava_expires_at", response.expires_at);
            localStorage.setItem("strava_scope", scope);
            // We reload the page to remove the code and scope from the
            // URL so that users don't accidentally share it by copying the URL.
            window.location.replace($605b91011dda62b7$var$CALLBACK_URL);
        });
    }
}
$605b91011dda62b7$var$auth();
let $605b91011dda62b7$var$pRefreshToken;
function $605b91011dda62b7$var$refreshToken(token) {
    if (!$605b91011dda62b7$var$pRefreshToken) {
        const request = new Request(`${$605b91011dda62b7$var$TOKEN_URL}?refresh_token=${token}&grant_type=refresh_token`, {
            method: "POST"
        });
        $605b91011dda62b7$var$pRefreshToken = fetch(request).then((response)=>response.json()).then((response)=>{
            localStorage.setItem("strava_access_token", response.access_token);
            localStorage.setItem("strava_refresh_token", response.refresh_token);
            localStorage.setItem("strava_expires_at", response.expires_at);
            return response.access_token;
        }).finally(()=>$605b91011dda62b7$var$pRefreshToken = null);
    }
    return $605b91011dda62b7$var$pRefreshToken;
}
function $605b91011dda62b7$var$getHeaders() {
    return $605b91011dda62b7$var$getAccessToken().then((token)=>({
            Authorization: `Bearer ${token}`
        }));
}
function $605b91011dda62b7$var$fetchStrava(url) {
    return $605b91011dda62b7$var$getHeaders().then((headers)=>fetch(url, {
            headers: headers
        })).then((response)=>response.json());
}
function $605b91011dda62b7$var$getRoute(route_id) {
    return $605b91011dda62b7$var$fetchStrava(`${$605b91011dda62b7$var$BASE_URL}/routes/${route_id}`);
}
function $605b91011dda62b7$var$getRoutePolyline(route_id) {
    return $605b91011dda62b7$var$getRoute(route_id).then((route)=>L.PolylineUtil.decode(route.map.summary_polyline));
}
function $605b91011dda62b7$var$getRidesPolylines() {
    return $605b91011dda62b7$var$getRideActivities().then((activities)=>activities.map((activity)=>L.PolylineUtil.decode(activity.map.summary_polyline)));
}
const $605b91011dda62b7$var$PER_PAGE = 200;
async function $605b91011dda62b7$var$getRideActivities(page = 1) {
    const activities = await $605b91011dda62b7$var$fetchStrava(`${$605b91011dda62b7$var$BASE_URL}/activities?page=${page}&per_page=${$605b91011dda62b7$var$PER_PAGE}`);
    if (activities.length === 0) return [];
    const rides = activities.filter((a)=>a.type === "Ride" && a.map && a.map.summary_polyline);
    const otherActivities = await $605b91011dda62b7$var$getRideActivities(page + 1);
    return rides.concat(otherActivities);
}
var $605b91011dda62b7$export$2e2bcd8739ae039 = {
    askStravaAccess: $605b91011dda62b7$var$askStravaAccess,
    hasStravaAccess: $605b91011dda62b7$var$hasStravaAccess,
    disconnectStrava: $605b91011dda62b7$var$disconnectStrava,
    getRoute: $605b91011dda62b7$var$getRoute,
    getRoutePolyline: $605b91011dda62b7$var$getRoutePolyline,
    getRidesPolylines: $605b91011dda62b7$var$getRidesPolylines
};



const $16ccedfa4f561b29$var$STRAVA_ROUTE_URL = "https://www.strava.com/routes/";
function $16ccedfa4f561b29$var$showChallengesDetails(challenges) {
    document.getElementById("challenges-detail").style.display = "block";
    const distance = challenges.reduce((acc, challenge)=>acc + challenge.distance, 0) / 1000;
    document.getElementById("challenges-distance").textContent = String(Math.round(distance));
    const computedDistance = challenges.reduce((acc, challenge)=>acc + (challenge.computedDistance ?? NaN), 0);
    const coveredDistance = challenges.reduce((acc, challenge)=>acc + (challenge.coveredDistance ?? NaN), 0);
    const shouldDisplayCoverage = distance > 0 && !Number.isNaN(computedDistance) && computedDistance > 0 && !Number.isNaN(coveredDistance);
    if (shouldDisplayCoverage) document.getElementById("challenges-covered").textContent = String(Math.round(coveredDistance / computedDistance * 100));
    const coverageDisplay = shouldDisplayCoverage ? "inline" : "none";
    document.querySelectorAll("#challenges-detail .strava-coverage").forEach((node)=>node.style.display = coverageDisplay);
}
function $16ccedfa4f561b29$var$showChallengeDetails(challenge) {
    if (!challenge) {
        document.getElementById("challenge-detail").style.display = "none";
        return;
    }
    document.getElementById("challenge-detail").style.display = "block";
    document.getElementById("challenge-title").textContent = challenge.name;
    document.getElementById("challenge-distance").textContent = String(Math.round(challenge.distance / 1000));
    document.getElementById("challenge-elevation").textContent = String(Math.round(challenge.elevation));
    document.getElementById("challenge-strava-link").setAttribute("href", $16ccedfa4f561b29$var$STRAVA_ROUTE_URL + challenge.strava_route_id);
    document.getElementById("challenge-gpx").setAttribute("href", `https://www.strava.com/routes/${challenge.strava_route_id}/export_gpx`);
    if (challenge.coveredDistance !== undefined && !Number.isNaN(challenge.coveredDistance) && challenge.computedDistance !== undefined && !Number.isNaN(challenge.computedDistance) && challenge.computedDistance > 0) document.getElementById("challenge-covered").textContent = String(Math.round(challenge.coveredDistance / challenge.computedDistance * 100));
}
function $16ccedfa4f561b29$var$stravaButtonsManager() {
    document.getElementById("strava-auth").onclick = (0, $605b91011dda62b7$export$2e2bcd8739ae039).askStravaAccess;
    document.getElementById("strava-unauth").onclick = ()=>{
        (0, $605b91011dda62b7$export$2e2bcd8739ae039).disconnectStrava();
        $16ccedfa4f561b29$var$refreshStravaDisplays();
    };
}
$16ccedfa4f561b29$var$stravaButtonsManager();
function $16ccedfa4f561b29$var$refreshStravaDisplays() {
    const hasStravaAccess = (0, $605b91011dda62b7$export$2e2bcd8739ae039).hasStravaAccess();
    const authButton = document.getElementById("strava-auth");
    const unauthButton = document.getElementById("strava-unauth");
    if (hasStravaAccess) {
        authButton.style.display = "none";
        unauthButton.style.display = "block";
    } else {
        authButton.style.display = "block";
        unauthButton.style.display = "none";
    }
    const stravaCoverageDisplay = hasStravaAccess ? "initial" : "none";
    document.querySelectorAll(".strava-coverage").forEach((node)=>node.style.display = stravaCoverageDisplay);
}
$16ccedfa4f561b29$var$refreshStravaDisplays();
const $16ccedfa4f561b29$var$yearFilters = {
    year17: "2017",
    year18: "2018",
    year19: "2019",
    year20: "2020",
    year21: "2021",
    year22: "2022",
    year23: "2023",
    year24: "2024",
    year25: "2025",
    year26: "2026"
};
const $16ccedfa4f561b29$var$yearFilterElements = Array.from(document.querySelectorAll("#year-filter input[type='checkbox']"));
function $16ccedfa4f561b29$var$onFilterChanged(callback) {
    $16ccedfa4f561b29$var$yearFilterElements.forEach((e)=>e.onchange = callback);
}
function $16ccedfa4f561b29$var$matchFilter(challenge) {
    const challengeDate = challenge.id.substring(0, 4);
    return $16ccedfa4f561b29$var$yearFilterElements.filter((element)=>element.checked).map((element)=>$16ccedfa4f561b29$var$yearFilters[element.id]).includes(challengeDate);
}
const $16ccedfa4f561b29$var$userTracesElement = document.getElementById("user-traces");
function $16ccedfa4f561b29$var$userTracesEnabled() {
    return $16ccedfa4f561b29$var$userTracesElement.checked;
}
function $16ccedfa4f561b29$var$onShowUserTracesChanged(callback) {
    $16ccedfa4f561b29$var$userTracesElement.onchange = callback;
}
var $16ccedfa4f561b29$export$2e2bcd8739ae039 = {
    onFilterChanged: $16ccedfa4f561b29$var$onFilterChanged,
    onShowUserTracesChanged: $16ccedfa4f561b29$var$onShowUserTracesChanged,
    matchFilter: $16ccedfa4f561b29$var$matchFilter,
    showChallengesDetails: $16ccedfa4f561b29$var$showChallengesDetails,
    showChallengeDetails: $16ccedfa4f561b29$var$showChallengeDetails,
    userTracesEnabled: $16ccedfa4f561b29$var$userTracesEnabled
};


var $4e7af9fc52322521$exports = {};
$4e7af9fc52322521$exports = JSON.parse('[{"id":"2017-01","name":"Paris - Rouen","strava_route_id":"7608196","distance":151606.22776364977,"elevation":1799.2615002092673,"summary_polyline":"_fiiHan~LnDtKuHj]mo@ytAeb@hf@k|@ts@rGr[eTnVeKcXgK~NuOpH]yLkKtYkHlAmCh[kLkGoHpUaWsXwErYgm@ePgMtGsj@t|@_p@lq@pArDuEdFsCn]rEtUsQxDiWnRqe@bp@{VboAeUbk@dW`RaXbdAaVp[wAvLyDU_Cbj@yg@z\\\\oa@vu@wNpfAoPxt@a@t_B}Ifp@bEl~@u@~yAjAln@vSp~AmJt]jA}JyCk@gf@fC_BxXmSi@oj@l_@fHhYea@fUtA~FyDtBlGrmAbKz[wTv`@}h@rn@gu@uFwNbElPt|@hA~[vOh^fBdcB_Gxf@wz@xWgOcDgJxMcStImNl]cFb^uM~WuF~g@yGtKgDoAg^n{@wK|c@_GxGRzOgQoAgFhFw[fx@cG^_U{ZeYyKcKxaAu\\\\bv@cAz^gInRT`IvHdE}Ppz@eArTbAtPvOl\\\\yW|d@_OpFb@`K{c@t_AhClFcPxR_PhqArArWgKbd@pG~`BbJr\\\\Zrk@~K|_A{Qt@FxcApEfNw@vKpd@bZvSp~@lGjbAcJvg@{Ujc@yEdk@|CvRiNoFmLdPmhA~a@sa@pj@|@zM|DbDm\\\\~~@_Htb@uA~c@vCjBh@pKaBfPzBvp@eG~vAdKb]xS~S_T|m@zCnNoYnr@kMfQoh@yBeWvGoJxJky@tRjHxXu@tMqO|O}DzLob@bS}Vxu@z@`EcM~MgJ{FrAdRwD|OuOjWeIbAiWxWeRfbAmWli@qj@lyBxFvZqTdFyMqDyE~FRzOaQ~K{e@kRuWCm^tTya@fp@in@|`@cKpUqIne@_Tdc@abA~tA_`@pKsWsJyF|~@oTzE`@~MmPdB`IfSqEhi@xHr}CgFl_@g[lXrDnEMhIcZ~M}[`f@|U`MnB|`@_AlLqE~B^xT`IdZpLvmAye@`P}Vfa@yFhSmNoZ_LkK`Ifq@{_Ad_AsZme@wRqKuLc[aL{@ma@|`@yFxToh@jRgHtNkLzCsOxb@{Z``@nXd[hOlGeFtp@bHlc@qRzO}R~x@yN|[sGnAgGuMqCR}Sv`@_Hv[oR`SmBtj@{L~U`^zj@nKdg@h@xZnItNlO~kA~Mzi@wOnOiLq]gf@fNcEoU}GxK_IsCnLpXwEbHzArIiIxOt@mVgI_YgeAyTch@~x@wStTgLxDms@pgB_q@rd@cY|a@gVzAiBaTwGaHcOfX}DyB{Lt_A|BhOErl@aApDkG{A_Hja@iEvs@yO_GqKz\\\\k^|bCo@hLlC~CwRld@zF~KeSjoAu_AfdAoHb`@mRvUyD`Z_Rz]qBoSfC{GgB_JpAir@}Rz~A_Q|w@mFwBaCrLuL|AiCfV~NvGxEuBlMfK_D`Skx@ma@"},{"id":"2017-02","name":"Paris - \xc9vreux","strava_route_id":"7452449","distance":159409.42737364626,"elevation":1396.4207586287957,"summary_polyline":"mdiiHgj~L|BzG{BzH|U~k@hEzZsA~FzTbr@pA`b@hUjmAfE~y@sHvXzFxGW_O|HcMpP|E``@}AnQlGgH|b@k\\\\bI}b@iRiCsYlHmMcEgCa]dyA`AnNx]zVbCfJvPnQfv@_Uhi@nFxCnClBfa@pGuAnB~PvhAjvAbFfYpP|LjNePiG{g@zAg@tH`NdOqIzK`UnRlQd\\\\xdA`E|z@nKde@gF|JfElA[`fArKfDp@tIzThEl@vLtFfLiQncAls@z`@zHkYfE~VdDnBlIaKrFkl@t]rEdGrIlk@fYrBXvD{K{@jO`JlI`Om^zDiBvNmw@rWn\\\\tInTUn`@yE~Arc@xV`e@xEtIhOfHeCnDbLaEfI_@rLpc@zHfq@zl@b@|RsGbk@dKtC`ZiRvJv@|K|^`q@`Xr]nBvChJFp\\\\lPhWhBhPkEnAw@tMvEly@oG`nARrl@b@fNhTjx@hBlrAqV|uB\\\\le@hCdKeKlKwE|a@b[`eA\\\\jf@eKrx@zFvqAeBtKfDlZgNbs@vDd]cSvt@gRzyAmEfHxOna@pYD|HnNbBdNnWhDnEbT~FbcA?df@rFp_@pa@~MnFmPhDNoD~g@mMh[fKhLxMhc@{PfZoFdUuJLoMdwAsU`v@`PtNhMtw@pUzw@tL~cAbPhg@s@tZtHdGx`@b{@kBbTyQdi@mRxS}s@r|A_Px}@yi@da@ba@jrHyA|SoPmJ_SpDJdUtGpCtZ`v@pT~\\\\{HvLbDdUkC~~@yWvUKvSsJrGO|I`Nht@dVdj@qEz]vDv@wEfc@`AdQ{Uz{@tGtaAyN`yAsSrd@af@fu@bFhIbFxe@hTha@j@lSkO|r@aPrxAwGbShHdQgLR}AvQqYxa@e@nVsKbs@sElhAlAd[iRvj@}Blq@xPd^_H`_@{@nX|P|YlGpk@sCdHxFnq@mG~JUxJrDjClB`QrGn@~Fhx@xNve@SjJk[j`@wVjQ_H~PcFdCsH{QaF~EbE~Rqo@iBkDvEjAjIoEpB`A|H_InFyP{Sc^{Dwa@nYgW|a@yFjBfElW{@xd@xCdr@_Ntc@aFtC|Blc@oKsWaXjJkIsBhIlq@aBr^sDhLxA_\\\\yIl]cUzR_Cd^mG|CSfQdKfOzAjWyD~NkCvm@B~}@_Hte@wI~RuI~GgTeHiHtQmPM{CxVwTnJkIp_Ae[pRaEzKsBv\\\\}nAnhBoNre@wX~Vug@vZu[mCg_@tTo]{Kkl@_AiS{M}]mv@qTwJeYg^_TuLkZwj@mv@aJe[gi@uFfIyJtBml@Joj@pN}X|`@q_@rU_a@~KwDtQeAzpAwVdHag@o@}LvM_`ArWtA~N_BpF_e@zy@i`@nhAaEmCuNbIwf@{DoQs\\\\kq@`_@}M{RkHwXqImEaHbCqH}`@gKAyJ~HaOtv@kGbw@aFrQr@vH_FjPqXrTsGlQ_o@lPnClSySu@s@bXsKdFhBdLct@~_@wReJyEia@m]vMgHe_AsPfEdDfKbTqKvGtDfBw@_CcKnMkDnC`O"},{"id":"2017-03","name":"Paris - Nemours","strava_route_id":"7439991","distance":165899.4678877187,"elevation":1146.3192106325416,"summary_polyline":"mx_iHavtMhNcTrD}K~@se@bCkUUo`@jBsUfDeMbNuTdGmXrAkSFwo@vGcw@oPch@[qvBig@agCaBgJh@wIuDuF}CkZwHyTmLyDwInD}Ay@IeDjDyFa@oD}LiDiChIiD}KaEeAyDbBkSePuWooAmBwXeGyHcH}_@e@s[tDoj@Dco@_Cin@bHoH_BaUr@wT}GDmCm^iHscA}@alA~Gil@a@aDbKg~BeGqs@a@wXxCop@m@kKl@ms@zEy|@iAaJt@wHhUi{@rHsImD{JoCia@gp@`GaGyDdDkk@|GsPfA{Qy@wGl@ed@dLor@tBsIfFkHhTqs@IuCtG{[bVsPla@y@nMiIdOoD~h@`Fp]}Pf]~Khz@ca@fLzAbNgBxG_JjCqKdSwTrKqDlPExHaGzMeEnEaLfi@{^vKn@lR|RfKkC~f@`AdA~GlE|@hP_ZhLm^zZ|GhRsW`WqStBqIvUwOu@mq@oHktAh@qGxp@uExZhHvUpPzNf@zLiDlh@jHd\\\\lMvEaMvEq_AbE{^bBinC|Dei@tNnMdl@~WhN|C~PxSrKP`Z`NpJ|XxYn_@bFyJ~GjChRkFfV{\\\\z]{CxOzBhNuOf`@}YhLmVpFsHxEsArRo]xHcT|AuLxJsIlYy`@dj@mfAbCoRrGdFlvBuZlUU\\\\bC|HIbpA{O`Ddp@LziAnUpFRzSdPbL@zJz@tAfN~Jf[zDlRfLLvDeChC?tOoBvToGx[iNpmAQlLnF~OtE`AfGjItDj@lIjJ~Pji@zAfNnDvI_@zI~CjRsErIHrC`Hli@~@p[`DdAkAbStCnHdA`SgIb`@X~EdEg@fDiOrJ_KlSmCfB`PzFpMjMnDpq@o@lLiOp@`\\\\sAt[lRzTfGtCfIcDvM~Wx|@r`@J|WjBa@n@`ClEvUo@|A~EdCvB`EpLfCbLxHpRlg@|dAp`Bp^tTxZxt@hHd[p^p\\\\hQvKdEah@lAoa@cCgb@uF{~Bn@cg@zDs]pN`Hj`@tk@dfAza@vNcJxWwWrKqCtOcMl\\\\oHN_KaKgLHmMgHuQlBmK`WrMzAtIpMrQzk@df@ja@~Mf]FdCvEi@uWbHsWnZHfDtFzLy@dWgIzNcQfHma@nCs@\\\\_d@sAs[sKgt@gCg^nAmXxJuXx[a[dOuB~@oEnVz@hB{B|Pe@`NrDfJsCbFeEjGgMbHoE{B{Q|GcHrIxS|EhGr[sm@uBcDxGkErTgp@nO|@`NaEgAtPxIzD`HzNr`@pb@xKfVxKjLvYlf@`RpFpBrKfZxq@hTf}@dFxL}WzWvWrz@~Kph@hEtd@s@vJ}BhF|Eb^nAd`@gDh}AkKzDiO~N_r@gRoSzF_EpKgBva@{Cj@iAjFcEtFnAdGoD`QaB|CgQ\\\\|NrlEgwAfhEp@`eG|BdRq@d~@`CdRl@pYtCbCeCzMbAjC}@rK|@fOzAhFfIrGbEfItGkH~`@cLn]nMpKf@rJ{n@vE`A~CiNpLcVpMol@ra@mfA~@qToAe]yDcM`D{LiDmQgA}iA{Dac@`Ggk@eByK`FeL{BiAv]k]tF[`DmO~EeDrEsStA}[|BeFp@wV|CwDnHwVdP}Y~KmNbNdTpNlb@bEna@zEhUtBeTbHyUt@qnAkMaj@eDgErBcF~UjLhINcCsXyM{Ti@kFvB{Ll@b@zA}D~HeWlCiWhUmd@hG}FxBrAlRsSvHoNbP{d@bQc[rHcSfPoDzd@c[xXcKdHcG`Ybp@`X}_@|KwHzH`d@rCxf@k@lFnAxDfEvi@hI|d@]hNcCdMxDjxA_@dEwF|Ff@|@"},{"id":"2017-04","name":"Paris - Trouville","strava_route_id":"9377114","distance":233785.08938676282,"elevation":1981.7736681257372,"summary_polyline":"_fiiHan~LnDtKmB`JnUxj@vCvd@vNn@ddCh~A_AxeBtm@htAoBjn@ztAiSbj@jlC`^`o@f`@dOx_@lo@xHpeB|_@vz@r@zmAe^dsB`FxGaHtSzOtIyNx`BdPb|DrF`YeFnf@a\\\\jo@yOrn@sb@kVsG`Jsd@al@m{@dcFiWbNnC`_@aKnK{M_BuMdPmOzZ}Pfv@cVbYkJjXp@jM}NjGiLlc@zD`|@cNlF_TmJmDrGqWhcAe@ny@kp@ka@wlAhgDmBpgAm[x`@qg@joAwZjd@sN|j@rz@xiAfF|d@{g@|GgO`M{c@zfA`Q~u@jGf}D_Rh}AqItIwHrh@~h@`cCfeAphBlPjv@rUxArWbRpFnRuGbJB~[rApz@rHnFkk@djA~[|UhD~^mDhb@kJ`Qc\\\\`L@dLoV`Uh]bN~Vln@a_@xF_HpO`@xQxaAjaAk]lq@iVdLqQni@yDL|JnfAmArl@`OxcAwAzXz_@t{@`PhJ_Dr|@lDvh@yd@tEgp@j`Ai[`SwPnXoAjXg`@dCcM`W`NrYyFriCeC|OuYzV}ErOcH|yAuIbJaIuEf@b_@zF|MqEzUvAj_@bR~i@bGxz@bYfvAEz\\\\~GnKyz@dyAq}@blAmGjYkA`v@qXhb@dAnOcHtYv@~sAz[feDfBlwCxUn^vUn`A`b@n]tEpj@xw@jrBkKdN`QvGHf^wUtq@y@hwBkQv}A}CzwB}Z~cAuCdg@wNjc@oCljAaSpr@sNflAcCbu@pEbn@qDtt@ec@fmAe|@~}AaOd{@iO|N{Izu@aO~f@}fAfpCoAd~@_NbpAkp@rfAyKk@{Lwa@eReSSdYoErGhFnNShYmK|k@xIhcBzRfu@}QjmA~Njj@lEfr@{RnuGa[rbA_D`rBkm@t`B{SpDyG~Ye_@fkFpDhh@dNxLnFdTxi@vg@{Edn@fBdk@oVnx@_i@bVi@dr@wRnfAeSvWml@x[eIiR{QzCHhx@|Gjc@}Fb`@w`@ze@wKzs@iMaEb@~MmPzm@mwBteCzEzLiPvj@kl@xn@fAjGi[xm@_Eru@sZ|a@wR|Dn@bz@cXlYeMto@lCtx@eUq@yKdUjAnUdLBZf^qFzBgAfS{Agb@aVvHKba@fGd\\\\iM\\\\cgAvz@qoAfrAkn@tJm_@zUsv@r~A}l@fn@{[|Ke^tc@bEhk@uCru@yP~Ji~@cN}dAwj@wa@n[m_@`C{Fvc@kR~i@gGhBbIfcAgUh~@tAxXyRxg@gDvn@eRhEon@fq@Zd\\\\}k@z[{NeJ\\\\tK_]jh@yUxs@i[dpBqAvi@zDfh@uRns@bBf_@wj@pz@kTqNwz@bbAaBbu@p\\\\jbBwI`o@rGxeBwC`l@uo@|iAqEll@ii@nxAqLzvB_Ibb@yqAhnAoLuJtIf}@uExw@oOln@k@hc@tU`k@gYr_A|[v[pRz_@iR|yAjEf[oIxSrAt_AmI`\\\\qWxWeOy@sGzP{NpFtJzs@cU`Dc_@nnA}]`p@sg@|RgXl^iUtm@`BlO}c@pI_`@gd@eYg@g`AvhAmJrTc@rQeYrR_DsLaOxUqYyu@tViTmCmUoIoF{b@bk@"},{"id":"2017-05","name":"Paris - \xc9pernay","strava_route_id":"9811401","distance":177234.95636261627,"elevation":1917.3738928770726,"summary_polyline":"mx_iHavtM|Saa@~EqkBnEqTnU{h@bCwmAzG}s@xMwXuPu[qNhBf@se@x@tT}^|DkNkDsOs[yFyw@z@sbAxLy}As@oN_Mu[mXcIkOzIiJlPwb@dJkPsCqQoVoLyfB~Bww@wHy]dBy`BqH{^}DyBwe@xR_GuL{Gcn@Eqr@bCoSuEqf@t\\\\eJxLrCxA}LvSz@~DePfIyI{AysA~Gil@`JicCgHimAtJcoDeCgm@aNcHmJfFqGaq@nG{pAnGeNtAiTK}l@|Mox@n]qaAjGq`@bVsPla@y@rb@iUpNuj@oAoM`L}Nxp@eaCs@kOhFcCkD{SlBqj@gNe}AvO}z@xHqKeC}jAkVkvC_Wq}@oG{c@{T}k@iRolAaa@{T{l@cNsSu`@~Aw@oH_bAoMmPyJkFgR|AgB{IaQvOoFiz@vEeMqCi@wCc[fEwNzBmt@|HVxCkHdH_u@mFga@{`@|l@mXgb@hDkJ~HyxAc@ql@uG`@s\\\\g\\\\sCjF_HB}@cS_Q}W}TrBiSoKjUmb@aCia@jTgqAuMq_A`e@kUnk@aL|a@Q`ZlHdB}EvB}o@hN{w@aCi|AtQwWpLiEbQu`AaDwRpAwTaNelAtFk]}Ba_@dCaIsEkR|CsRcO{e@qRuPw@mr@oZg[y]eLeXyk@oQ_hAyKkQwPck@cAwV_E}BsEo\\\\mNqQfBmTmc@u[iFyLqTmH}Cua@zCmCjAqTySsStBwI{JoJiVwf@b@oHnLuHDmDeTd@yJ`Ym@cXaIrXuNsH_CoMuEaEnKskAqXnDaQcgAyLaLiDuPgI|EsMyOOuI_YaTaPe[cJmd@sJgQ|B_[sFeL|A}G_E_IiH_yABs}@vCw]}Wol@`BoQsS_dAiEsf@vCyf@aHsEap@l\\\\wJcuAhFqg@kDsXLa^gtArm@{kA`EiXvXiZbLgIf@q^eR{NbKfCoKpGyCbQ}jAwCy^d@}\\\\pG{g@\\\\ee@~Lul@~aB_OnJaHdJyZ\\\\ov@aGkh@vAil@tKqd@iCcZrAas@zXoe@l[{MvX_b@xJk_@XyX~L{^sDm[Zo_A}JkD{Qis@of@ey@me@_gAsDeViNoM[sEmFqEaRfDgh@mGhZmJoA}KqG}AbFmEaVwHmXqd@aPsLqH}k@kJyUnRwZzl@e_@`M}q@dKaXjS_X{@uXdMqSxAyKoQ]eQaLkQqBce@g`@{@sZ}IhSnCod@iB_CeEoAuFl^qP{DmNiP_Vs@uTkSgJuQuc@iLuPmVi`@qVo`@B}@mFaLaCeKdDsBePhFeEyFsDaK}c@oBkaB~BaXgGmg@gj@}~AqInFgFmZcDsbAoZiMeEeOoTsXo_@wZ`DmVSef@xMgh@dL}OkVa_@sGsa@{GsNsB{q@|@yc@oCmXxB}G_CqJxBsXjKoTsETrBwSqE_y@`Uw`@yQsNkf@lHaIqi@wRmGu_@bRoe@px@eK_Wb@cKoBvF{VsIuKqPW}GoHgDhGaZc@in@qGgSuGrKlBitAyDw\\\\nDcOpPuV|Eg`@~A{aArScj@tOs{A~BqFdL~@rOomB~CozAaDu[jLG{Iew@}L{j@_CJzRmFt{@xIvWsDbDcBLkHjXJTuD~UbF_@yQlIxIpBa[}AeZpMylAwJ}TmHmD"},{"id":"2017-06","name":"Paris - Fontainebleau","strava_route_id":"10382702","distance":142959.7902395894,"elevation":1689.3191329114925,"summary_polyline":"_fiiHcn~LnDvKmB`JnUxj@hEzZsA~FtUhx@fJrAnO}GhH~JbBnOzRtOpApG`Cbn@gBl[oVlk@cH_Ao]d|A~ArJx]zVbCfJjNrJjJbV|dAoS{Er|@iEjStKt\\\\rFjv@zYl`@dB}VzNmCjFpKtS}B|AzMxS|d@ZzN`MgD~SpPlFvj@eB|TdH~VbBvZvO|OfApShMgBbOtk@pFf@rVmc@xDfG`CgKrf@vLl@vLbGpLzDkStI`DtElXhp@nb@d^vEdGrIlk@fYrBXvD{K{@jO|GnGoCdHzZrXeRb`BcVfoAtGbd@pMnMn_@vLf[~u@j@lKqGva@`Sfi@rFfj@`GnDD{Onc@fFrBoDfIfMhFeJzECfStf@~O`KvItc@z[kMtQlC|Ro|@vMcDnGme@lW}]nl@gSdQHvVxYoGtiAx@|z@vNk@hV|L~KtSpM~JdZpt@vXlE|DzLhSav@hU_PdAskAxIkp@`KpJjPs[|Ak^xKk]k@aQ~IM_BsKv_@{tBvB_]|l@kO`k@e}@tKSvNpTtIzYmDhY~RvBdPzXv@zSoEpaA~Pxo@fZta@rLlHdMb`@@rKv^|Ojf@xG_AtrAjRct@dWqf@z`B{_BdSfJlNvTlUuD`f@j\\\\rL`@nNwB~HkRzReKhTHAgGpDI~M_[FqKxKzGaAaT~DiHfYvOza@yBfp@q[jF_UClOxDaH~BrC[wVzJoGva@c@lKbJzm@vM}Cse@wWoy@~B}G|WaOhl@oaApR_EWw`@sL}{@t@qIhMoKpTuA`g@nK~VeShBqTgNaLdAol@hMaiAbPoRjN{d@kFaeAvB_e@nMbEzMmm@UsOnRoPhA{TeBmj@xF_Uqd@ow@kEa^vWo`@to@klBlJeIvKfVlB_@aCug@hAqShE}GTco@gCcKnAu\\\\`E}P~IkKmKkg@|Loc@fHdDxBeHkBiUxFi`@rAuk@tIit@dRqk@nEeb@qZs@ir@}c@cXe]e\\\\gw@{KgEkFgJ~N{PbPBsAmF~DgDf@wMdFaA~I_Tp]gAhWikBzUio@hAmWcScqBi[cXiQue@fCkOjK{KuCeo@fM]vR{ObEuOpRyDFcaAxK_Zjb@ayB`Wq~@NiFuJmJcOqh@}^cTil@a|@g_@ex@CgK`UaiAfe@tI`MqI`Pga@oBeH|E_UsEkD`DiUnN{BzCiRbYgTbE_Oi@sSne@eD~Qm|@hPqKvLg[bd@ysBcx@acAod@s^zTgaAfKwjA`W|@rM{RlP}IzZm~A|c@ss@xSi`ChJci@rW}RLuv@nFyMj`@wa@nM}\\\\vZgVuN_qA}LlEuIaFwTjAwSoZgVT"},{"id":"2017-07","name":"Paris - Chantilly","strava_route_id":"7454996","distance":109128.04997237989,"elevation":1196.251161582588,"summary_polyline":"_fiiHcn~LnDvKuHj]uD|C_AfGoA~@uKmOaqAfgAmLMoImT}Rku@ax@ytBiAyLaAUc\\\\wfBiMcj@aGjIkC}EicAy`AmYoGiTjE}S|JwHjIoFnLuV|wAoHvo@yBba@m^cH{JoJcDrC]mHuMxD_EoHuAtAtCnKg_@ll@_OySsC~FwG|CgJoH}CGsHnRVjKiBnA[xJqFnNHrDpChCP`HoIJaLsDh@pEkD~Ry\\\\`XyEvKgE~BoGlK_MhDgk@uLtCuWgKkI_IqOqUwTZsJqMsEsF{\\\\oC{Gq^aa@mMiYoB_JkGuIwOse@oN}RgN{K{Gff@aMtHyDvKkCpAaF~IiP_BmLzMeTtNiDlM{ChEsCpTcAl]}ClLsNsJsM}Pc`@rUcRJt@zQpFf[mAxA_JgAj@}KwCgWiPiPwZeK_RFaMxCHiRnEi]uCeJkCScA{GwTvGeLlIfCpHuBxTe`@dr@oGzj@ad@xPSfH~A~LsC~JxA|ZkFbKE`OoAnD{BGoGeGoEiRmF{IaFe@kDpCmAlEoDbA}QeO_@k_@aO{}@}GgMw@gIzJmObKcb@rJ{PuLmP_P}Mij@uqAy`@~a@aXcs@zKgf@`QxBlRiOrWmt@dFsVqCwC\\\\yGgMeXo^mLoYyBwDqNiH{BuGce@DcMcFaI}ZiAe@lKwVxk@oEkXih@cn@uYyy@ImKzCwU~EaGcXekAqCgBw@uEk|@fA~FogDbJsTDvThh@hDpNmgAdG{ApJqy@xBygA}@ydA_o@dCiPmTwHqWuFfAaHkUeFuHeC{QlIuO{A__@d@mg@kF}SVuLxEuGvScFl@eL}@{w@zEsE`@cGzMyD}@kShFgfAaDsUO}XhHqUqRkRsBkPbI{`BxHu[jCr@bEkEd]u@`TmFvE{DrByHzKoHbImDjLMpEiJjYmL|E}[rE{I`Lki@jEsKvFyEja@tO~Fg@vMvMnFuQcAaEbCsYEcWiIeLaaC{nEax@kf@az@frAuuBpm@y`Ad{AyDnKaIxJy^ft@{IfCqOsMoJnAqIpS_Ch\\\\yJrVmBp^dAfLlGjH`Ixh@zFfEgGtq@fCzMyBpOjDzTTlU}A~WvBlPv@tq@dDhF~BtSE|EuAvCQ`Q~ElXpDpl@mCj\\\\kEjNk@`JxU~CbPxh@zX~i@jAtj@@nAwi@lj@~CtZzIxKpDh]d@`J_EtObGhn@}U_KcA{MoR_KUwUmLw@a@pRxAzCJ`TbBy@h@wH|F`C`Ghd@hZeE"},{"id":"2018-01","name":"Paris - Provins","strava_route_id":"11622226","distance":103198.8594491366,"elevation":890.6763997061324,"summary_polyline":"ab_iHi`vMPm]`C}SoWxBuQuF_X~CiF}RuMsYkKej@lA{NlqAioBxRsRaTui@or@_y@{EsZx@y_@_AiL|BqQ`Kq|DoB{Au@wEeKgEuDmLaEeAyDbBkSePuWooAmBwXeGyHcH}_@e@s[tDoj@Dcp@_Cim@bHoH_BaUr@wT}GDmCm^iHscA}@alA~Gil@a@aDbKg~BeGqs@a@wXxCop@m@kKl@ms@zEy|@kBiKeJkAiHeJyEgUqGaq@nG{pAnGeNtAiTy@wGl@ed@|Mox@dH_MhTqs@~Fu_@nVoQla@y@x`@cRjP{m@oAoM`L}Nxp@eaCs@kOhFcCkD{SbBmTCaZyMgxAnFgPfHui@dDwCjAyFfA?iDgcAb@uFkVkvC}Rsx@aC}CFmEwGm]sFgI}G_RmNmo@KiRaCgC}AePx@oAMqQeBiTvA{G{HYEuBbFmDyGgDhA_HuBqYfBcd@wBqWLwVaCwBmHo`@vAem@~NqWbV}KiD_L{Au]fHvMbGdBjKoT|Is@tXeMlNyA~ItBjMpVxG~FgApIrAdOhJhE~SdY~[vBrQ}AhQ{Lm@uHpWhBlAeSlPm@~Q{EpTaY`n@qUrmB}nAnfA_g@jZyUxEiIp@aFlMoCbD{FbAyMQ{|Bs[_BqTcJc[q]gGsJ_CqLmAwY_DwMa@qj@dGod@gDe[zBihBxTscAHmcAfCy]p_@ytBjBku@}D}j@bAwNrA_@nD_O_BmO|Fk^`Bqb@rCaL|H}KhLw[bf@a}@pGu[nPeTdIuFz[KlBkV~FwY|Q}`@jD{Q[wI~ByTpGcRnL}IpDsG`DySpI}OtEqg@Le`ArCipB_BqNlCyHzVwM~P~FdX{FxL`EdM?nq@uFzOnEh_@mDfGjEjH`@|_B_QnMiNvV_G`m@zInq@x@tY}ShVmF~^yRvb@eIjy@bBtWwF|KoX~LcHzGi_@CuL_CyFhFkDpAaNYqJjBwMnCeL~CyEhJeDlGoIdOaIzPz@nHaHzWxIxOuQ|G`OfBu@lCdN~JwDfAnKjNdChArIjSi]g@qMzGu_@~D~BhCiGjGkWlDwEy@{FrE_Ev@dJqEy[J}E"},{"id":"2018-02","name":"Paris - Chartres","strava_route_id":"11759000","distance":106644.90667239657,"elevation":983.2046482660893,"summary_polyline":"aeiiHwk~LbBdGNp@j@Xq@`@yFbWIt@Rr@[b@_@`A@Pf@r@L`@N|B@`AEbAYzAa@t@a@\\\\k@Xy@La@CMHw@jDKVxCpBf@Ht@TTAK`@Dp@D^H\\\\l@rG@j@NnBn@vPB|CKbBUlBWnAwAjDSTKDILCRD\\\\PNt@hALp@t@zHf@nIT`C~@vHtCrPZ`C`A`KTdB\\\\xAzAlEZnAPx@?fAKBMRA\\\\FR?fAeIph@m@pEm@pC}BfHaBbDeD`F{@jAgAvBaClGf@r@EtEc@rN[jFa@`WKDERFdDE`@s@zBpCnFv@~C|@|IfCbMRx@dF|IcChEnBjCTT`@x@nA`FNNVAJM`@w@|@gATQPE\\\\@i@rE_@tA?RDV~@e@hGb@vAFt@@RA^Mf@i@jBgD`@i@HG\\\\GTFzFrCPBLZ|@rA`@VTFf@Dj@?NIzEB`FzCZXrRvVNVjAvA\\\\YdFQfAL\\\\k@b@k@zFyBj@Qd@@XIz@bEr@zD^l@~@r@nAh@Df@Vf@f@b@rDbCxMpQb@XvGpC`Dn@XRXDWU@?TTLTbBr@j@b@PTRr@P`@TZv@bBvCdJ`@`AZj@v@`ArDdIv@jCdAnCV`@@b@ZvAp@bERtCA`AQzC@hA~AlJxBhQh@~CC\\\\]nAGd@@PPf@tClCPMTa@VBNXPnAl@fCt@~AbAz@b@sApB_FnKlB|Cp@x@I`FkCv@WDQZT`EpJJFJ@VE~CsAXGtA?bJ[RxChA`Ix@dBx@fAfDvDh@bAnAvDvDbM^Q`@|BLpAHfLP\\\\LDx@KtJqCrRzNj@t@\\\\v@n@pBxAbRb@pGf@vL@fAEp@y@pFo@rD@|@p@fEt@lCx@|BpA~BVfAXbBbBvZ\\\\vAZz@j@lAl@z@hAt@pDzC\\\\Rn@HRALDFH?ZK|@?VP\\\\T@SfFB|APhAPn@h@`ATTp@b@f@HRAd@ONMLQN_@h@gBLQd@]l@EPBd@N`@\\\\Tf@hQ`r@Hl@?Zo@bPC`@Mb@Dz@jCTlPvI`^tQNTnARvBf@FEXLnGbD@LHFpBdARFlE~Bn@b@|@f@d@P|@h@fB|@ZF`_@vThEmTHOVwAAa@JYHEn@DJDXXHP|@hFl@tGVvBLn@Pj@Th@X`@^VTJ^B^C^Mb@[|CsDx@iAr@_BT}@TyAHaAd@kRFeAVwBXaBp@mDXgAPgAtCd@VPTHpBX`AHh@GnALxDj@rGr@~Fx@lCvAXHbAOP?LBfEpCe@zB@ZDT~BdC|ApB\\\\ZbBnAxAZtAJmE_A\\\\VxAZrAJLC`A^^f@`@v@d@hAHFV@NDd@TPPn@VpCn@R?~AXLWhCgIJu@FKJDBJmApJ?v@Dt@F^L\\\\hA`@LN|@hBX\\\\pCrALIFBBD~A_B?@r@{@~AoElDiJd@eB^[RGIwABUROh@Sn@_@n@SCMJGJSLXZEx@Db@P|@d@|@l@HLhA~@zDjCtG`EdQnL@ZLPNBLGXLbGxDhB|@rRdM|@^z@TdD`@bWnBd@AXFTKf@XpATfAX`Ap@dAbAl@bAf@dAh@bBM`@?RBLLNN?HFHh@R^PNl@tBr@zCjA`Dl@lABVEN?\\\\PjA?hBBBZ@K~DK~@@DIXEzBBzMDpBTrAh@jAxWh`@n@tAz@pCbAxFXhCJfB@b@Oz@?T^z@F`@D^Gb@Fn@NTRJNAt@^`BxCfA~BZb@dFlE\\\\^jAlCfDdGTp@PP^Jt@@vA[fBY|AId@DPFjAbAVHTGJITg@Be@Ea@Og@Io@TaCL\\\\LNPL~CtA`Cb@^B~@Oj@Ur@a@bAy@pDqE^Ob@E^?RDVLVD~@AZKz@y@bB_Cl@q@`@Yd@Qr@MX?f@JdAd@d@NjBHVJ\\\\VV\\\\N^d@lD~@xIBt@PtANr@Vl@Xd@jBnBTP|BdAlGhCxDdBNLDXHLLHH@JCNMnA^dPjGb@VvFnBh@N^BhCf@|@^lF~@lA`@f@Jh@@hAChAI\\\\MtAgA`@CNDNJHLnBnFT`AFh@?bBe@zGExBf@dKJp@j@~Bx@tB|BlDfF`G`BbBAPDNHFCVCpAOfAC`@Bl@RhAjAfCLv@ALHJFGZLnBtCdA|CPT^PhCBxDh@zEAp@JxFpC`@Jf@BrAG`@@\\\\H\\\\NlGxFfAx@l@ZjAf@RDb@Eb@KjC_B^Gh@DvCr@d@BdAGXKzAcAt@SdBDp@Gv@D`@Nd@b@lGvIxB|E\\\\d@d@Tb@?t@Gh@Qd@Wh@g@r@p@`Af@rAJpAErA@dAV`Ab@tAt@jBjCh@vA^dBj@lAhA~ATb@@RmCeFj@lAhA~ATb@@PEd@?nAHd@Th@\\\\tAhEnTt@|BxA`Cn@x@pAlAxExD\\\\b@Rb@@\\\\ATuAvGh@B|@TxAz@t@l@rBt@XCEj@mDvVcAvGuA~JGp@GrBOtX@pAn@xPB|AWtFi@lHYhFKp@Zn@X^VLh@Nb@\\\\FXHDdDoAb@EbCpA^X\\\\Jv@CbBc@vFiAd@DVZLhBXvAd@~@t@bAn@j@xDpBhDjAdAf@zD`CnBbBd@p@f@~AJhAAjBG`A_@rBEt@tRn@VCnBlMZrCN|C`@d]H|@Nr@Pj@Xh@Z^\\\\XvIzFTLh@RnBL\\\\PcQtaAmQvcAQCOLEV@TFPNHPELc@lCVdBFr@HfATrLzCl@JtBJ`a@u@dCIrE]n@|AfK~TjDhG`EdEjKnHlEnDfHjLpBzEvFtQb@fCGhCiBlKHdBbBjEz@jBxChCz@PrEAxAZdCp@VVZjGGtEHlBh@zEZ|EPx@l@zAbOhe@RbADd@C|@GXQVg@d@KROl@I~BD`AHh@PTRHZ?j@W|CeBx@gEvAiF\\\\c@\\\\IjARrEfA`@\\\\z@bAf@|@Lp@^`GvCnNvApG`@t@~BpCXr@JhACtGGlA{ClZq@~K@pOd@xCnAlBxDtE|CvCjI`KtKjLrJlLrGdH~TpW`CnDrHbObDdHTx@BtCHf@Rf@XZVFvA?\\\\FXPd@l@x@dBX^f@XbBb@b@VR\\\\Nl@ThCTv@`@p@`Az@xI`Gq@nCYt@k@bAxJlTfTdTnUbRdAn@zKzCVOvAeC|EiHfh@ql@NGF?DDhCfJ`BfHVv@LHx@OP\\\\~A|KfCdGlC`GlArBvAhBbEtEjElHpHbQvAnGVj@jDdFfNfHhBvBxClElK{JtCdDnBbB`@d@dCjFd@zApCdPElDX`EEjBiAhDmAvBz@bDdAc@vWkC~COjBJ|Gj@\\\\A^O~AiBf@]z@WhJ{@tUs@z@IjNyCp@Kl@EnAA`H@|@HhAPgE`b@`BfBRtAHxA]dFExE[fEI\\\\B@@h@CF@Nr@z@zAtAbDhDjBzCr@|@JFfALpFDp@JnJhG~@f@lAZ|Dp@lKpBT@JF|DBh@J`AVfBx@lA`@|Bh@vNxCXJbAr@Rf@jAtBj@r@vEnEpG~GvBfBh@\\\\tDlBdC~A|AvArAfBxHzN^z@x@`Cj@nCm@XwI|GcB~@yCtAw@RoAJG~BFdCKrAa@dCUXcCmBo@Oe@Ng@BmBT_@AeAx@dAnGV~B?lBaAxKkBlKsJ~NoFlWsA~Aq@r@yAlBo@lAqBdFKPGlC@~@HXNRZHNAVOX_@NG`BBNDNNJRF^OtIc@dR_@tSc@vIc@|P|FdIxJpOzAhB~AzAvAhBnBvCfCnFdHvMfAfBVfAjGrK`BhAf@h@vExCXLb@J^D~EB`@XbErIfAbBt@t@pBrCnA`Bh@l@ZPPZNj@Hr@ElACjICt@s@DKfB@~BJhDBtIHhD^dCt@|B^dCh@pGt@nGl@jBzLpX`@dBj@zWKlLc@jLv@lDPjBG|@m@bExI~DpAXh@Zt@h@fBx@Rd@b@bCdElPv@r@vDfLz@b@LfGF`@JTNH`@HVRHn@IhEFjASNO^qAtHMTyA~@q@n@kFvGy@lA_@x@Ql@Mr@QhBCd@@pAJbBZbD`@dDTdA~BfDPb@FZAVe@dDW`ABf@f@|A^pBJr@Bd@c@lq@K|Bq@zEk@zBiAfDu@jBk@vBOfA?lADn@LFp@jAfBpArBrA~A~@f@n@^n@PRNDhACNLNVvBxHPh@T`@pCzBbBxA~AfBXTRFl@@jBIPBPTXhFVpCdBlNAIpDlWP|@d@zAnAnClBrD~ApCjG`JFZ?v@HFz@nDf@lDZzD@pBAyB@vBW~Am@fB{@pAmArA_ArAo@dAQ^s@rBq@~B[dBQnBMvB?pDFdAAjBETnBd@vBp@l@NHpALZb@ZlAD@Rp@jBBVCx@Sv@i@vA{AxC}ArDr@tA|@tBhEbETPpVpWhEfLCEnCzEfC~Cr@bAt@tAh@`BXpDZ~CEvDy@bL?bAFvATlCp@`CR~AKlBQlB^|CTfEc@qGLhATzDClAQnAg@t@aCbBQ`@Df@bBhCZfA?jAc@fDwBtF{CvLuJhf@|Bn@xAZjADnMgAj@Cj@@d@Dl@Nn@ThAv@jDnEzCpD`@TxAn@hEdAbA\\\\b@HbDPdABpC^dABl@CnAOn@FlCjAbAh@RPHPIzA@~GOnESpBm@nDBxAFdAvDxSdA|CpDvDf@fAjB|N^bHBnOHzBdBdXVrCVnBb@lChAvFZnA|AfFpA|Fd@`CRdBX`E\\\\jNZbEX~EF`DLtCdA|It@`NPnJn@dL`@lERxAjA`EL|@@|A_@tR_AnWa@rIC|AA|ATnK?`JExEYdFO~I@dDHdA@tAApEKj@Ad@FnCFdJQj@i@pAu@rAoAdAcAlAOLM@QbFHd@e@l@o@hAqCpF[x@Ip@MjC@v@PfATx@@rAOxD@fBHp@b@pBDt@EPMR{@f@K\\\\QpC[|CcA|Fa@xCe@lBmDxIsBlGgA|Gi@zF]hFUrEYhI]zDe@nDo@nCaA`CWLCHgAjAeEbGgAjBiCbFMb@@^RpALdBJbCApBGjCAfID|BT`Cf@|BvAfE\\\\|AhAjIv@vJ`@|Bj@zBx@rDTj@TXpAbAjAjAfAz@bDzBdAlA`AhBHd@Q~@Bb@FRhBxCJ\\\\f@TRb@Vz@hAtE|@|CNbA@bBPdAzAxDJvALxE?nACV`@jB`@nA`@bA`@t@fAfCd@|@f@vABTCVQESDy@VmDpAQ@APKNK?Dl@nA`G`@|CD~@A~@OpA]pAc@nASfAQ|AWbEg@pD_@rAiAnDOn@W|CYdCAhAVxAdBbHHpAUrKMpBKj@W~@s@~A]`AQr@O~@KfA?|BPhAZjA^t@rBnC|JzNfIdK~A~AfDfB|E|Bt@RfAjCbIlPtAlDbB~BxAnAp@\\\\vKdDf@DhA@b@NZXTb@tAlJ|BjLn@tCrBrGP`ATfBTdAl@bB|@bBlBzCn@tAp@|BRb@hAhB|AxFBXG`@\\\\JtBpAvD|@nC|@z@HT?|DU|Bk@xAs@pG{Dl@YfA_@xCs@hFkBpCsBtEuEl@e@xHcFhCmAbAq@`DyE`@UvGoA`ByAjBeA`@MHI\\\\C@FbBURG`CcC`D}@h@@nATJ?bAe@l@N`@MTWCD\\\\s@hAm@`@OzBBj@EvBaAl@IBn@Cp@Qh@]j@aAhAeB`AUj@h@r@|@XX^Xj@FT|@xA@VQZfBjEj@q@jAaB`@|@TNJN^z@bAbDjCnCRpA]VU\\\\Mh@Ch@DNR^gCSiGu@I?OHiFbK"},{"id":"2018-03","name":"Paris - Beauvais","strava_route_id":"11998198","distance":105453.96179395508,"elevation":1184.3244322611297,"summary_polyline":"_fiiHcn~LnDvKwJb`@a[}MoD{GqE`G}J{PiDrc@oy@x|@mBBoMkb@}UxXmAd_@aBtJuJdHgSlDaAhRgGrHcr@mI{CjBkLjTuBfd@yWcAmYgLeTmBgWqOiw@lz@pArDkQbQua@pNcQhOmQnJiBfIxD|_AqIx[kKlp@eUbk@bWvRiXddAwUxZwAvLyDU_Cbj@eXzNsN~LwMhRwRlb@_FrVwG|n@oPxt@oAlYjAzi@]jZk@hHuFlR{@nSbEl~@gBt`@p@hx@jAln@lTl|AqK``@xAeKyCk@gf@fCwBbY|@lQMz`@hE|UoEliArHfq@y@n{@hIz[_oCnjCmLdDwDgAmKgNcIpBg@le@|A`i@uAvAaAjVgCnNqCzBkGsAyl@vTgOcDgJxMyFt@{EtFmDh@mNl]kAtPwClLuM~W_Hpa@h@lEmB\\\\kDvJgDoAgDnGsBnLkGnI_M~ZwK|c@_GxGRzOgQoAgFhFqYzt@qCbDwDWaU}Zi\\\\kNwHkAoFfPcCHiCk_@aQePu^{i@mH{EwKyNiP_p@}F{^cM}^tAwM_@aEoFm@iFxD_EwHwr@bRuHfLkX|r@iPxNwF~SkHgMaHpCqKgKiFbAyQmFaKtIaDlL}ObJ_ItKsFrBqD|LgEtD_To@aHbC_F_CiEfEaGYeGyCoEoMgCeCaNM}@nHeKfQiM|A}DhGiEuAu@yKcBkCkQzBQqGaHiM{Vm~@aMbCoUaGgHtEsTbCoBlRcByJwJoIqAfCdB|Jq@`EeXlTm`@`P{MpKkLb\\\\gHhb@t@x@{b@`f@ke@lQeb@~XiKNo\\\\`N_e@dF_KxLuXbPeEmDuBsJ_Zyb@g^{SsZlDmNoBgOeHgOuNiCqH{e@uc@wIcVcK}LsNqIuUeFDwOuFwMvAmG_LgTeCuCuX}DoSkQoM_VkBsOnAkNqYiG_GaIsIuc@_Noa@iKyu@eIl@LePhLiYUiLgf@gE{i@qc@aHwO}LgN}KOgN{FmMxG{Mgh@aIoFeNwRaO_z@gLmf@kD_GnB{F{GiEzA}PkIqByVgXoDW}EjGGvHsE_@mCvBQxd@uBzB}a@{[yVyCoXmQiLsBaMxd@qPv_@cB`NoOfV~CpJaBdV_h@i]yM|@cLuH{YiIqb@sA|F}LbGge@|L{Cp@aJYmKeFyUIcXcQ{a@yXyKiMgNaPiJaY{GcS|A}F~DoQzBcBaOag@_^aHwKi`@uZyIPPjPcAdBmAmEbA}EkE_IRuH}Cy@kGhKoOwMgN_HvG{VvLvJ~DvIjAqPaJuD~@aEwGkEzIg_@tHxHnCvJt@_N"},{"id":"2018-04","name":"Paris - Soissons","strava_route_id":"11742129","distance":136123.85106658656,"elevation":1264.097160088123,"summary_polyline":"kxliHgypM{EpDuH_It@{i@qAmg@fGsKvCHfBm`Ak@oTmEm@Q_CKs{@{@iNsx@s|Gt@uAyYieC{HwTelBiwBsOiV}O_`AiAqEXfBw@MbE}w@|AwBs@uE~B}_@kC__@v@qYm@kJvAeDsDuMgF{w@gUbE{YvOkBcBDzA_[mvBmUesAkAZ{@wNvH_l@X}Lq@oHeG_QaBkOgWkqGi@{DsEF|@mOsDeIkJmCmCkIsIX}NwEKmE|CmGPmGkD_\\\\sSsm@j@}XvFmFl@s]}C}WiEexI_CgNgFcCk@_QeLfAeL_Yw_@kbA}@cTsGFoOfIyK_Kyf@{OgOiRcWm@eDcEaBaJ|BgFlMsFyDmMwCwYfAoc@mBy^hD}r@s@k_@wHeScPiKoJeQwZm\\\\dEeo@{Eir@`AuSiK{XbB}KuCs_@kRi^oDuUyKs[`H_IrMq|@Bib@rE}YzVyl@`DaR_@_I|N@wFuIvHsa@bIMtHgEvIiI`BeFuAu`@jBiFqPkf@m@iZgCmJiKaFsYKuLqCoIqQyAiOl@uPxLgs@lF{f@~EcKlEeZpJpJpI`@xGc^XgS`N}[qAel@cQak@gEaBsQzGc`@yAiV|Hih@cz@iK{IuDwGqE}RhFiY@}JwAuCqWoG{E{HiPkIuYSyO~Z_JjE_Fi[{FcKcLse@_DkZwKaWgMwk@iD{IeImJwFmQsCyBTaAuF}Be@cEnAyUxCoBvGmRVmE}HiHVmWqBoBaTsBm_A}ZyAsQmAmB}AfAyBdLuNd_@kEeAoQsNqGpA}JqBeQrDoR_EuBxEyApScCgA{HdH_Q}MsMoSiJyXiO{K}KcS_L{D{QcN@}CrGqLs@wCgSkLsAdDkMhB}LxToc@ca@qT`@_KuCcQrDcDlDwGz]}Cd\\\\oDvD{Kk@uBhd@_Jr@sAbLqWgRm`@mL_OwTqPmAoFmDySrLyAiJvEaH|HoVwHl@gVaE_KmJeK_XUgScE_MqLqKmFxEeBkCcExIiOmQwJ[oW{MjBwD|BsYoBeLoGcM]se@`WiIsLge@mH_H{JaU}`@yRiDcPcVwL_FyPsDiWe@sQ`Bgr@gBcEaH_@iEcFwZuLyI_JsWeIsTsFq]V_fAa^wWxCgMbYuQdKfA~Ni@~HmLtZiNnV{I`KsC^OzHmB`EuWeWmBkHkC`CwEaYgBPiBjHiCxBoEoBgCuGiAh@T`CaBf@mAeAfC_PiBcf@vA}AFqFzIch@eHqEwbAbEu{@ga@{DapApHir@bLgFxCaGwO}u@NwLnGgEeGoN}GaDyBc[mFoFkGoAgPuRuCYyS~Kwu@lu@_|@rg@}VvEqCuBI{FyQ{e@aVkWcLvEiHy@_NdD_Ud@uGzImFdYqEfF{UMgZyPm]g]}i@pc@gMnUoCca@mDaP_JaT_@}tAlEk@RkCuPqLmMw[dAgAfG|DlGeAtIkP|JiIbD@EwJrCzHvOIYyBsHf@m@mClH[jE{DMePdFeb@zOw{@uBaFxYswAnGkIiCTgFi[n@iNmBmVkHqFvA}RiAkLcMuXcDuFqJEgBkJcNgWgH~EqIkHiP{@mPuL|@qDe@gGvBuBiAmLz@aOi@yQyJmRaGxJcOlLkDO_Q_UsDbC_LlReThBqIfEoHoFeCzEoD_AcTvENjTsDB}@i_@p@{@jViJpEtEdEkD@uG|CyIxQtBfSuU"},{"id":"2018-05","name":"Paris - Amiens","strava_route_id":"12414992","distance":166786.76532922685,"elevation":1902.9690086510786,"summary_polyline":"mdiiHgj~L|BzGwJb`@kRgIiAxGepAtdAaOwA{M}b@}UxXkCrh@yKlJaKvAaN{h@gQ~@mLiO{GbOuK}OyIhYgBs@aH|b@gm@ePgMtGki@d{@gq@|r@pArDkFxFwm@nYmm@`c@}Qg@gF|[cS}Wgb@eFkCzm@_G`HpAfSmKyD}EfKqFyTiHf@{^k]eD`Ka^eXcb@f~AwTlGs`@rdB_]wUqkAa|AcBcCiJlQnL{d@{DcG{DnGeRgL}WrEuq@yZuCqXeT_l@mVoV{Fsh@sSiDcMhEuJ}FfAv[}NzbA}MGgLrNcK|CKnr@_n@tyAwFgCuAzLsN~J}GkAZ|HcRw@iQz[q`@sGoKp\\\\o@vHrCxHeCfM{VfZwQxa@eJnFoL_Cca@~g@mb@RgYiQmZpj@@nQmDfI{L`FcCxLyWjAiTvQ}Nrg@c@lZfJv\\\\vHbJhUdkA{Ojx@qBdf@gFvGaFkBeIpFgIdNiClQoQeC@{OeHqE{_@zJ}HxL_LdCtG~IZvTyMziB`C~\\\\u\\\\jG_U{U_b@kTujAslAuByLbIeT}IvAwBiF_A{c@aQvM_d@wCye@sZuEkNoPwIiAoKwF_CwAh`@_Vxq@_Tdd@yUtX}Nda@imBl~@wLs@aIf\\\\aTyOst@eoA{Qaw@_H}ADkM{L}KGibAhEwZsBmmAdE[}XsUuLy\\\\jE|BjBuDbEem@gHy~A}l@fNcl@x]aJlPaf@j\\\\oOi[mK@rCkOay@iJacAfOwQgAaJqQxCpP}MoVmd@q^}^yA_MuNcVgHkOyQgKbViO|qAuG`E`BhKiPzKqFaI{x@eYmHgIo`@nMqG_NgG~EgLuCiHiLa@}Hc[uCwUy^yYaKiLwPiGfFiQ}AkIaZkNmJ_UpOqEn[_@nf@{LdCeJqHHeNas@quAob@}XkT}^qKcB~Aoa@oLtEqh@aCcKfKmFxPeGkAkJgL{c@wFmaAyf@}j@}dAuTdBcCdWyw@|tAyZt{@oCja@sJgGmMtAem@pWiA|GgKd@s]r[mG_El@{KaNqEwUtA_ZnRcpA`DeE}DyApIcUyTg[ba@oa@_B_dAbMeYoSeNrXox@mh@gDfo@ohB~n@a`@jWiObAaZlPmA|FiI~BfCrWc`@zf@wbArFea@|J~AlL}NlQuSpHc{@z}AkKcJyq@gNqj@w\\\\_Rw@w[tK}MyI_FrAgIjXeO`OgK`i@uLxOcBrKyt@vVwDmC}AlKmZ`G}Ud^oAeDsGzEgz@{oA{s@}NkVqR_Lo\\\\aYpQ_[hDi\\\\u^_]iH{O|AqeAc_@QqmAqLwiABq^eIie@ua@qL_UoPgO[exAgd@kXeTiJaAkLiZ{Trc@yCs@}g@sp@oOkc@uo@sd@oa@}r@a\\\\yNao@uf@}LcT}Er@ot@wr@qKwCuJeUeBlDuq@qEmUeH{\\\\~E}SgT~E{MqBqFkIpIsNg^oWqZii@sFoOmJoBdRwG`@{_@gVwDqOnEu]}PiMiE~@ol@_x@wZi`AkRm`@r@kPyAmGiFKp@iK{G`CqCkZdVok@eG}A`DsXeG{ErD{AbN}k@vItF"},{"id":"2018-06","name":"Paris - Moret-sur-Loing","strava_route_id":"13482336","distance":168962.99611885217,"elevation":1725.0975121998806,"summary_polyline":"_fiiHcn~LnDvKmB`JnUxj@hEzZeKvVyWvI|T~{A{Lpx@_e@bhAdN~Oo@xJdLlf@oFzInIhE~FvMpEiDcAnI`OFnFoGtVtHr\\\\~^`cAaXF~\\\\v]|CeBtf@mWp}AtHlJaBjIrVtXuH`cA|f@dV|JhOlOh@q@u\\\\hd@iOxBgPtUcDrRzNzGnl@gBzTdH~VbBvZ`PrPgHdu@fK~^za@lExaAff@bByJt\\\\oZjGgRhp@nb@d^vEfo@jb@~FhAvD{K{@jOvIhIjOi^pGgBvhA`t@xh@pGtIhOfHeCnDbLtOyU`Ngf@`fAiJvOxK{Hzd@nIuJdCgLhH{DfEvHxMxBv^vWbd@sLvNc]zJ_Ine@`PhHmp@|Mb\\\\iCrf@|LyZdLwBjDxD}C~UzEhK`HzCbLuMnMvRlQrHdKzYnXe^tJs`@nEhCxCsIrNv`@vJz@~k@nwC~M{A`MmMpYcc@dImUhWn\\\\fIpW_Dr[zPzB~Fcs@lh@?p_@dKvDeMlHc@hHcLpBpCxMaTj]}NzRhLd[lBzLra@tTv^|I_x@Z}p@qFkn@jF}U[aOcEiIoGonAbw@gInA_NtJ{ElV|oAdOhQ~_@nOnA~KtgAae@tPm`@rN}Cn_@|e@rHzAzUjf@jNhEjDqIjTeF`]|iApNvaAdKKjAhLbLpEmBoRdQbClX~YbJzXDlOzVzs@zAr_@tHdOjIj@hLtM{@ldAjGrU~hAgBrMgJzHm^~VfZne@tYzTpe@zN|Af]f]zOhCjc@aFdcAmn@zOoO`BsO_B_Hf\\\\hMdHoLvKbXrDaAhAxHrQgg@lSuNne@iJnRgt@rFiDkLuFyCsL~PsXm@cj@nKyb@rCc`@mCac@x@_}@xJ{q@aByYqGeSu@ck@lC{HvH}BpB~HrKjElFix@xh@{HhOqVvr@vMfWeGnUbGx[jUlm@jEjLqGbUad@fWqFzEkGvcAvp@jUyJn[ie@jQaEnSzFvLyWzQgFtBcLoKqPgNio@gCamAcJoc@cD_q@mH_j@wO_`@qMqiAvCuRVy}@tJ}q@gK{aA_EmfAfBw_@j[{ChCmt@bRg\\\\lk@}aCuNomB}c@|Fo{@}UeNg^qZoUmi@chAnBcNzYmF~b@g_CbOuMrIl@mGqU`CseAmKgEd@cFnI{A}Ccf@zKcZ`DojAiEov@iX_c@hhA}nAbFwT`AcYpR}e@dCqY{AmLgPiRiD_^mSal@oCg}@uPqkAZgk@}NwiAxBmiBvOsmAcBsaBrJym@vE`ApQme@q^ae@iL{j@rHqAjFwtDbGeZkI}u@bG{hA|c@`UrZn@v]k]tF[tQgi@dG{z@lMo\\\\|E}d@s@eMlFgT}Tev@lGeJuDwP_HsRw_@w^sEyOqB_wApEivBhOuBlB_t@`GyCvA}KqHamAsLiRg]}`AhQ}HzP_ZtSiLp@}i@oDmJeYkAq\\\\q]wVyj@ad@olBuLeUk[sUsIdG}YcOe\\\\|JyJfr@bMlJaSnKiOf_AcKrX"},{"id":"2018-07","name":"Paris - Lisieux","strava_route_id":"13015074","distance":214059.89142223148,"elevation":1889.7557036533526,"summary_polyline":"kciiHkg~LzA~DwJb`@kRgIiAxGepAtdA`JfWiqAxnAs@dR}h@~UnO`n@oFpA~B`Zm`@j\\\\sSpg@zBlLgGxKuPbVi]xLbFnPoz@jbAka@niBo[vcApEnHhF~g@oAnB~HfNkSfg@i_@wXi^{l@kOjD{b@sk@_YcIqTlNaBbIsj@hWgBnTxCtJuNdd@hGtLmTl|@kHuCgEj\\\\wE|sB~Eb`@\\\\hsCdCdl@MfDs[bM~Kjr@eLh_@lBmJhPzG~Olf@dh@li@fLfa@iEtg@fFpnBwC|dBij@jc@mOo@oHoGwYbEkB}OgStL}o@_c@atAlqAyMdG_UeQgo@bFgTmI_NzAkLb[tAnoBoGhRsQdI{M~[uFp_@uM~WuF~g@yGtKgDoAg^n{@wK|c@_GxGRzOgQoAgFhFi_@jz@uYc\\\\aYuKcKxaAu\\\\bv@cAz^gInRT`IvHdE}Ppz@eArTbAtPvOl\\\\yW|d@_OpFb@`KoWzj@aGf[cPxRuOznAhA`ZgKbd@pG~`BbJr\\\\Zrk@~K|_A{Qt@FxcApEfNw@vKpd@bZvSp~@tGn`AkJri@{Ujc@yEdk@`D`Qjj@hj@vGvSJx_A~Ihu@uMpaDdBj`@gCpm@Ztk@pD`^sBpa@|FbbAdPhu@j_@zu@qFzBdMn`AgArXzE|`@zn@xpC`M|}@p[pcAgnA`q@{@pXgDxGgPlvAsaAz{Amr@pxAw@xTl^`l@dI_MjFxLeX~j@cCz_AlApS|J~[aS~UuIpa@dQljA_NqIe@p^nL~g@XpVrg@jY`L|W`b@ncBv@lZ~L~CwGlTzNnqBzPjg@vDsDhBfHrEgGoBjK~EvQoG`GlIpPhNnJ|KvVlHdq@eFfZaYru@iI|i@~@jd@mGb^c]dg@dIuDvOtq@zW`R~FzSkLjGuQtc@kl@tSab@~o@yVfq@c[ff@m]`w@sJzu@_EZmGzm@@tPhJn]dHvHlOz@bRt]zq@pt@xRvCgEh[~Oh\\\\Ltp@oJxcAfB|IfLzM{Eha@zGjQ`D`]gLho@Yv[uHp\\\\wSfMqc@jGfBvPad@nd@sDn`CgW|Bcv@iNuRdFpFtnB{SveDhHpz@eBzo@vOll@sCfc@zHdr@{Cje@`Bd[fUjaAgrBnpAgSvsCkXthApCfe@wO`t@s@xg@_PnBaa@hTyr@eA_Rnf@sBra@}G|XrM`XdI~q@fRhG`Q|}@hY`c@~Jto@Vz[pMvr@mAx_@pFlf@^f{@lG~w@bg@poDbCxfAyDx`AhAti@vSjtC~G~b@pk@rY~D~OkDnQg@n_@lBdMlHdKVtN|g@rp@rA_OzCpFJhK`JzWxVd`@lGvd@rk@bnA|Q`SfDrX`Qjc@hBrQkBvr@nG|_AgHro@Ot^_Hrq@k_@vh@dKduBhQrd@hHt^dLBp@jGe`@`RpPf_@Yd\\\\fM`g@jEfg@}FxoBmGnc@zA`g@zOloApGfSzO`fBhr@fgCkM`OlFnQm@l^rGhk@_Czy@~HlE`[pvBnDjaApBpO|DhCsCdGz@pRjCZqKjdAcLff@cD}BeC~GiHx|AiJbZoBhV}She@gNts@rKjGzYlh@k@jT~Klk@tLrJvQ`a@tHp\\\\qXzr@mQbTrH~LHpNxNbj@uDrZeGfAgw@xxBaXlXeEfLmH_@sO`OoItz@ya@~~AkW|bB_a@pQ{f@b@mLv^_Gvc@V~b@eClIqD^wS}Fz@rTkDxOsE~AeJtu@gP{KeG}Qae@_TsUkA{Ya_@gRbHmPgx@pNsIpCyIjMaFrGzJfCoF"},{"id":"2018-07-bis","name":"Lisieux - Bayeux","strava_route_id":"13096455","distance":146129.38384239847,"elevation":1488.9465068346587,"summary_polyline":"ui|jHqbl@{Ez@iEyEkM`FqD|GkA{FyMlD}JrFt@bTcbA`RaNjIij@tIyOrLwShYkZhOkCq`BcRnCyGyUqEuE_VmRqPi@}EcEiMsWqYm^eK_j@qXgr@eBsS{EcFyg@OaHeHiOuAuXlGyViJuTa@w\\\\_RgJiWiDy@eRlEeV}FkK{L_PvBkJ`HkPvCcJxHwc@pt@kSzKgIVoKkLKeNaAiB{_@bF}KkE}Nr@k`@cLiLe@sZ}NgRsSsAyL{[yV{GuBtFqf@e@_DwCsBgDjBaKtOiNCkMjJsId[qH`O}FjB{J}FcPtWqY|O}F|@yFhGcz@zDeN_B}HtJeQlLwJsIiuA`oDky@|iA{Ljj@aCeHiJaFiS`BuCqBaIh@iSuK_OOaHqC[qDiD}B{KqSwEs]cFeJkPlGcRrMyGq@mDpF{OrJc^aLq`@wXmSoAkRkFyMyGa@gGgAm@wHvBHtCoEfDyEQyH~LcCgB_Tfj@bChmAjOzk@bRvU|DnOM|FmD~HD|G`Mr_@`b@rs@bYzs@fCbKPtLvDzSnR~t@`Dza@}DxZHvPbChFcDrc@xHxWdBha@`FvJtNfKxc@djA~OfL`AnPjLpJfOd\\\\lRtJxGlItQn|@bErJf^~_@zUtDtRc]tFkBvC`IzBvRoRpKeBxI~CdPnWth@HdDnU|r@zPlZhLuArUj|@dI~NdH`_@h[~m@xGx[px@hqBb\\\\`kAtOpLoBtHvFvG`FaDvAl@hD~Tz\\\\jNxFhFhFjM`Ez@uOfDoCtC~Ct[vLrZfMle@|AB{AhKpA`\\\\fFr]pB|e@dBvKvBdHhLaBdCrBjA~EV`\\\\uBvQcEvIwI~@fIvGvIdAp@vFmUpTnPni@hh@hi@bG`SbF~Fk@bIdI~`@je@xw@kCvRmIe@mLxFz@hQoYuEZlCfAPm@fDz@xGtCnCtEsBlFbQfDja@oNnC|K`iApG?vG~mA`G`SpFu@}@vl@vAvo@eCrc@h@~KjmAfiApj@hc@`Q`JxNpVd[t`@|u@~d@zXbq@bHpYpM|SxXrgBvDfIrB~PbIhYw@hEal@~k@WnFgCz@kGfb@gA_Bw@oL_sAcfAeVqEyCgEmIj@uu@iOcEyByC{JsDoCyWwDgFtHwFaAIlAnB`AOjChA^g@jD{VuCeDvF}XuEgFfRf@pVoDxXgDhDcEp\\\\{MffBwYhhBjDhB_[dqAiCaDyK|^wLtYyAtG|BpAGrEkRrd@ep@zsBeHzGe^tgAkOpfAmFxLwW|`BoG~QmCvr@sDMaGlr@qAbq@z@rCvCTa@nYpMZdF_CxSbFb@`JvFzSn@lJyFtrCmA??~DgJB~@hAZbRtTfWKdVwA|GqCPeCvIoFzEwEnK@pFuKd]NjOzGdNiCbd@gJ`EsI{AeJtb@}Rrg@kDdX~c@~n@pJtTjHpj@y@fP|@tEiE|ThAvQxRdl@dDj^Yz`@xL~\\\\QhJzAhBiHzU~@lES~NkEtb@cFu@wErD}Xf^uIdQk`@tCQ|FkCxD|CfW`Hx@Thb@vHjVvAvLQrM{Ed[`@fWu@`TiA?KpClA`PyEgAVdUeBxAkAn[nNpSfF|v@rGzUtIdM`d@pU|L`_@yRjQu@~g@aMxu@v@bJfIr]IxIxPkBx^nQpZzE|OdK|M~Anh@ve@LvTkHdD|JtYlAjMrJ_DjC`Cru@gCb]zE`^x@o@uNn\\\\vDrIpGpCiO~UjLvFoBCcFnHoXrA[DnGf@oD"},{"id":"2018-08","name":"Paris - Sens","strava_route_id":"12859889","distance":156922.0511920883,"elevation":1172.9282328365694,"summary_polyline":"ab_iHi`vMPm]`C}S`CDz@sRnUQfB{FtEQNu~CxHcp@rQed@zBuRlPoWnW{@bKbJt]qHZiNfEgFfgAwv@|Bcu@sAoe@bFDxAqiAaQwn@kTmQjCcI`PtJi_@wt@dB_T~_@bDn[uZ_@iD`IqAjIbEzCjL|Ia@}Cc[dDgMqFeS~LyMcB_FzJeKjVdDvCtHnFN|M`k@tOzYnFoUtEmx@bScGwAqTbR}UrcA^lH`FbCi]|U}HpA{OjQ`DrXaTbFmr@hY_MlOucAlVgAhO`TpDOyGcyAiJqu@sh@ipAsAkYo^qAfKk~@tn@e}AgPyRkH}|@jx@q\\\\tk@cc@bZtg@`dAkYpZ~_@fGlBhH`QvLw@DcHjm@~P~iB_|@hM_YlBb_@~CrDjt@_^pBz\\\\tZxCn|@zt@`k@{P|i@fe@tKzYno@bNhBbJpIaE`L~CuA}XnHi}@lO}^|C{Ub\\\\zF~HhMjNbDmPg}@|e@gqB~NyRtp@e|Afv@{t@r@aSvg@oHcEwUcJyPvCsMtF_EcMuv@hBco@_WapClKuMvDk\\\\kHaf@jAcSaDeAaJ_fAhEgN_Cg]yS_y@xXuGxKuSdO_KoCos@jGg@rA}IbGkDmCsPxGwGaa@u~@hdAkChlBbf@jNjWdMzEdGxg@`KbXjDsGlLdJt`A_ZT}\\\\|V_Ex[oi@|UiVqAaIdYwOzAyWdl@iBzV}gCfY_tApF_Jz^y}AzOkXhWeQbEka@xQq`@fFa`Avb@iNhIfHj\\\\dC`~AdC|bBuXtBgeAjO{AvGiNwJyzAtIcr@tAmEpHZJiyAcCs\\\\~p@clAj^qPfYRNq\\\\kRcp@|RnS~j@{[df@kAWuDpMsHrb@sz@|Yg_@hZaQhRpIrIuYfVofDrFcQxIaz@n@sn@xXg_CNk^p`@c|@n@u`AjLi[hPuLnQ{c@xr@emCl[ao@jLwb@h[sXzJic@n^w|@vMup@bMoTlRwMdBdF~_Ar\\\\tWrsAhZn`@mGpMvHhCb@cGdUeMdv@}uApa@ug@|qAebAj\\\\qMtAp]`KlYTnl@jPhkA{C|d@tEdX_FfTeDxAhDzJ]deA~ErZ~\\\\jNdQ|e@_@vPvE?pCmF|_@wHxK}hAtSaf@xFiEnJs^~ErYvLoDnr@vh@|Y_UjMeS|TpV~IeEy@_|@oDqKjCiFU_Zn^}@jEld@rZaIbRjWcAi{@{Gii@p@_c@f[iHdAaHj@rE|VcGxBsl@wCwRbDqMcJutAfB{j@qm@sSd@_Eyp@c{@iMg@wCbGcB}FhBgXtLzCr@}[cCGB{PyZzD~Dbb@lID_Etq@bBbB"},{"id":"2018-09","name":"Paris - Dreux","strava_route_id":"15535175","distance":146635.26115979147,"elevation":1365.776459777822,"summary_polyline":"kciiHkg~LzA~DmB`JnUxj@hEzZ{LlXgVbIvWtbBeDj`@lk@~e@dDb_@hHhQgT~_AqNsBaE`RrF`D`CzRbR`E|UnZxVyFnChLbZf\\\\`UfKjU`j@~H|_Ajn@zv@f@zz@xc@sNhDgQ|TwC~SpPlFvj@eB|TdH~VbBvZvO|OfApShMgBvJj^`FxSu@`V|GjBmCzc@hh@xHyB`X~JlF|AmV|G`@~QyeAhVx@hCwHhp@nb@vdAxUSnIhIxG~FhAvD{KcAjNxIjIy@dM~OfMcHzj@oBvy@cVfoAdJrh@pk@vVf[~u@j@lKoGlb@~Rph@rFfj@`GnDD{Onc@fFrBoDfIfMhFeJzECfStf@~O`KfJxc@j[oMtQlC|Ro|@pD{Cni@a@jb@|OpQjSl@vI_m@tpAe`@nrBkKt`@_OjW_Ejc@i]nfBwX`b@c[z|@pBtFvEkM~d@vi@na@mGdYpQxHgDfBvH`ElApMrjAPzx@cClZiTtbA|AxIrKpLtG~^]bPtEjKhEt^eClSrLdMvFc@bXpQn[\\\\|HnNbBdNnWhDnEbT~FbcA?df@rFp_@pa@~MnFmPhDNgElj@iS|g@aH`a@qWl]gM`g@sExe@}Tf}@{^sSsKsPgh@uG{N{Ny[m@u^pnBbP`LsQnu@tcAtVnXr\\\\vW{MxPgb@nO`p@`DiO~LaOhn@}g@`iBkn@zQgMxo@iMfd@qa@hN{@`Nu\\\\lX}AfVlR`C}PtBfAvLcXjPzIcDbVoO|CP|JjL`OdHti@pj@bzA~@~g@yFdmAjSiLrFvHf@rMjt@cGt]fS|v@f`AjZXda@~Xvi@vkAfFfd@mBjv@vKoTjIz@`@pG{Nhs@yKxWyCzVqN|Q_Edh@kH`HvDjAOlG`IlDnDyHfQpOtXpDh|@b]|z@wEr]sf@zHcH~DvJgUhdAkEri@nBxm@xF~SoEpNaK~oArGp|AkEp`@pAj`@kCr\\\\pLjUgAvRlGfEyGzjAsZhMecAyAqHhK{CpYbG~m@aPxNwRbo@bKdOvKW}\\\\~y@wMPiNmOyRbNuNaQwnAfb@af@jC{K~TyMqD{LlLgw@vLms@zi@aC}H_E`Aq_@bZq[ja@uFiKwAbPcIrS{[tWsGvO_YnYyCjN{H`GvD`D_@~I~HwE~@zGt\\\\pZpBfIoBjKfQib@|OpJtGlHuFlRgOtQ{Ozu@cGjBaDvJ{GjDqOkOoBbEkGj[y^~dA}TrbA{l@hsAsbBb~AeZ~K{y@pm@wi@zt@bIhSlGpk@sCdHxFnq@mG~JUxJrDjClB`QrGn@~Fhx@xNve@]pLyr@pp@_H~PcFdCsH{QaF~EbE~Rqo@iBuIdNfBlNmB`DqElAqOeSoK{BDsMtBe@vDxHfHmDvJzHiH{PrAmG|HzIpb@{M"},{"id":"2018-10","name":"Paris - Villers-Cotter\xeats","strava_route_id":"13388772","distance":111467.43106883836,"elevation":1136.8861502223679,"summary_polyline":"ab_iHi`vMPm]bCkUZqn@nEqTtN{UxE_R~ByYBco@zGww@oPch@Pko@ShPdAbCgh@pCaE_CyK{PgEgSkDin@zAgX_@ki@\\\\gUtKubAWeQgNs^ySaIgJ~BeHpFiJlPwb@dJkPsCkMeNsEiQmDm{@sDk`@KcOvCwc@u@oGcEoJiAuMGm_@fCoh@Y{VqH{^}DyBuF^y_@zPsFqOcFse@fAsYiAm\\\\bCqReFug@t\\\\eJxLrCxA}LvCdBrNc@ZiFnDaIxCuFlDcB{AysA~Gim@kG`@}PeHoCwKVi_@`IkBhAsEkFylAVu[oCeZtEwg@lCaAhTrH~Aa\\\\m@kKl@ms@zEy|@kBiKeJkAiGiHyFcWmYpGuWmJgBcGcG~DcSxD{GrN_LkKaJwTkLtCo@cDgUtINyaAcE{v@}CyWq@m[cGu\\\\w@sn@t@uc@sGegAOi[wDaXcHiKvE}EvFqNmMsXkNcSfEah@_[qv@EwGhJyXyGyCsBkDlCoEkEkDcDjAeB{BcByLcJsDuCpBHnE~CtGXtEkBrMcEfFiHaDy\\\\aAZ{HyA{CwNkJEwI{DsEkJab@cKhJeGc@sPvHmk@xF{GoAss@~Oed@cGkXp@iAsBm@mYeBsGmC|Dj@lF}OvDyEzEuGxMcD`OiAzPH|bAbBtHmB~G`@lBtJxEkElSaInCiGzO}GpDaNVg\\\\xO_g@`H{LnLwYpB}l@k|A}@cTmGDuOhIyK_Kyf@{OgOiRcWm@eDcEaBaJ|BgFlMsFyDmMwCwYfAoc@mBy^hD}r@UmY}B_NwEcJcPiKoJeQwZm\\\\dEeo@{Eir@`AuSiK{XbB}KuCs_@kRi^oDuUyKs[`H_IrMq|@Pef@bE_VxEmLkEiGaCwM_FwK{OeVkjAkWyPgJ_WqYuHgS~IoScVyC}RwKwv@}IqKeEyHuKoK_IuPob@w^or@i]of@sMoI{KZqSgE}MeL~AgUeAcRiGuf@}L}a@w`As|@}AcJyIRdBtXc[hBg]qi@gYvJeh@df@aF~MgKxE]`_@oR{LuHkd@kZkt@{IaOM_W~@sHsBi@iSlYsRtMkEbMoCMaCtC{IuFkHnD_JxW_FvB{GfZgBl@gI_FgQ~Kac@yWsOKgGgHcPnAmw@wJsM_O_\\\\sQkLo^oHiEkJeP_L}JoRbDc\\\\eCcHqEuMmUaHaCgAiWgO_H{VhD{`@uJaRiJHwIlKqc@kAmuF{hAe`GsNuu@mN_`@cfA|a@aVxmAeMxWoK~e@uC|FwHiPmA~T_AnCaEkIYjA_@nStEhC|DcIzJzHnEeIwBcE"},{"id":"2018-11","name":"Paris - Feucherolles - Paris","strava_route_id":"15867794","distance":72545.94617464495,"elevation":1132.023290746467,"summary_polyline":"ofiiHko~L~D~LmB`JtFtSxMbV`AxQfC`H_BrEtBlDxCfRtKdWxBpWzXf[xa@|E`Crk@gBl[{EhQsObYcH_AiBxNcMx]aLpm@`@fFlBrEpOhOvKhDvCzJtLnH|EfSnDjC|dAoSmBxPmBxj@eJxa@gLvz@PpC~GjE}AzIrVtXuH`cA`J~I?p}BcObWp@pMoGh@NjGeMeI_GP}FbJaa@M|EfCPdC|F?hBr^kEsJsDrGNrJlCbMmGfYeHth@oI|O}AnJX~BnLlFFrC}Qfm@dBtH{KdJsF\\\\vAdEwDfIhA~JgOtRsHo@gDhe@jBzGpFd@mDhIgAbLfOxg@aIzNxAtH{B~AlJ`TpBxQ@hN}El]xBz^tF|A`@bIjEISfGrH~f@y@fPoMtXrX~h@s@lL}Jj`@_T`b@uJdp@qG|RoFlZaCxC{D`RqGfHmAjUmH|j@xBtFnBz[lEbHlIiAdBzLaAdJ`IvH~JlCpDl`@lYrlAvAyPfUo}@~E}J~SlJxMyC^{FkE_x@xK}`@fOuHq@kMjJkXlTeV~GuPrIog@rHiPnTwZzM~A`KoK`@sKeD{CHkM}FwRW__@gDyYs@ua@PkGpMic@ByCgAkF_c@or@qPgLi@{CqCw@eLgOyLgYod@mAjByxBqn@w@cSmRyBcRmF_OdAyDpFBpAyEiMij@lEu@zKeJeBuHiHcHoBcRXmRrIsN{BqDxFqI~Bi_@kHwPN_PqCwO|Cce@~JaKjUGw@qBqE{@JkBh`@l@|FcJ~FQdMdIOkGdFNz@}BaBePRgXbD_A|AcKoRu]f@kHqQ_Y}WuOsTt@{HcAcIeGtH{]mZgXyGyUpKmHmLw`@rLktA_U{l@fBiIKmLcEeUfBaVpC|BlGeKtBqJlCjBuEoKYwFtKqo@nLu[|BeRecA}x@M_GfDwLOmKwOi}@gE_e@`SiGzHiL`GaCl@eCu@iC}CLuOqQiH}UgVke@lGqc@hF~FbC~G"},{"id":"2019-01","name":"Paris - Compi\xe8gne","strava_route_id":"13388990","distance":113382.53823762525,"elevation":927.9938701070852,"summary_polyline":"uzliHghwMrBp_@m@vMvGTU|CmLWrBmARuOi@aLsE{@sAonAsx@q|Gt@wAyYieC{HwTgvBsbCuEiJcg@}`DlAw@eXmiBuCaAqEwP_\\\\izBkU{rAmAP{@wNvH_l@X}Lq@oHeG_QaBkOgWkqGk@gEqER|@mOsDeIkJkCmCmIsIX}NwEKmE|CmGRaIwCeWiTyp@j@}XvFmFl@a^cp@zDmRvFwc@rAuRvOqOeBk`@sc@sf@qVqBA}BjOso@nIwBi^kOuPaH_XQ_h@sEyk@@}r@fBoRq^cQaVuOyGgIiEy\\\\ZeKqHrFcCpGgNXeM|ZuF|AqElKuKrIuG_S{@_M\\\\sEvBz@~BmMh@g`@aXiW{GiUeEv@s@sDqW{IoF}YcDuH_BlI@`YsA`NyMzd@aEj^yEddARfK_f@}GcIaEqAkXsKkJ{NgFaYGyF|C{\\\\zAsZgH{NNyHpIOcEeE_EiF_OgMcRwE_S_H_FqDnMiGyGaGb@cBaE_LfOqQ?uKhLgM|Uef@z[kXvXyLvC}MfKw]hG}GgQiBLqEeJ}QJyEua@sUeh@sYwe@o[aX}c@gOyHkHsIaU_ZcNcJyHeJaPoScv@kL~EiROqWtDqImGcAgIkAc@kErH_s@vNa@nPoI[}~@tMsDyAuAaFkFmEaSqCu\\\\iUqKxH_CvJ{EeBj@tR|Ihh@mBtWwk@}AqbAfAiQ_NqRqI@sg@gPku@uCwAuBeNkBgDgE_f@mEoTC_LqVqMsGh@yVwT_YaI{Gqm@sEjB{Iu]mIco@aHwYgh@s`@Cqo@eDuCaHY{AyDd@iBvDr@xIoCIaOePnB_^`PuYfUyf@_CpGod@BeBaB]}AwNiEqA{DaKmIuH}G}LyYmPoDqIcMiLqMnA}M{AaFoF{OgFuLuY{R}I}[_DwJpGgdA}_@OeDnCqHcC_JgGcK}Jk^cIvNwW|EeWwyAaLqJu@wFbAuClLqFrBcF}DeW_NkW@uOxBsIjTcSt@oGyNibAgFaqAeOwuABmMzAsHD}i@xAg_@uBmH_E_BwJiQaFhDyA`MkGvD_JzN}MxLuEdJeO|LyX?eGzB_MnNaIvDkc@aKaG`@cLlOuNp`@eVtsA}Lr^eQhSgIrQcB`J{Bzr@jM|DbKkNeD~m@yM|s@aFjpAYn`@`B~Ll@b[{@xS_Vzp@aa@|zBkBzv@sa@vk@]nc@t@bBcVzXbBzCUtChA~CjDxEwFnHiLrEgEiOTaEoAaF}AjAoEaSiDyHyCmA}I`KdRfg@gDlDmEgIgB`C"},{"id":"2019-02","name":"Paris - Vernon","strava_route_id":"13392397","distance":128077.8804259882,"elevation":1665.7435303358686,"summary_polyline":"eeiiHel~LtCxIwJb`@kRgIiAxGepAtdAmLM}GoPoTiy@ax@ytBiAyLaAUc\\\\wfBiMcj@aGjIcD{GqbA{~@cNcF_OSqd@pPwHjIoFnLuV|wAoHvo@yBba@m^cH{JoJig@hi@qJrPcTs[{BrFqHhDeJoH}CGsHnRsFlAmGpRiEcAgBhLa@~R}A`C|@jCqAfN}ArDy\\\\`XsDfJmFnDoGlK_MhD{IyA_JpUea@uN{SkTePqIsAwEyWcEiQpfAuF{VkNoR}OlToGnSyPhSyBlGaMr}@kY~k@o[q\\\\}J__@oDiG}BUgHtEeMYs[oHoF|@oW}_@gXcDuo@xKm_A|bAmZjUhFjMjJlIpDnc@jHx_@s@lDyG`EiKzj@hIh_@oCzLSfUbFv^}F|YsN~J}GkAZ|HcRw@iJtT{HbG^nCjGrC_@rTc]gE{HfKmGxAkB`Dc@xHwH`G_NhSaBlIkJdRiM|IoL_CwOtWmMjMiZ_AaJpC{SaQkDG_NxZmKvN`@jK_BzJqHxHwFv@cCxLmJvBiKy@sPpJwG|N}Jh_@c@lZrE`JrCtQrCb@bD~HbGdUt@|SjKtZBjD{Ojx@aCbh@sFdFeEwBgDhFgBm@oLvScCrZwBdIg@zPpA|MtH`LaCvFaEEaFnKeEhp@j@xQqJqC^`LsAvFmCpBeKmDcL`CgP~IyFvPfEfRjCbDeIpUsBjM_@z]wDvR{G|KsHfs@bAtRyA~KpE`OhMnu@bJzRVbNnG~f@pAlWsAnNoCfG`AlASzFeIbJ}BdGkCsCkB~@gBvJsI|MsElB{GiD{F~CiEvIaNtCJxR_BdJlAlQO`]gBbJExSuEdO?vFiCtHoNrDu_@l|@kE~Q}Ydk@nGbQoBlRcByJwJoIqAfCdB|Jq@`E_[hV{f@pT}IhNaG~RgHhb@t@x@{b@`f@ke@lQeb@~XiKNwa@dO|@jo@dB`QoB|j@RveApBb\\\\fD~Q|Ctn@uAvAjBJpGnLzAbHmEp]wHbGeJpSoS~pAyIdY{C|Bcb@bBwMfJia@dQ_IpG{BzFoNc@sDtC_ExLmC`TkDdHFxReF~KoLhn@sPsN_IrIoM_ZeFnIwAjHQ|JdBvSaAtHac@nQkf@il@pCvr@kDv_@m@|v@im@xVeK|ApGta@lKoCjHhGbU}QhV}IlI|b@jLqIfHZzQlHnRp@|H|MvBsLlH{@hGfBfAhAvAlMxIhKbWdPnG~P~NfKdVf]lFzA`TgCrDjEuIpo@sG~WcEbk@wClBo@rC}CC{AvFx@hIeAla@tGfn@wHv^SpRjSxA|g@bSzS~BrIzEfVhWrYhe@f\\\\f^dN`\\\\vHfHnVtc@rBdIzw@hMhWxPzi@|O~LmC`YqNfMuI`DuKve@lDrQoDxEfHdSdGyA|XWnn@_B`Ek@~NcDlS_EtK`HlCgBdDm@|j@~DnPRnIk@~WoC~SbBzWvE`YfP`XzEnMNn\\\\xAzQfNzYv@dG|OlEtVbTbF`Kpa@nRjg@tAve@iMwBj^b@nVjE|SrIlMdFtb@nEjF`@vGzg@`fAfMCnSfLnB`ElCrUjMjVhGr`@zP~j@~Ipw@Pxn@bK~g@ZpJxMn\\\\tNbL}ArP{ElSpH|c@eAff@~Ur_@rCeGlGpPhAmGpChE_F|IbCtFuAdGpEtL"},{"id":"2019-03","name":"Paris - Chamarande","strava_route_id":"16851141","distance":131660.67172479277,"elevation":1492.6086512293125,"summary_polyline":"ib_iHayrLzGbGnEyKrJwDtI_Ia@aq@lB_SlBj@lF_L`ItIz_@`vAy@dD}JbFpI[hBd]`{@tx@jBc@fIaMq@`PeBnF{F}CgCpf@gHdYoBhAkF`a@iE|O~BhHjVnI^fWdBmVByUzFmIxUyPjKxa@sP`{ArE~KrKfG|K{L~MxCnO{@|X`n@zFMj@kJlCiEQlNqE`K@`HxHw@rK_LnFz@fJeK|IR`CiFzWjNbOfPgAnp@zDsAtBhEWtLiGtSm@~\\\\xJnOaEnSJlS_ErLrWn\\\\tInTUn`@yCg@mAtBdb@xVbg@dGnInNhEqClCbA~BjJaEfIOjf@rZbe@lEz]hPzQjGlMvPl@ZsInLhDtIcIbGIbJkHlIrCzCfVrDrE`q@`XhSbErIeAlCzIk@dNr@jMdBtFfMrOIjHrB|FkEnAs@hJrEx|@sGdqAt@fw@zOQtFlHlM|BhL~SbE~@lG~HjEvM~KbQvAzI~DdIdFjCjPPdGhQzHlIzC[|DzCdK~^y@|SkFnb@r^ru@zE|YhKz\\\\dAne@dFhV~[jRlJrB~[xWn_@zGnLaBrLfDfOqHfVgEhCuCxChCfOtBfFqMxPeFdJqf@dNiVpFgRr@a_@bBmKnCaB`Y~PzWyNlI}K~IzUxJ|ItBnGtTn\\\\|GlE|BrInJsCzOuWpE}Qhe@}cAtF{[uKkJtHyRcF{Gx[s]zJ{@dTmQzC|AnXeLn]}`@vk@qg@vGeNpTeOlEsInAeHiAwG[cYjFu`@nKMfG{CDyNuBmRyEoRq@aTpDI~M_[MoJhBw@tHjIRiLaAsHrEwGnXfPza@yBfp@q[fAcI|DqEYiDtAlCmBhGRtBvAa@`B_G~BrCt@kAsAmEp@iHo@sDnRuIvZl@pDbFuAd@AjNlGbMhHl[|LhP`H|DbV~[|VfJjF`Rjp@oElW~AvMeJjFo\\\\pAw@~VfZdP~FxGvE`CtHlGfAfHfSrKhQjStDvXnZbI`Clg@qDho@k^zd@e^tBaG\\\\eJwBuDViBdCfDxW`HrFcLdAEjK|WfDmARtG`B^rPwf@fDKdNiNxGbAd]}LzFoNzJ_f@zEqBdG~EpKhXbG~CsAdIdArD~XjHxIrKpBfJhAb[vQdd@dLrLrY|OnEtHvDvQ`GhHpJzDlIlXpKnPbFxCdOkF~El@fEjEjKtZvQqB|F~K|OdMx@fCtRwJtDvBt@_HmBkHlEbDfIeFnIiTvUweAfLsy@cBeRgGkKoBeIfCyVaAiEo@|Dn@}D}AsOHkWzI_KRu[zJ_^o@yGhFeO`ByXfDmLrMiDpSdIjHuPmEs[cHsUmC_SpFcd@~GsQwA{SbAwWs@aVzByOaHmZiHoPt@gB`IdFpB}P{BsFx@uZ|GkJvUeFlG{Kf@eJrEaArC}Td\\\\rC~TiNqA{Jb@kInVaHbEoNe@gFwH|AeOsRuMgl@i@qFv@yNuDoy@uJsf@iE{v@qGoc@iNm[qMcfAOaFrCoPXm~@tJis@aAkV_I{g@eEugAgd@cDab@`TuMrCsh@~Aan@~K}eAmLe[jGgHkBeCeF}EwBaQ}WcWaz@sHeNwWqXoQyBeYpBmH_Fi]aAsDdVnFdq@iB~Yl@`O_Gz@uEdJOfJiGnAkBxPsMrU_KvDkMCc\\\\wGs_@lEaFq@mE{KkDyCgFnToThNap@fPmYrMaSwH]fIxBdREnUgAVwBaDqB_JeE}FmJdIqGzKcEhX_b@~gAcOlUmXyNaMeBah@zCmQf`@iPfg@qHlHcQgRyF{Xr@iG"},{"id":"2019-04","name":"Paris - Ch\xe2teau-Thierry","strava_route_id":"15889409","distance":155468.30273930452,"elevation":1408.8797547591118,"summary_polyline":"ab_iHi`vMhDoaBvEmVnU{h@bC}iAvGgw@fMeXfVp`@vXin@_A_IzHwJzh@uMzDqw@j[mn@o@qq@dCsNmNyFqLcTdn@swBrPzHi_@wt@dB_Txb@jJpCxHv\\\\ePsA}FfOyH~Kv@}Cc[dDgMqFeS~LyMcB_FpJcKtVbDvCtHnFN|M`k@xOnXjFcTtEmx@bScGwAqTbR}UrcA^lH`FbCi]xUuHtAcPrQzCvYcUpCmN~V}DppBx|Ab[~f@zD~]|z@{oAbVnEzWkNv]`E`KeHvRpXx^p@_EoQjHyDbJQAfDzJnFo@iLxLoWhG_g@|FarAjIop@xAkeA~Heh@nBoi@xLau@`_@}c@uQuR`B_MiGwKvV_{@zOocB`@kc@kEmt@iFgJeD{v@oGuKgOst@k^aBg_A~T_d@mKHub@wRmeAcp@sy@ws@a`BkPwRlDm_@mQsjAbFem@eAeMvCcKzMwMlcAo_@d]g_AlEu^vHkGs@_m@dEef@~]ccAkEgC{Dyd@ga@cn@bFyJ~GjChRkFfV{\\\\`[_Cc@}JtJ}i@rFmBdX_gAvQs^hRbBpDyHtSuChIpCpJtXhSgU{Pw}@wCwzAcHea@yR}h@c`@n^eIdAYib@iLifA_FcRkKkNmJ{h@{HCaF_\\\\oi@sJ@qXaGcRcC_o@wOcb@iUuGmLpYeBeZmPwi@J{VjLsCe]vT~F_KkWq{AjFc^`Csw@eJ}y@uMw[{P_@{WvQ}z@}y@{Rof@oIma@{PqVmhA}CUmIcHoHyJy@f@gr@fIqr@dBok@kSdEy`BgNhU}gAJieAdC}[p_@ytBlBor@_Eym@bAwNgZ_Za_@yO{Xke@m^aQwMqQaFkVyTpHaX{e@gUuOd@oN}DcKoLeCkEaKaOrNsTpBsFtIyPmCR`Wgl@pAki@pOwEaUxB}ZqHi^mXq@gPeIaXbCsAaS}H{EjBoJ`\\\\ia@`Cwy@gy@cn@kC{JaXkRi]lBqGyG}a@ey@_a@ocBiFqIgQsGe@yKqIe@yh@sg@i_Agb@cNaRgQqJgTuH}ZtT}\\\\wuAsTjkAw_@~FlFig@y]hLbIiXyDkQod@mGyNpN{Y~Aqk@{Sw^cZaPe[cJmd@sJgQ|B_[sFeL|A}G_E_IiH_yABs}@bDu[iXqn@`BoQsS_dAiEsf@j@g^iQhUyNna@qZjS{HfK}@zJgz@x^ic@sD}MrM{@xIaLie@ix@kkBwVmYqi@_[_JmS{E\\\\bCqKs@s^{Y_Hyg@dIyE`Ed@xD}Z~B}`@bkA_@dc@zFpi@wDoDgh@dIy]kOoKqUeCot@}RyYZkOqKgf@vFg]eA{G{b@o]ym@miAkIohAmEjBH`HkElFcH_DoFuYW{FjE}BnMhDlGvRrDuA`AjG`HqK`JcBPsUjHqD"},{"id":"2019-05","name":"Paris - Rouen","strava_route_id":"17875054","distance":169350.58768539494,"elevation":1793.0138422206771,"summary_polyline":"kciiHkg~LzA~DuHj]{IkAiRyHm`@au@{oA~fAw{@_~Bso@waDwFzHqoAqkAuQsC{XjGuV~PyKdVySppAiLzqAw^cHqJoJor@xy@aDuDz@fDyZzl@aN}EaMpPoZiBqEzWy]fYgS`[_MhDgQkEaE|Ww^oMug@ue@kn@cOyOtb@gn@jcA{NlbAkY~k@o[q\\\\oQmg@_NpEmn@yGqXs`@qGi@cK`z@p@rRtDhEnEvWaR`EuJ}FfAv[}NzbA}MGgLrNcK|CqFtXk@rf@ue@dlAoFqCuAzLsN~J}GkAZ|HcRy@iQ|[q`@sGqKh]m@~GtCbIgCbMmWxZyOn_@yKbHaLgCk^ff@ke@pAkYqQcZ~i@cA`XiPpJkI}MfB_Iw[uDeIoH{T`HmChc@iMp^wV~\\\\qNh]mQ~BqRpPaRPiCnDI`MkQjWqN{CaGrI}U_FaXrCqZjRaXxhA{HvObGpZVfTaDd@kCbQc@vY~CdL}A|Kmb@`x@}Dx`@iMle@uDx`@tFbFx@~U_GxIkBh]gFrSkGpFsB^sGgOwIhh@k^nP{IjNsNgFyEndA{Tjo@xA`PqIpeAcYp]oHjk@mLnRgGz^z@nhA_Hn\\\\~AlZoExKtDpZqCdo@xKf\\\\MxSzD`LeUpx@jChR~HtlF{AtqBxGbo@fAlq@xM~UmEp]}St[oS~pAyIdY{ZhDzMhYbD`V~Mr]~Kp|@bSbe@vIfo@`HtnAcClMbB|\\\\iLpn@{JrCwJtXmR`LaN~QcQrf@aPvCiRphAcEbk@aMtNKvk@tGfn@mGbX}@dYbsAzZ|^f]ly@dhAlp@rpAvOlL@`JoXpj@xb@xInNxe@_Kb}@sQj}@q@|u@jDnOpHdGdA|JiF`c@{CbeAxDfn@eLp^o\\\\lgB~@bn@`EjJuPr^hAjB{EjVyPh_@Pt]gUvhAo`@zt@jKl[`DvgA`Qhv@jIqBsG~FvJvz@ZvgAuCvJiWwC_HkQoKsHog@wGwEwJiE^tBaNgTwLgFpDeEnRiY{@cKl`@}d@eJqNbMiMi@`@~Mkh@vEoI{DoXnQ}]dGwWgGgT|o@cEhb@iMjg@dDvEdG|{@gVzOrE`\\\\eU|QpFdJkVnpByKf\\\\qFrc@iMnNx@pIwLbFld@nu@jEh|@t_@d~@{PtLmX{e@wRqKuLc[aL{@ma@|`@yFxToh@jRgHtNkLzCsOxb@oa@vj@}Qrk@gJnj@yLnQkDh]_ZgAkGnc@q_@t[_Dbm@cCjB}X}c@b[liAge@~SdQdm@f^vh@n`@voBvNpCtCrRoClj@hCpS}OdDoDgU}GxKiIiCxLfXwEbHzArIiIxOt@mVgI_YgeAyTch@~x@wStTgLxDct@~hBip@dc@cY|a@gVzAiBaTwGaHcOfX}DyB{Lt_A|BhOErl@aApDkG{A_Hja@iEvs@yO_GqKz\\\\k^|bCo@hLlC~CwRld@zF~KeSjoAu_AfdAoHb`@mRvUyD`Z_Rz]qBoSfC{GgBaLjB{q@uSf`BaSv~@x@jMiEhf@kGjA}CtIiBbOxDtCaBtDsP}JwHyk@uFs@"},{"id":"2019-06","name":"Paris - Laon","strava_route_id":"17569295","distance":168094.09909019497,"elevation":1694.6648236396566,"summary_polyline":"ovliHojwM_App@vGTU|CmLWrBmARuOqIm}ActAqlLqSk]eiBasBsH{R{OmeAdJwyAkC__@`Bcj@wKufAkr@nU{t@oiE{@wNpI}y@yK{j@gWkqGk@gEqER|@mOsDeIkJkCmCmIqY}DdD}WwCeWiTyp@j@}XvFmFl@a^{fB|N~EkeApB}zErUybA|Gkh@iaBsp@ui@`Gmt@gRem@lImw@mByGeDaAyPew@g|BwCu_@mXw_AqInDuCqMsNpIy_@`CiWyFiQiGcWwUqr@yIiGkE|AcKqe@}SmVr@uoAub@oNXuV`MiC}]}H{KeNkq@oXcn@s@iWocAVkOmF}EcJfH_ZMgb@tFoc@kPwOsd@gv@qDuW_~@wwA_AqOaKmAxEm^ap@iNuVma@qcAab@{Pcj@_L`GpGe^lMuUt^esAhL{U_WnAscBeRUce@{t@}{Asa@ucBuCgc@gYeiAmWy]wGtCgi@xrBcX|E{R|SnCca@kWwK_G_Twg@iu@yRqg@cpAlj@ec@mFcS~E}XwFcCdLh@lg@uAuJqS{CcEhRwBqD|@fIaGtBmFaQkX}a@ox@edAmVci@o_@y^kRzB{D{LuOeNgI}TdKih@zImqBxW{m@jWgoBrDqq@yIkm@dDk]xHpHyAi`@iQ~Wo@wKaWiYgRwQkQaGmGky@_LfGyMsGc@}IiIyLaKeFaJsQyHyAeCrKyQ~KmFhWvHrIdBxSqGmEeRrJ{OyZgRsQeKmG_X|Aw`@yi@gGub@^gRsFgQyKf@cEsMoPkOqFaYmMwKeIw\\\\kZwPya@gFiZzGya@_U_JgQmb@]mNgXwNoLmb@ZoU|R_VzGkdByQcBe]wG}VvGeSrDkd@gLgbAqRkS}TsFgMc\\\\q`@kN{Uwf@sOkIqE_MnBmLqM{QuAqLyNlF}f@{oBuOa^~@ab@oQimAzHwHsMyF_CkGcGs_AD_bAfF__AoFok@l@}Tdh@qAnW|KfSgTqCuSjFqXx`@qRzFwSbHg~@{F}v@|A}\\\\lFwIpM{EnIuTmNkOeC{NwI{GYya@}Tmj@uFdCkf@gKBiY{\\\\tMaTaTgWfCiEaXaQe[uR{gA`p@}`C_CcNwHmD@_M_N_LzCgHqc@k[wOca@cK_IqiA|KoZqO_PXrOy[g@wSqJgYrJ{qG|F_YaKh@}k@}SwQh@m]mTuUBeQsfAcBf@oRq`@_J}A~@pHmC|LoLxP?zFcNvJuPkQoTsByM_JsOpOiUk]eYqLuI}f@cV{_@dBsOeH_f@gVwh@eJo|Ae]ed@sF}\\\\i^s{@xa@_j@|Bue@eUaLiVi\\\\iMTqDe[{CxV_BmWZpJqEtJbB_MoI}O{HpFmCvb@fF`TmG}PAhKgN{T}JJ"},{"id":"2019-07","name":"Paris - Auxerre","strava_route_id":"18044268","distance":230274.40065474948,"elevation":1808.1010117298945,"summary_polyline":"ab_iHi`vMpDkcBv\\\\saAjBwfAjG_p@kPso@Iyo@xArTvPaTfTsv@|NkbBTqgAcHwE`Oyv@fS{TrWaHjj@Edq@rXi_@wt@dB_Ttg@ag@rFjIhMcDhQnIzCjL|Ia@n]nl@jI_JfKlAlb@a~@~Lc~A|HoDt@bG`SiWvbAb@lH`FbCi]xUuHtAcP`QbD`YkT~Eer@hY_MlOucAli@yC}D_bAiJqu@sh@ipAsAkYo^qAfIay@tp@obBkPeSgHq|@jx@q\\\\tk@cc@bYhg@`eA_Yb\\\\ba@z[aB`@pK|l@`QziBu{@fYk|@rTw\\\\f@}LaEmSjDcFwEiTp|@uDbL}GtDeYSiy@pJ{Gzj@eIj}@wx@fHmY`IlDfqCeaB~]gv@pLmG|Oef@_QgtA~@yOnSdFdLmLtEpAny@q[t[lGFnIuD|H~V`pCyC|b@bNlcAfReM`MIdC{X~LoUtNym@|[oy@dZw\\\\nQMvM~Wx|@r`@D~V`D|B|CtXld@hWpRlg@|dAp`Bp^tTxZxt@hHd[zp@hi@kIj]vBtQpO}GbbAxSvb@ysApUk_@dMeHn{@ytBp@}q@hEoq@tDEN_KqKyMX{KgHuQ|AiKpWnMrD|Mf_@na@~ZjTx]tKf]FlCpEq@oW`HqWpZFfDtFhg@uLrLoOxMcm@wAqv@{OosAnAmXzF_SbWyYpVwHfBkFpz@nAzNqFfSaW{B{QvFwGnQt[z[qm@sBeDlHoFhSgn@~_@oCvG_a@d\\\\}JjYzNlJqEv\\\\pVnPzAhExIg@jIji@rD|YpOz}@eAjTqYfLfS~XxNrv@nC`s@mz@nSeHjNh\\\\jo@jOz`@lYxr@tWxr@|K|^gFlWaRv^_qAfa@mbEbNce@hRiXzT}j@vF}zAdHa_@wAar@xT_cAd@ibAh_@st@bJqe@x`AiJd`@_OtVxDpf@}XlTjA`@mTrNqMdDsOpHoJfp@kQbZ}fAloAkXkC_k@`UcD`mAhHrbAuk@lk@X|FkOdb@}Ypx@mb@n_@{HvZ_]~QcAdi@sc@v`@aB{[q`@ge@g{@wPqMki@aJyK}MqHqPiDwcAjKykAnGqPXwSjBC~@cKuIebAhFqKtI{hArj@uvArv@cs@zFyg@hFoHgE}Kv\\\\gdA`RwZ~g@gRgD}RjFiq@tJcSbKgl@sK_ZXqPeK{t@wQ_Ml@mM{D_SbGws@bEyHnFy`@cCuu@xDm`@{Eo@gGfH}LgR{Iy\\\\aGeFoCwa@ca@ih@aKab@aEap@uDaKbJoa@|H{JsCsQjUgMjZwfA`De]rTyPtOn@yOgNjFmg@aWqDuAwRcJ}JzYiNkBgf@hBgRoNko@rRw`@^iSfMyZvHgi@mAyyAd[cyEdV}z@vY{i@~b@ipAdSc`AqEuRtUuRnj@f`@ra@iFnUpQ~c@cB~`@rStd@~F`sA~aBrvAxj@tNfbAhLv`@hRvQbCYV}K_Gi_AlF}HzEBfH_g@`QjI_F~^nZ`I|PcCjB}PjAjQdCc@zcA{g@hf@fNRcEd]lPhGrLpu@tZlL|Sx_@`Hzi@fiBxD`IpU~IbBawBvHmx@nGyV}Deq@`d@oxCqQwe@x@yUcLosBjOkw@J{XzPm]bPgNfXsrAi@}NjCcJqIoHvB{HkEw[zF_]bWvMnEiRtQqDnHcKb~@mSxQuK}@yRdPs@f^gd@gHcx@aNkUzA_PiBgp@~X{Kb[ej@hJ_Fxo@nLx`@qRxA|YpCi@cByZdF}FpIc]zGwo@pIaLzD~NrKaBpErMxqAlR~p@[fb@aWreApYrBaIdLlCzKiN`^cBhNna@mD`GbDvDvDmCxFoYoLcHnHiQqBoGhJ}_@mMgJkPc@"},{"id":"2019-07-bis","name":"Auxerre - Nevers","strava_route_id":"19367022","distance":166074.4831109683,"elevation":2022.5098361799478,"summary_polyline":"spubHoszTyIaLva@ov@xQ}L\\\\{KxYaz@nHoKtDrB|MqRtGi@~eAhXpTfn@xWzTjPbY_ErNzr@rUpX}Ijn@md@x`@ah@rVlHbX{UrM{XdEjPfZvZfz@|eBn[o@`Mnb@dHwDbIiSzIqElr@gBvR_Hz@kPrKeNlKtAbD|Gxe@yGlnAhLji@yLjCcMnJ`ExZeZ|aAuKlc@x\\\\~YhHjH}BnDoLpQ_BnHkQvUaHbZs_@pLlHrT{Dx[pK|_@b@oGyyAaMyw@}H_UGwNjFaV}CoGTsXtLbInJtXfZfFlMcL`YaHbWeZvH`_@zcAbYVxVdCrFgBkIjDqTyDoQ`Nwh@_SXlDkq@~DuLzOqEtJ`FnGnMdSryAfKtL|a@~@jq@{Yx`@bQhQkDbHig@gLiRbBsq@{B}R{EyCfC{FyAkYfEgu@vHqXCeLvJqLfBuSrFi@pAoLvGk@x@cn@tLih@hbB|I|^wGrSc^hEqUCawBnFwZrMcTY{HxGqSrx@whBvg@bIxrAzkAcD_L_KoJX}G~MxYcAxKvJ|CPtH_QhRjFfdA_ClKzP~X_LzVwXb]wYf{BuMt`@sRfhA{`@`m@kFjYbJrIlBx[yA|_@gLjFhXhRpJlPpBdj@wAhWhDb`@b~@`iETv|AfExt@gDbk@tF~h@l^ju@dMnA}Bfa@bHjSjSvOoPny@}OrOmGnRbPq@~BtHlStLlOtl@zKrRnI|ApReHx[tc@t]oDtJpHdPhd@bJsUhMcFtn@hZr[dGtXcLhLcNt[iHzf@tZvm@e_@hZeJzKlHl`Bs@~l@dp@n]s@hr@p\\\\|Y|[dSyAzL}Wre@d[jb@rLfInR~OrFt_@ia@nH{[vh@oZrJ|A~a@nn@bSdIn}@gLf_@qb@bNq@`d@jnAd^|DpQbRzi@~T~ObgA|PtW`P?xc@jWli@xr@f`@t@fq@zh@rg@lTjE_I|BrAd@dThRpz@Abg@`Gvb@lSh[nQvE~ThXfRhJvCiF`k@oKrfAvh@jSrQje@qHxIn[fHlIr\\\\xEdHeGb_@tYtSnc@h[uNfIbXbQjWh_@z^fNVkIreApW|h@rRkAvXl[~]~~@~D~ZwCvf@lo@nH|O`L|SpBdNjNlT_@{Clb@~GpK}Gt{@WdjAfBnGpd@rV`F~`@pRxRvHxWpMxLjTth@`g@tOjE{u@dHgNhLmm@}AuOlZid@l_A}cC`HoCfc@zUbc@xb@pz@eBru@ri@tHnhBcQr^u@z`@cO`h@mChZdAd_@dKru@pSbl@lGdd@r@|WsCdWjLn[dQ{TvJ{Ytl@h@z@fOjPtd@tSbK`i@|{@gErJo@hWiE_@oBlVzAbPzIoC|UxbAlSfi@rDrBmL|`@y\\\\jCmOzw@|G@yLjMyOnh@jZhE~AoLjn@sFbE{FSak@fTh@tBeA_@qFvIkCbT||@"},{"id":"2019-08","name":"Paris - Bernay","strava_route_id":"20060695","distance":171327.9975176814,"elevation":1498.5692578936669,"summary_polyline":"kciiHkg~LzA~DmB`JkMl]IxMfDxBuE~t@dIjFtRvwAuLdx@kS~b@oArw@no@ll@~AeFxRzHdDjKvn@~i@|EfSb[t]hTfJxK|VcQdiApH|I}AzIrVtXuH`cA`J~I?b}@gJpQSxZqCdKlAli@aHlBNjGoDuApO~WqEjQjD`JcFdJ{XkA{JxOqPzx@w`@rtAiFyA}CuIeEfU~BvJwC`CnNbh@wA|GkHrChJ|b@rV`T`k@BoC|rCoYlo@sErVwOvQi^fx@dJhQ}BtJsDrAsa@x~@o_@x\\\\mT~_CwKzf@tDfZmCpMqL_Byz@hrD}b@faApUjQpGzUdLhF|A~VlGi@pBtH``@d`@jZhQlx@~H`_@nk@xCpXS~`@gTtuA{Zhg@vHlUqDra@kOzLeP~i@gRxRrIdW^jhAfLr{AmPzf@zKhN`AvIzMgH|d@uCjZ~RjRxe@oVpZqNv|@bS`SpFjTsHhPae@vP_Dhp@uv@`oB_Xdf@cAvl@cIhWyN`LnA~MoaAxUo\\\\f\\\\{^wAHtLnNb\\\\sW~a@mc@bjAuKheAcTdw@bV`HlI~X^rMzF|Go@jTiNzc@_Cx\\\\rEtBU~F`f@`k@x]tUbMxSrz@`V`OrY{B~\\\\|DbC`I~q@QbaA`OxcAwAzXzPpW~Mbc@`PhJ_Dr|@lDvh@{Jv@oNls@iWt_@mLvc@cGheAsOzWkLp`@ei@n_A}Lx@uShp@eJqBwObN{DrNkIh{AcHnGsX_P{PtM}I]i[rXcOmCmS{Sk]_AkNl[uHr@uEzUyL}M{EpMuY`XmRd[wN`g@eb@tk@mP|w@~b@v~A}CtWlZpbBfEv|@yi@tLb@~zAfEbF~BnYcK|TcOxB_FnKh@n[fHzKgHzm@kFtIjJxYuCd^@xm@|Ctd@`HdI|BbXfLbPy@bJ}Nty@kNjWyLzq@gYb\\\\fEzgAyC~cAkPxa@eWhmAnWn^fi@hxBrc@zbAbJ`d@rE^tExVkFrJhBvK}CdQlE~IaMxVzBjK_Fdp@nO~aADzWlI|TiP`KjBbXoFzh@|AjLpTn^~Sjy@rLjMuCvj@dC~UiI|ZzB|SfI`S{z@pdAm[dpB_d@|`AmuAnyDeMrMoBpb@kJhTnD|NyEnKlf@hv@hT`y@SpYoEfGhFnNShYmK|k@xIhcBxR|r@{QtoAlFh^pG`KlEfr@cEx]Z~d@}BfHdCx[iFz_@lAjZsGf}@q@fq@mKtTmNxk@oCnpB}Qnn@}Zvr@eE|@]xEwLeB{Mlw@]n\\\\kPf@iFfWuOl@_r@jr@kHoMoh@p\\\\}z@zScSxXmTf@uPpe@_SbJsQtZuTbG{Sph@qf@`o@id@naAuv@nQaOpn@hGvu@oMrYdEiEbEhFqDeCgq@tlAoDpRiFmBcyA~wAwNdWcAbl@|Qje@zMhOlGvd@rk@bnA|Q`SfDrX`Qjc@hBrQs@jw@vEh{@gHro@Ot^_Hrq@k_@vh@dKduBhQrd@hHt^dLBb@rDGrXqFzBgAfSa@eK"},{"id":"2019-09","name":"Paris - Houdan","strava_route_id":"19838388","distance":146830.4028479677,"elevation":1610.198103175605,"summary_polyline":"kciiHkg~LzA~DcIb^iOaZaUp{Ag\\\\vv@{N}c@o{AhyAiItaBqGoA}EyFoGbB~B`Z{RdLuOrSoPbc@rB`M}Xtc@Y|GcOfKgSz[_l@vm@uf@twBiMnc@wPpb@_BB_P}Pqc@m]c`@cNuZ_AcV`E{r@`a@{L`MoU`a@cLd]}Ivx@oPxt@uAlYnAzk@[jXeAzJgEfMoAbVbEl~@gBt`@lB|bBxFr^d@~MlJxj@FxIwJf]fBkKyCk@gf@lCkB|WkTnf@kJhC_v@hc@eGkDCbJsW~f@qJtEyHtQeSpJuYz]mErKyQfCw[_E}J}UaWw[EsEoF{OyAxPrEb[wKlMrGvPo@nWoTzc@yCtAb@pFqCli@dXdb@cCfQd@jDrPzHbO`PXdRjEbRk@~LhAzq@aAxXhBpRaE~OoTtL{M~[}AbRwClLuM~W_Hpa@h@lEmB^kDtJgDoAgDnGsBnLkGnI_M~ZwK|c@uFzFHxPgQmAgFfFqZvv@wCrBqCc@wVw[sZqMwHkAoFfPsB\\\\yC_`@ePeOq_@{j@mH{EwKyNiP_p@}F{^cM}^rAyL]_FoFm@iFxDwDqH_s@|QuHfLkX|r@iPxNwF~SkHgMgGvCkLmK_FfAcRqFaKtIaDlLqa@lZqD|LqCfDuUa@aHbC_F_CiEfEaGYeGyCoEoMgCeCwK[qATu@dHeKhQiM|AiDbG_FkA]pK_Gr[|AlQsBrq@lGpRvIhh@bDf_@R`h@rE`y@|PzXtGkF`B`ELzFcAfRvA`}@}Cta@{Odp@yDbG{OpLrDzFvBvLqBr\\\\zDzUIn`AmD`Z}Ava@hAzb@jFhw@SzSjFbKRfDwOlm@`MvWxCpMuAR\\\\bJsDlFqJjB_AEiJiU_EkFeBbDoClMaHdO\\\\xHy@vFyMf\\\\kZnfA_A~d@lAx\\\\tRdz@VnJcCbe@|^~MpMn@bKxKrSxIbRvAtH`J~KpG`LpAxCfEfDBvOtZbNuBfLzIk@w@xqAxKr[}@bNxNpRaOkAjE{FnDoAxFjArJ|DbDlMmKtM~CbSTjNhG[vMpCpMuObQiBnHDlt@oD`Wra@\\\\zl@bh@zNzGzHvKjP`NhAjEEdH|GtNjBdVeCjk@Rfl@vDt_@aC|KLrT|AzI~Cfw@fHhS|F~`@j_@zu@qFzBdMn`AiA|W|En`@fm@gk@xCInEvFxFkBXtG`CbAbBqCvCvAvCwIj@dIlACf@cExHhCx_@|^vQlZnEzCji@xbAzTzt@dt@ah@zCbMh@~b@lP|_@la@tyAjDda@dLrGzEjl@hZx`@aAvCb^ja@jLg@dUdYdZtOvVvAr@oFrE}GvF`Z~Aw@pDbFxGwGjEa@r^bYvQp\\\\|RzEj]pWfq@`o@lMjW|R|AfSkBz[|HhL_CtK`NtE{UtHs@`Oy[t\\\\jAlSzSxL?hAlCfFcAjCsGtO{M|I\\\\nQwM~XtPj@tJvAS~@kF~MjEfOtSrJnGpIgEzjAlAhK|FlYcITvDsJnIFlBnEh@bTpMnStQpLfAkBdiAlEfEvPfCr@yDrOYbLdItYdd@pLr_@hd@`fAnOkBl@hOtCl@^zJj]wUIcEdDsPe@qf@bJoEzDeK~FkF~Gea@nGeFxFcNjTk]~E}EvK{CnCuGnCm_@uFgMeE}WsCsF@yPzJoI`GoOfGyj@lYwiAnDkHz_@y[vZq`ApCe\\\\vRwm@xFgc@vI_KjF{d@dAwc@fAqG`D_BtFkUv@oMdLgn@K{LjC}JhMgXpLwMvYcGxP~CjEoDhGeb@fGeL|ByLe@{BjHyTsNfHoWaL"},{"id":"2019-10","name":"Paris - Ch\xe2teau-Landon","strava_route_id":"17370829","distance":132650.95473731917,"elevation":824.2420910446011,"summary_polyline":"ab_iHi`vMPm]`C}S\\\\_p@nEqTtN{UpFeUfBsVBco@vGgw@ba@o{@`Yy_@`OcdApEgNzNTjn@it@ze@oiC_KyLuGeClCcI`PtJeHcR}IiLKcDyJeOdB_Ttg@ag@fBFjCbIhMcDhQnIzCjLfK@lWp_@fDzJt@k]`La[jG}BrF~@hD|C`CfJtJwJjFkUxFubApCyS|HoDt@bGdReWrcA^tFnC|BlJvB~BxPP|EvB`KlR~IuFvM`Ff@gI`EgIuBeLdIm`@bI_PzPyg@bXxOnNjRtWdNjl@~f@fWrb@pEpb@dK~RoArNeH`LjDpEyB`A`BzN[lFcSd[y@xGxBlSfLhIbQrc@`J~q@i@jHv@jF{AxJ}MfN}IxB`Ft_@@`j@vMnhBvBmDzcArWx@}BnCa@hBfGzpAzUrgB_dB|XxsB|FuJhGo[fg@{@rd@}\\\\n@mMrIwT`@kVmIwx@eEsSXwd@qByDcWmEbCuKvJcNy@cEd@aLxB{EtEcAnBiGjZaDnN_IdKuMvCjDbMfD|s@xh@jEEl@cBr|@wXvCv|@sCvJoDbD@hM`d@cFxBpi@jX{@pi@fRjXbE~S}A~T~AxS}K`OqBrFwLzAIdD_a@sCiCv@gL_@{PoRijAeHsq@q@}RdAqv@dBwPdJs_@jRoTbKgGzy@nJzC}GtNtH`M\\\\~z@uTfe@`UmD`Z`FbGnHnVd@tNjQrCpJkEp@|o@wBzMRhMpBvBlAbIkAzKfIbT`LbI_@lIrGjOdN`PhUtFlEpF~KlEj[l^pFxJxX`Q|AsFhEaCpYlBxd@sDhV`HxV`A`Q_ChP|GnGVbLfIzJnAnCoA~GwLdJgUtKuIxl@f}@zMtL`PlFbDrH~B~P~E|LjKfKhTde@jEnEbSl@tBlL?zLmB|HfPzRhCvJ~LtUzHbH~WiAdFyDbKo@vEcJ|EgBnLdAnJuJ|n@xCr_@kElL`Bi@wC`g@wKj@_EoBgX`AkTdFEhEiIjAzO`EYbMzHh[pIlPgOnKiQtNqNdP@jOaNnLeEvKcKpGiRq@wGlCgLlAuWlBwKyAyOvBgOjHkHjD@tEiKdFwU~A}QnCoGdIqAr]sVfImCeBiOh@{Dh^a@|CuE|Ca@hGtAz[p]`E~Hna@rIvmAvhA~a@cGrH{MhHjKtFrBWoAbCwCzL}Fx[`DzC{MoAeYdEkFv[mJhHyH|^qx@~FmSvGaEjAwE_EkRXeItPuT~CoQrSuf@zBiR^kY}Ce\\\\PkN|ReeC~PaB`SaOf`@ou@xQ{j@pHuF~PnAzJrJpNhCl{@aMlSdEvMCvD_Jxh@_m@xh@zLbbAOt[gI`BbFtMiYvD}_@pLuo@`Def@bFaW`Yui@|Nuf@t\\\\ck@jBuLGwLvH^pSmKvBiG|@yLhSg[tGcHzRmHhd@q\\\\nu@eu@hHiOzLsJzYyc@`o@__@|FJ|KnGc@tCvM}L_AmHqD{E~@wAqE_Ny@y[eA}CF}E~GgB`DkFbAqQqHsWcOgLiCsLHeg@`Bkb@qG}PiF{DqQuAkU|GqXzT[yAhEuCaEaOo]`^aKaNoNzHyCiAqf@~YkBeCe@wFtDkF"},{"id":"2019-11","name":"Paris - Versailles - Paris","strava_route_id":"22535256","distance":60517.88419240435,"elevation":783.4448712951425,"summary_polyline":"kciiHkg~LhBdEqB`JjFlSjQvYvAlWcBlE`CbEpCrQrLxYzA|T~Z|\\\\d^`C`Dbp@oCv\\\\fNbIbPbJv\\\\sBzBnAtRmVpZ{LxGfD~n@gb@pKvVfBpN~j@gWnWbCL|BdIfInPwJnHJxDpHzTmD~ArF`ElEzB~IzDfA|GrLxEtBsBzVsOoFuE^GbHyBb@W|CiCWUpGgClHsDjBoCtG}JbFpI[hBd]vy@tw@tCCfIaMq@`PeBnF{F}CgCpf@gHdYoBhAkF`a@iE|O~BhHnY~Il@_VrF}HxUyPjKxa@sP`{ArE~KxEnEfFl@nJqL~MxCnO{@tPl\\\\nEvN`H~@|@}J~CaFp@gQnf@wr@hG{YdYmJ`Cae@jIgQfLuHnIbGhFs@`Iwe@tH_Uk@|D~ApCTnVcCjYyCp@mFdOyBnAy@jFoGc@uMx_AmCfCwIIsBtKz@hGqAtGr@bRfEjf@nA~GjAZw@bPrF~BaCde@zBdFI~HuGxVq@j\\\\zJlPaEnSJlSiHvPaLpm@RxD_FvAaI`YoD|CmIoHz@kOwDzKsBYaHwBsDqERoIuHFcL_Kkm@}IoCxOmAlYeKhMwC_DcDuUi\\\\yQuOtSuOeIgDtRmJwBuEyEgHMoI_EJaCaLeA~A_YoPcLh@_RmQor@}CsAkCvEiDq@mA{Df@sLgLaHsC}GcBwZeH_WjB}QeDmh@mAiD_TqPaMfDgA_TgHoReIiL}A{MwSzBsFyKoHbE_@sEoVuILcP}MkFtCkHn@cY`Ae@m@yZrAw\\\\qc@gEzG{QI{FiEyXcBgCyAVeCiJiEz@c@yh@eAeF`BuTsInGcJnAye@yMsEeIuAqPrAeIbHyFgkAk`AU{EzCgJN{LuGmZsM}iAyd@{SdXckB~@[fBpGxJgHrAvE"},{"id":"2020-01","name":"Paris - Mickey","strava_route_id":"22065710","distance":102457.13976411473,"elevation":825.0782029048099,"summary_polyline":"ac_iHi`vMp@m]`C}SS}a@lAqQdEgQ~K}PrF{PhDu^Bco@vGgw@fMeX_Pw\\\\yDeB_H|DNae@GbU{\\\\nDkNkDyK{PyBwIaDmWwAk_@zAgXAs_AzKqgAs@oN_Mu[iO_IcHCkOzIiJlPwb@dJkPsCgPwSwMmhBMgP`CkTHgRmFcOiAuMGm_@fCoh@Y{VsGg\\\\}FeEmf@rQsFqOkFmg@bAoSmA}`@fC{Vls@_R|Fei@hIcQxDmB_BcsAbHam@u@yAsE|AgQmHcC_KRy_@lHgB|A_EmFwmATg]kCoXhBa[xBeL~Bq@hTrH~Aa\\\\m@kKl@ms@zEy|@iAaJj@aSaDmPgLyEuc@tNwN}DSeRuBiNdA{D_AgIlDk^aA_@f@aMtDqVyEgA`AaGg@{NhGkd@bNvAvEo`@dKgd@pSiTdCk@pGoLhTqs@tF__@hUmQpb@mAzMmIdOoD~h@`Fp]}Pf]~Khz@ca@fLzAbNgBxG_JjCqKdSwTrKqDlPExHaGzMeEnEaLfi@{^vKn@pR|RbKkC~f@`AdA~GnEz@fP}YhLm^n[nGrQiW`NmMkHqQoDs@mEeFePg]mIoY{Es^aFoJuG_G{Z{hAWmCdD_E{R}b@mL_OhBop@eKwm@`Jw^vHmR|QuRbJ?vUml@kDeN}HoKc@eFvYmSzIgB}@cL|Fkd@S_|AsCaU|AcPUoUaEyANcEgCwAsaCyv@ySFm`@nMaN_EsWrIgC_DeOLoSwQgYuFa]iZ_KuCy@fV_BzGaNGcY{GiB}AOeEhC{ZqMiBrPcZxC}ObJqz@Wyk@gDo\\\\ea@yCmCsAcBsFyTfF_IjO_@tAlFfAnC|Ex[d@aRpQ{IzE}ECq@hWmDvBkB|N{RtWeBdx@_HiAYrLtBvVgBve@vBvXiA~GxGfDcFlDDtBzHXwAzGrBzf@ud@kVyi@{JaUo_@mEc`@oCgJqc@qZiDv@cBfJO`_@nDf\\\\{AhKrBzSq@~_@jF`LbM|B[pLvFb@|@jF{CfSaUt]uVlO}MzB}Vdu@cPvYuEhOoO~Z}UlLyJvP}LlHaQld@oIGgGwVcGmDcI~S{Izg@oIrUui@fdAcAxJ`EbB|@nFp]fKsSl_@sH`ZiAl@OpF{G|Rc@pGpIxr@nM`MlExUdBzB@pFhCKbFfG`G|@uJj`@lAvG`Yhq@sCx`@zQbFr[qQjFcGrHhVrChC]~ApJvNUtCfTxESvJzDzFhInEz@`CtJHi@zNxUy@rWaGzO}IbT}TwL_WIqDuB{@mDgHbHsM"},{"id":"2020-02","name":"Paris - Pontoise","strava_route_id":"22691701","distance":107596.65606347256,"elevation":1329.3111712176178,"summary_polyline":"_fiiHcn~L|D|KsI|]_l@goAg@iEyAb@IxC}_@p_@we@ii@of@c{AwP`V}]tTi[ybByN{m@wFpHygAugAmYoGy^xJaOnKsJzPuV|wAoHvo@{B~_@u^_GqJoJig@hi@{J`PySa[uCbGwGxCeJoHyCIyHzRok@xDkIxGcV{JyYnKySgUcR`p@eQl`@|@nAuO~s@}Mhd@iBnANpHaI~TkJnb@_^_JR_D}CeBq@AqB|SmBjEw@qFyBYuAkDeP?ih@j`B}p@sr@}J__@qEmG_NpE}f@wIoF|@qXm`@xScPbQynAdNyZa@kNhDoF]yTePyIsM}Pc`@rUcRHt@|QpFf[_J`@iAmAf@aJmDqXaXgTcRgEn@sn@iR}@wGzCiBuGgEsC{@}EkTxFeLnIjCxHyBnTe`@dr@_Hrk@ac@dPc@bHxA|NkC|G|ArPQzJ_FtJa@dR{CpAcHsGoEiR{EwHsFiAkDpCmAlEoDfAqRmPh@eHu@aU_P_`AsGgLg@mH~JcObKcb@rJ{PuLmP_P}Msi@opAab@n`@oWyr@|K}e@wNqBoFyN}I_r@eJgwAqX{r@yOh]eAtHwEoZih@en@kYyx@W_KrCaVjFeHaWahAlAoLmoBfCsFtvAqCjtA_H|G`@r\\\\vAdEu@lK`FlXm@dKeGK}F{GuCG_Xn`@wLba@y}@bcBaM`IuQdW}ErAo@nZzCfb@_C|~@_Ill@?|ZeGdH~J`IyH|E{AxIgKnSoI`bAbB~VgHhJhDpGyDtFlAjQ{@pHnIzMfXnsAaA~SHfx@vEbXjCft@`FlUcWzSmEvc@tDbShC_BlH~JjL~[|K~QpGtPpCvN{DnCyAtVdE|XlCtD`OpEzWvPxYpZ|Ppe@rGjGxCrNtKrP`Gn^tJnNdLrf@xC~FjTnDbSkDWbN_HpOoInGiNmDwBrGoBx@{Y}EaTrCaZjQqXxiA{HvObGpZo@`HfAdK`HfGjDfJ}@pHd@lDoF|]aH~OB`HbU|SxNfThh@dg@p`@bSlVbWpZaIlE|PYxGxCeIfP_JbLaCdKlDxEwHSmMzAXpGpBtAfKiA`IxArGlO~E|CdFtYpOlUdRbCzE~StKzDdGnNoApGpI\\\\wG~GqUhJkI|EuKtI{Hb`@ok@bZoZhh@uo@rGsOlWjE`QiJhYsHfDiGy@yHfLgG|c@aa@pKrGfJ`MxGm@bLvTbEfCdKyDtJqVhTl@zChP`EfFpY|NzWhFlEzNbGwLnAFzB|BBfElCtGb@tMlBg@nGaW"},{"id":"2020-03","name":"Paris - La Fert\xe9-sous-Jouarre","strava_route_id":"23305563","distance":125765.9748739771,"elevation":1134.333743129193,"summary_polyline":"izliHeewMfBn\\\\q@dNdGT?nCqKSvAqARuOi@aLsE{@sAonAsx@q|Gt@wA{ZeiCyG{PelBiwBsOiVwT}pAoQenAlAw@g@uD}V{cBuCaAcEoOm\\\\q{BmUqsAiAh@}@yNvH_l@X}Lq@oHeG_QaBkOyVklGBaM~@v@oIt@h@_RkEwG_IgBmCmIsIX}NwEKmE|CmGRaIwCeWiTyp@j@}XvFsFl@{]cp@zDmRvFwc@rAuRvOqOeBk`@sc@sf@qVqBA}BjOso@nIwBi^qOgQ{GmWQ_h@sEyk@@}r@fBoR_s@u_@eLcO}Cg]hCgb@zFaYpB}r@qGmK_BySew@g|BwCu_@wSsl@gCqQ_J|CuCqMsNpI{`@zBqh@}NaMyNaI}Eg[cAe\\\\iJmAwB|AcKiT{Fi@qC}NoGmVr@sYgOsg@sJmLyFoNXaR`HsC~Cz@~DwJx}@aR~x@}CxI{SjZGlSrHho@`Enq@yUdS{VhLyMzOiDbWcq@rsBi@`c@y\\\\rX^jGgCg@wF{JcQd@mEya@sGePsg@w}@cN{Nq\\\\cQwSiFwImKgUn^}BiBgF}IuAeLfCaO~FcMiRuKiLwO_Vq{@jMwG`L]xGwHbJy@vHsJ{ByRt@ml@}Kif@aOebAj@eh@hDiRCi`@~EycAsIePxAyANuFyCuOBe`@iBof@`@eSxCkRjBgD{I{C}Cef@nLqDnLJDqNxDyBrH|@hD}Q`LkWlZsW~Ow\\\\lKsMhVob@jEiVvHqClILjLaMxT{Dbv@qfA`UyEj[PrDsMs@_K~@gKls@iW|CmK`E{\\\\mFw{@pG_SjJyEhEqFoB{GFwJzHiNpT_cAtE}_ByB_f@jAkSpWgJrx@a`A~GwN|T{@bEaIxQiHrUwTsIaImMkTU}ZmKuc@aEsFhAgJq@kG{AkDwDaBeDuU}HeGeCcRjAg`@da@yYyd@wnBuO{AyOiKtSuYvIqn@`Ay`@zB_KeDaRh@i\\\\hHgVhCuT`MsIhEqJjA_HPyVjFgLtBmLnEwBxOz@~CmBbLnHrEpGdLwWlQwL|J{K|I{VvNiWrv@ss@tVan@|C{ArIwTlCiCjDeP|GgJlTmInPgSta@{aAvFcB|K_MdJi[}EoM?qHzOpFlGgCzGsM`EgDpIeBjXsZrK{@`GhBlIqBtEcRxGgHFm_@kH}n@iKmLzCiH?yDoMmLeCeGhGwJvC`EzE]fLnHzNgAhEbE`QmCjKwH~RH|LtF|DgBtItDrAiAbAmHbCe@fOj[bL|KlCFf@kHpGJbClXxQv`@zLrPlb@ja@vNwg@pCiFhBtDlOqYbUtRf[bQhH|MbBzKfFtMpAvhAi@nQ~BzCFzDuAbh@yHlToDtQwFdx@`K|`@`JdQhGv`@jJh\\\\nF~FlBjSvEvQuAzEoH|AwHlGcAxO}@XcKuMaEtEuH`TaEfFv@nI"},{"id":"2020-04","name":"Paris - Noyon","strava_route_id":"23643080","distance":159325.930499508,"elevation":1627.082011018346,"summary_polyline":"kciiHkg~LhBdEsI|]}SiGuBtHynAxcAyLj@ik@ojBmi@qsA}B_NpJb^}w@qrDyE`HqoAqkAuQsC{XjG_U|NoMfXySppAiLzqA{^qGcJwIin@np@_DyDcDfFlAbE_Zrl@}NiE_MdPi]qCOvQeE`J{ZpU_Tj[gL~CiQmEkEfXot@w_@eRvi@b@nF{YpiA_Mzv@eW|YcN`a@}NyGw@{FwFhDAuOiEhFo@oKmEjCs{@e{@sS}i@_NpEmn@yGqXm`@ui@Ww@bhAfHfy@eOjgA}MGgLrNcK|CKnr@gn@~yA`AnTeFtS{n@cNiQ|[m_@iHuL~]Q|LkWhWeRni@_`@yE{J~]aLvI{Xu@q]cT}ZtE{KnHgQxbA}f@aN_TnGiI`K_`@dDwGlGi_@gHuFoNkHeD{]a_A{\\\\qi@iG_b@cPc[sAkWfHy]}SiSTi`@iD`FkD~_@mDkIJcOsNi@{JzSKpLqJt@eK{RmL~@_SsLcFdFoBuCws@`h@eNmo@ct@_rA}Fsb@uP{GwOmQ{WRg{@{PgD_GMcXaPo`@oPrFmm@{_@gVh@mUiMs@iG_KwJ{n@|EkT_Lql@yCmQaJgAsEpS|DpDi]uGc\\\\gSkQgFyOiQkQwDoe@wGHiWuRuDyVqK_Tqi@mXaQeWeItA}GtSa[{Iq[um@}Gwh@}FeNyKnFqE}OwU|QkPjBi@cXwUyIkY{ZbD{[iAoLdEgNmAic@gEmP{z@sRcMeXcZwTdBwK~LuHxHrD_OeYbEgZsDg_AjD{\\\\tGoRr@wo@cFga@ZoUeKaD{FaQd@iVea@}bBhGwXJ_YuCcM?wYeIi^xS_CvHkHfFoWtWsMsKkd@oUia@aIwd@zAgTyG_d@jMkPcGcR{MyNxOwFkVmh@uLaKnIu}@nE_@{Jgz@Aw|@aEwo@pHcj@f`@oxHb[an@lC_\\\\sNqiALat@w[qW{c@gj@yYwHy_Aok@wMk]uIjMeZgQ_DnFei@uZe@qHxGgVua@kq@}Pac@qf@yQgMjJuKJoQg[ct@c^c]iEm\\\\qPgLqPwVcNuO}s@{VMHiSk[sIeI}h@kXwq@kWwUe`@io@wNo_@NwfAoK_GsOdBGhEgh@rPg@cu@qHam@eTcX{IiX{@}SpH_e@{H}cA}EgDkKcYevBjIag@zMej@jCkVmKw@uPeKiG_Ay~@k]uM{Hc]dEisAyJsKxPkKcMoB}QsRsWq{@cLmQiUgaB{Qu^}Hsj@lj@}aAhYqGjFeR|Cgc@fH_PbbAcSpSyz@pAgp@lVkFnB|CjRoTqRg~@uCkBR}VfJsH?qGsNkBe\\\\yh@}HgAwEnFufAcPeYiMgDw`BwRcY_Vmj@gfBgfAoBqHqb@fc@c\\\\qy@mRvFmItLcRfJmWic@RwJ}It@xD}GuAmJn[sQ"},{"id":"2020-05","name":"Paris - Nemours","strava_route_id":"2738684289169355218","distance":151733.85852521696,"elevation":779.7196633465143,"summary_polyline":"kb_iHk`vMZk]`C}S\\\\_p@nEqTtN{UpFeUfBsVB}r@vGms@{No`@oAuRqQjDqQuDsGmEeNeScF}SqGqJyDslAqNlChA_f@tQ_JlFaj@lCuJPsQrCmNcGyVuJsJ{FFa@wNuTfOiJlP}a@|IeQkCgPwSwMmhBMgP`CkTHgR_G{Pw@}KGm_@fCoh@Y{VsGg\\\\}FeE_\\\\dKqEdI{DoCsDyNkFmg@bAoSmA}`@xBkW_@oByGhAwAgZcEgYJgKiAmBX{JtCuHf@mJnDwN}G{D`S}_DDiKiCa@pA{SlAZ^kF_BqJ~ApJ_@jFmA[g@xHf@yHlAZ^kFcDkTp[aTvFuAvKbN~FpRlABy@}_@j@gNiCiXbDad@~DqDdTrHd@gF|@yTm@kKl@ms@zEy|@kBiKeJkAiHeJyEgUqGaq@nG{pAnGeNrA{Sw@eHl@ed@pMox@pH_MhTqs@tF__@hUmQpb@mAzMmIdOoD~h@`Fp]}Px]zK|c@wQxTgNlMzA`OmCtEyHjCqKdSwTrKqDlPExHaGzMeEnEaL`g@g^|MZpR|RvRkBw@_ZhDaEj@cEeGyRyPojDzz@w`A}Oe^zV}VhQqLr[wF~D}LrGuD~e@mL|RdBnDeCfHdMpScQ~DuNn^aUbF[aAem@hE_LtAmMgBof@lB}WU_f@lNTvU`QdVtDxDtDbCnKjr@iDfCf^uCbDGfKfA~GvFuHHhQ|BjKtNnMdl@~WhN|C~PxSrKP`Z`NpJ|X`|@rnAzDxd@fEpBkB`MnAhCfEp@hPuE`GaKbIu@rVmOpLW~NxWbH`YhPvArN}YnWydAbX~IwI`Xl]rt@|Ssb@CcFrDeAtOyY|SzF_@hSnGtYj~A`[jEpNrMwCbBhFvMbPzCfM~ChD~J`B|I{CjOpBhNcDjTtDxd@|@~HgE~DrFdDbL_RfkAcOls@DvXnSdFdLmLtEpAdFwF~k@{MhE}DdQ|HnIo@X~EpAn@rBwApC_Nd@kMuCq\\\\uCoHjAcSaDeA_Aq[wHim@~EkJ_DkR^{I{C}Gq@yJkMgd@xXuGxKuSdO_KyA}Ku@qf@jGg@|A_CI}EfGiDqCuPxGwGka@w~@bWqCrQvBzYoBhlBbf@jNjWdMzEdGxg@`KbXjDsGlLdJrU{FjUkNtSwBT}\\\\`OsEzFRpH{PzLaNjDqHjLmHpH{LsB{V~Ceb@d[zFbi@wB~^~FtLKdc@{HtQmWxG`LjFhCfb@zp@|VdJ~OzM~JtYfHn\\\\fBtQhPje@mD~t@_Shj@uCno@GjVxEtc@]pHxKdb@yKf]jLlKh@fDaD|GoFhZ_CzEgDzDe^dQqAzIrCzEzQzBp_@dPzd@p]xBoAtBqGdNpYqBtO}D`IjKbUdX`Zbd@tSbNlCfVQ`Ay\\\\nc@n@fDtFzLy@lY{JrLoOfHma@nCs@`@aIwAqv@sKgt@gCg^nAmXzF_SpQ_UdMwJdOuB~@oE{@}A}@xB[rY_BfQnAhBhXr@bl@hJpUJ~c@oRnPaSxAb@~D|LfLo[vD_DjXiq@wBy^fJak@nJtEpGhNl`@hb@xKfVxKjLvYlf@`RpFpBrKzW~k@lWvdAtc@`mArLhRzArOf@j^lD`]xJnUxGv^dKnW|G|]xTpz@pCtj@|Jfd@pLj`A_EtHjXnSxJc^lCiWhUmd@vFqFzBvAnFkEbRwWdSkj@bQc[rHcSfPoDzd@c[xXcKv]k\\\\l`@sMrC`^hMho@rCxf@k@jFnAzDbEdi@zHba@KtRcCdMxAri@|LeAlCt]kK~KuBeFOzQgDpEeFhA"},{"id":"2021-01","name":"Paris - Dourdan","strava_route_id":"2738743135024316600","distance":129159.73031000131,"elevation":1355.3034681861807,"summary_polyline":"{biiHef~LxA~C}It^bAjJ}AnDqC^gApEbGtCfCpg@_EjOzAhDrDda@pLvs@aLtx@_Tpb@`@hGeD~x@hEnKxEzYdF|IcChEvF|LnEuCc@hIpHThEKfEeGrHtCkBbVfE`VH~KsFfVCrIgNduAcFxIxFjMyA`NzCxB_A~D@dTxEt@hHpTrIjG`JxVhJnKvNrKb`@d@hV|NpQ~Xg@jHjNvVRzGk@rHNgB{L|QwArLkFhPjE`CzQh[qEnQlDlIeFxJmXu@pNr@qNs@iK~NqQ`v@^|AoAn@cHtTcUl}@iFyA}CuIsBrIqArJ~BvJmBtEfCjD~Htc@uCnE_Ff@wBaCiCxN{T`g@iA`KbIh]dEpJkHfN`AzI}BpAvJzShBrQDjM}Er^vBz^|FnB\\\\tHfECU|FtHje@y@tQyKlXnHrQyBlJsDrAkR`f@gNvWmKtNaSbMmT~_CmKdg@jD|YmCpMcEfAyBiFsB`Ayz@hrDgc@xaAxCdFnGh@pHhHpGzUxBvBfEc@bBtC|A~VlGi@pBtHd`@f`@hUnItBjCZtFeB?eGxLgKdYaCpD]kFS|GqKvRwNhMqg@joAcZzb@eCxPaKrZmLoIr@rFaBjW`Dz`AuMvE{IyAcBjHmE~BbLj`@j@nKsIbVeD~Cv@zDtEgC~ErH`D|Fs@d@MlKzF~DrCcDbFnEzV`Fnc@xQdTt]hMhNjYnm@nEtEtWvLzKhN`AvIzMgHlOnAnTeFjZ~RlOrb@pEzCnCkCjF~Jw@bC`BDfEwFx[f`@~L`HbLzCpO`KrHgCfFh@lV~Yx`@bVlJnRjOeKdJkLvj@hN|EaA`MjHtKeK~VeKtJAlc@wJdUdJKxJfLyC`QzDrKfL`\\\\|Tb@pVhJ~UtDpWdL`RfM`DwArVJbZ|GzZFdJfIdRvH`DfBvItD~E|C~^OjLbTpF|LtIx^qMnH`M`MfCtGzWpDlE~LpFnBlNhGvLhZ?zMgTnXkQvEcd@dk@sdAdw@kfAq_@qPqTqn@zi@}bByOgEmOl@np@ssD|[n@zNzNdXj@`OhFzOdTp~@te@~L{X|G_]dM}uAjKg@xEkTzPgZvSog@lFzKnLvL|IoPnJyGfGtHfM{Bjh@tH`BqDj@_XrAsBZeGnNaLxBuMxCiAjFkOlOiHJoEhWyAz_A`RhRnSbNr\\\\~E}ExF|@|Mxd@~X{b@lNx\\\\x@bGnH~Cxj@mmBbVhXu@aGpAoKtMyk@pBgYxAmDtF~L|KrH|ItQrH~ErFxTtQcW`IhBhDbErFgE`MoSnEoDtD{J~M{MrFgMbCmU~S_\\\\jDpIlKsN`HLbSsQfHnHjDfIpCdPLzM~`@i_@pHmVBmKcEqXlBu_AuB}NrEaU{E_u@oD{Th@qd@|A}CuAqJ\\\\mKsDgPeBsAsBkOtD}DbAtQrGm@eCiXlB_k@_F{Qu@o]tCy`@w@oNhEm^h@qb@oNac@qZof@aAuI_L}BwAkKs`@jUm@kBkHt@mWwMpCsm@}A{gAiFmd@`Bf@pW{Kl^ga@vk@qg@vGeNxToOrGsPcBwc@tFia@t[cD~ItBdC_C`CuJtRb@~J_SbTlQlTSjn@bInDiFbFjEpI|@xDaGy@gHpAaBfCzG`@tLjGzKh@tJnRiDfEbZxDvCpMn^nWfvAsBj^o`@dWeCs@}FfEkBjFxAtA[jJ}BlFeFqDeAeEiCdDqEaB"},{"id":"2021-02","name":"Paris - Epernay - Paris","strava_route_id":"2835084050483853132","distance":322109.2662952024,"elevation":3348.3219066386728,"summary_polyline":"apmiH_ssMsBbOzUyXhB_fAaGmQUk_AusAwtLufCkdD_~@mlG_`AkaFrGwiAyK{j@gWkqGsJg_@ki@wSLcp@iTyp@pIm_AgJupJsKkd@eLfAoKuWm`@ucA}@cTcXnIeaBwv@ZiQlMsFqIeh@nAswCcaAcoAdEeo@yC_gAiK{Xq@ql@ud@sqAtVqfAtEe}@|V{l@`Ca\\\\dOM_GeIbHeq@x_@y\\\\bAyRgVcmA}p@cIeLmSk@_a@~f@unDsKgc@klBkrCgC_PbQkgAqR}Xg]cmBa]cWkBoTdGi`AgKynAxAkc@vTer@rHmdArMySeVa}@rd@ckCiV{w@eg@uy@hIow@ku@gRu_AsgAwQirC~`@_jAcBgQu^kH_@mc@kv@ebAkgA{f@uWyUkEka@ie@oNdJey@sPuIwY}m@ySlDp@gZmUip@eH_nAwY_g@}{@ew@_AsMqVqJi\\\\igAFa]yQyOgD_Twg@wIsUubAfD}Xq\\\\uz@~Cyx@aSiXeEgi@qVk@{i@ijEoJqHrh@yhAfFq`@`r@{hAj@iaCjg@ibAoBka@su@geBcQgoEl\\\\glBcJq_@mSuJ~RcqC}@kr@|DsUdZqUyQcd@z@sjA~j@uKjQ}Qz]unAjTsIbSqx@`B}c@wUc_BbSoSnYoqA|[u\\\\qJ_jBn[guBtg@yv@fJeAfe@i~@|@utAwNul@|IaBxByj@lT{R|Syp@kKkI{NeiAth@a`@vQabAuA_qBtUce@~Ee`@vAkgA}UghBdNon@ezAefBbLca@kLgh@af@mOwRlG{OsTqQ\\\\RcI{j@aEzeAcaB|@e}F}PoMdQiYlM_uCeZq}C{WsHqAwPxa@ke@veAcF`g@ul@t\\\\oEp^fGdQvRxKa[zZxRhWgEvm@hc@bLvWbj@vxDw[bz@l~@psFxZx]hv@vNPxPv{@bc@zYb^hv@hgDiZ~lFnHd[mQba@{JrqAmcAnnCyzC`oF|AvmArEUkKnTsBbm@tExpBlPxp@xUx^{Zdy@mCr}@zf@va@rRba@x[xNvJf}ApIoFfj@|~AfGlg@OlzB|R`j@mF`ExDtb@{ErGlR~tEjTpaA~c@zt@oGlcAyXf`Asd@vw@uMhwArYpJtVnp@xb@fYvPpb@~p@xOdD`YoiBt{B{Y|~@_{@`rAeAveC{s@rs@aCbeD}ZjLpHvfAxh@jcArh@fc@uCfg@tJrv@rS`\\\\nBfr@~WpjAsEzwBfGvYzSlWnk@iAhMlzAr`Ajn@tg@raBkDrMwQoAmGb}Bm\\\\zk@{Hla@gf@vk@xXpg@{CbNbMfRhFpiAr_@hq@gCnr@`V|kBrc@~]~p@hPh_@nl@pBrVxuAlqAtaA|k@{JdUtIxF}AhrAqXrvBGrjCcUrw@oIx_Aj@z_C~LjoAxf@yE|TbL|Oh\\\\d[gM`w@n^d^lr@tLqPl]~pCaRl\\\\`Ejg@ePbtAl`@zw@fI|lBpr@n|AzfArn@yK`[hIhwCfl@sKda@z{@`a@dZeYfZaDlh@cGmDo^nsAui@fdAzDlUp]fK}i@haBjIhr@fNrM~Gz_@nRxHuJj`@n[`z@gE`h@x\\\\vl@oMnUzMjd@bHjwD~PvoB|O_CvAfc@|HfFdYeBvY`Ql^zo@TliA}OdS|LtOaAtu@dL|cBwc@p^xDj{@aS|_D|GzDqKri@|IpjA~H\\\\sB|jAnFhj@xIpSre@yTdMra@rAnyDlQboBv^lQ|a@}Ip^_\\\\~S`IlIrRpDd]oNnsCjDjw@bXbi@~c@aCZ{TLvo@vPhi@uJz}Bi]bbAiDzbB"},{"id":"2021-03","name":"Paris - Vernon","strava_route_id":"2861987676275212444","distance":167252.37293710507,"elevation":1571.910063690741,"summary_polyline":"{ufiH{|sLdAkMyiA__AvGwb@gbAka@gSdy@{IdGqHpTkInIsOxIeKqY{KdKkEgRqHfOcJfEiNeUyCbs@oN}HeUlGdKpWg`@ta@iNl_@vBpKaInNgOfTo[pJ~DfSez@zaAag@pwBa`@`hAuv@qp@ur@ePed@fHgp@b`@mSxVeXdn@a_@zdCf@nnAkHj]o@~U`Ehz@iBr`@nB~bBxUncB_JpUwJoE}^pDkB~WoUlg@g`Atf@eGkDCbJsW~f@sJtEkHhQqS|Jc`@nj@on@u@_K_Vs`@ug@|Dza@_L|LdHdTeBlXkYtb@ii@}IwHxpAuOsAeR~`A}h@_S}i@k@iXfMwHkHwIhWySdUwKxl@cXh^KvO_Jl]oW_BmS`M_LhSdNbPeD|Pyz@hSab@d`AiPxNsFpTkHsMgGtCqLoKaYkDaKtIaDlLuYlVnGnQeDvFoBdYhJjKfOnA_K`RxElMqD|nAaYpg@PpO{^hNkDhL{GmBmO~YoHpcAkOpAnBnKHpuAsCz]{Odp@qh@xi@yQkAuCfU{LzDsEvI{fBru@_CbW_FeAoAfEuPeFau@pKmb@kT}FtQgA`[dBzP}Gtp@p@~Osb@hxBaDhJsMeJwQnEl@jfAyKbi@qK|CcJjXmR`LaN~QcQrf@aPtCiRrhAcEbk@aMtNKvk@tGfn@wHv^iIv`B~FlApDhOuBn]cOj`AyD{@kB~Zmp@~s@{H~Bo|@lrAoJ~v@qx@jh@_OnC]{Fy@`HmKt@wFrI@xV{DpGsy@tXoUxViVh[lIza@gPhKcXwDAtEii@~@uZsb@kU~d@k]{@um@hVmb@}Aud@fUgQnQsk@_UoNeU{Vzu@aKjzA_Ajq@gJxHgAzNuNcKyGfI{T|D{Zvd@wVlPk@pZeNvi@ud@~NqHuKgb@b_CyIrRqCt~@xDzrAkBhy@cRbe@tE|q@hIdQiGrJ`EdE?sG|IyD`HxPh@fSzlAxGpWnGz]h[vFYwBq|@pY_b@|Ph\\\\b[mCjMpMtOMvXhKfC|F|JcIfGrTfHpDpGpRvc@nQfbAfDrt@uc@jd@~NtW~tCnHn_@cAjUnp@huA|UndAxs@zlAjEh|@fd@`iAxFvkA`MdJpfCkVeCu\\\\jKyl@SmWdO|DePiUxRfGpr@qbBDuMnV}NiEaIyVmoBDqRtGgC[mRdEiYfHhL`JHxFnLjGrAoF~ErNdAlBvy@wLxq@vHjAsT~`@^nDtWBPwH|C}@xv@bCbAwVjIkJuAtLnV}b@XqOmKkHnHo^dm@rYfVtDhj@n`@pm@tR~]x\\\\naAva@|Ud`@zJsQq@cPjO}FfNkn@dVia@r\\\\ktA~IgeB`HvGn|AsM~w@}|@blA_b@vg@_k@~fAykBtJu[~UiRdLwD|JdUdDaHxClIzG}FfNl]wKxT"},{"id":"2021-04","name":"Paris - Montargis","strava_route_id":"23983159","distance":155262.2713938471,"elevation":1058.7380004987106,"summary_polyline":"ab_iHi`vMPm]`C}S\\\\_p@nEqTtN{UpFeUfBsVB_p@tGuv@n`@kz@lJmMvTiAdCiIdE}d@ni@sj@R}`@|Xa[ze@oiC_KyL_G{BvBmIfP|JkHkR}IiLKcDyJeOdBaTzi@ci@|DtLxLiEhQnIzCjLpJU~Vx^|DhLhI_JxHbCdBsAfMo]tMyNxA_FbCmKbFm{@bScGiBqSzRcWfdAj@zEfC~BrJvBzB`Q@rEfC`KlR~IuFjFxDzEGjAiIxCwDRcDuB_JdIm`@bI_PxPyg@dXxOnNjRtWdNzZ`YnGpChTdYzK|SnDf`@tK|T{AxLeHbLjDpEyB`A`BzN[lFcSd[s@|NrBhLfLhIxOl`@tDxOnEbc@`Hj@AxQzIrFnGb@pHhJt_@xIdQpp@A~D`\\\\dOfiA|Hdb@fLfb@l[nT|yAjHoLlH~@nBmBbe@wAxEnK`Jv^~BHX`FnMrD`KxP]lElCjG|H{LwDyGf@_D`SaSjCxA`F}HnE{HJ{K~Qi_@rAQvHaNjb@k_@lIoLzEpApBmIe@iBhCkGjhAmNrcAzQ`]`B`t@~RxK}AlUwOxMiQrDmL~D{WpBqf@fFm@lBeQzNHnBib@rAsE_@cG`Bo[fHeBvNc\\\\zFmHpIch@~]dO~g@eN|@gAa@}BrQm`@hCyN~RiX|ApEn@`O`QfCpJkE|Owt@h_@d`@pGsLh\\\\xGr[lUpHtB|LoBhHdIzNhI~GaNhAqI|LgIzB_EtEeXj[A~C_F`J_E`FaJfHoCxS_@rRuEbDnBfg@ue@zS}AtW~DzQyAh_@rAxZxI~MvJ`DnGdX{FTpDtK}A|DiYzKya@lPyKvLg[j@cL~b@{gBeQ_O}Ze`@gJuPeVeUiMmHbE{WvNkh@|JijAjWn@rM{RnIkA|EqGlNs|@`Jo_@fKcT`Yy_@nTkaCrIah@vCaElL_DlE{Gb@ox@tEoKn`@kb@~MaYK}BtZeVgB}HwB{d@_CeOc]y`BtBomBt`D}nFlMkh@z@uTnOo`@uBw^p\\\\qxB|NgDrGeG~De^lJiVtBs@|E}JxSsB`]iMtKwErH{JpCh@~GlInDgBfBiGvBrAvLuCrE{JpXbFbGaGjy@{P~FeL~CiNb@}UtROnEqhAlPyc@pGck@e@{kAnIeNzCs\\\\dE_MjE_Yj@eZxCsKf]~Ud\\\\hDrVxJllA~r@ny@hJdRtIhIP`VyHjJpExN_@tBlB|BcEzF}@bNrQxXvEbKtIf^hFnFg@vGsOpEiEfSwAzKmJfIvGfAbo@q@fJt]~XxQlUtY|J~AaCfAeK~CsDpG[jDtD`UoDxIgOfh@of@rJyCtLaMbN}TlV|CjSqB~FjCvAbJtNxHjm@S~Knp@lO`c@lBjMrDjI`EfCh@xf@nk@y@pDjB~OfVzHqHd_@hGfWhIpJbKzP`J`PeI|RqBf_@vFdJa@fFbLpIbF`DrG~N~@|QhTvXfPz\\\\gE~m@c`@jF~@|TbPhl@Zh_@`PnJtHzGpP|NhQ~Rbj@no@pp@vBpLcCnLb@hBjDE~AaHdFYxp@vPdPjIfCnHGvFpEbIbEdRb`AhgCdo@fEfQvVrLYvFzC}yA|dCkDbSyCj`@~r@f\\\\lHn`@|HpRbCrLvD|BdEpI`B~RbNpYhi@`TtVeNhVqGn\\\\hA|^bMUnTpEzEvB~JdLrB~@~NjW}MdEzGr[pHfLgn@zAr@gFoCbB[\\\\kMzLjD~A_IHoKmBGiFzHs_@cJ{Be[aFyPoRvCe@sG"},{"id":"2021-05","name":"Paris - Cr\xe9py-en-Valois","strava_route_id":"2887703875178144968","distance":124651.01638330898,"elevation":1039.5977256398478,"summary_polyline":"exliHyuvMj@~Js@zOTBjCB?HrBBU|CqKS@StA_ATaG@aDCkBYmGSyCiEk@EMKqBMmLBYCKa@ye@FcDDYTc@@Ie@_ISoACwAwF_f@AeAo@uFIUQ_BA_@Ik@IYsDg[SyBWaB_BiNu@iESk@OkAcGch@uMsgAD[MmAO[eGgi@i@{C[gCr@wA}@uGsEi_@qCcVmBaOy@aIyAgLYyALq@wBkQKKi@_EFa@?Oa@{Bc@iBw@sCs@uBiCgEaLmNcCeCOFYYGMKi@qEuF_MiNuBkCi@k@KEoGkH]MSWK]eCkCyBmCaLqMYU[@k@o@CQmBcCMa@oKwLeAqAaA}@KWaBaBG?aAu@G?SOkAyAIe@wHuImAiBwA}Ce@yA_AiDk@_Dy@cF?GJWAq@cAgGEISQ{@mFQo@Ek@yAwIuB}M{@cEQc@kAqHAq@UqBe@wCAS_@uBQiB[qBOqBc@eBmKkr@NO|@g@e@wDoHyf@eK_s@iA_Hg@@[Ew@aAYBm@qBaByGs@cCm@cDUwD_@mD_@mBo@eFs@qEMeAg@kAMc@UmDiBcL@_ACW_AiGSm@Sa@K_@OeA?u@CU[m@kBoLq@qBOsAAg@Q_AQe@_@}Aa@sC?gBCi@aA_I]q@Oq@sA_JU_A_@o@Og@m@eDw@_GkBoKaBeKCq@@]oCuPGYYm@Ou@MuBkAh@AmCc@eCW{BAm@B{@J_Bb@mDj@yARmA?qBfEwZNiBJcC@mBCaBi@uGGYgAwBa@eAaB_Fy@aD[iBIwA{@iIy@qS@gB{@iRAgAB]GoAIYaLitCsEmeAC}BDEEDB|BM_DKw@YmACu@oBVwAAKMEQ`@{Fb@oEAo@Gm@Kc@{@iB}@{Ae@m@k@c@iAi@}@Uy@K}AK_@O_@c@Oi@q@uDIYa@o@{Bo@i@d@]Te@JiB@sAg@yBm@iE}AqA_@SCKmEx@cC`@s@TYXQPi@@cBP}EMeBiC_TUeBi@mBwE}McG_P_BuE]kAOeA?sB`@uRHsAP[j@i@lBo@ZORQHOJg@Dc@B}DGaGDeCb@eHFoBaCFuCGyNdAuRzA{CXw@NuPfFoM`@qOZgCJm@HYR}BdDoAbAaJnGk@HiHm@kDa@{@Uu@m@gGwIcHoFeHaJcD{DiJwF{DuAmGoAcB{AyAyAk@_@qBgAcBu@y@Bw@Ee@hE{@bFIVQdA[Aq@F{Dn@ye@zGo@Ai@G_Bc@cDu@sIyAgJ_EyEeCgLaB}GmAc@?eTzEuFf@_Cv@iIjEeIfCgGhCuCxAmBnAiI`GmFhE_K|H_BpBi@b@iElAk@JGOECIDGXmAHUJYDYEcDb@eBZo@AaBTe@N[V[`@y@lBU`A_B`Fe@p@g@d@aGzCwErBsALwAKcA_@}@i@aAeAw@wAkB_Ge@gA[c@c@Ya@K_@A_@D]J_@VqPxNmE~Di@j@_@XO@g@zMO@GPBNa@h@KTGXAXFhEKdAi@pAOTg@RgBV]LOPwAmBSa@Sw@Ge@Ao@NaC?_@Iy@Q_@MQSOUGW?UDSHQLSVqCtIo@vAY`@YTs@TeFz@u@HgNdA_Jx@KHGMOAKPMCY@mNfAiCf@m@FU?SGQMMOWo@OEI@GFELC\\\\Wh@oDnEyGhHwBjCWViF`EuBvAw@^e@b@w@LMKQ@mD]O@aARUBUAm@Ok@c@UIm@AaB_@cA_@WGuIq@e@G@a@A`@a@`EM`C[pK[~B_BnEeBfGoCtH_@zAYfCCbA@bAp@~M@~BFl@H`@FdBEl@}@fFY~@iKhZuClNAh@HpBfBlSL|CD^b@nBtAtIOh@mA`Ig@jCkJdLgHjIa@t@UhAa@bEu@jEm@bCQd@OPgE`Di@RYFc@?{Di@i@B]P[h@uDtJwTpd@kL`WaOnt@QfAwIdy@C|ABnCU|Mo@zKFlETnCLp@@ZGb@iBpCy@r@WHMEaFmEoJsHWCUJSXkA|CeDwD_Q}Og@o@[s@?}AFoCPsBhBoQ^oMByBMeB[sA_@{@a@s@gGuHoK{RwIoPk@qAYiAMu@{@Ou\\\\yn@kTea@{Sw`@mBgDmW_f@BFm@oAe@e@ax@kf@}YaRk\\\\mSoBeA_NuIaRyKqBoBm@KqHyDeFaDyQ_KkWg[{Uw[mCcDmCwR{@kFg@mE}@cH?W^wFaEq@aM{BuLmBm@Y_lAobAcB_BaDsC[Um@s@gBgDyh@rBwF}@_DkAkSt@oBt@y@BaDAMDaAxBiBpFmAxBa@DaBIkAQc@S_ArCYh@u@l@kA|CeA~HyGtV_J~_@uBbLuEtQMRGBHCa@L]Dc@Gc@YMCWHSd@a@TMNO\\\\Mn@C`@\\\\zH@v@G`AOv@k@`BsA~CuJtPiB~DwCbBiBlAyBjCg@r@aDfGw@`AwBfDGn@@tD[dBm@hAIXUtEMbEW~ESz@gIxTiDzJg@rBiClNqAvHcBvIUfBKjBO~@k@|By@dEwFvHWLi@HKE_@_@cBaDOOe@AgE^cCbAuEbAkDnAEd@y@n@cAfAQr@q@rGg@jAwC~DBHiC{EcB_EiKmWgGwO]sA{GyZ}AsFsAaEeLaS{EcM{EoJcO}XqTkw@YqAyA{EKk@Eo@AmBCc@Ic@[u@Mc@XyAsAcC]_Ag@_FuAgOUsBUo@{B}Cg@aAk@eBWsAyFig@IgC@qWH}ALgAfAsF|Hk^p@qC|AiFDWKaMBiG?V{OgDSMW_@Y{Bq@uVoEsG{Zwd@qKwNk@]k@KeI\\\\yNnA}FdAaBV{Fi_AoFe~@YaDuImx@S}AmGq\\\\u@gEI{@?aBtD_m@bE}^|AtBp@b@dBVdDt@|@d@|DbF\\\\wDH_@r@sARi@Fe@Ei@GQk@q@gCmCWo@MiAAw@DcAl@mHFgHbAsM@g@GWOWi@]e@i@MYe@_CSs@mEmNwCaKMkA?}AFaCIqAmBiMcCmXY{BBJgAsFe@gBsAmDqA}B{@mAa@c@_@Ui@Oi@Gg@Q_@EuBu@w@u@i@{@w@}Ac@s@[SYo@q@m@g@SoEKqP^yAI_CeAMKQUMa@Ii@OwCBmCXsF@gAQ}FIe@KM_@IWXKd@Ap@Dl@RxABdAI^_@f@i@b@OVG`@K`CSb@MHQ@UKMOI[A{@FeBS}BO_AMYwBSOM_@i@ISc@kA{@eDq@gBi@eBMs@sAgFaAyCu@mBa@wBuBsHMYcD_EwAmA}@oAkHgMmEyIe@u@y@{Au@_Bu@gCi@uBqB}JeAiEaB_CsB_F_@oCgAwMAwBw@kJcB}QQ}Ae@sBeOmg@{Jw]iAiCgCgHs@yDcGsV}@aEq@_BaA[mKmCsDmAa@a@uHqSsUin@iHgRg@}@q~@vl@iAzBeG|SEp@DhBAVEPI@MGQeBSsDGoBPgCEu@Kq@]WSDwSpMgMxHUXTYaLcMwIiJkOyOeEwEf@eVJwHGo@U]eDuBsCyAg@g@_@kAc@oBgA_RBEAiBDGIOUcA_AyPfE}QN_AJqBMqQB}GAyA_@cJB}Bf@gIlAsTP_C@i@`DwL?Ku@wFBWHg@Xs@Za@t@e@vJkExAiDVu@?OOaBeCePQaASo@c@}@qG_JWc@_AwBqAqEMiAG}AAeDXgE\\\\kCVqARm@\\\\q@PU~@y@tC{Bp@c@r@Uf@[^e@|@{B\\\\g@\\\\[vBoA`@e@R[L_@RaARmDGaAmFa]qFe_@Q_Ba@iFYwE}@e[yAq`@SgEUeCgBoNyAeMuFsh@m@kGMqCBqA?cHBa@LaAd@qAXcAL{A?sBJwHMqDA}DBcCFs@Eg@DmLb@iEFUB{Ad@gIB{ArFJ?y@`AyGDw@?qBDaAl@uBf@uAPRd@g@h@S[y@kAaCm@}AnBwBp@mA\\\\iAd@mB`@}@RUPIpBEr@WhAi@dAu@rAg@fB_@z@I`AHfEfBl@Jp@@pCm@tZgKxAy@l@k@n@eAjD{HnK]fAInAUxWgMp@a@jKmIfPoJr@]zAUH?JGNm@b@y@PGJJf@z@LFLCLMHQDY?WQuBTqD`@vGFbKBTTbApBlGr@lH^jGCtASpAaBjECb@@dAPx@vCbDhAtAb@b@vIbG\\\\\\\\dGnJtAhBnJlKJPFh@Gh@_Kjb@?j@|AvMJlBiHtjAeAnQUVs@RC`Gp@VZVTrA|U`Dp@LfAx@vGjEbShLVD|CRnADn@OdK|AZBb@Ap@O|GsCr@Sz@G~@FvLlAZ@XEPWrBeFjGqJdCmDPe@^iBR_@TQPIPC`@?dBJPATId@]Z]Ti@\\\\qAtAsGBk@?{ADc@hAcBTg@DWLqCHs@Ne@LMVG~D?`@LZN^FXKhA{@^M^?RBj@Lx@\\\\|@h@p@~@l@xBXjBb@nAbDrEh@j@VBrCsDTITRh@~A`BwAvB_CX?Cl@Dd@Ld@`IzN\\\\v@TfALdCLdAX`A~GpMZdAFv@@~@OdFD~@V`ATZjGdHx@pArBzFhDhFbEdEh@r@XLb@QhBwCVSf@GpCb@h@Sf@W~@{@XBJ\\\\Sx@c@h@_@\\\\i@x@iBtAYXKv@Hl@`@\\\\b@KZi@~@wB~FuDTAJREb@_EhD]\\\\_@z@C`AHz@p@bETn@\\\\d@dF`Ero@jd@dN|JpAhAx@\\\\`EBdACxBWpACf@Jp@d@pAp@x@j@PxEc@bE@|BHr@`@bBXl@`AxA^`AVzAThBRdDfAdFhBtGrFnPzc@z~ArF`M?\\\\VV^h@jC|Fn@lA\\\\^nAbAjKhHfB~@hBt@bFhBxEpA`@NZTf@l@Xd@HZF|@SnFD~@PvABl@?rBJbBCh@Ih@c@tAcA`CQr@?ZFf@b@p@~BrBp@dAbApBVz@@`@KjCBN\\\\N?FHyD[gDBq@Ni@N[n@g@`@MZJd@\\\\NTd@hAJHN?`@GhAa@~AGh@Bz@NxEfCJ?nAy@pFDPFnB~AxCnCHc@HKhAI`@O"},{"id":"2021-06","name":"Paris sans les mains","strava_route_id":"2892780680068432842","distance":59494.03522567121,"elevation":382.8805244326317,"summary_polyline":"iyliHm{pMkE~EW]sD}DODqAuACmEDiM^qNXsEIUCY_@wP@o@G}CQoFIqE|@}ALc@tA{Bd@}@XKd@w@PMd@Kx@LJDNXFYCKMMGAn@qOfDw@NIbRcErHm@bCHOmXbA?HABEEUQyDEeJ?}\\\\[aPKg@EIwG}KiAeBYm@FSGUa@UG?@S\\\\uBV_C\\\\mEMg@fEoRz@_BFGz@Kz@j@JNXlAZfFP`@\\\\PC?VBlGQpBi@p@q@`AiA\\\\FOxCO~Aw@Hs@b@cAv@k@TYTa@~@Up@y@~IGfAB`@F\\\\h@lBJRX^FX@h@N^RX^TNPh@rATt@BV`DNrBbAn@d@hAjCjB|AX`@NZNn@?n@bAnCXj@d@TgAdBhF~GhElE`DhCp@r@h@p@Re@HEpBMl@?ZH^EzDqAvHaGVDHk@RE~DaDhD~LXnA@VLKlHsAzHe@n@mAJd@FFLD~DQtCgFJ[`@l@TVNMhB}Et@oC|@{G{CkB}DoB}@w@yByAGg@B{@Ku@?q@F[L]h@}@Re@~A}Gf@iHbAkPvAeMg@s@e@gA_CgLF_@CYA@rFqExB_A`BaArCeA~LaGbBu@xAg@jAY`G}@`AIpAAtAHvAb@dDx@jCd@BpAJ~@TGJBPEFWk@eGVIlBkAf@D~@Tv@f@`FpDtBnAdDbBbC|@bD~@hDl@bAHhGC\\\\BBBnFG@CPAV}KJuARF~H|@pDd@jD\\\\XgHLaALaBvTlCdBVBTSpE@|@Ff@HNJvBIh@[z@EZ?\\\\JLHb@lFf[n@nDx@|DdAxDn@rBv@pBxApCrAzBpAfClBvEfAhDbDvMACtBsA`A_@b@CpDF|Fk@rCCh@BnALfATz@X`FnCbAV`@DdB?AUTGDoAKGNwAz@kDPCFu@}@OJsBl@HFgAYwBU{@_AiA]IiDZcAPoBj@UsAQkCc@iDm@aDo@qCgAsCo@mAqAoBmA}@_BcAUUdDKxBWlGeAjEiAdHaCvIuD|CyAxCkBROhBwBxBcEdAkDrA_IVmCTiDr@aSXoE|AoOxDbDvAbBp@hAr@lBHOH@@mBImKF?PmDTiJJwCPyCr@wGf@yCf@}Bh@uBBBHpB{AnK[fECz@KrJNzSArHdAJ@o@KAABCd@@@dD`@XgGJCHbE@lCCpA]lEo@nCEbB]jEK`FF|FD`@l@rBTjAJpB?xABTVVJZFpADdDCxAOdDi@jFa@zAR|UYtA?pDCxAWhEMn@Ex@`@bAQfCKtCCzDBxAPlBn@vFd@zGRvD@rBGvCBNE~@ETWvI[tB?A_@zAGAuCwA}BrO@Ra@pCCCNkAB@OjABLdI`DLm@L_@CCM\\\\If@BBT{@Rk@BDYz@Ox@DBPeAp@cBbCwEnA_Bh@]n@SxAUnBHv@L~A\\\\y@fEoAlBmA|@[H@iXBS@cAEaADCOEO?OKgF]DyDF_CnBGKoFeBgUzCu@m@qGBaBxBeJhAoF_CaB]G_@Jk@CMK]q@CUAaBF{Cf@sLLqEH}JEKB_@KmGSyRBwGu@{JZgGd@iTa@uES{H\\\\wTFgAd@kCVu@zA}C`IcKjO}NXo@tAmFfAwDzGcQpBoEnEgHpAgBrHcMb@k@f@g@CM|@k@IOaA\\\\G?mA{DKc@@EBAFJD^KH[]K@EGG]NOh@AJE?@fCgA?IzAq@|AKhAAnCRd@IpDsAl@[n@OrDyAJHnA_@JOFYvBOfAQhAGzEq@tCe@`B]rEiAjCa@dA?zDL~DU`@Gv@Wx@g@|BuB`G{FjC}ChAyB^_AnE}OdBeJPgAnA}KzBuMRiBTqHL{Q?}CEwAIYIuESkF]iCEm@FiCWiFOgEEwDB{IdAc]RaICODsJEg@Fa@C_CGq@WeAoAaDQQGc@qDcISYo@qIMeAk@mCIGEIA_@W_Ae@qA{@_BSMCGASyDyEEEOEEIAMIMwCqCcCkBWIWAs@HeBy@MAQBSTa@lASNWEMGEIE[HeBA]GUOOqBk@_@@UQ]GoCIUJQGmFm@I@GDG?SSsFi@Q@MIq@GqFr@IDKAuARyAFkB@GDWBq@QcBE{Di@I?QHOGeBFwGbAeBd@Q?EEM@GP@HQPwAdAkAbAIPQFyCdCIRM?{@|@mCvDyBhEkAzD[rACj@KZeAlGOfA[vFYdHGlCG\\\\KfExCz@tA\\\\|Bb@i@lGSvA_A|DYr@?VDFPLVB?j@Ed@iA~By@rAkAxAALRzQLjR_@R_BfNSbA_@Pu@CW~Bk@jD_@jCS|C]dCCp@Qp@_DxSAl@IRGf@InBWlBMnFGbA@d@k@nFCv@IV[rES\\\\i@nEc@jBe@~B@TDP}A`F{BxJg@bBsClI}AvDqAnBoCfDmAnAqA`BQf@If@Cx@t@|EId@KRWVYJiAm@MCY?mAp@s@VeBpAy@f@SG_@CsBHoEdAaEz@k@F}AGwBo@y@a@mCcAsDWaAg@eDyBk@k@_EsFuFeIo@kAuC}L]}@Me@a@{BaAeCu@eAoAmAiAwAeBFOHILMf@A|CCT]z@E^?f@CTw@zB[n@Y`@o@j@_@TwBf@{@eA]w@a@FYnEqCxPCl@[Hm@VsA`A_FzFo@n@mBfBsFnEgAnAgAzAcAhB_BdD{@~Bu@nCi@~Bs@zDoA~JkAhMET@ToBzZm@xG{HoBD?yA[KOiBq@c@a@We@m@wAkCiHcB_De@o@mAeDUg@II@UGMGCKL]Wo@Yi@Km@Ci@Bg@JoBl@k@Da@Ae@Ke@QYU[Y[e@Ym@iAZa@Ba@A[KaE}BgEZQEIGGDYDYGk@@}]bHw@Z_DhCGHEGG?IFAPUDy@l@{ArA{GpFI@IPoAtKc@M}Dg@mBbLcBjJs@@YLYXU^Md@C`@KCa@BcGFwQ@e@rAKs@EKyB_AiAs@gBwAME}HsFgAq@cA]UAIj@oDhMC^eAzDkAnC}GhIm@x@wAxDsA~DW^kCtHEReDta@gAlMsA~PEJWVnBrHzAlGy@kDv@fDIXWnB[jAKLIKK?GFCP@PJHJAFf@oBtBkAnGILYe@u@u@Hl@f@fASTOrGGRSJLFBHHF~IdE?HJRN@I?]|LbGtGj@PCAQxF`DhCp@r@lClD[h@qAFUHLlBBrAAp@]fCu@zCIj@@x@p@zBDX?bAcFzWSr@_ErJqLzOgAdA{AfA_@NU?{@W]hFUlABfAg@EqHvAIVwGpAMWc@[iB\\\\i@T{YnE}Br@{@d@u@f@_B`By@`BUv@q@lD]hDMrDCtBBJw@?EhMBbGfG|GXw@JNlEaF"},{"id":"2022-01","name":"Paris - Provins","strava_route_id":"2893176953184227932","distance":104033.02987854672,"elevation":576.5805813811672,"summary_polyline":"ab_iHi`vMLoBDqDAkCKmF@qDH_Cf@mFj@gDZ}BPiCD{DCgDQ{IEiF@sDLqDNkCRcCZqC\\\\_Cl@uCl@aCjAmDvAsCjAoBl@y@jAsA`CkDbAwB`@iAlAyD~@}D`AcGl@eGd@qGR{EDoHImKF?PmDTiJ\\\\qHr@wGf@yCd@}Bj@uBBBHpBjAoNH_@JFrBuOhAwB`EeGLc@BqCEyB@EFCBUJYpAqBNK`@FFDbKjSGJlB~DHDd@jAHDLA`CoEz@{Cr@yBzA{D@S|@iCpByEfBqDA?pE}G_AmBOeDNk@lGeIn@u@jDuADL`@?rCkA?IzAq@|AKhAAnCRd@IpDsAl@[n@OrDyAJHnA_@JOFYvBOfAQhAGzEq@tCe@`B]rEiAjCa@dA?zDL~DU`@Gv@Wx@g@|BuB`G{FjC}ChAyB^_AvEsPnBwKnA}KzBuMRiBJoCEALqDDuQ?BEgGIuESkF]iCEm@FiCWiFOgEEwDB{IxAeg@CODsJEg@Fa@C_CGq@WeAoAaDQQGc@qDcISYo@qIMeAk@mCIGEIA_@W_Ae@qA{@_BSMCGASyDyEEEOEEIAMIMwCqCcCkBWIWAs@Hm@WNQjBwFPy@fP|J~RtXd@lA^pA^x@XNv@NRJxJhNr@t@b@\\\\JDxM~AtALDYRi@n@oAfFiIlDcDdAoApHcK~IaOhAsBd@m@tAoCNKf@OC_DHBr@MTInAeANS~EgEv@c@B@HCDI@GEUICYcBGaAHuQAo@FMdAg@V]Xw@h@uBhDcKb@cBdBwDzAuCn@aAlGcGbAmAr@mAH@HEZiBl@sBF@FCBMAIEEfCoJfD_g@z@mSHCFSEQGC^cHt@yE`@yBDm@CVt@aHJAnHoDd@dF@CHDXk@xQeUrr@`AbBHVPF@JGDQbBCT@t@N\\\\@l@EhAa@^IV?^FzEfCCPDb@V\\\\R?P`Bd@bCXx@\\\\l@^`@x@j@nAf@pAP~@@pFc@bBE@LFFFCBKb@FvAj@jA|@l@j@EVBRRLNIA@FU?OKSVaABWDsBRu@RYNIVER@d@XvAVl@FNGJcDN{BpAyKLq_@b@mED}@JW@Ob@aAb@W`BYf@Sj@_@lIkGt@q@nBoCJG?UHOFC?aBv@sMd@_GPgAHyA^iE`AwIT_Ad@oA^o@\\\\a@b@[`@Kn@JLXJHJBXGHKLc@bEiB|D_A~Aw@ZW@SFGF@j@_DZoCh@gGN{@~AcHlAwEn@iBVcAhAgJZcFr@oFaA@`AABYXNb@B|CYpOaARLJMNDRKDGPGbACj@MlCClAQh@MrA?x@EaAcGQkCC{AXcI@yFQqCc@wEHIDQGYIEI?W_AUo@QwAEw@FuHAyAMqAQkA_@aB]eCm@qIEeBOuCQ{AaA_HcBuIOk@Y_@{C}CSW]y@[g@yCwJaAoCqBwGaVqm@Sw@YcDOgDIkDAsBBwBAYKUSEeEl@]?}SgByAQx@iQJiAbByM@s@Nm@r@yGr@_Fb@wBrFqRd@sAnB_FR_@vAmBp@_BlAwD~\\\\cx@eMuREEKA{@PKCKU]iFgA{KUqCy@kPq@cL_AiEbMeDvBq@xH{EtL_IxBqApCc@rC[~Ak@vc@yZ`BgBfA{Aj@o@TOPET@\\\\L~@|@r@hAv@`B~KnYd@x@l@t@n@h@~@d@^JlALd@AjAQxLkC`Bg@dFoB`CoA|@]rI[j@MvLgF~@k@zBeBTKTCXLb@h@jCzFpAxBbCfCpCnBf@f@xBfC`BfCz@`Ap@b@|FxAfCm@`B[lC}@jBg@jBI`B?Q|@?p@^~GlEd@d@Jtb@jNf@T\\\\JL@XGHItAi@tDoAtVyIfEaBrDyCxEsDl@_@vi@_XZUbAaAdCsATGlAENE\\\\[bCiFf@_AV{@FgAN}FLeAFQfAkANW|@aCb@q@z@e@NOd@eAd@}AZw@x@_APa@TaALw@EqBFc@p@qCd@}Aj@}@\\\\WvCgAVQPS`@w@xDiMv@mAnAy@\\\\]Tc@Ng@T{A?kENyA@{@QqAaDkNIg@Cg@RgA`@w@VY|AiAq@{Dq@qEQw@aBcFI@ICKS[kA]qBGIuAg@yA}@cBa@g@WIOAgADa@nFuOF]@c@GUKQMCSBkAd@e@f@kAxDKPMHS?QEMSiAwCQeA{Cyk@MkBIm@_BgIE_@HaIWcF]aBkDkLYkAWuAK}@GaA@SJ_@I_ASs@[k@aAkA}IcOcB}CwI}NSBiAqAsAeByA_BTg@aD}DyB}CgAiB}A_DiF}LeC_FaEwGqWuc@wEsI_C_Gc@a@oC_A[[O[QUEe@w@mCG_@Ak@Jk@v@uBHm@T_AVs@|@eAx@q@r@c@pAc@v@a@p@i@n@o@nAeBn@qAz@yBbAgDl@uC\\\\qBNyA@m@JSTQ`EJ~@AzCQTKLSHSZoAXkDHe@Ty@`HoQlDqIf@eAZi@^e@l@k@tB}Al@k@jBuBz@{AbBoEhEmNxAcGb@mAdAcCrAqD~@uBp@aAXb@l@h@\\\\FJA|CoA`CYJsABuEVoAx@qCqBaDa@oA_AgDu@iDeCiFcAoCKc@Ea@`AoG\\\\iE@a@QcFEwCAqE@eAJg@b@iAXgAn@}DXeAh@sALk@BS?w@MeD@y@D]h@oBLqABi@Cm@iA{MQ}@w@kCyBgPW_BoCoNuKal@SwDCsDIk@c@{G[uCcCsMkCcOa@mQpAeh@FeGEwEDqCD_@d@cChBmHHi@BkAQs@a@{@w@cAMc@CU@]Nu@bB{DnBgHJk@Ae@_@qCQsDOkBScBS}C_@gCi@aC|@w@j@Ul@ExCRrD\\\\|BNt@PNQJBJ_@R_@xAkAjJsInJgHnEuDzEyDjGeEhLmVjBqD~AmBx@o@lCm@p@WrAcBbAkBj@uAp@oApKiRfDyJbCkG`@eBb@yCBiCH]R_@dHmFhAsAxHaLc@oA[qBmD{Ie@eBaAqFaAcHaBoMaAmJe@eGUcHQeLa@_q@KoD[wDyCmRgA}FaAyE[_A_@_AmIeQwBkH{V{_A[eBmB}O[sB]_ByN_d@_AeC_AwBiIeNaAyBmEsOoAkDw@uA_AgAiAm@_B]}Ak@_Ai@wAyA}EqFoBcBgBeAcBoA{AaBkAkBgAaCeA}Cy@qB{BgD_CqFkBuCo@s@qJoGo@k@]{@s@aI@iGOgB_AqE_BoGkAmGo@sCw@uCmA{B{AeDs@qBWaB}b@iDYSS_@yCsIb@_A`GeLh`@yzAjBqHN}@rb@urJt@}LZqCJg@n@eB~DwJdYcq@jN{[fAqDZyFV_H|@eOT{B^aA`@Wv@KrBBr@Q`@k@RiAp@k_@Pm@OeB?mBLcONqDf@{DLmCW}D?]F[jAcANa@Hk@RoDvBLTAp@T`CDhDNt@NNw@RiCj@cEh@oCb@wAv@uAf@u@dCwCz@}@hOyK|UaVhPgPrEmEN]He@DyFlAuHhByIVuBJgB@oBMgKJwIvJJwAmr@Mw@a@aAcEeFWi@Oi@]eBKs@Es@GcFHeMI{AU}@OOqAs@S_@yA}D{C{FSSg@U[GuBGUMeCmJtGmIblAa}AXq@LeAfAqPPcEZiD~`@cxAp@iB`BsDfGeZb@wApAkCrCqGzB}GfI_Nh@m@vBwA`@e@\\\\w@hAwFdAuDtA{DjByEfByD~BwEnAkBnAuAo@qCm@kBkCaHU{@M}@e@gGaCeUC{Ad@_MAiDP}IIoCQ{BcAkHoBuIgA}Ls@kFmMaq@eAkCyHaJo@qAeFyP_@cEQcGqIyT}@mD{N_y@k@yGiIujAKkAMa@f@aAz@q@tEaAzAu@l@gBjA_IfAeFhCgFzB_FtBmGhCmFvAg@fDw@nCuAtA{@Vg@v@s@jCqAbCg@tBwAdCkB|DmAvH_BEyADxAvQsDfFq@jy@bBjBQdQ{EbBIjAaAtCsJfCyHVc@Z[`@UbDgAxB}@d@_@dM_NtP_M|@c@hGwBvAq@dGoF~BeB`CsAZk@TwAa@qIy@uAcAoAg@cDImGTw@p@}@|@uA~BeJr@yAr@kA^c@`As@pFsCfBiApAsAnGiJzCyC`CcA`CYtIv@`B]hHiEpGkDbEi@p@Uv@c@f@vB~A`JHJ\\\\AvAc@vDuB\\\\Mr@KPLNVHf@FdAFdEB^FTLRNPNDT?`CWV?PBZ\\\\Xt@Z`@\\\\RNDP?NCfAc@PDHRBtBDf@n@bDbAmA|B}ExDkFxCgDZq@T}@~@{CY_@MYFuDAcEB]dBkKb@mETwAx@aD|@aEH?xD~B?UV{@bAcBDSRYRe@h@oB~AeFvAJdD?hGM~@Mz@G@oA[uC_AsGg@mE"},{"id":"2022-02","name":"Paris - Chartres","strava_route_id":"2889901527179733988","distance":108119.26452964457,"elevation":946.0372885966083,"summary_polyline":"{sfiHymtLL`@Gn@sAk@iEqCiGaFk@m@aEqDuDoDoC_CqDqCkGgEeDcCkFsEwE{EuEaEoAdIm@pEm@pC}BfHaBbDeD`F{@jAgAvBaClGj@t@IrEc@tN[hFa@`WKDERFdDE`@s@zBpCnFv@~C|@|IfCbMRx@dF|IcChEnBjCTT`@x@nA`FNNVAJM`@w@|@gATQPE\\\\@i@rE_@tA?RDV~@e@hGb@vAFt@@RA^Mf@i@jBgD`@i@HG\\\\GTFzFrCPBLZ|@rA`@VTFf@Dj@?NIzEB`FzCZXrRvVNVjAvA\\\\YdFQfAL\\\\k@b@k@zFyBj@Qd@@XIz@bEr@zD^l@~@r@nAh@Df@Vf@f@b@rDbCxMpQb@XvGpC`Dn@XRXDWUB@RRLTbBr@j@b@PTRr@P`@TZv@bBvCdJ`@`AZj@v@`ArDdIv@jCdAnCV`@@b@ZvAp@bERtCA`AQzC@hA~AlJxBhQh@~CC\\\\]nAGd@@PPf@tClCPMTa@VBNXPnAl@fCt@~AbAz@b@sApB_FnKlB|Cp@x@I`FkCv@WDQZT`EpJJFJ@VE~CsAXGtA?bJ[RxChA`Ix@dBx@fAfDvDh@bAnAvDvDbM^Q`@|BLpAHfLP\\\\LDx@KtJqCrRzNj@t@\\\\v@n@pBxAbRb@pGf@vL@fAEp@y@pFo@rD@|@p@fEt@lCx@|BpA~BVfAXbBbBvZ\\\\vAZz@j@lAl@z@hAt@pDzC\\\\Rn@HRALDFH?ZK|@?VP\\\\T@SfFB|APhAPn@h@`ATTp@b@f@HRAd@ONMLQN_@h@gBLQd@]l@EPBd@N`@\\\\Tf@~AdGjNbj@Fd@?Zo@bPC`@Mb@Dz@jCTlPvI`^tQNTnARvBf@FEXLnGbD@LHFpBdARFlE~Bn@b@|@f@d@P|@h@fB|@ZF`_@vThEmTHOVwAAa@JYHEn@DJDXXHP|@hFl@tGVvBLn@Pj@Th@X`@^VTJ^B^C^Mb@[|CsDx@iAr@_BT}@TyAHaAd@kRFeAVwBXaBp@mDXgAPgAtCd@VPTHpBX`AHh@GnALxDj@xGt@xFv@lCvAXHbAOP?LBfEpCe@zB@ZDT~BdC|ApB\\\\ZbBnAxAZtAJmE_A\\\\VxAZrAJLC`A^^f@`@v@d@hAHFV@NDd@TPPn@VpCn@R?~AXLWhCgIN}@BCJDBJmApJ?v@LtAL\\\\hA`@LN|@hBX\\\\pCrAATJLFdCC`@eAtFRXnCbBfJvG?NR^DADInDfCNR?VDJDBJAFBt@l@fQjTNVFBTCTYbCeGzAeEXcAbA}E\\\\w@~AmHJgAfEmRVeALYD?LGXLbGxDhB|@rRdM|@^z@TdD`@bWnBd@AXFTKf@XpATfAX`Ap@dAbAl@bAf@dAh@bBM`@?RBLLNN?HFHh@R^PNl@tBr@zCjA`Dl@lABVEN?\\\\PjA?hBBBZ@K~DK~@@DIXEzBBzMDpBTrAh@jAxWh`@n@tAz@pCbAxFXhCJfB@b@Oz@?T^z@F`@D^Gb@Fn@NTRJNAt@^`BxCfA~BZb@dFlE\\\\^jAlCfDdGTp@PP^Jt@@vA[fBY|AId@DPFjAbAVHTGJITg@Be@Ea@Og@Io@TaCL\\\\LNPL~CtA`Cb@^B~@OnCcLvAuGZgDLs@vF{Ox@kCrC_K`@eD\\\\{BV{@Ve@j@o@r@k@vAaAjBeDrCoCzAkAxByBzAoBhAcBzWsd@d@aAb@oAZoA^iA`@w@dBuBdCyD\\\\c@rCuCfAJxAn@h@JrAWvBo@xD}Bv@m@hAuA^Wj@MxK_AtANXAPEVSDFFBFCDOVGfDeBVGn@EdCd@xAb@z@@XB^JVRvCnF`@zANHTAxBn^xBna@FzFCxD@x@h@lGBvBCr@ObBc@zCUpDmD`RuAxOMbAwB|Ic@zBKvA?bAT~DB~@?lAIbAcC~TuAdLgBbPCjBHtBh@jErB~MTxBHhA?bCO~AAf@BZGJAPDNHFCVCpAOfAC`@Bl@RhAjAfCPhADBDCZLnBtCdA|CPT^PhCBxDh@zEAp@JxFpC`@Jf@BrAG`@@\\\\H\\\\NlGxFfAx@l@ZjAf@RDb@Eb@KjC_B^Gh@DvCr@d@BdAGXKzAcAt@SdBDp@Gv@D`@Nd@b@lGvIxB|E\\\\d@d@Tb@?t@Gh@Qd@Wh@g@r@p@`Af@rAJpAErA@dAV`Ab@tAt@jBjCh@vAb@hBCCj@lAhA~ATb@@PEd@?nAHd@Th@\\\\tAhEnTt@|BxA`Cn@x@pAlAxExD\\\\b@Rb@@\\\\ATuAvGh@B|@TxAz@t@l@rBt@XCEj@mDvVcAvGuA~JGp@GrBOtX@pAn@xPB|AWtFi@lHYhFKp@Zn@X^VLh@Nb@\\\\FXHDdDoAb@EbCpA^X\\\\Jv@CbBc@vFiAd@DVZLhBXvAd@~@t@bAn@j@xDpBhDjAdAf@zD`CnBbBd@p@f@~AJhAAjBG`A_@rBEt@tRn@VCnBlMZrCN|C`@d]H|@Nr@Pj@Xh@Z^\\\\XvIzFTLh@RnBL\\\\PcQtaAmQvcAQCOLEV@TFPNHPELc@lCVdBFr@HfATrLzCl@JrBJba@u@dCIrE]n@|AfK~TjDhG`EdEjKnHlEnDfHjLpBzEvFtQb@fCGhCiBlKHdBbBjEz@jBxChCz@PrEAxAZdCp@VVZjGGtEHlBh@zEZ|EPx@l@zAbOhe@RbADd@C|@GXQVg@d@KROl@I~BD`AHh@PTRHZ?j@W|CeBx@gEvAiF\\\\c@NELCjARrEfA`@\\\\z@bAf@|@Lp@^`GvCnNvApG`@t@~BpCXr@JhACtGGlA{ClZq@~K@pOd@xCnAlBxDtE|CvCjI`KtKjLrJlLrGdH~TpW`CnDrHbObDdHTx@BtCHf@Rf@XZVFvA?\\\\FXPd@l@x@dBX^f@XbBb@b@VR\\\\Nl@ThCTv@`@p@`Az@xI`Gq@nCYt@k@bAxJlTbG~FbLdLnUbRdAn@zKzCVOvAeC|EiHfh@ql@NGF?DDhCfJ`BfHVv@LHx@OP\\\\~A|KfCdGlC`GlArBvAhBbEtEjElHpHbQvAnGVj@jDdFfNfHhBvBxClElK{JtCdDnBbB`@d@dCjFd@zApCdPElDX`EEjBiAhDmAvBz@bDdAc@vWkC~COjBJ|Gj@\\\\A^O~AiBf@]z@WhJ{@tUs@z@IjNyCp@Kl@EnAA`H@|@HhAPgE`b@`BfBRtAHxA]dFExE[fEI\\\\B@@h@CF@Nr@z@zAtA|CbDpB`Dr@|@JFfALpFDp@JnJhG~@f@lAZ|Dp@lKpBT@JF|DBh@J`AVfBx@lA`@|Bh@vNxCXJbAr@Rf@jAtBj@r@vEnEpG~GvBfBh@\\\\tDlBdC~A|AvArAfBxHzN^z@x@`Cj@nCm@XwI|GcB~@yCtAw@RoAJG~BFdCKrAa@dCUXcCmBo@Oe@Ng@BmBT_@AeAx@dAnGV~B?lBaAxKkBlKsJ~NoFlWsA~Aq@r@yAlBo@lAqBdFKPGlC@~@HXNRZHNAVOX_@NG`BBNDNNJRF^OtIc@dR_@tSc@vIc@|P|FdIxJpOzAhB~AzAvAhBnBvCfCnFdHvMfAfBVfAjGrK`BhAf@h@vExCXLb@J^D~EB`@XbErIfAbBt@t@pBrCnA`Bh@l@ZPPZNj@Hr@ElACjICt@s@DKfB@~BJhDBtIHhD^dCt@|B^dCh@pGt@nGl@jBzLpX`@dBj@zWKlLc@jLv@lDPjBG|@m@bExI~DpAXh@Zt@h@fBx@Rd@b@bCdElPv@r@vDfLz@b@LfGF`@JTNH`@HVRHn@IhEFjASNO^qAtHMTyA~@q@n@kFvGy@lA_@x@Ql@Mr@QhBCd@@pAJbBZbD`@dDTdA~BfDPb@FZAVe@dDW`ABf@f@|A^pBJr@Bd@c@lq@K|Bq@zEk@zBiAfDu@jBk@vBOfA?lADn@LFp@jAfBpArBrA~A~@f@n@^n@PRNDhACNLNVvBxHPh@T`@pCzBbBxA~AfBXTRFl@@jBIPBPTXhFVpCfBnNCKpDlWP|@d@zAnAnClBrD~ApCjG`JFZ?v@HFz@nDf@lDZzD@pBAuB@rBW~Am@fB{@pAmArA_ArAo@dAQ^s@rBq@~B[dBQnBMvB?pDFdAAjBETnBd@vBp@l@NHpALZb@ZlAD@Rp@jBBVCx@Sv@i@vA{AxC}ArDr@tA|@tBhEbETPpVpWjEjLEInCzEfC~Cr@bAt@tAh@`BXpDZ~CEvDy@bL?bAFvATlCp@`CR~AKlBQlB^|CTfEc@oGLfATzDClAQnAg@t@aCbBQ`@Df@bBhCZfA?jAc@fDXJrClCx@`Ap@l@`Ap@zCrCpBdC`Xd[tDnF`AdBrAlDvBfGn@zCr@nGRhARPHPIzA@~GOnESpBm@nDBxAFdAvDxSdA|CpDvDf@fAjB|N^bHBnOHzBdBdXVrCVnBb@lChAvFZnA|AfFpA|Fd@`CRdBX`E\\\\jNZbEX~EF`DLtCdA|Id@dINzCPnJn@dL`@lERxAjA`EL|@@|A_@tR_AnWa@rIC|AA|ATnK?`JExEYdFO~I@dDHdA@tAApEKj@Ad@FnCFdJQj@i@pAu@rAoAdAcAlAOLM@QbFHd@e@l@o@hAqCpF[x@Ip@MjC@v@PfATx@@rAOxD@fBHp@b@pBDt@EPMR{@f@K\\\\QpC[|CcA|Fa@xCe@lBmDxIsBlGgA|Gi@zF]hFUrEYhI]zDe@nDo@nCaA`CWLCHgAjAeEbGgAjBiCbFMb@@^RpALdBJbCApBGjCAfID|BT`Cf@|BvAfE\\\\|AhAjIv@vJ`@|Bj@zBx@rDTj@TXpAbAjAjAfAz@bDzBdAlA`AhBHd@Q~@Bb@FRhBxCJ\\\\f@TRb@Vz@hAtE|@|CNbA@bBPdAzAxDJvALxE?nACV`@jB`@nA`@bA`@t@fAfCd@|@f@vABTCVQESDy@VmDpAQ@APKNK?Dl@nA`G`@|CD~@A~@OpA]pAc@nASfAQ|AWbEg@pD_@rAiAnDOn@W|CYdCAhAVxAdBbHHpAUrKMpBKj@W~@s@~A]`AQr@O~@KfA?|BPhAZjA^t@rBnC|JzNfIdK~A~AfDfB|E|Bt@RfAjCbIlPtAlDbB~BxAnAp@\\\\vKdDf@DhA@b@NZXTb@tAlJ|BjLrTpn@d@fBBXG`@\\\\Jl@gAN_@z@{D^}@^c@`CsACTHTR@Tb@fBt@hBZFCHkD`@Nn@JpFV~@XlATr@@`@GTIjA}@t@u@hAeBzAkBzCkE`Ak@jFoHn@o@TOZG`@?\\\\Fz@^tA[h@g@h@q@hAeAbAg@~@S`L]xAAlD@d@Bj@LZVRv@bA_@?GbBURG`CcC`D}@h@@nATJ?bAe@l@N`@MTWCD\\\\s@hAm@`@OzBBj@EvBaAl@IBn@Cp@Qh@]j@aAhAeB`AUj@h@r@|@XX^Xj@FTXb@jCiDl@]b@g@b@s@JKxBk@lA_@f@Wv@Ox@VhB?pAGnAs@hCqAT@@xB?QCv@_@z@cAxLe@rEMd@c@hAoD`GQtAQ`@_@d@YNi@L}CWsGu@OH_@p@iEpI"},{"id":"2022-03","name":"Paris - \xc9vreux","strava_route_id":"2928305507756502406","distance":152540.93330444972,"elevation":1107.9122943397233,"summary_polyline":"_fiiHcn~L|D|K}It^h@fMeIjKay@jpDgJdHkIjTeWvQcLoYmc@lb@sFrNyOzBuzA`{BuChOcOdKgSz[wk@dn@}TjcAjF`WkPbr@xE`C{J~w@_IdQvCzFeCdElCnGoSnf@oSvD|GdPmCxF`JzH}ArDpKlJjEu@tj@nxAt[fYn{@trA|Ktl@tNrb@rLxHwGmL{DcZff@`_@fj@zMvQnc@vIdDhMG~G{Mvk@sANcPfEbL`GwBbEnUvbA`zApNlInLbZb@vF}BpAvJzShBrQwE~l@pBz]bGnCb@vH`EE~Ghm@y@tQqM`YjJtPek@dmAo_@x\\\\mT~_CmKdg@jD|YoCtMoLcByz@hrD}b@faA`V`R`GdUdK~CrCdZdFgBbCvIp`@p`@SdL|sAvMh_@tk@fClx@oTn`ByKhUgCte@xJ`P|ZlL`x@kIhG~Og@v]~FvZrRdZ~Jjd@pn@|kAhZpB{@ja@eOi@kH|fA|Azf@sPz_@eKpo@qJz@mFxSqV`e@wSznBcNla@\\\\bVaF~_@tAh[tNph@t@~^qDt]zXzTrj@`uAzQx|@~`@trA}NvOzOb{Av@d^bJt\\\\_Pfp@um@jkA_Q`SaRsAuW|KaNj\\\\SzIc_@dUgMbo@qGjKmBte@lGtt@n[zy@a@pRrNjrA_Fzo@bAhKaInT~c@bm@hbA|~BbRnVvJlWiP~l@j@xj@{Ijc@eDnrA~L~l@xZ|o@kA~\\\\nQxm@oCl_@oCtGwRxJud@ts@_Hda@{LpRcJnEd@pf@sDjWs[jU_AcK_DoAg@oOiNbDoH`N{AfRgNfX|AlSgCfCjQ~v@p@bPcI`IxGfy@tJbb@hTnV~Trx@bXz\\\\hWvv@y\\\\fx@kLaQlBzXkOtEm^j^`Hjx@mDjOwH~ByCeO_F{BoSbW_Hf_@k[nt@aJt|@cN`N}Sfh@e^t\\\\iAvNwNz[}AfQyZpDoFzWcLpJkY~o@m[fh@gB_LeGjWhBlAeCrTzAbCyUxp@u@~vBmQ|~ArAlTaEpSc@hkAuHlb@kRle@}Bzd@mG~Rj]dyBdO~YvCno@nSl_AkFpJmEpj@`BnYgCnQJvj@zCj[a_@`]sLhTcHvh@fCr{@zLpd@dXla@vIxDZnXrGjNwFnKjEbA]rVs]hEcD}]wJuCoY|]kQbHmCoEqDzII|V{KfSQhRgIgAuMrVyTaJaGld@sBmD^}NmEoD{Qj\\\\eNpIkJ~BcFwIyHyA{M`GuAnJsv@jeAyJUvA~MoJlYyGjDqQmIcj@~hAyQvEkNgb@uR{TuTcy@cf@qu@|EsKuDyN|G}M{EoW@qZiLLoAtEnD_IiMwXB}IkLEtBqdA|VmWoEuw@{UusAfKqEsOi^pA_JkOgTcmAis@{Sq]od@kvBqEqw@jCkA`KfZ|EoA_CeKtOeC"},{"id":"2022-04","name":"Paris - Soissons","strava_route_id":"2929029056036187416","distance":144485.52887011255,"elevation":1437.1747276379836,"summary_polyline":"{_miH{txMd@|E{Bb@[uRqGmm@clAocKuFqMaLmNkiBctBwHkT{c@yuClAw@{Uq`BiA_HuCaAcEoOm\\\\q{BmUqsAkAh@{@yNvH_l@X}Lq@oHeG_QaBkOgWkqGi@{DsEF|@mOsDeIkJkCmCmIsIX}NwEKmEvCwFXwImDkZuSum@p@wXrFwFl@{]cp@zDmRvFwc@rAuRvOqOeBk`@sc@uf@mVoBEyChOmn@tImBi]ePkR{GmWU}j@oE{h@Lgv@dBmPgZsLuZ}RyGgIqE__@b@_IqHrFcCpGgNXeM|ZuF|AqElKuKrIuG_SaAiNn@Y]iFzBhBlCaLh@g`@aXgW{GkUeEv@uA{EoVsHoF}YcDeH_B|H@`YsA`NyMzd@aEj^wEtcATxKcf@_HeIaE{AkYgKkI{NgFaYGyF|C{\\\\zAsZgH{NNyHpIOcEgE{DgFcOgMcRmGuUiFiCoDrMkG}GaGb@cB{DaK~McPGgFxCwY~c@oa@rWkXvXuMhDaMtJw]hG}GgQiBLwF{Jih@lAo`ArWwSbQiZpJue@nEmb@eB_KeIcIaAqDiPp@_BgJiFiN}AmWoj@iEwQgOkX}Fo]kK}M_O}r@x@sGeBiYhDwVAuUqiAvMsDyAuAaFkFmEaSqCu\\\\iUoLhJ_H_HqB_e@D_`@oAm@aEqZ@om@{FeDy[yg@gDc@afAdc@{TxDuI`Q{B|JsH~CcKbO]uNqVqMsGh@yVwT_YaI{Gqm@sEjBkIw[}Iaq@aHwYkh@w`@?mo@eDwCaH[yAcEp@cBfEr@`IgCOaOaPgMoK_OcKjC|@uIaJ_KsQga@oCuWj@wn@wAyDoHq@wBkF`BoY]kPqX}IvDm[jAa|AnEeWiBMkFgJyG_AsSoTmH{BoQgV}Co@aD{IwFsC~AoGrDyCPyFyBtEaRoHoAjAe@wIjCgOXsNyCkg@aB_JeXmt@vUpBbNaElPpA|Qm]jH{AnHy]rQG`MbThD}D~@rBxGuI_HaV{Ge`@?ePvSypB{@}NbBkI@eMrJoYrCy}@OyVrGwGjAkGg@yr@}FwLvCmt@`JgS|Fcc@oAkk@fB{W?ue@qCGsAvBi\\\\gQsDxAaEsMiDzDwFYyOjKyH`BbCaQnVej@hVwkBrDqq@yIkm@dDk]xHpHw@}^kBa@eHrQyE`Eo@wKaWiYgRwQ_RmG}E{GuMaBaLjDk`@jCkQuIsG{IcDeYcI}JvEsV~JqEnIgJn@kJ{AeKyEdAM_DlDgGrBr@lBaF\\\\{XjHaZgB?tCok@sl@~Lua@mE}JxBcDgBsXf^_QuFwJxAeHoQhSyNdEoGzJyCnJqHhCqEhDaRAka@zE{\\\\cBsIt@sGqGea@wAw]cOse@sBo\\\\r@uPuMwg@k@kR`BuHXec@`E}_@l@yZ`I_g@`@ce@r@sFzFeMcCgIFyMjE{Whc@_tAti@yt@t`@ao@_Iq\\\\}Fgd@eSmFaJ|C|BsGeDqTZ{IqKid@uNiTwIqVmJka@|@iMs@qGcR\\\\aJeM_FkM|BqGrSaI{F_WkBuf@}CkQoCul@hHmg@yHqBi\\\\~GsR{@{CtDcAlI}GJ{AlFaC|@eGoG{ENkEjOeLlAeMd`@iUva@oIpKqQfKyEbTkA[K_UqFxIaFNoA~GmLbSk\\\\bXvLlMuLza@{HhJqJ~Dsa@p}@wR{WyHnMmMAwDuiB`Ih@nCbKtAJrJtNrIo@{A}KsFkL~PkMqHyFfi@ar@"},{"id":"2022-05","name":"Paris - Amiens","strava_route_id":"2929053386404412806","distance":165445.55299888167,"elevation":1379.564327849094,"summary_polyline":"_fiiHcn~L|D|KsI|]gOaZkGl[qe@b`@kB|Q{Oz]ob@yuAsJ}|@hPsN{m@_eBa|@r@_XqyAaGsM{EvIqoAqkAuQsC{XjG_U|NsMdX_UtvAyJjkA}^uGqJoJan@|q@}C}DcDfFyN}SaKtKqPqH}HvRlIzk@kIbOg\\\\mDwBtYw\\\\bXsT`\\\\}LlDgk@uLgG~n@uTqKcKgNaJhUb@nF{YpiA_Mzv@qWnZ_~@ftCeRgL}WtEuq@{ZuCqXeT_l@uVaWsFah@{SiD{LhEmJuF~@nZaOhdAyMUkChG_TfKObs@cn@hyA`AvSeFnT{n@cNyRl\\\\a_@cHsKn]`B~Q_C`MmWxZyOn_@wK`H_LiCq`@rg@ic@h@iYgQeZti@OhTaDfGaMxEiCdMkVx@{QxKaSfp@G~WgGjWsB_CiRxIwVoUyCwLcE]i^tTyi@pIkToD_Qsn@uJoNaGo^ak@eoAyYqZkl@_]eE}XxAuVzDoCqCwN{a@u`AmH_KiC~AuDcSmh@rw@}[|x@kRvZoPhq@cFnrAsTiD{x@mx@_z@wQ{gAzr@od@bIoSrMlBjMwG|V~F~}@cEdm@kBtDkE}BnQra@wh@og@u{@_Q}Z|BuEhSsWHke@`e@cNq@oJvHyF`LJpUo[rPgExTmWq@n@_PyWqM}Mkj@gAi]dJmi@JeaA_IaQvAfNwSe[s]mW}^yA_MuNcVgHkOyQgKbViO|qA_H`DjBhLcQrK}EyHux@eYkGcIqa@jMqG_NgG~EgLuCyI_VuZ}CwUy^yYaKeLaPmLfFiLsBmJc\\\\iMkH_UpOkEpY_@bj@aMnAeJqHHeNgImIqh@}jAwb@cYkT}^}KeBpAia@_MjEeg@uBmIrHeHfSyFiAwJiL{c@wFmaAyf@kd@}~@iMgEcM~B}BrVwJbKqu@f{AiQfi@oCja@sJgGmMtAem@nWoAhGaKz@g]t[yGaEp@uKcNwEeUjAyYvR}pAbDeE}DyAjIeUqTe[`a@oa@_B_dAbMiYuSmNvY_x@wi@sDfo@o`@lSwfA|Za`@jWaObAiZdPmAdGiI~BfCrWc`@zf@wbArFea@zJ|AlLeLnOmWtKaz@v|AkKcJyq@gNqj@w\\\\_Rw@w[tK_NwIcGxBkH`WqMvLqLlk@uLxOcBrKyt@vVwDmC}AlKmZ`GyUx]sAyCeG|E}|@crAsq@wLkVqReLs\\\\_YxQ{ZdDi\\\\u^c[aHwQtAqeAc_@QqmAqLwiABq^yI}e@}_@kKeVcQeOYc{A}e@}UyR}J{AgKeY{Trc@yCs@}g@sp@oOkc@uo@sd@oa@}r@a\\\\yNao@uf@}LmS}E\\\\ot@wr@qKwCuJeUiBlDqq@qEkUkHy[bFcOcIgEwJdFmOyEkDyFdIsXcl@dF{Lc}@sn@ys@kbBeAtF_MnHeYymA}a@md@}AaZ{EcQ_CpFaWqWeHuZvDaZcOqMxKoUyKqFhAaIrKlIjE{R"},{"id":"2022-06","name":"Paris - Orl\xe9ans","strava_route_id":"2929377062062317848","distance":169445.49856453296,"elevation":855.3529370284162,"summary_polyline":"ab_iHi`vMpDkcBv\\\\saAjBsgAtGuv@n`@kz@vYs`@pUmsAvNVpn@it@ze@oiCuS_QlCcIfP|Jo_@_u@dBaTzi@ci@|DtLxLiEhQnIzCjLpJU|\\\\bl@hI_JxHbC|a@}v@fJ{gAbScGiBqSzRcWfcAb@hHbFlCi]xUuHtAcPrQzCvYcUpCmN~V}DltBdaBfWrb@lEjb@bKxRfKfJ|KcT|KeH~SlY~Nbj@tE}D`Ctw@iCnXkMzIoIuDaMzXzn@h[aNlo@t\\\\dvA`\\\\dOfiA|Hpb@lLza@f[nT|yAjHoL`r@eCzPfk@hR~K`KxPnBxM|H{LoCyLn^eZnE{HJ{K~Qi_@dy@o|@zEpAtEcUjhAmNtaB|T`t@~Rja@_RhTm_@pHm_AfFm@lBeQfOj@xFsnAfHeBrVqe@pIch@~]dO`l@eOhGte@~Bc@rBjH|Kj@pj@`ZvTr^tFaKzQzW~i@rUlp@nv@rJdC|HaIh{@kAjZfHzf@mAxs@|UtWoe@tKuIxl@f}@|^bTbOph@jKfKhTde@fYvF|BrLkBzVdPxRhQla@nPzFDfMxPbUxH|bAuDpUyHnJlF`MxUzfBbMrI_DrK|Fxf@_@|]hLj{@tl@eO~Y}WxJ~@|n@er@bXtHvKrQt[bUvArQlZpMvi@Sl\\\\_XvIbQv\\\\lTff@rFnMyLdh@zCzMyN`NuCtIcb@hJsCna@b]lVZlV__@nNyGz^tRxPso@d_@qTdPmBqCerAvE[pN|PtKuMbn@yFtE}IpJIfS{NnKmPbAoR|HiGrHhJl\\\\fDlGtUd[hHfS{Fpl@j[xSAdRwL~MmWrXoOwDi[b_@iPlCnJ}Arh@nIbb@l|@{e@be@KtJrHd_@nFnNpTfNfH~q@zQlb@`c@tFIhQfTpBdKbTkDbCkHzEra@t`@f`A~XpnAkBdTnSpOpf@y@jf@}MdeAp[tj@uK`_@|CrKvObB~Ytg@`Jf}A|Bha@fYWtXfMbDrAeDpHhNvJcTr}@eF~k@r[rl@nt@t\\\\`V`fBzN|Dtg@f`AzbBaFd^zGfd@kGj_@bBhLvPjZaI`Q~Jnj@{E|k@vdA`dAdU|y@vvBaGvdCf_Dd`A|yBjDpVnJlIlo@dsA`l@lTsK|Pa@xPaG`LpPb\\\\aZfiAi@xMxPzxBF|p@lDlQkPpo@kCte@jQnb@fDvr@~CpI}B`JxQa@lt@dj@ne@rx@b]rqAlWxd@vf@jrAny@bgAfg@pY|Hv[Z|MhMbb@jDnvAsK`YwEfk@rDZnAtGdI}HnOa@zMtTlI|s@~H|KbGrn@oBf_@hHdeCh[hs@lFuCxCt\\\\hJVjHf]rOdsBr@~k@uV`Ax@|UqCbCad@hB"},{"id":"2022-07","name":"Paris - Nogent Le Rotrou","strava_route_id":"2934410159469854402","distance":185738.91563343332,"elevation":1512.0418532726233,"summary_polyline":"eeiiHel~LbD~IqB`JjFlSxMdVpB~b@zT~p@tA`c@zSzgA`fA~m@n[iB`@{DbQjd@fx@_VMiEh|Aas@pWbCtPbTx_@bvA_LvJzHIhBb]`{@tx@rLeNwCpW{F}CgCpf@gPvh@kHxd@lCpH|UfISdf@p]fd@{Qn|AbBp[eBjP`AfzAtJjFdEtWrm@pa@z`@rF`o@lb@dGhAvD{K{@jOnIjHnOk]zEmBhnAbv@h^vCjLsLpVjA`QjZjFjm@tq@nm@eGj}@rKzBnZeRlI|@|K~^tq@hXh]rBlCzIFp\\\\lPhWbBtPgE|@w@tMxEd}@iGthANfn@xFdd@dMb`@rBbiAgChl@eRxsAp@ni@f`@do@dmBreAdHlZ`V_Av\\\\dZIt`@cLrG{Mrr@wQt^zAdh@iFtYyNpXuGhZiRn[kB|XeGtOce@de@uE~QnA|^wP~HsHx^Mh]zFrBzEoOdEP`DpPhMxOpn@fQtXbQiUh`AcIzOkG~|@uRnf@mJ~f@uOpNwHvRaQbgA}Tf}@~s@vd@fMxw@rUvw@tL~cApO~e@a@~[`TdYdYpp@`K~B|B~G`NnAvJhR~Bdd@iEfl@rE`SpMnPlBlTzPbo@Xb_@xF``@jXvZjB~WbTtr@pIvId\\\\tEoXvbAu{A|lBuY|kA}Vl]_\\\\tyAkGxf@oDfkCoRdsAcAf^nAzQp]|T_BrUgQ`h@nPxe@tF~cA_G~UtEri@t^tlAtArOpF{HtL`AKkJpSdM?rKxHcFArEj`@j_@s@bSfQib@tX|SoGbToN`PwOru@{E`AwKpQcRgOoBbEyt@blCzVf\\\\_Lfi@lGhAzDbSxAq@fC~WvPv[bD`VtOlVno@vrB{v@xbAm[b~@_Tp~@vDbWqApChG`UmExBnFjXzC`j@b@v^gDjc@tKrEdKdpAgCjq@_^zfAuFrd@re@zmBnDzi@kWrT|Ena@jKp[x`@dZlPk@nBiFfUbIlBva@aIl^zCzLjRtQdFnPcAl[eD~GlJ|HoMzi@y@bTfd@jo@vSlEnT`h@nSzLjFzJuFxGJtQgL~HsPtd@oF~AbRni@bArs@hOv_@fJv}@eE~Nj@jS_GraApf@p{BnQlVpH`yBvLxHrFdXnc@jUbw@pt@vo@_Cp_@x_Btd@pj@by@xaBj`@~d@le@ltAte@jSrUpf@K~x@xOy@fP|]p^l|AdP~fAtx@fcCyJnKmObz@{@vr@pUra@xPdw@nZdn@a_@zxAoRhlBdMfLpW`AnLtLQv^bj@xqAfZd_@dUxOzJgChRtI`Ixb@qE`WrKvSqInYbLpq@mBlF`PlUrFzf@`LtSrYzXbHwUpJsHrnAcUzf@iUvHaOxBqQpEeBhNtXn_@|Rzj@oFrLd|@~d@jUds@~Cr~@oR~LrBjg@yWlTdCd]vQnDjDsBzTb`@{q@z_@gWt{@uWjUzu@p_AkSzSlR|c@bCdR_c@va@mT~PxSbd@jZxh@e@pa@zk@`s@pp@fD?NqF`ExF~F{DpD`FdS_C|DqLxSlG|A_UvI|A`E}I`L}DvKlA|HtOpKsC_CpQsPpH_Pp\\\\sNjGsPoBeG|H"},{"id":"2022-08","name":"Paris - Rouen","strava_route_id":"2988846800236627594","distance":168042.24030811212,"elevation":1887.9049589006906,"summary_polyline":"urfiHuotLo`@xcBaNkAaDlPhFvCr@tOaHiD}FxGoU`BcFrFqCv^}Ix@ec@h^cBr@z@iX}HqK{E|HgPm_@{JhP_LeWuErHaRbAyFfI_@vNsIjUia@it@kd@exAyq@ndAs[rK|DvQ_z@hbAag@pwBa`@`hAuv@qp@e]kM{^oAsTxDmu@fc@mSxVuTne@wNpfAuPxu@[t~AuI`m@zDraAiBr`@zBxgBbTl{AuHxXwJoEkRpDsBlg@gKzLhF|k@mElkArHfq@y@n{@hIb\\\\_oCfjCmLdD}Q{PiHzBr@poAmGxg@iz@xVgOcDgJxMiS~IgNb]qEz\\\\gNdYyF`h@uGtKgDoAi]ly@kLje@_GnGFzPeQmAgFbFk_@pz@qY}[gYyK_KraAw]dy@a@x[oIbWpI~JyPdz@eArTlAvQnOn[_NpV`P`NnJPeH~q@jDvj@{CbsA|Od|DcJjMyTkBaErEgNl_@r@lXg]hz@iRgIkT^PlbApEdOs@tKnd@bZvSp~@tGn`AkJri@{Ujc@{Elk@dDtRiNuFcOxQ}eAj`@{h@dj@cNyNggA_Cej@sFaGqG}MzBwOuZcV}GuVeSwe@_LcKyKom@iOMwFoG~EaTaLeUtWsa@xJml@gK}WcUqe@_NkMeAiJnJkb@wuAyPaTqAcPcMmQ_HoZsZmn@EiGqK|CcJjXmR`LaN~QcQrf@yj@jAuj@qh@iLsVq\\\\iV_FaSoPcBmDpM}H}M{JO~Ba`@wUxBkYuMqa@bOq^zV`BhReOfFmXpi@}j@x_@qsAzkB{Dfk@{KbThElYe}@tJiUlKkZ~[aoAzUwOgF_GeM_MH}BnP}DhE}OcVgYu@oo@~e@eGvJXzLaEdNua@jh@oEdSqAn`@cI|[zBrJaMpX{LrFcYx]wQlj@}U|@ml@jeAiD@mByOhF_@DaGgy@_aB{HjBaEb]iE`BnAzIy|@gHRfd@eCvS`BdNmMzu@eBzc@}ExMzVfg@t@nLbK~T{Ups@eLtJwLv|@yKhH|Qp\\\\VpJiKx]}QjSwNd`@iN|J?bNoN|CmCvLmHhFgDlScp@wP_ZxxAqGvAeKje@E~SrQloA?nf@|Idt@zE`BrDwU|GjFlk@a^hd@z`BbzArx@c@jLxGiLuBvUjBjQrNvZfMbKte@feArHbc@dJsApOnZ~Dxi@yCvDlC|OyOeL|DzM_TdrBiHrc@iM|[cLjInCpOy@r_Au_@t_@oCdbAeG`\\\\ya@xOgJwAga@nu@}FfVlIjWGh[xNd`@{E|d@fD`]cDbo@kLjh@}WjQ_M`[k@ti@qMdkAsRlh@kDhAgBdNx@x\\\\dL|`@lDp~AoBz[bItj@qNjlBpDnaBzM~ZcGt\\\\pDdc@AxqA|UdHzSz^|Ex\\\\xFzLXh]~I~JnLdj@pMd\\\\mk@nw@}DrN{Kt|@|DvDoBlT`Dl@gNn_A`@hz@mGrI|@bTsN~SoAjgAcYpxAmLPqFth@sUgK"},{"id":"2022-09","name":"Paris - Maintenon","strava_route_id":"3000388134503626468","distance":154184.26038037697,"elevation":1269.12092931731,"summary_polyline":"_fiiHcn~L|D|KqB`JjFlSxMdVnBr]iDxNaKtIzeArfE~WxLvtAMt]hs@cAhh@xCp@aCfAvRfWjLnsDra@vcAjAtS|LwClVzUdDlh@kB|QdH~V`Cn]hNbMeG~v@v{AjMtDtlAhObLjNqQdb@jV`GuY`GhWdE`BdIwL|Eej@r]nE`o@lb@dGhAvD{K{@jOhJjHtNk]~DgBvNow@ja@fo@Ffc@gFlAdb@xVd`@lDnIoKfPiApK`EdFbMnN{f@zdAaK`RbLaI|d@nIuJdCgLnH{D`ErHfNvB`XrUkl@dbAaWnXoXzgA|\\\\sRlIlCxHj\\\\uQbh@oX|SoDbf@_XhMoFhSiKvLyYxmAtLp`AvN``@zVwItQlChWeaAtj@g@~f@tSnLtNfAjJkm@~pAe`@nrBkKt`@_OjW_Ejc@i]nfB}h@x_A{Jx]d@|E`HiK~d@vi@na@mGdYpQrHgDbBvHzEvBnC`_@nFdAtGyj@nUws@lLys@tQm`@hLkp@vJmKkCaL]_d@vQoqAhAsZdAoDpLdFjRqh@lIyEyJad@pOcHlU~g@pW|CbE|MrXo}@tJoHxb@|ApFrKzV|N@`OnSj@vEvx@jSlMod@vhCrkAtBbRf`@ba@pa@lKx\\\\qBvOhD|K`T~FbBh_@vQbl@uAhNjG}A_MjJqb@sCmT|LeNpPiLr]yJrGoItUkb@bV}BvB\\\\nKyZdUyRtm@wLlQgQkAcIxyAyMxPd@t]uMrIyPzWib@rJew@eDkD~MlEfTzF~bA?df@}a@h`@hh@fl@pPeEsEde@bJrC_Ivb@uOpNwHvRaQbgA}Tf}@{^sSsKsPgh@uG{N{Nc\\\\EaKwFiEyJoE{v@q]~NqF{UqOiXg]F_UqLw[_o@qYkB{EvNxC~OuEbFjBdh@gD~J{H~BkSj|@kUdJwg@vgAeXiIkLvAoFhQqQtMyGxNaPfC_`@tUsHxUmH|Hxd@l`@b@pVhJ~U`CxUvMfThMrCwArV`BpXt[uEtCbHbb@mCdBjOxYvO`Svb@gJz\\\\Q|a@pGzK~MlDtGzWlRdMfL|\\\\aK~RsFd]|Erl@ol@vmAa\\\\fcA}Cbb@gPnb@oDfZnI|KyDrN~JfNXtPnN|Ihf@kLf^d[|w@cBr[lVpSoHrKsx@bO~Irj@qo@|EhKps@hf@hl@xw@|XtHl\\\\mQtj@xX|g@uD``Afb@pOno@tQmTz]lSdVjm@~Kjs@iGdm@|HhNLzM`KoB|UvO^b`@bH|e@nEbkBzBvVrFtAzJzQnFjsAqIzW|FzDH~r@cSro@rKlHOfIhSjXlLgWRyObTiYeHyQbh@wb@nbAqSzLmLlMxDhLoUlc@iBbsAyb@dIgGzm@qcArMz\\\\fHfFrDiCkGiAgB{JnJwWaAuHxHmf@dDvFmAsGhBE"},{"id":"2022-10","name":"Paris - Moret-sur-Loing","strava_route_id":"3011607294473600444","distance":163631.90903395737,"elevation":1404.0589153768694,"summary_polyline":"_fiiHcn~L|D|K}It^h@fM}GdIlGnC~AzWvqA|`FuWvgAsDjUdArH|QjStKjDhCpJdNjJjJbVj_A_T~KjCfFvJdBh[`Yt@vcAptAbFfY`a@t`@nIfeAhT`~@neAl_CzDzaAtcAhi@`GuYpHtYpKcGfHco@r]nE`o@lb@dGhAvD{KcAjNvIjIw@`M`l@tj@tVo{@zg@bXbYtBnIoK`R}@vItDdFbMnN{f@~z@sJvLPdNbKaI|d@nIuJdCgLnH{D`ErHfNvBl^zWnb@gLjPw]vJuHne@`PtGmp@pNb\\\\iCrf@jQe^rMxDfS}QzSbKni@q`@l\\\\|e@`_@{s@lUgExOaMfM{^xz@qr@nDyS|GbDv]joBbDnh@sAnc@vl@ed@fT}Bfa@pYjw@oLja@V`b@xMpNrRpCuGUsOcEmHsGwoAbw@gIpA_NnJyEpVzoAdOhQr_@hO|AdLngAee@xPi`@`P}C`^|e@rHzAzUjf@jNhEjDqIlOcHrSdUfMyCxOuSjCi[sCcQhJsg@fNeFrTmf@jOjEcA}JjF}KnN`O~Ntd@|i@`dAfJln@nU|x@zMtu@hB``@vLxj@xNlJvKwFpR~@hKxKjD~b@eBZiEt}@{GjOmObE`CpUkAhLxWnZne@tYzTpe@jStDvXnZbI`Cpd@mCjvAi|@tDaKkAqQ~[hMxHiLhSt_@rQgg@lSuN~e@yJ~Qws@rFiDkLuFyCsL~PsX_A_f@`L}f@rCc`@mCac@x@_}@lGuWhCea@qK_f@u@ck@hLePdCbLzKrElFkx@ph@sH|IeT~DuAjr@zMfWeGnUbGx[jUlm@jEjLqGbUad@|]cO|cA|p@jUyJn[ie@jQaEnSzFvLyWzQgFtBcLwKcQcNqo@cCglAuJsf@iE{v@qGoc@iNm[cNskAtCaRXm~@tJ}q@aKs`AeEugAfBw_@j[{ChCmt@bRg\\\\jk@_bCsNmmB}c@|Fo{@}UeNg^qZoUmi@chAnBcNzYmF~b@g_CbOuMrIl@mGqU`CseAoKqERwEbJ}A}Ccf@zKcZtDs`A}Ek`AiX_c@hhA}nAbFwT`AcYpR}e@bCqYyAmLgPiRiD_^mSal@oCg}@uPqkAd@ai@gO}kAxBmiBvOsmAcBsaBrJym@vE`AjQme@k^ae@iL{j@rHqAjFwtDbGeZkI}u@bG{hA|c@`UrZn@f]_]|Fq@xQuh@bGiz@rMi]tE_a@_A{PbGoTyTsv@rFaG?iGaMw^qc@id@gDcg@c@iy@pEcvBrOgDbBms@`GyCvA}KqHamAsLiRg]{`AfP_H|Q_[`TeLd@aj@qDiJcYqAm\\\\q]uVej@wd@ymBeLmTq[wUmIdG}YcOe\\\\`KyJfr@xLrIiH|IkIn@}Np}@aHzQ"},{"id":"2022-11","name":"Paris - Meaux","strava_route_id":"3022519412406654878","distance":140025.45735699616,"elevation":1286.3987492211186,"summary_polyline":"ic_iH{zuMx@{b@`C}SS}a@lAsQdEeQbNuTfE{OpC}[Lcs@jGqs@|M_YsPs[}DgB{G~DNae@GdU{\\\\lDkNkDyK{PyBwIuFiu@vAu^Au{@zKqgAs@oN_Mu[iO_IsGC{OzIiJlP_c@bJcPqCgPwSwMmhBMgP`CkTHgR_G{Pw@}KGm_@fCoh@Y{VuFcZoEoFiGDeXfKqEhEkFmJmH{m@dA_SkAea@nCoRaFig@l\\\\iJ~LpChBkL~Rf@JgEfHsOzE}C}A_tA~G_l@a@eD~Jy|B}Fgt@g@qYzCwm@@qbAxEu{@gAeKj@aS{B}NwLgGkd@rNwN}DSeRyBqNhAsD_AgInDo^cA[f@aMtDqVyEgA`AaGc@_PbE_^`AgDbNvAvEo`@dKgd@pSiTdCk@pGoLhTqs@IuCtGs[bV{P`a@u@db@uSnOam@sAuL`LcOxp@eaCq@qOfF}BmD{SdBmTE_ZwMkxAnFePbHqi@vCeC~AeHdAViDicAb@uFsVivCuRux@aC}CFuEwGe]xDoh@rBeHjG}DqFog@pKat@bAaSp]ejAgIiDJeUfBaKoMwBhPcY`DoPhJy{@U}g@oDc_@ea@yCmCsAcBsFtQuHrQStDlCrKvTxG~Fs@vGvNy[`FeBzJaLhCmIpFcZfC{m@qHI{AkDiCk@_Frq@aH}XuF}DeQcXoG{b@tDkYaCsChFiYaJq@gTrOuMn@mHvWuIVuHpHkOmE{`@mZxA|TzDxRj^zo@qJnb@sA~OlApSHfe@jCbG|Dz@m@pAcGeBqH}LhBd\\\\tC|M{V|KaLjRmBzPLlf@pFfXpCpCO~VtBvVgBve@vBvXiA~GxGfDoFzFlI`AwAzGrBzf@ud@kVyi@{JaUo_@mEc`@oCgJqc@qZiDv@cBfJKja@jD|Y{AhKmCCyCgFwAwIeHwDxAx`@oA|DwUfHyIhOsAEoCqFcGLsIvG_f@~@mOoGwIqKbFqSd@{XiI}p@}Dus@wKxCyTsMwPlDiOuAViBcD}DVaLeG{DgSeg@{Cwb@jCkJTeQ}LXsLiNsIwa@yu@_MqPdB}DcTiEkEg\\\\_MqFoJwBgd@dFiNnJgK}Gkp@w@}ZwR}cA`]gb@dS{QfRa[uK_j@hBef@mb@wx@eH}e@oGeQiKmQs@ue@uFyWs@}SmGsP}GnG`CfMqG~Za@pSmHrq@`@f\\\\aI`o@mAhj@iJjN_]}FkBvEgIYQ~WjCvCbBnKvDfEs@bRuA~H}StNiA}@[kH}LyJk@qEuP{BgCgHoURiPdEaAwOeK_n@qBqBeG|AuQuAoPqZuHuCsQiQeP_\\\\aHab@gAr@sAnPcAdAod@{OqXPqWvEyE}BVw]yDe@sEdCqPp@mWzTmZnAqEzLePjPu@fK_GtP}h@j_@_GnOxSjMr[be@|U|LjJtIrb@zcAlH|UnUb\\\\nGrNjDzRnGpq@lO|c@ip@~wDpJjKoAfFzErRnd@gMdCjA}c@h_@_`@hHmR`b@uXhKbE~KwGhH{BdGZtMaIdb@f@bDtEjDaOLRvIuChQoJtUtCdLxVzVng@hRjFxPtCbDlGV`EnFlAk@pPkcAjLaN|SgIrQiNhMa[`UmOlF}GpI_SxGeJtFcSfTiWdFeBtKrrAeC|f@iUfGwQzVoHlE]zBzpAtl@|I|^aFhN}Lzk@bEhRvA~@TrE~Ks@|K|BZ~EkC\\\\E~Er@hBjGdA"},{"id":"2022-12","name":"Paris - Paris","strava_route_id":"3033643304863107852","distance":69545.47268214948,"elevation":622.424948058618,"summary_polyline":"_fiiHcn~L`CpINp@j@Xq@`@yFbWIt@Rr@[b@_@`A@Pf@r@L`@N|B@`AEbAYzAa@t@a@\\\\k@Xy@La@CMHw@jDKVxCpBf@Ht@TTAK`@Dp@D^H\\\\l@rG@j@NnBLzDF\\\\FFPFPEPFf@p@v_@tyAjAfFILpQpr@rObJbAh@le@lXk@bC_@pAaArCcB|DsCxFFRuGxKi@t@NNUd@dAx@tDlB~Ah@|A^hAJj@@bBGlDc@~GaAnAG|C?pEXjB\\\\lDfAtAT~@An@M\\\\F\\\\RPZZlAA`CIpBO~BWrC]lCc@jCk@rCmAjDs@`ACfBgAbGU|BCp@?rCLLBb@HP?j@dBDfACtEy@fJ}BhAO`BO~BCxCPfALnEhAf@VdLbD~Cb@dAf@pCdBvBp@bExAt@JdDX~DJtFSh@Md@WpEsEnKsIpAk@vA]jEm@xHuAx@YrAo@JCL?`FvULf@r@jBPx@RrALbBjBdQb@~CFFD?HGJOTQxBg@l@_@|HsB`@Ob@[l@}@n@_CJq@NyCPa@RENKXJFFLXrC`M^vBFtCL`@LNRDHAJGr@}@JBl@r@zAbAr@b@zFxClAt@vAhAd@V|D`BnMvHhD|@n@@VEvBs@ZE\\\\@^h@C_@Hw@L]h@I|AH\\\\?`@LXXP^dAiA|@_BjE}KHUXoA|@kIAmAf@aGQkFBe@f@sAD[?s@Gs@jEdEnBfB|@vFbCdQhDxTXp@`@j@Pb@Jb@NjAFrAHbF`Gh_@dApH@ZC\\\\W^Mh@Cb@Fr@StA_CxFk@xG[lFWrC{@jCcClII`@A`@B^jBvFLLNJrC~@BCdErA?BrIlCTLTVP`@Jh@QhREtAHHELBHOrJo@`Dc@pCEv@z@jLTjB@`@LTh@jEx@dBAZg@xD@p@bDtd@Bx@QtBPbBXnDR~Jv@lPP|BXxARbRPrAnBeA~LrVrDtHk@hFbGsI~@tBTTJEBLL@hGrCZVvB`CjDrGxAzDtB|CBJNAFGf@t@j@Nv@Lp@@fACbAQ`DeACKLK@_@UoB?SBQ`@_Az@aA\\\\k@TKNCnBMTEd@Yn@k@Tb@Zk@dAy@`HiE~@c@dAYz@K^C~@?HFdAF~Ad@z@b@b@\\\\fAdAzPvQp@x@nDnD~P|Q~AjAXZf@ZDJ|@l@J@\\\\PDIHBHCT@CPpAjC~AlDEHC^ExAMx@_BvESt@Kj@o@tG[z@oEbFc@`AmCfJe@hDg@xBiA|Dq@vAaA~@Ul@Cd@?vCCt@d@CRF~OtF|BvBn@|@Nb@p@tCRj@Vb@b@b@rC~BPVv@`@BNHHB@LIBUROh@Sn@_@pAc@ZEx@Db@P|@d@|@l@HLhA~@zDjCtG`EdQnL@ZLPNBLGXLbGxDhB|@rRdM|@^z@TdD`@fUfBz@Fd@AXFTKJOJe@Ae@Jo@\\\\u@^e@@I`BqAtB_AzAc@nB]zAM~AE~AB~@Fx@JjAVjA^rAl@v@d@r@h@fAnAp@jAb@tAVvAEX@d@FVJPPJLBNCLI|@x@l@x@t@hBn@fC^tDvBz^J`ATtAVfAXx@|@~Az@fAr@b@bD|BnHxErCpBnAlAhEtDxDrDHN|BvBRFlB~A\\\\`@p@hAPd@N`ADp@KbJI~AmBpL}ArGMz@At@Dx@Pv@n@bBDnAOx@KPQLy@^QNQd@ETCv@Nf@LNPL~CtA`Cb@^B~@OnCcLvAuGZgDLs@vF{Ox@kCrC_K`@eD\\\\{BV{@Ve@j@o@r@k@vAaAjBeDrCoCzAkAxByBzAoBhAcBzWsd@d@aAb@oAZoA^iA`@w@dBuBdCyD\\\\c@rCuCi@EYQ{BgC_@c@mAiC{CcBk@c@}A}AaAy@kCeBcA_@s@I_DGkBKcBy@e@g@}@aCQw@KWU_@[UMCS?iBz@sCbB]Z[d@e@pBg@zD[rAwCzEoApCOLc@H[AWMSUOWEYA]Be@XaAz@mB`@}ATuAp@qGJg@HSz@yAj@eCp@}DAWYgBKa@^sAF]AWGSOSI_@_BiYL]pAmMV_MFcAt@eDV}@v@_C\\\\i@CCG_@DSGAEMFwCASM]aCyCeEuEw@cAcNuOUwDgEed@Q_CUmFGyHBsCPkCjAwLd@{Hl@sCK[Js@fAeDRAHGDM?UGOMEMF{BoAcE{A]?oBm@s@GGMyIk@wBYIKg@GOWUGI@QLKVYHWBaA?gUgA{b@}BmCIeSgAqAY}A{@aAu@EWGMMKMCO@[EsAqAg@o@iP}NmAmAeD{CKMMi@EGIGQBQEIGgHqGwE_E_@c@aBqEa@u@a@i@yBgBYMWEY@WH_@Rc@`@c@l@KRe@nDQ@MG]_C[yK_@iIg@HAQP]@MIwAEoB?yDN_DVaCDo@G]Ly@l@eCz@_CnAgC`GuJvAmDfA}Dt@aERaBFuBr@qC_@s@a@]o@Ua@Ge@J_A^M?OEWYe@oAwBcBc@i@Uc@kBeH_@g@Sc@WuAIQSeC?e@L{@p@eCJSZMXAhAPhBz@XEJQZmBJyADQJGn@OXMb@i@^}@RkALa@rB}Dv@{C\\\\a@\\\\Mx@@RBNGp@oDNuBZkH`@mDBkA[sC?sAN_FIgH{AwBCYDc@h@aCCWh@_BfBqBrB}CZcATqAf@kD@WFAXu@YLGAIBMu@cAsCiAoDiAwBWWqAeAuGgF@?{FkEqAoAgD_E}DyFMY}AyES[eC_C]i@gAsC_@q@aNsOEKeCsCC]FcBBEBs@H}@b@sBz@sGLe@?KkBeAsAaASg@Eo@\\\\sB@[KUQGYAUFWPS@QKEQ@U`AmFPc@`@]h@]l@o@`@}ALsAGgAnIdK^XX@bDi@xA]VB\\\\Qd@Xr@Vl@HVLNLLPd@fAPr@JlBDVHRf@p@dF{g@oHqGiE{PaD{O[sAIIQIW?}E|@UT{@vGGV[TmAWiIeCgMsDiAoAQF[CSTMVCLKpAQdASl@_B`EwDzHoEpJwH~NoAlCsAvDc@~@{@xAWbAK|@MrD]tEu@hWIt@EIGCGLa@XCQIESJkEkCqEcDaBq@gGoBuCmJGIOEyB`@}@eHGQc@qDA]_@gCcDj@qBXc@VqATM?}Dj@oDn@gALwDj@OFMNw@zASj@_@tAGl@ElAIt@S~@Kt@EnCI~@[v@e@f@i@Hm@Kg@Qk@De@f@q@pA]Ti@J_CDaAEcEaAiAH{Av@g@Rg@@i@Kc@UaA{@@?[Qc@Kk@@{@ViAf@aANq@E?MISICG@KPqCmA_CoAuLwFuGbAcDU?PzBPf@McF[eByAmAsAyAsAUQa@QwBWqCUgFk@}BEqDQwAAy@EkEgBkCaAOCI@s@iCg@gFAuC_AiA_Bs@iEwQy@eAGOGi@k@{BsA_H]i@}ByBGSAQBMEOGCGDi@Da@]UW_CiEqBmBIQQoEY{Cw@}D_PpGgAQcALYc@iBuHWy@eBwHiAeE[{@Ke@iBuDsAaC{A}B]e@aB~CO`@_@]yGqJSKK_@OUSIg@AYZiA|AW@YQQSc@gAQKYCo@ByA{@MASDKH_@c@rAcECSN}@[KI~@{E|NAZOb@_@~BPRh@aDKU}C_FmB}Bi@a@wKqJADc@WoIuIYe@S`AsCz^m@fDSMOES?_@Fq@^]f@aJsC]PyKjDMtEcGgC@@_I}CmJyDyBoAyBaAcB_@uCiAi^aSQWiBeA]CaJ_FHi@KGt@oENMOLHs@Ay@QBEc@O?wGgEeBq@s@a@}Am@YFgJbAo@BgCmAq@e@UqA?eBGs@a@_CkAoDu@{C_@gBc@@[G_EMeCYeB]iAa@cBw@kAu@gWgQKG_@JgJyeBe@DgAKy@_@][e@i@a@u@Uq@q@h@UQiBvAK@aAv@KTKH@b@kBxAYJzA~E"},{"id":"2023-01","name":"Paris - Rambouillet","strava_route_id":"3046383821851669028","distance":118873.5155174805,"elevation":1101.545221246371,"summary_polyline":"}diiHok~L~A|FNp@j@Xq@`@yFbWIt@Rr@[b@_@`A@Pf@r@L`@N|B@`AEbAYzAa@t@a@\\\\k@Xy@La@CMHw@jDKVxCpBf@Ht@TTAK`@Dp@D^H\\\\l@rG@j@NnBLzDF\\\\FFPFPEPFf@p@v_@tyAjAfFIL~g@zpBBTLC~@pDZlBH~@K@Br@InBU~BYbB_@|Ae@`AG\\\\Uf@k@jBy@dBSNOVCTiDlJk@nBeAhFoDnSU~@JdASdB_CxJ]bBM`ACrADb@b@lB^lAz@fBp@`Ar@l@tBtAx@p@t@x@bA|Al@t@v@x@j@b@p@`@fAf@tA\\\\xC^j@b@b@p@Tt@`@hDJf@N^PVLJdIvEvA`AVT`@n@P`@J^bBjIRt@d@rC^l@~@r@nAh@Df@Vf@f@b@rDbCxMpQb@XvGpC`Dn@XRXDLTbBr@j@b@PTRr@P`@TZv@bBvCdJ`@`AZj@v@`A}B~I]lB}BlRg@vDiDdS[hDy@lFAr@FrBH\\\\NNxBdAbB|@^ZPZBN@`@If@aBdDCT@n@HTpM~Pd@f@nFtDBPFD[vBw@bK_A|O}AtNi@hGYhI@VVf@|CjE|CtA@PHHBh~@KVBTFDCfU?l[FDBLERE@@dGALuErIEBMCEDCJ@PMZyFfKIFp@~ER~BAl@QbAOb@ONO@mDYY?[VQf@ATD^`@~@FZ?d@G`@KFMBWIeBsAQBnLxSzAxBaC`Hm@|BYjBGbABv@D\\\\Zz@~BbDFVCB@NsAlAe@n@eAnBUTC|A[?g@WSAmFZsCI}Ii@AHGJG?EEMTyBxCgA|AaD`Fq@~Bw@|CgBfGcAzEIDA`@gBnJu@vEqCnJZd@HXE\\\\i@FOFU^qBhIgAxCy@hBo@fBu@|Ce@rCWl@SpAILDV?TM`AcDpLu@jAo@r@Y~@g@|B[xD{@zD_@nAeBfFs@t@n@dCp@`DqKfJg@JiA_@AHg@Du@f@QDICKBGNB`@NJ^rAXh@^^r@j@NXnH~]LbADt@Cz@Kn@OX]`@a@~@SRQHSDQ?UEm@c@UK]ASDKF]`@Wn@Mn@Ap@FZdDrI`AnCXvAnA~JBbBJf@^j@zOnNhAfA`@Zb@Vf@JjFDtc@Ce@zg@IxFCbJG`E[za@KpGG|JQvLGxJ?AId@mJ|S}LbXc@jAiD`S_@`Bg@xAo@nA_CnD{@|@_ChAo@f@}A|Am@hA{@pB}A|DwOf^_EtJ]l@i@^GRDVj@\\\\xF|K\\\\|@`@b@YbAyA|GITWT{C|@OZg@rBk@bBUf@wAdC{AhD{AtDiAnDwCnHmAjBsA`CqGtMs@rAoItL}@~@i@^gDdBWPkAl@}BvAeDfBY\\\\Qp@aKlhAgH~u@yEdUsCjM_@rBjCbY^XoCtM{@s@G?YNKGODM\\\\APMVYTMAKEQYYiAi@yAYWOGOAO@WHWXSd@{j@lbCCFIDK~@cNll@e@vAwa@n~@t@lBNXNx@FJp@h@ZRPFb@DtCIf@Pp@f@bFdFj@p@Xl@XpAJbDTvAx@~AzAbETd@lApAj@d@`@Fb@@z@Gb@?n@FZHXRZj@FX@\\\\IzA?tA\\\\|Ap@pBLlA]zBEf@Dp@Lf@h@r@n@Rd@c@h@eATQZOr@NP`@n@nDf@|AXf@nGhHl@l@nPrMfDjFZXE|@MfJv@LjBl@`AVnFdB`E|@dBh@~ADDCJaDDWn@wAfCl@pBp@lCzAhCdAx@`@vCbBf@Lh@Bv@Eb@?rF\\\\t@?|Em@`ACb@B~Et@VJd@`@fCxEh@r@dFxE`@d@`@l@`@x@~FxMt@zAd@v@l@v@z@~@VPC`@Br@J~@x@lEh@jDLlAZrENhGFjFY|LGlAI|@_@hDuGhi@eGf]kBxGo@rBg@hAcA~Ag@j@{AvAqBxAy@d@c@\\\\_@^W\\\\cA`ByAxCuDnKTnApAxDTx@`@dCLf@f@dA\\\\dAz@jBZrCNr@Xv@v@`BlErGv@pA`@`@nBh@bE|AfLpF`Dr@`AHx@GpCGhAKrJwAtE}@~Bo@Bn@PjBfApGr@dDd@|@|A_BrCaA^I`AKR?\\\\PxB`BXLXDtEJB~@RnC@hACXHr@@f@EpHBrAJv@Pn@bBpDh@rAv@`KZhCjBtHTf@vDtDxFlFd@t@Xj@rCtIjC~GRpADr@DdDHrA^`CTr@xAnChZ~h@zA`D|I|SXj@xA`BDMjD^vT~AzJB|@Fz@HzH|ArI\\\\v@Gp@OLOfIdEjB`@dQhCbBT|@HbIGbBHxCv@vCz@pPjEnA^`E~Ab@J`BTtFd@n@QZWd@In@?l@DRCPIPa@RkAHWNQpAy@~@a@bBKX@\\\\Hj@uIh@_HBoADi@@{BEcBLypBEm@Ga@vBeFrFeO^gBZaCRcAX}@`@aAT]hAu@|@WxEEhFLl@CjKyB`A@n@SbCKnF]vAUzAq@tVwNxBiAv@Wz@KjYhBdBM|Cu@l@Ib@Cd@Bx@RrCbAZD|@Bv@Cj@MRKj@g@b@k@t@yAz@oAb@[|@a@`AOT?f@D|B\\\\l@@f@K`@W^a@JJLCL`@t@bBl@t@|IlJ~@hA~AfCfA`C|@rCd@jBzAhF`AzDNXr@|BvAdGlAdGLv@PtD?z@QfB?fABz@d@`G?p@WvGQdI_@hK]nDuB~LOfCAh@R`E?jACPQd@QRg@Jg@DUJ]Zg@xAMhJ[hLg@dwAN~CtAnN`@hFDbC?lGDdBfAnOf@fGl@`Gv@nE~@zGsDNg@Pc@d@Q\\\\St@Y~EGP~Af@j@Vx@p@|BnChAdAh@\\\\?PJVtCtCb@p@o@xB@FbAbAvAD@jABBQrDd@@h@H\\\\Rd@r@PhA@h@Ev@Kt@c@hBsAnIuEfOHf@M^UhDaIjdAUhDAbBFvANtAhChOVdC@rAM`AYp@s@fAmBdCaCdBiB~@aHbGyAbBw@jCSfAQtAG`BFnGEpAKz@k@|BSnAMfCBtGBjAGfK@fAHp@hClKlBbJd@hCFp@DrBG|DJNpApCtAvAx@tBl@vCl@~A`@^n@XdFfBjAlD?nAJt@Nb@\\\\^v@n@~@fBh@vARz@RfJRnFT`Bb@tATzCGrKtM|ElAJ~AA^H^PxJxHRHN?hHsDrO{EzDaAtBnEfAtBrAtAb@X~@XtEt@xBXTNTX\\\\n@P|@NfCHx@f@`BbAdC`@lAd@fCVl@bBjBn@`A\\\\^r@^|HpChAdAd@x@XfAR~BNxCNjAZz@lFzJh@\\\\{BrEeGjLa@xAy@~FwCjRGlAZ~EjA`MfClPBb@Ar@K|@sA`EgMz[gB`EcWhb@g@lAmExOcU|p@On@E\\\\YdFQ`HWnEw@hG[bBsCxIgDlIkFfM{@vNy@fEy@fDlHbJVb@Ll@Gt@Kd@iD~JlAzCZn@`@n@b@d@nDvC^l@t@lCDx@IrA_@xCCx@JdADNJPZXdCv@ZNbA|@vA~Al@f@j@Nh@B^ErPwEvOcEd@Ih@Cl@Bt@T\\\\T`EpDh@j@`RhQb@\\\\`@R|ADrBAXB@PJNJ?HQAY`BmBLKjAOxCCbBH``@Zr@DjAf@\\\\h@FVJFLEHWEUJu@h@w@RQbBq@zLaG^YPWRc@b@aBVs@h@o@l@_@p@Kl@ArCLr@?nEeAzD{B~AyBZUbB]pAsIxCzBrB|CpAhAx@Tv@Ep@SrAy@bA_AtGaI~@_AbFgDzEuEt@y@zD{G\\\\{@n@_Cb@s@^c@l@k@RAJDPXRf@h@`C\\\\p@VRt@`BTVzAb@hB`Aj@R~DjCtExFfBhBxF|CdD~AbAl@jCjBi@dTU`Fa@tDaAdFe@tDGtAuA`HOjA[vF?x@hB~Tl@tGyA~BIDP`@`@l@RPd@VRxNFfAVxAvBpEZdAH`@l@dUErDDf@JLxAdA`AvA`AnBd@tBb@nGQfAcApC_BjNKdCOvB{@pFE`BIrKQ|@EdA@dBp@fIPjFcArJjArNY~G?bBHf@b@lAn@z@`EpAt@PbB?lOsAzJrFnLxEbCcBfBk@nJ`ArJgFdAbAbACpAZnBk@hBl@rAlB~@i@`BoBpDgAPSL]Bc@WuEJqEA{ADs@N{@hAkB`BsAbNkHj@u@lAcCZqAViB@sA_@yE@o@ZkDpAcKReJ@aSc@wDYoAuAqCOw@?sFJqBP{AdAcBhD}BnCWvLkCzOcM`IkFnBuGv@cIt@oGdG_PlEmKt@\\\\lHfAxDx@dA`@zI|Ev@j@jCdCp@z@|B@RNPVlAtC`@zAd@pCdEtMZtAPtAx@zIh@tBP^fNiQ`@IjAyAp@}BNiAnAyMtTiw@rA}BzwAigBd@u@f@eAj@gB`Mse@dBcDbByHnAwG_@KmEyB_@O_@Ik@GqAAkDRgB?i@C{D{@{Ai@WSqA{AkC}Da@cAoCiJqAkD}CmJs@cCyCkLs@}BGg@MaCe@cNOy@_@wA_@{@c@s@g@m@_RiQe@k@Yc@_@_AMk@uEe[UoBCuBE_WCeAKgAqGuXgFoPo@@kUdBk@\\\\e@fAGb@Aj@ZbAFp@Od@aAh@cAjBwBjIgBzHQh@QNMG_FiEsDgGse@cSiHo@e_AiLA[GSp[gv@xUqe@`DcArAsAf@kBf@kCfHiGVcAR_@Jk@jAaDdAyBtAgEfBqIl@kBbDsGVsAReDbCdBOItBtAn@}ARm@TaBLwAlAFp@NZLjAp@l@t@J\\\\b@~CN`@NH\\\\@bA[\\\\Sr@Wl@@p@P^ZlDdBfBvBr@fARb@n@fBfAhD^t@n@|@FClHl@z@BnCMl@N`@XfBdBh@VdLtDZFf@DlAC\\\\EvVcInAe@TOR]pFoK~AmDjAsBda@_{@|HoObAcBz\\\\gDzDyArR_JdGsDD?NZF@DCt@gAPk@XU~JgMxBiCd@_@f@WNYJ{DPaCvEwaAB{Bu@kb@M_CY{BqA{Fi@_@qB_CcKyTiFoMeEsMmIoXQo@[cDcB{NiBeOMo@g@cAuJaLM[Ge@?wBEcB|Mw@HU@w@f@sCGFuA@{@LWL{@XS@KsDHeEd@wF_AkAmFcGrFqJtCiFzE}JxFvH?TFHF@DEl@x@XX\\\\Nb@LXz@hELx@PXTRg@xFkDbBi@tJyArA[lF{B@UCSGAs@e@MYGG?GIOIAKTM?mAs@gCsAkLwFcCFiKh@APm@Dq@_AeAsBOI"},{"id":"2023-02","name":"Paris-en-Brie","strava_route_id":"3056151788164882894","distance":131955.3881321985,"elevation":705.4151797384138,"summary_polyline":"ac_iHi`vMp@m]`C}SS}a@lAsQdEeQ~K}PrFyPhDw^Lcs@lGgs@fMeX_Pw\\\\yDgB_H~DNae@GdU{\\\\lDkNkDyK{PyBwIaDmWwAk_@lAcUJwbAzKqgAs@oN_Mu[iO_IcHCkOzIiJlP_c@bJcPqCgPwSwMmhBMgP`CkTHgR_G{Pw@}KGm_@fCoh@Y{VsGg\\\\}FeEmf@rQsFqOkFmg@bAoSmA}`@fC{Vls@_R|Fei@hIcQxDmB}A_tA~G_l@a@eD~Jy|B}Fgt@g@qY|Cop@m@kKl@ms@zEy|@iAaJj@aS{B}NmMiGuc@tNwN}DSeRyBqNkGvFcQgTe@}TvCet@QwOiCqGAgHvGiT`Pm[|Yu_@bUyJpSiTdCk@pGoLhTqs@tF__@hUmQpb@mAzMmIdOoD~h@`Fp]}Px]zK|c@wQxTgNfLzA~NmB|FyI`CyJnSoUrKqDlPExHaGzMeEnEaL`g@g^|MZpR|RvRkBw@_ZjEcGCqDwFiQyPojDwGmCjCeG}BgD_@eEmCiBkA_IEaK|C_CoA{]vFqAtK}PhSoK~A{p@eK}o@`Oqg@tGiL~MyMbJ?~S}i@fXmA}Oos@`Au@pKmChTNh`@yZ~h@xD~[g@hRyKdErFfHPfAjAm@|PlNTvU`QjR|BrHlFtBnKpXdb@AdTwCpIT`B|LvF~PmXbFsCv@nQbBbFtNnMdl@~WhN|C~PxSrKP`Z`NpJ|X`|@rnAzDxd@jEfCoBjLhF`EvQ{E`GaKbIu@rVmOpLWeDoEd@kPiIaYmWcWxCqKuDc^|@w@g@{JxJ_j@rFmBfH_SvP_w@vR_]nOnDpDyH~HXtIoDhIpCpJtXl\\\\i_@tq@cqA~Fm^xO{UbGyRvQaQvLsvAj{@`KrKtKxHtcAlJbCBj^eDdIXdCdzAgP`Ddp@?zhA|UpGRzSdPbL@zJz@tAfN~Jr]`FvOnJVdEj`@wEvA|IhEhGpDpArZ}CrQvBzYoBhlBbf@jNjWdMzEdGxg@`KbXjDsGlLdJrU{FjUkNtSwBT}\\\\`OsEzFRpH}P|L_NhDqHjLmHpH{LsB{V~Ceb@d[zFbi@wB~^~FtLKdc@{HfPkWzJtMdFtAdy@aZfDQjPrLTzC{ElPmLlRdArK}@|HuBbD?pDjQpPrI~VfHn\\\\fBtQhPje@mD~t@_Shj@gD|`AtEpo@}K}D{JbMqHoIoAaFsPi@kZlDgh@f}@oEfLyIkJu^{E_\\\\bFqS}FcJ`C{MsBmOaJwCFaHvX`FvHnIGfNvR~LqAbFjG`NzFpD~DxGtRfL~RdAlu@pDlj@MhKsApDvDjH_H`h@gBtb@vGvxClAtZnDvT^vUIdj@_DnWd`@dI{Btb@mJjl@eIfUiNvUoNtLaQpIghA~I}cCWwWbIaKzGcJbSiDjOfApHaa@mQm@aDkC}@yF~Ho@dFxS|Dj_Ara@|B~@b@mE"},{"id":"2023-03","name":"Paris - Mantes","strava_route_id":"3067781780671157172","distance":139948.1176906143,"elevation":1616.702223465278,"summary_polyline":"_fiiHcn~L|D|KsI|]an@wuAiAbEw`@j`@c{@rr@{Qgh@wTpYeGgIub@tVm\\\\vMaAw@eBdFoVtYmY~RcHhX_Q~Kwc@ht@yv@ty@nAtD}QnQ}a@tNcm@vb@qRYgF~[_S{W_ZoAkGyCkB~Oj@~KkApP}FnGrAfSoK}DiBnAsBxHqFyTiHf@__@m]iDzJw]{Web@d~AwTlGeO`p@}bAqs@sm@ku@mH}EeFtRoDvFcE}GwDnAiFyEyIlFcMWuV{GuH_IiP_HaB_Fs@qQwNaZmD}PeJqFoKoO_E_Qs@aV{SiD{LhEmJuF~@nZaOhdAyMUkChGkBa@sDdG_KbDkAvHlBl`@q@|GsLfTmQvd@kFjSuF|I`AvSeFnToR_Jk[cCgIbSqHhHa_@cH}AbBuHjZi@xGjCdIeBtCYjHkIxGaM~QwBjJ}IvQ{MlJ_LiC{P~XoO`NeWwBiJrCqWaRcJzN}CrJ{K~NM~HgJeG_HdCiA}AeB|Gw[yDwIaHoUhH]`YwNne@qWx^kP~^jDhLjEj@vMpSxTkIjBnCXhNnChBxQgKfLb_@hArV`Kj[yOjy@eCbi@wExEaFoB{BdEuDRwJ~PoBhOmQ_CLgPyI{EqOvJ_NZwF~DgAvFoLhD`HvHXzTcNtwBzGl_@yBbQjEtPfC~CiJzWqA~Ka@~\\\\iCbOoIpPiHtr@dAbRwAlLzDtMrMpv@jJvRVbNlG~f@|@t]oE|P`AbAg@fHoHrHkBzF}CiCkB~@gBvJiHxLiGhCeGeD_F`CoFxJaNxCHpQaBpLnA~POf\\\\cBlJGnSuEdOWxHqBtFwPhHm]tx@kE~Q}Ydk@`E|NbDlBtRqDtHsEjS|F`NuB`Vb|@xHlOH~FpC~@nKyDpC~CTlX{Fp[tAnSfAVfCqExR~IbHhHzc@`|A`M`SzG`]dAdCrFfBhEyL`MsHxPuDQqO~Vu`@jBqLxAiTeBcTrCy]yEmMdJkKXuEeBaCaLp@iJkKnBeYdDwF{G}PbI{K|OcJ`DmL`KuIdRrFzEgAtJ|JbIcCdHhMxFgThPyNjX}r@tHgL|UaErTuJfNqAyBdJmP~UjBniAaE|c@yIpk@Zpb@w@lRiWz}@kHfQgAvb@pBpEvK`bAjDzgAuI`WrFjHhl@zSwQpb@`FnEJpGzDfLnBzPlT`WLxIz@jAaE`FkFnWwTnVqHrC|ElQjBt`@pIrSuD~NdHvBsBxTrCpZe@tM`Dpt@hJ`^Rbj@|CbRtBtb@nC|IcRr@NvbApEdOs@tKbAhDlJ\\\\~BlE|RlMxAtM|Pzo@tGn`AkJri@{Ujc@{Elk@pDvRuNwFsLdPoTdHoI|c@wQrl@`NjGWvMpCpMmOxPqBxHDlt@oD`Wbb@f@rk@lg@pOlHxHrKrPhNz@|MjItR|@fNcCxq@T`j@vDt_@aC|KFjObGjgAfHhS|F~`@j_@zu@o@iO_DaDHgFuDmOwBo`@qGsTmC}ByEmb@aE{l@T}s@nAyRbPalAtFiW|Yw`Axo@uvA`N{RxBmH`HgCeDkN\\\\mt@oHyUyF{FzA}LDoSzBoFc@iMdC}Z{FcKmFk@ToBiFcW}NwQkGuYiY{M`HsJ|Kw\\\\lSu[dH{DpJrAvQ}Bd`@mb@xJyEiFwMg@gEv@cH|EjGlFfQlP_Ld|@uL`CuHfJmJZxE|FpP~F`KvNxFbGjM|r@fk@bWhMzJrLdGrBlO~RlXrH|`@bg@\\\\~FdEjE~YgE}BQ}PpDrScDpLnFhGfM`d@bjBaDpL`FrB|@qD~EnSp@}HbD~@fUtVkBoBjBnBfFcQ"},{"id":"2023-04","name":"Paris - \xc9tampes","strava_route_id":"3077257479147655780","distance":151775.60212237138,"elevation":1557.978123039057,"summary_polyline":"wtfiHwktLq\\\\`~AtAlL~PrQdL~CfBdJtMrIlKrWj_A_T~KjCfFvJdBh[`Yt@vcAptA~BzSzFnGqD|rAfWpUdDlh@kB|QdH~V`Cn]nNrQ|i@cDpI`E|\\\\lu@xCx~@`PvGdB}JvZqXfI{Srm@pa@rp@~JdMhKfJuA`HkUxQxFjPvTnIsBpgAts@zh@jGpPz_@NrPvc@fGlo@vj@jBhRcF`ZjAzIuC|FpJbEnZkhAjYs[nd@gy@ln@yOjPw]`OoGbJsb@YoRnQsFrFsQrCpo@jPj[iCrf@vNk\\\\vIoAtDhEsCbWxM|NxLzc@{EhCeJhUkIj@yD~LaAmRuIt\\\\y@{MeDMuKtCiGnWiFzFeFkC{DhGgL_FmLxs@U|TnJdEpExsBdVnD`OlK|[cDlNnSfYnC`IzOxHza@fNjOuAjIbKvDsIjn@iArmAiU|O{Sdu@hJvLfJxBjJzYKbZmFbb@d]lr@rJzd@{Yn]ii@nFqRlh@Ati@qNvUBrKhEjN|IuGbOrDdRlP|CfLmYnjA\\\\xQhCfDqBpZoKfU{ZbM{Zp{@aJxc@aJjHiRrh@ia@d|AzYV~Ir\\\\bVlEnS_kAu@kd@nMuXxNkH`Ty]dCo[hRo[tGiZxNqXhFuYk@}l@fP}YzMsr@bLsGFw`@eIeN`JsQnAmh@lg@zU~[xWn_@zGbZdAxj@oS`T~FfFqM`SiIvDu[|Xiq@vCok@nHQ|RtNlQeI~PwQw@w_@~KmJn_@d@fbA|PzNbNzd@~Azo@tWc@nExLlFxApUrLwDgEsT~m@g[hFkVpDmt@mE{\\\\dPw{AcLoZbi@sm@Uak@tFia@tf@m@fGuNtRb@`L_S`SlQxcAnHnDiFtPhGxDaGViKnNnn@d\\\\{FtZuRpTvKlEcR@yZzSoJbfA_BxNaL`Gs\\\\xWnZne@tYvUhf@nR|CvXnZbI`Ct^_Bf|Aw}@tDaKkAqQ~[hMxHiLjK|WfDmAtBtHrPwf@lSuN~e@yJvRou@zEqBvSh_@bG~CMxN|`@fP~DrLvAn]pK`ZhP`Ut[rQfKl[rRdNvRjf@jIjGdV}DrQ`a@vQqBtYl^tRwJvDvBy@kQlEbDnLuInc@iqBtEic@yMie@fCyVuCin@zI_KRu[zJ_^i@{HbFcNjEkc@vPgGjRfIjHuP_SgfApFcd@~GsQYqs@nWyGbElLlJdFrKrd@hb@`RvOlXzy@rMjC|KGjb@nb@lV`J`P|N|Jbi@hHh@_`@bGgXLaOuJkPcZzK}JmHcVjAeVof@g`AcQys@}p@_K_a@kd@_YmCqYoR_d@QgPdF{R`XuGfIeN\\\\mIrEaArC}TsJ{CsBgIoXn`@_TnI}cA}p@}]bOcU`d@sSdHef@_Fy[kUoUcGgWdGqv@uLgKbUai@fIqFlw@jBvOcBhJfE|PHdv@qCnWoG~L{LmDqCqIvF{b@aBeXqGeSu@ck@lC{HvH}BgG}^hCoA"},{"id":"2023-05","name":"Paris - Dourdan","strava_route_id":"3087868951478663690","distance":159185.9076718499,"elevation":1565.614185634378,"summary_polyline":"}diiHok~LzChI}It^bAjJwH`LlGnC~AzWvqA|`FiO|i@}L|v@pDdJd[lShCpJbMzH|EfSb[t]nTbJrK`WcQdiApH|I}AzIrVtXuHbbA`J|JJfsBKhHcObX`@tNcGNFhG}CuAjOrWqEnQjD`JyE`JwXq@iK~NqP~x@kb@hvA`BfHsS`LnNth@yA|GiHlDhKnc@rUvR`k@@eCxqCyYpp@qF|XyNlOo^xx@xX~h@y@tL{J|_@_T`b@wZp_BoQb`@}Jh`AgKgDoMjGoCtM{KiCm{@nsD}b@faA`V`R`GdUdK~CrCdZdFgBbCvIp`@p`@SdL|sAvM`_@nk@nBnOIjo@eSfyAyKhU}IdaAkOzLqGhYsGtO_QbP`@lG}Cd@_I|XgCKaQkt@ie@wBAbMoe@pCkQhO__@d|@dOtRj{@zXnb@~l@`Y`m@n^zSzKhNfAvJtMgI|d@uCSeh@ha@bHhFrChDh_@hPv[eEnP|ErGfo@fn@t\\\\|OzO}AlV~Yx`@bVlJnRpZqXv_ArUtc@kWbo@yJ~TfJ@~J~K}CbThHdLePhOuz@xOw]vBml@jF@jLyWpZ_ZpAcnBnEmEtDkm@tPpEjZv[nLyU~PcMxGma@pb@w`AzNch@gJw_@vAgQjGzIj@fJpGp@phBgZdn@qCin@fCwGxA`wA}FxJeImIhHkQjAzUmCpIsMyNyUhJkTl^j@pA{NaL_k@ZePyHqa@sJuJwAaIlU{fAvA{UEww@cGsf@~EgBbGaRp[hPpQeKda@lWtBlj@eBtKfDlZgNbs@zDt[gSfv@uRr{A{DrFhOfa@~\\\\bAnJf\\\\lLRtEkp@dG}NxLgDoA}^tE_Rbe@ee@dGuOjB}XhRo[tGiZxNqXhFuY{Aeh@vQu^lMwq@pLoHFw`@`QtLoBtO~M\\\\pFdqAhTkM|g@}jAhOyCdNoa@jl@{S`T~FbBh_@vQbl@uAhNjG}A~D{MrLvFdNzj@yEpr@f@jTpmAnvApSxf@x^d]wBhGxJlTbb@~_@kAvB|X|Hps@yz@jQhk@pg@haAjVlRlK{JfHnH|HlZLzM~`@i_@rHcZrNaDkB{Sps@wz@zUiz@~NnLdJydAlJ``@j`@jm@~a@^|gAgm@hRnFdA}c@h{@oe@lEqIeC_InA}BdIlTjQVVoVeMuX|Mkc@dNiSrQgtAlWcQzLe\\\\bH{b@jJmQwD{Vra@iqAdMxUbnAxpA~\\\\cm@kIah@{Ccw@kI_OlHyOqFwOr@gs@{XqqBwLge@|Eqd@sRmDz@_QnJiWs@qqAiR{qA`Bc^jIkc@ig@{C_YzGiPxSsVlBqEx~@sGfNmObE|BjWqKrk@_NdIkgAzA_R`KVvY{D|QcUqKaZjRoThDtEtnDqKlj@tB~DmJ|A"},{"id":"2023-06","name":"Paris - Ch\xe2lon-en-Champagne","strava_route_id":"3099671623679549110","distance":195770.76539319413,"elevation":1658.091653008382,"summary_polyline":"ic_iH{zuMxEyhBv\\\\saAjBsgAlGop@uPio@Zmn@ExT{\\\\lDoLsB}NgUmIagAzAwqA~J}|@?wVwMa^yPgI~@cE}QyMuDmLwJ`@wTcSsTgfAiDc_@aG}HaHm^jBuiB{Oya@eWmYaP}_@nPeq@tFwh@bOqT}A_tA~G_l@|I_bCeHynAxJwoDkBuJeJkAiHeJkNigAnG{pAnGeNrA{SIkm@pMox@z]qaAjGi`@bV{P`a@u@db@uSnOam@sAuLnKwMbq@abCi@aPfF}BmD{S~Amo@wMkxArOwz@|HsKeC_kAsVivCwVs}@oG{c@qOg\\\\mNmo@KiR_FmT\\\\gr@{HY|EcHyGgDk@gxBaLcf@|B_o@hMsSrUuJ_Gck@pH|LpHRiI_IwAyy@~Lwt@e^sn@uGwh@qFmEb`@wd@vi@oyAjFWyh@{jAa@yK{OqT~@wIuF@eFeSuIwAEyEmMzCge@j`@abA}oAcHyCxCgLbAsi@bNiy@{B{zAtQwWpLiEbQu`AaDwRpAwTaNelAtFk]}Ba_@dCaIoEsRnCeTyNad@qRuPw@mr@oZg[y]eLeXyk@oQ_hAyKkQwPck@cAwV_E}BsEo\\\\mNqQrBuSyc@m\\\\iFyLoSeF_E}c@zCmCjAqTySsSvJq_@jAy{@vF_Rlf@{n@bTyj@fMqF~AcFaDsPzGg^zc@sz@dNqf@lRoKbPc^uGag@fUm}@eI_f@tHsb@@}f@_CuOmV_DgJemAbFkl@{\\\\mh@yLyn@}X_VkQ{d@j^wwAmHwb@jAmN_FuFkDzIeDgUwIjRqDmKi@oYrDilA|n@_D`EwPwFeZnBeMcCoq@pRqZjWmH|DcJWsMwK{QkMgAeC{SiR_FaSin@u@yXwQ{D}Vgo@eNuHaDeYnEuf@eNar@zCiEbDwc@gIk]tIGl@cVpe@aBvSkH{AuaAxEck@}Bsg@xDmPfN`BfPeTEyL|MqTuB{g@~Juv@tPuXp`@k@hF{VzHaDpD{y@zo@y}@rFe[_KkGk@}h@_a@uQgHiUsEAeJqc@{UeBhFgZ_Cu`AbIc]iBsTlCgIrWmRCyl@dGcd@nFkHhPuCC{gAnKoy@qA_J{Sq]_FmkA{UcRxJe]`Du_Amk@scCmHmiAlEenAjO_l@mVyOjBqF{F{BjAaJkNqcAkLwe@`HksEzOs^~Eq]eI{D\\\\{o@cSyy@olAan@oQ_YeNgZsUcz@mOmY?mElOtDnJi]pLmEnNuQP{g@aRijAmKrHkWuj@qk@o[aOkj@eUeQoJyTuGaoAeD{yCwIy|@c_@qxAoDsDoA}MbDsJ{EgGjIvEzEmEjN}e@n@qQpKsOgFwaAcPsoCu^i|@\\\\iJlJyAQeLuMye@{LjAqCsP`CiJnW{UtR{sAvH}hAnj@mn@cE{VlEwJl}@{t@zU{z@tB_d@hYod@`b@y[nHgQQesAzsAiNfQ_Ufa@kpAna@{~B}Wor@gjAodB{bAyn@oo@st@uKsu@bR}OrC_`CzLekBhQem@Y_\\\\`]mn@ei@m\\\\hAuZcp@_w@g]am@}VeMevA{hBil@ke@qO`SyVvG{RkTmSjQwz@dKur@cFcSvIgEtHgRb@sSeuA~IkHtArH{CdFnErMuFvCbKly@{D`F"},{"id":"2023-07","name":"Paris - Pontoise","strava_route_id":"3109426802085958806","distance":186206.32533534424,"elevation":1899.220470372306,"summary_polyline":"_fiiHan~L|DzKaHn[sInOqLeOypAhgAqLMi]wjAmw@_sB{n@g`DoGjGqgAigAuY{Gia@nLeXt[_X~}A_KxkAw^cHqJoJ_D~Cc@yHiM~DkEqHsApAtClKk_@rl@yN}SkLxKgOuHsSv|@lD|QiViDiCtYy\\\\`XiUn\\\\gL~Cgk@uLtCuWyk@uo@ZsJqMsEcKwe@a]y^qk@{wAu]y_@{Gbf@cMxHgPhYsOmBib@|]cInSuJt`Ai]o\\\\c`@rUsRRxHvk@sAlCsIs@sBid@iPiPuZ}Jc`@xCzEgm@oIkVub@pQjCxHyBnTe`@dr@eGhj@md@xRFv|@_FbKa@dR{CpAcHsGkLa\\\\sFiAiLfLkR}OQw^_P_`AsGgLWcJnJmMbKcb@rJ{Pu]k_@si@opA}`@na@sXys@|K}e@zPdBtPkL|Wur@vG_[gO}c@sz@aRwDqNiH{BwGas@}EcI{ZmAg@jKuVzk@oEiXih@en@kYyx@zBab@jFeHm^cuAsnClDcc@ml@oe@i]}Lni@wAfXgd@p{@bDzq@oKtS{z@`i@fBpo@aBhEt^rOtBba@mPxYsZnMo\\\\fv@}G~h@pAdf@wCl_@a~@dlCoTnhBuZoAug@pTuo@vGmdAz}AkRhg@k{AuYmC}F`NrFhGmFjBwVwF}ZuUkUkNyWkRHi^|_@sc@hEsk@paAeDjf@uQlw@kCoPn@iS_P|CiSksA{[k_AwQgQgH{vAeTkXLcOwRiLmI`k@gPh]gEbYyTlWeJj]xErf@mLdYfDvZ{E`ITrJyg@`UwWbpAeEIaD~KyMhN}D|vAyVtKiWhb@aDqOmGkHuLdKiFpW}I_N{Fz@}Al\\\\gLnBaI~P{A|i@wLt@qNdQ{NrCoIrRqCj\\\\nEvm@cLtYpH~i@hGsEhLbPxY`KvUx^xX~C|Sfe@dFbXdXtExEdMvO|MbC|WoGhNbIdh@t[|V|i@``DdHzm@mKla@U~S|i@xKjWaNgG`[vT~TjXnbA`Vlc@pRzM`MyDdw@rl@`O_@fBnQ|SxDlSdWnSvL|]SxcApTjP|\\\\uChLp@xP~Pde@|~@j]x]h[nK_\\\\bCw`@bXowAzBeU{A{RdIkl@tMqTzH_ZfKoMr\\\\kdAxMlI?~d@sG|_Avd@luBtWxYjEiA|@tFrc@rd@rFdSf@f^vJfSrEwClVfKrRZv@yEvNlAhLyHjJ`JcYheBpD|Nh`@xYrUpGxVqCxIvEdMwTvGh@`CjM{EhJdAxg@|Sbq@zp@qIz]dIxNuD|AeGxI}x@\\\\inBqXegBoJcQnIeRbv@_r@bOkr@y@mUhHur@nIqP|Fcz@hJ{WuIeWxF{PzXeMrOjCbFmIYuLlJjCjAcw@hGkVhJuGhTj[bSlEpR|q@tXpn@`Gx[tBt^gUpc@a\\\\zbAdOlGlJrc@pi@n`A~Fv^~K~PfL|EzA`SmShUeGxS{Ax\\\\vHhWiKjd@Wlb@~Uh~@`Lk@rMnIra@vn@~RbHfRsXdRkLvXhAvNkw@pTsVhMso@~Zi`@e@wXnIeJtBsb@jTcx@bD}_@bDkBjQ~IvLyF~FwNs@ua@fMm\\\\lVnEdLuItDeY|D{Bnx@fOjYtr@rKoMqE_[xAyP_DmXT{NfKab@sAuq@iCqEjCaIgOql@{`@u|@pCyGuA{XrJcWpBr@"},{"id":"2023-09","name":"Paris - Abbeville","strava_route_id":"3132030343050952256","distance":186612.637611956,"elevation":1849.476313688427,"summary_polyline":"_fiiHcn~L|D|KyIv]aO{YkGl[unAvcAiOuA{L}b@qU`YeKcXkK`Ogf@xWmCh[kLkGoHpUcYmPwCnQem@gPgMtGim@|_Asm@pn@zAdDuEfFen@|Ycm@vb@qRYgF~[_S{Wkb@iFkCpn@}FnGrAfSoK}D}EhKqFyTiHf@__@m]iDzJq]_Xkb@h~AwTlGeO`p@}bAqs@aw@i|@uKlZeRgL}WtEuq@{ZuCqXeT_l@uVaWsFah@{SiD{LhEmJuF~@nZaOhdAyMUkXpSObs@cn@hyA`AvSeFnT{n@cNyRl\\\\m^wHgLb^`B~Q_C`MmWxZiQ~`@gJpF_LiCka@`h@ob@ZiYgQeZti@cA`XoPhJgCdMqWfA{SfQc_@qG_k@dfAyPvBqRjPoQ@oDnEQrMcQxVmOwCgFlIeY_Fsn@`TaZjlAqHrNbGb[X`TcDj@yDpS}NfKud@eCwS_L{SmP{BmK_P_JyAiK{FcCsAn`@_Vtq@_Tdd@yUtX}Nda@imBl~@aUw@uCrYcWeLu`@xDaaBgDyAhYzAbo@oFv[q]bYgi@jq@}IbBc@vMfDzGwSrAmPh\\\\}a@bh@sa@pVoO~Vcm@nB__@~ZgjAohAkGkUoLyLwQqDiTjFm[}Fi]{ZcGzGGvHaJvAQxd@uBzB}a@{[yVyCye@aUwa@rtAoOfV~CpJaB|U_h@a]yM|@_g@_Sqb@sAeTrh@c@jKmGSw@rHsTx\\\\o]n[gNbDuQyEqBvZqe@wMaKhDmBlHaQkPeKvGaCxMoKfEgSkIgBaLg`@cJqKeX}RhB_KdHcWlj@mSyD{IpG}KoIy`@~GaMdkAsb@h^g^lF_UhPiH_\\\\fBs`AaL_OaIu[gg@cq@{LlNaEs@_D|j@gUbn@iGyJme@mS{Nn]uVgRyvAuDcp@{Wab@hMsg@bg@wiAca@mNeMmRs]yf@gTyV{Ecb@f`@oBaHo]aAaW{Lkj@jj@knA|VeVxNq}@tdA{X~IeeArdAij@oW{Sqa@wYq^oC}Ood@rF{WsGc\\\\lCecBuGuFdBcOda@sg@~p@ik@{r@eTtD{DuFeEvEvArNuIjFwNyO}RwGwHeQem@bD}Y`Tsh@mWlH~YwTo\\\\k_@gZsDqKkKfDoLih@BrgAcOtQoCmH}DN{]pXwl@aHk_@lh@aR|Dsc@R}QeU{ChB_FeSTmMiLpBkJoRqN~Bu\\\\sMyX\\\\mIaNma@cGe^~Ow[lAix@_P_D`tAiG|[bAbm@eeA``Fg]zYox@b~Ae`@tV~J`c@mCp^ek@~{@uQbg@oMiO_RrTcClU}Mn\\\\gV~Ocm@}@uAbKcNqFmD`D{N_`@iBrDwbA{@kWlMwIeGgG{]}]ua@eO_]}Q{IwQ}U}Wqj@}uBcoB_QbAuSvXiNv^wGl^wVdVo_AxJ_CcKq@`HaF`Bcb@|m@sJp]gYdg@od@uCcx@xMgDhA}Dv\\\\qHlHkq@`Iql@lCiy@sKskAepA}XiNkNug@wwA}bA{XiAgXvk@cl@zbBqSf\\\\o_@`tAyo@tsAN|GgHDy`@xZwZb@q\\\\`LwWrReIhRkEb@rR`t@jFtC"},{"id":"2023-10","name":"Paris - Nogent-sur-Seine","strava_route_id":"3142454474447594714","distance":158809.31190408583,"elevation":1124.0094808549434,"summary_polyline":"o}~hHcaxMQoTjBsUfDeMbNuTpFeUfBsVB_p@tGuv@hM{WtDbCpPl\\\\~Ny_@pIoNeAoFnGkI|MoHfIBlPeGUoHfEgJzLaL~PeH{@aEc@en@`AcBeAiBq@{r@p_@orBgMeH_@vAwHgHjNyb@fP|JdVn_@|OtQtQfCtl@e|@C_D~MeJg@mYdBsArMc^hMeN|EmRbFm{@bScGiBqSzRcWfcAb@hHbFlCi]zSaGrCwQzNr@vAfBvYcUpCmN~V}Dz^rVtOjSnVdMnh@rb@b[~f@`Ex]nVo\\\\`U}b@bMiNdVnEhYwNlTP~FhE|JqHvRpX~^l@eEkQdHwDhJSAfDzJnFc@}MdIsUfBCb@oKdFsZLoR|BsNpB}n@`Iyo@a@a_@bB__@jIuk@hC{m@rHo\\\\tC_XnNkNxGcP|EmBoQkR~AyLgG}KnLeZfIy_@hD}k@~DyTh@oQfCgN`@kc@qDsl@es@`^eEuDf@{JiAyQmB]eEhFZmExLkS|B_OrGoErEuNjEqFf@}LaEmSjDcFwEiTp|@uDbL}GtDeY`Aai@uAgO`DmDjq@sLnMmOhKkFpb@}`@fHmY`IlDvDqG|uBumApT}I~]gv@tMeIlG}VjFoLsGqZmD{o@}ByG~@yOnSdFdLmLtEpAdFwF~k@{MbFaEjP`InIo@LdEpAjAfCgBxDoXcD_`@qCoHjAcSaDeA_Aq[aHmi@IsCrEsI_DkR^{I{C}Gq@yJkMgd@xXuGxKuSdO_KyA}Ku@qf@jGg@|A_CI}EfGiDqCuPxGwG_a@y~@vVoCrQvBzYoBdmB~f@nMnVlJdCnBjClFbf@`KbXF|FhJd]`A~JjG`PoA~XdArJQfOcKjOnUfFtj@rX|C~CvCvMbGeBpYpEfM|OnH~XtFbJzAi@xC|LhHyIxJ~@xNzIzMrBbJaCpS|F~[cFt^zExIjJnEgLfh@g}@jZmDrPh@nA`FpHnIzJcM|K|DuEqo@fD}`A~Rij@lD_u@uEsMrTelApGkm@`Pin@`Lyt@Aqf@fCyTu@oL`@qTa@mCcKgI}EoNtAuVuJm_@|D_Zg@sf@}CoQyMoGkC_]aGyPwEwt@iQmb@sMuQmIqRyBw@mXu_B_TidCTehAwB}An@_KxW_m@n@w\\\\iCeT\\\\{VoDyr@|l@yeB~GqGnK{CxLe\\\\}H_v@xDcUhUqFyAwS|GaFnTuBbAyFpd@uw@nAeNhFyLvC{QtZ}GzP{XbP{M~S]xRkM|TqE_f@snAmUks@jLiPr@sEr]iP~r@o~Bc}Ai`Bqn@u]iRaA_CaQei@v[wToAsx@bVeDkI_Kqu@mEsOoIsw@cc@pE_A_@u@gKkOoFkDDsNvJsEJvDc]sD}z@iB{C{V}Fsf@owBcBqBmLbBkCsCc^cxAqD{v@mQkB_Aoj@oLuI}HzBsFuAsJgOe@el@eAsJjBoNoLii@iJsNdEi]`HiNrAa\\\\_Fyf@yFmM{@o\\\\`DaR^eMpKk_@`AyIjE_K{ByR_IgZgCmRbEeL|@s_@e@wOeD{OeLsFh@}Lcf@eIyi@aU}s@eJ{r@oRg[aSeU{YcWeOsLuPSwS_Iks@|AwdA~Kev@bFexBk@sm@dHul@b@ym@|DiUjUhGxQoBzVcu@FuL_Jqe@dDqDn@mF~EmDz@uNtEuBlNbYhKd]pQjWdHUvK|JhEaKrF}B`AhC}BjHfC~JnIf@~CbHxPvNbL{@tCtIjFd@n@tInKsDzGuOxD}AmHkf@kQwgBsKwo@wBgt@lIwSpQgTpLl@pHiGzNzAvQqd@`D_EpRiAzLiI"},{"id":"2023-11","name":"Paris - Nangis","strava_route_id":"3154067848770418530","distance":114565.40038298126,"elevation":801.7717926514019,"summary_polyline":"ic_iH{zuMLcANkBH@LoBDqDAkCKmG@qCH_Cf@mFj@gDZ}BPiCD{DCgDQ{IEiF@sDLqDNkCRcCZqC\\\\_Cl@uCl@aCjAmDvAsCjAoBpDsEfAgBdAuBnBcG~@}D`AcGl@eGd@qGR{EBaCq@uBUi@q@iAwAcByDcDb@mGNaDXuJ?oACq@QmB[{AkAaEMJjA|DkA}DLKcAyCy@gBs@mA}@eBoEiLuAgDu@{AH]I_@IGGAI@GFcCqFyBmHgAaDu@mB{CeH@?yAcDFWCQrCa@|JiAhDo@~A?h@BZHzCjBz@\\\\fGpA~@g@x@i@Us@a@yCKiBAiFQAH{d@RG?FD?BHEd@AxCD`@EbIBd@Rn@n@n@r@Qf@Qr@k@~BeFvAwBjEuFvBsDxAeElA{EdBwHpDwKHq@f@qCz@eG?_@N}@NuAb@cGd@aLf@eE~@uG@]J]|AkJb@yDb@{G?_@Jm@f@qFB_ALy@n@gL?s@Be@G}B?FWeDKmDCUEcKDSHeA?o@I{@EaABiBQuCn@sIr@cLKeEEMSY[UaBe@Dc@x@ZnGbB`FxAtA\\\\rCh@`BoIr@sCnEgI`@kAVKlDcEzBqBx@o@|BqAh@ShCs@tB]JEB@TGLAVJtDCjAFv@HzB`@~Ab@pAh@lDhB~EoXhJfG|@b@dG~DxF{PpAeEPs@NQjBwFPy@fP|JyBqGqDyI{@{AiE}EwAoBOYCa@JqACUmBsD_@c@kAeAzAb@PAN{Br@oGVoBjAyH|Bl@HMxKmKy@gCfTwSx@hCbA}@TMvFuBz@MR?VD\\\\LhObH`@\\\\PVXz@hAvFZpAHLPFT@|Gq@VDAm@IqA[aDmBeIC]AcGL_Bv@mERa@~@cAHm@My@oDsMu@}BnB{BpIyIaB_FnJaKHANBBTDFLDLGDUtId@NJ~@jAhGZb@R?ZHJJ@HINPbApFLD`FHLGJ^ZdBZfA`BrE^lA\\\\vBP~AxEzRL~@OI@NfA|AvLpUCJ?PBHDDH@HEZiBl@sBF@FCBMAIEEfCoJfD_g@z@mSHCFSFEhReFiBqSFE?KXk@xQeUrr@`AjADXDTNF@JGDQbBCT@t@N\\\\@l@EhAa@^IV?^FzEfCCPDb@V\\\\R?PKFIFa@A_@EKXm@Fe@ByBHcAPcAD{@?}HXoBPe@Vc@t@m@XMTExAK?LHPNFLGH_@jAErBUxA]t@[^YtAsAH?DQAIXeBN_B@_AKgBBm@F?LKFU?KIWJWLMb@I~DJrGn@XJPf@Bd@JPLDPGJW@Kh@qA^M|A[n@UrJkHr@m@f@k@z@sAXU?UHOFC?aBv@sMd@_GPgAHyA^iE`AwIP_Ab@iAd@y@\\\\]v@e@LAn@JNZHFRBPGHKLc@NKrD}A|D_A~Aw@ZW@SFGF@j@_DZoCh@gGN{@~AcHlAwEn@iBVcAhAgJZcFv@iGXNb@B|CYpOaARLJMNDZQrAMj@M`CAxASh@MrBAXCy@mFK{@MeBC{AXcI@yFu@iJHID[GOIEI?W_AUo@QwAEw@FuHAyASoBk@oC]eCm@qIEeBOuCQ{AaA_HsBeKQWsAoAoAqASWy@aB{GaTq@}BcVkm@U_A[}CMiDIeG?yCIg@QGgEj@[@q@EeUwB`@}HXaHnB}O?_@Nm@r@yGr@_Fb@wBrFqRd@sAnB_FR_@vAmBp@_BlAwD~\\\\ax@eMwREEKA{@PKCMU[iFhEmAvAg@f@UgBmLk@aCSqCq@wN?m@hAyNvBq@xH{EtL_IxBqApCc@rC[~Ak@vc@yZ`BgBfA{Aj@o@TOPET@\\\\L~@|@r@hAv@`B~KnYd@x@l@t@n@h@~@d@^JlALd@AjAQxLkC`Bg@dFoB`CoA|@]rI[j@MvLgF~@k@zBeBTKTCXLb@h@jCzFpAxBbCfCpCnBf@f@xBfC`BfCz@`Ap@b@|FxAfCm@`B[lC}@jBg@nDK\\\\@Q|@?p@^~GlEd@d@Jtb@jNf@T\\\\JL@XGHI[IgA@RJ\\\\JL@XGHItAi@tDoAtVyIfEaBrDyCxEsDl@_@vi@_XZUbAaAdCsATGlAENE\\\\[bCiFf@_AV{@PoETcAp@gA|B}A`@Ob@Bf@h@NpAx@fOGtC]lDAv@Ll@\\\\h@tAlA\\\\Ld@@l@Sl^cRlQaJZGYyFUe@{Ao@oAwBg@yCi@gIEkAFqE?oAK}AkBuMImAH}HGcCIk@s@y@}@m@a@c@_@o@oAoDcAsFYwBU}@yAaKq@{Dq@qEQw@aBcFI@ICKS[kA]qBGIuAg@yA}@cBa@g@WIOAgADa@nFuOF]@c@GUKQMCSBkAd@e@f@kAxDKPMHS?QEMSiAwCQeA{Cyk@MkBIm@_BgIE_@HaIWcF]aBkDkLYkAWuAK}@GaA@SJ_@I_ASs@[k@aAkA}IcOuBwD?@eIeN}BoDyGmIqAeBcBoCy@yAo@sAiF}LeC_FaEwGqWuc@wEsI_C_Gc@a@oC_A[[O[QUEe@w@mCG_@Ak@Jk@v@uBHm@T_AVs@|@eAx@q@r@c@pAc@v@a@p@i@n@o@nAeBn@qAz@yB|@uCr@gD\\\\qBLyABm@JSTQ`EJ~@AzCQTKLSHSZoAXkDHe@Ty@`HoQlDqIf@eAZi@^e@l@k@tB}Al@k@dBkB`AeBbBoEhEmNxAcGb@mAdAcCrAqD~@uBp@aA{@aCwAwFcAqCjCaDnBmCkA}B{@mBFSh@}F@kCJi@J[PURCp@iEZmCPaC@a@QcFEyCAoE@y@Js@b@kAXeAn@}DXeAh@sALk@BS?w@MeD@y@D]h@oBLqAB}@mAuNQ}@w@kCyBgPW_BePq{@SwDCsDIk@c@{G[uCaEiT_AiGMmAa@cPrA{i@DoEEwE@qAF{Af@gChBmHNsAAa@Mm@e@aAw@cAMc@CUDq@Ro@|@mBv@}BtAiFJk@Ae@_@qCOuDe@mES}C_@gCi@aC|@w@E_@a@{IBAV{@l@mDHaADgAHw@VsAPi@\\\\a@Pa@?c@K{@Bo@p@aA^iApBsM`Bu@jBa@d@U^iArCmH`@yBpAmCZ}APcBj@kCzCsLxDmSlAoFx@_C~CiHxByE~@_AlAeA`By@`@q@P{@_@aA_@Li@IiBqBuAqAUa@SkCO}@]}A]w@c@mBKu@CiCgCiIuBeAqDqFlF{LVaAVwAFmAL{K?eEDkBPgA^kAz@{BT}ATkE~@}IPyCNeBb@yCHmCSoGYwBi@iGMcDu@sBKi@QcBi@}CKiB@_CLaDLaGDo@XuAZLtDG|AB`BAp@OnAy@`BqAfAwAr@kA^l@^\\\\`@RVFdALzDTxQ|BT?jEeDjE~Ij@q@~@]vDk@rEoNQg\\\\@eCXu@bAkA|@mAZmAV_B@yCGaBs@kJnAsECg@cCaJi@kEMkCe@qSBmAbBk[Jo@Ru@`@k@~A{A\\\\g@Na@v@eHCwBMeBD_BZmEVaBJ[x@cBLo@CaBMo@aA}B}BcEwBmGkDuHgAoCG{@BmAr@gENoBGgAYoA}CqHU}BQ{CEyA?eCMkHAuBDwGGkD@y@VqCx@uGEwKEu@McA{@wCiBmDgAqCc@y@u@cBcAkD_@_BEeA@iDFk@iA_@cBsAXmEASGQu@m@s@mAw@cCkDsOqAoDi@s@m@aB_@oBg@}FYoEIaEBiAb@uHEkB]gDuCoSGy@Ay@BiDC{@IgAO_AU{@gAeCwCgGJe@hAqILuA`@}KpAkGHE\\\\NvBjAj@P^Bv@OTMVUj@_A\\\\eBv@qFT}@X{@tT{g@TcAHyA^e]HoAHe@Tg@xXsc@~MqT^a@^Y`@Ud@Kn@ArAPlA\\\\bARj@Dl@@dEOx@KnBu@f@[vBsBjGcFhEgEW_DBOFIpAe@l@MdB@r@Ar@KhA[fCcBVe@Da@LBpASZ@bAb@nAVDI|@o@p@a@dCgB`TmNniBitBn@_@l@Ot@AdCn@`@B^I`@WfIuHj@s@^{@\\\\oA~Lak@`@wBlCa[\\\\uBx@aDfAmDpAoDtAmCrAyBlFwHlG}K^}@RoAR}@P_@`@k@EeFBqHNcFj@iDp@{CTm@`AeBVm@Eg@}BeGc@uBq@uBg@iBIiAEuD~EuPPgAxHko@tTokB@a@rA{BeAgHM_@KMgBRWQI_BYiDwF{]OeB]oKEyBD_Ax@oLrDud@`AoFj@iBrDmJj@aAr@{@dNwN`AmAhLaShAuAZaNFSJIpAUrOuFRQJS@iADMO_@wAeM}Gmp@a@eCm@}BgGcT]}BgCs[A[HcARqA{DsDyRwN{@w@iA_BwFkLo@}@_YcW|@aCxMu[bAyBpJsJtOiOFI|AmDxB{LHcIjBaOPgBVgAn@aAx@y@T_@h@eCx@gFvAX`C_@f@Cd@Fn@TdChB|@b@xAd@~Cn@pEt@fLj@fAAlCR~CnAzE?zGzDdBt@hMtBjCz@fCjAlO`KxNlLdD|BdAZbCNjC~BjJtAjB|@dAnAz@p@hAZjAAp@Dd@~IIhAJxBTnAlAvBbApAh@b@\\\\PxC`GT^z@fArChCfK`JlDfClPbLbAf@fEhAvHdB`CT|BBxBQc@tCEr@Dj@tAdICxCDVnE_ElAtFV`BH`B?|AYtHCrA@xAPlDjJn`BBfAAdA}AnL^?Ad@oAtImB~LYrA[`Ag@dAuCvEs@bAy@v@sJrFuAfAsArAaAnAw@`Bg@~A[fBo@bFa@vAcCvE_@~@WjAKlA]nJ[dDwDdYTLxAA`BO~CCzFBl@FzCr@pBZh@VjFdD`AZjA@HPAj@{C`YGbBCtMErBQtCk@zFa@bCe@zBIjB@|AhAIr@Nv@VRl@Hb@x@xRHvFAbA}@bMUdA{EbQO~@IpCUvNMbDU~B_@rC_Oby@iJrh@W~@a@l@yBnAuAl@eCz@sCvAi@R_@vCW`Gc@dHe@|CBpA^xG]TMXO|BKXoAnAa@n@ERAR`@xHEhAIj@mAvFY`BElAZlC?r@Mx@_AzDqBnH]|Bm@bJKnCMnJc@vN]~YE~AMbBi@lEO~AMxCKxAk@zDe@dFk@tD[jAw@|ASh@QbAEl@]hMOxB}@lJY|HAlCR|KHbAL|@`@xBHz@At@QhAHZLFFAZTPTLf@LvCOfDKFCR@DHHs@bRIjAc@nBYr@AV@FHFJABCLNDL^jCZ|FHvGcCVKHCJI|DETIDuBP}@D?AaZfAIz@iBvCGNAXK@ENIDMIG@"},{"id":"2023-12","name":"Paris - Paris","strava_route_id":"3165722802814443276","distance":78814.7301962924,"elevation":854.835940587667,"summary_polyline":"_fiiHcn~L`CpINp@j@XqB`Jp@f@xDdRl@nAjLtS`AxQfArCLRNHPEFlAAXENq@v@OXGZIv@?h@Jp@L^HLd@^`@DT|@ZhB`@nEb@~Bn@xCj@bBnA~ChExI^~@lAzDX~AIt@DtAHEBDD?~@}@RI`@GNBTJbBrAj@^n@NR`AxApD^l@h@b@p@\\\\tBf@p@\\\\~AfBh@f@tAj@r@?~BSrBV@LFFF?HK|AnCrArBd@j@d@b@rB|@fBl@tCtAd@\\\\ZLN?KlFDvBfAfSTrFM@HpBPdNEfDOxDUdDg@dE}@fFk@bC_@pAaArCcB|DsCxFkDjGoBxCiAxA]OiBsAi@g@Sg@IFo@JBr@InBU~BYbB_@|Ae@`AG\\\\Uf@k@jBy@dBSNOVCTiDlJk@nBeAhFoDnSU~@JdASdB_CxJ]bBM`ACrADb@b@lB^lAz@fBp@`AbAx@dBhAx@p@t@x@bA|Al@t@v@x@j@b@p@`@fAf@tA\\\\xC^j@b@b@p@Tt@`@hDJf@N^PVLJdIvEvA`AVT`@n@P`@J^bBjIRt@d@rC^l@~@r@nAh@Df@Vf@f@b@rDbCxMpQb@XvGpC`Dn@XRXDLTbBr@j@b@PTRr@P`@TZv@bBtC`Jb@dAZj@v@`ArDdIv@jCdAnCV`@@b@ZvAp@rENvCCfBKrAAb@Bz@~AfJxBhQh@~CC\\\\]nAGd@@PPf@tClCPMTa@VBNXPnAl@fCt@~AbAz@b@sApB_FrPzCL?d@E`FkCv@Y?O`@Td@lAHZbCxFHNTJjAa@pB{@XGtA?bJ[RxChA`Ix@dBx@fAfDvDh@bAnAvDvDbM^Q`@|BLpAHfLP\\\\LDx@KtJqCrRzNj@t@\\\\v@n@pBxAbRb@pGf@vL@fAEp@y@pFo@rD@|@p@fEt@lCx@|BpA~BVfAXbBbBvZ\\\\vAZz@j@lAl@z@hAt@pDzC\\\\Rn@HRALDFH?ZK|@lBZh@Dv@?fIYzFa@l@I`BM|A[tE[vCCjAHx@RlAh@x@n@bAhAvEhKl@fA~FtMZqBnBgGhE~@xHnB@JDFVFDAD`@|A^`@Y@EbQnEVpJJp@hEbKV`@t@`@rD_TNH`@b@vDjBt@?PC^XNVPv@BV?`@O|B@V~AtJr@zAh@z@tClCCA`BrAJV|IbG~DpBbCbA|BVf@LfAh@dAbAtCrDfBvAHIjAf@fDj@VPTHpBXr@FDKb@EnAHf@H?J~Cd@|Hz@tEp@lCvAXHbAOP?LBfEpCe@zB@ZDT~BdCbBvBzBdBxAZrAJLC`A^^f@`@v@d@hAHFV@NDd@TPPn@VpCn@R?~AXLWhCgIN}@BCJDBJmApJ?v@LtAL\\\\hA`@LN|@hBX\\\\pCrAATJLFdCC`@eAtFRXnCbBfJvG?NLXMj@oBxPgCrSWlC]fJKvECpOSrG@BJDQxAOlBOlEIpASlAcA~DsK|d@i@rCi@`Eu@`FaBlNKTN`@b@pCbDrWb@jCXnA`@dAl@hAv@dAf@b@t@\\\\lDnALFHP@RR|@EdBk@`BIEMFATHPD?HEnBnDx@nBXjA?HPt@FFdCnKpA`GGFEXDXNJF@FCjC~JTvAPlBD~CWrHMZ?`@It@U~@F`@SbJeClEz@rA~@pAqEhHSXKFFTb@fDTdCE`AGRNNAFNLBGDBLSFC^RX^~BzBxA_FTg@jAg@a@sC|BtOzCeBv@Mh@?x@J^Nj@^?NFP_Ofe@EGQCOJIZB^LP}F`RQPS@OJo@rBCRBhACLyL|_@M?GHALBNFFkK~j@g@|AYdBAhAMx@eGxRMx@Gv@?x@JfCIN?JFLF@z@pNHBFH@JtEnAjExAnG`DhAr@bEzB?VJPPEDM|EfClB`BnDzDvAhBARDNJJD?LGBERVhAdAtAx@T@lBf@nC|@r@yC`@gAb@_@h@Mr@GxAFp@^~@r@hDjDp@FtEMzH]nF_Bxy@yTl@UX?PPHATTzClH`@fAR|@v@lEJ^lEfLh@~@p@n@PJRFb@?`@IhAy@~CuCtAk@XQf@u@`@sAT]|BcBf@k@bB{EVSd@IRDRNJNL`@zA|GfGpW`@pA?^Vj@d@bCnDfOl@vBRf@d@v@RVrCdCj@r@f@t@d@z@bCtFvDfI~KvVXd@\\\\^ZRd@Nb@HxNh@f@LvBHx@CrBJl^lATBtBt@JFHLFZPVRDPGLMFU@YKi@KKEYBa@N}@Pk@t@}CfAyFN_Ch@wMn@aHr@iFf@sETgCCTXyEJgCRwArBkGb@gBNeA|@{OTm@b@g@fA{@xGmAxBeBrFSvAg@l@_BHuBcAiNKqBAeIa@oGG_CVgHVsDx@cHTmAJUb@]fAa@z@g@j@k@rAqBZq@Lo@\\\\{Cn@{BfBqEDAJH~@tDLRTLJ@JApAu@ZM^IbBQ\\\\a@NInEcA_BsCSW_@YsAo@E@Kk@O{AB{KEcDJwEs@mFJ{ABoA?wCH}Cb@sHqAc@}@M[Aq@XoAhAYd@YfAcAlESzAUjA}@rD_@l@u@r@y@|@Ub@{@xBe@bA]nAW_AcBiDe@y@u@_AoFqEsCwB{@a@kDsAqE{AwGsBwDcAmAi@oCgBi@MqBHQBiBzAc@Xe@RYF_@?sAOwCKkBQe@AeCXQAYMIK[y@GGs@MER_@M[CyB?qBH[HGNoA`AYXYd@KZMl@CbAJjA@fAK|@cBrGeAzCmAjB{BrGw@nCWnBK`CU`Ae@lAk@~BOz@]`AS^CA_@R[?yA]kJoCSAe@Bg@JsEtAaM`E}@r@i@_Bs@iCqC{GuByGw@yCaAqBWHCmA_BcW[kDY{AkFmTWwAKcAKmCAyAF_Cj@aEn@kCdCcI?SlDeKzDqJh@}AXmAPcAd@mEN{@t@gDdA_Er@{Av@kAj@m@lCoBl@k@~@sAb@cAf@_B\\\\eB`@cDVuAVu@h@aAr@q@b@Wv@Y~Bi@fCs@zAm@lCmAxAy@bAqAXq@T_AReBLaSJgBTuBZ{A^oAh@oAt@oAv@_Al@g@dAk@^?JJF@JGZk@`G_BHVDBPEHO@SKWECK?KoA?ODMlD_ALKlA{BnAuC`@kAn@gCD@FCDGASCGjDuKx@cDRk@|AqDkBoBYe@Wm@Os@QuACu@_AyIe@mDO_@W]]WWKkBIe@OeAe@g@KY?s@Le@Pa@Xm@p@e@r@}@jA{@x@[J_A@WEWMSEa@@a@H]L[XyBvCs@r@aBbAk@T_AN_@CaCc@_DuAc@]IKEJObBHn@Nf@D`@Cd@Uf@KHUFWIkAcAQGe@EaBJcC`@g@PiAG[EQQUq@gDeGkAmC]_@cEkDa@a@[c@o@sA@?{BeEQgADYCa@I[KMMGMAMBUMQS_@}@?SN{@Ac@KgBYiCcAyF{@qCo@uAyWi`@i@kAUsAEqBC{MDiBPc@HCDQGMEi@L_HMqAH]ICUQK?A[o@oAkAaDWaAYwAi@oBUQYu@JGOm@DOCWIMEAKBm@mBg@cAo@_AcAeAaB_AoBk@MOMi@@OAe@GSKOMIMCMBMHQ`@O|@QRg@H{VmBmAMe@I{@W{@a@qAu@aPoK}AwA}CuBoBgAOOC]Hw@NMR?PFn@`ATHPAPMH[^cLZoH@aCAc@UyB_@mBMe@yGcPm@iAqDkEISGy@Lm@vAcRBsAYwBQk@@Si@_EUwBQuGLCLa@AWEKi@m@@Uk@}IEqBIc@MQKCGGYmAGKKa@o@uC_@cA[q@sAsB{@gA}@q@m@YMMKSMg@CYBy@\\\\oBEoBAmGH{GBm@Hy@VkAdDcIlAkGH}AH_IEYOOeA}BMSFKBOCQGKPg@JkBhAqZ@[QGES?SDi@X{@s@k@cCkA}@ECpBiGe@aAK[UINERCdAFdCTxERzBnArGH|@D~@iCMk@HKA]k@GEO?S\\\\ID[WYiCEMsB]Aa@cBiMJsDH{@XwABg@Ak@Mm@cEfBUFeABSDUNcA^g@VYTi@JmBLuA@{ANmBb@oA@eKk@cK_@kFPs@S[Q_FeEY[DY[qAA}@B_@\\\\mBVw@P_@b@u@~@uAXo@R{@J}@FeACuFDaBUk@ECe@Ca@P}BxBULs@@wAOY@WHyA~@UBi@KSOMWUu@_@oBQm@cFaKgGiM[e@CSOUIEI?OJIXk@RwKt@eAGa@IOGOM[s@MOSMeFy@}AOgA@yAVwFrBm@Pc@H_AFy@Gm@K[K{@a@kAcAsGuHq@eA{OsRkB{B_BgBoBaCQmBP{JCIDMIIDuAP_O?iBKi@Qa@UWUMsImC?CeJyCMMGOeBiFCa@@a@F_@~D{MVsCZeFl@_H`CaGP[RCNLPFT?^QV_@H_@Bo@Gk@Qe@QQvFqTNJLBNAJGLOHUDYCi@O]SQfCqf@HITGXC`ErDdBoFJaBb@uL_@^kFjIy@jAs@`@]FYEi@_@oSqRmDyDaNaM}MiMyA}AGc@uAaZ?DKcAUEwG`@MQxEwBtCgB?gAn@oAOUiA}DaJa\\\\g@eFAuC_AiA_Bs@kA}E{B{Js@}@Ma@w@_DqAyG]i@}ByBGSAQBMEOGCGDi@Da@]UW_CiEqBmBIQUmFU}Bw@}D_PpGgAQcALi@p@yD~AoAP}@x@}H`DEGQAOHIX?TDTJJRBVZRr@zAjHh@nBzAzEp@hEVbCXbFJ~FGlCQfBQlAiDjNsBnGiBvEaAhAw@|AuCmDK\\\\tIfKNZrBfCDKu@aA"},{"id":"2024-01","name":"Paris - Maule-St Nom la Bret\xe8che","strava_route_id":"3176874520600158268","distance":128406.66640469556,"elevation":1161.796448262093,"summary_polyline":"wdiiH_k~LtCxHogAz_FuCbHcKpIeItTeWvQtDpNunAzKwzA`{BiCrEGtHeOdKgSz[wk@dn@cc@`mBcQtm@yPtb@w@n@gOuPwe@e_@ka@wNsTm@uZbEmm@x\\\\sN~LeMhQyVbl@gKz}@uPxu@oAlXrAnc@W`]cApMoFnRg@d]gDnH[rp@kFIsCuCmVnc@cCyJmX_g@oH_TaB|BGbS`DpM{KnCCzBwKvHSvB{GqDcYpb@aE{HmFrJkFeEsDnAcWdb@cBaA\\\\bHyBcAiC~FgA]yFhQe]iHod@g\\\\cf@aCw[aVqC`JzHpJ_KxDw@hEc@xVmAnHpAf\\\\wO`UcCbQc@xWoBvBuDnWiC`EsOpIxAApA_AkVrAwBrVcQl`A_BtY`ApAcD|VAzZwOfa@Zdd@gFfLeIrFoOoBmDiFcDjBcD|_@sBxGkBfAkM`m@uBrb@oIdJd@vXuMrTiLtJiMro@qTrV_D~IF|M_Jl]oW_BmS`M_LhSfK`IpDpPpB~BhAjNyApMhMz_@bGj_@nQ~q@xSbSzf@ht@hHbEvD~`@fBk@pFcPvKbDuDnSiEbm@iFbRkU~b@cAz^qH~O?pK|A[dEvDpEzQllAj{AtIpSru@|DxAdDnCn[xGxIjVx@|R_JxMfFjNmBnLjKtCw@dEeGfJg@x[zNnX_GxLfEjH_@sBhRrBiRsBhR^jm@rSl_@eAxHoIDiC~FXlHbHbPzHtCtD~MzBhTvN~`@|GrKl@vStCxC_@~BzCg@vPze@|Q|UzG``@pKtDrRaQpC]|z@bPvE~DbZu@AiFnq@uAl]nUpEx@f`@mQtk@eKhP@nGuZnEiA`FgHpFfApAlF]`CzChC`@{AhF~ClD_K~AvCxEl@xPzNfSdJnW`UrI|Zf`@`e@hHnR|LfPtJjHnLzR`CdK`AbV|BlKfA~^`Pd`@bBfNlJbQD`]nEbh@pU|h@hNdShBfGrFl_@_FpMp@nPdF~Hd@pGtEjIwBhKvWfu@dBlu@_B`w@aZjlApPnGxPxOzDI`RkKdNnAdZ{VpN}DiF{a@tLaT~Gus@jRue@|RwVpCiJfUm@xk@nG~L{IxBiJ~Ty[|Qed@nA{GpAuc@`QyTkEaG`Ey\\\\s@g^_EkIuCgS_D}IiAiVAmIrEu[kAkM}LuExD{InBeSeFkK}GyEcHcMiFoSAyYrDyToCuPoDsIaT}Tkd@g~@sLwd@kHig@aCgCnC}LsDeLnGsO`@qFgLs{A}@yn@x@iXyFwHk@}G}Cd@_@`I{EhFcApGgCKiCyT_Ly]we@cCyByIg@kP}Cf@qCyEeC_MaImFsH_Qef@_i@\\\\|GaBjW`Dz`AuMvE{IyAcBjHmExBjMfg@ErGyFjLcCkFgJoEkH{L{g@cgAqElAyAmDnTc_@bYyPvBeE_Aqv@{Dci@~L_fAa@el@rB{GmD}FxDqRw@{Npw@_~@nMon@vg@giA~{@auD`Cu@nBzE|DaAnCuMkD}YlKeg@zT_aCrRcLlKuNfNwWjRaf@|DiB~B}J_IsPxKgXx@uQuHae@TeH{Cf@"},{"id":"2024-02","name":"Paris - Cr\xe9py-en-Valois","strava_route_id":"3187768441258794706","distance":126957.24207169983,"elevation":1020.8724524725028,"summary_polyline":"_fiiHan~L|DzKaHn[eEnCmC~JqLeOypAhgAqLMgJcVaRss@mw@_sB}AgN{@]aj@apCoAQ_E|GwEqHy`Aw}@uY{Gia@nLqLxIsJzP_X~}AqGvj@mB``@w^cHqJoJ_D~Cc@yHiM~DkEqHsApAtClKk_@rl@yN}SsC`GwGvCiJkH}CIuHzRX`KiBnA[xJqFnNHrDpChCP~GcJDeKoD`@tEkD~Ry\\\\`XsDfJmFnDgHvKgL~Cgk@uLtCuWgKkI_IuOqUsTZsJqMsEsF{\\\\oC{Ga]y^aN{YcCkKsG_JwOse@sN_SaNyK{Gbf@cMxHiDfK}J`MsOmB{LzMmT`OmDnMuC~DyCbV_Ad\\\\{CjLuNqJsM}Pc`@rUsRRbEtd@tB`FsAlCsIs@b@cLwCeWiPiPuZ}Jc`@xCFaSrEeYeDmMqCw@WeFsUhGaLfIjCxHyBnTe`@dr@eGhj@md@xRfAvVkC|G|ArPQlJ_FbKa@dRkCvAsHyGoEiR{EwHsFiAkDpCmAlEoDfAkR}OQw^_P_`AsGgLWcJnJmMbKcb@rJ{PuLmP_P}Msi@opA}`@na@sXys@|K}e@zPdBtPkL|Wur@vG_[qCwC\\\\yGsKkVc`@gNoYyBwDqNiH{BqG_e@n@g@u@yKoBgGmB{@{ZmAg@jKuVzk@oEiXih@en@kYyx@W_KrCaVjFeHcXekAwCqBq@kEqfBzAwl@ftAk\\\\q@oD}BiOaf@}Nq|@oCcp@fLgGj^yk@j_@}t@zByQx_Bq^dAzBe@v_@sBzErB{EDvTrg@rDfOwgAhG}A`K{|@nB{zA{AySRqY_o@dCiPmTwHqWqFdAeHiUeFuHeC{QlIuO{A__@h@_f@oFkUVuLxEuG|SkF]wdAbFuE`@cGzMyD}@kShFgfAaDsUW{VpHsWqRkRsBkPbI{`BxHu[jCr@bEkEd]u@`TmFvE{DrByHzKoHbImDjLMpEiJjYmL|E}[rE{I`Lki@jEsKvFyEja@tO~Fg@rNjLrEiPcAaEbCsYToT__@ep@gDwJfJ}l@LeVdGih@iAwO^cLuCoI{KeLiB}F_Ekq@i`@kfAmGes@mCo|@{LkWNeDbJkMfBmTiFgAuAsFbAmCrGyCrAcQgBuCeEonAyCwXlCwv@c@uIoGc[eH{QiBLwF{JwP`@yEua@sUeh@sYwe@e[mXgd@{NyHkHsIaUo`@yRiLwO_Vq{@kL~EiROqWtDqImGcAgIkAc@kErH_s@vNa@nPoI[}~@tMsDyAuAaFkFmEaSqCu\\\\iUoLhJ_H_HwB_i@J_\\\\oAm@aEqZ@om@{FeDg]qh@iUxFqs@~ZiVxEcL~[sH~CcKbO]uNqVqMsGh@yVwT_YaIiD_a@gEgTTyLzHrBtBlHfAAG_MdDcVzFoHnD{T|T}h@hn@su@dJwY`P_R`EsQy@iLsPDiRqIs@oDqSkGLyLvFkSnBy]tJ{QzO}b@x@sFg@sKtDmHb@gSpVfElIs@zGvFrD}@"},{"id":"2024-03","name":"Paris - Chartres","strava_route_id":"3198018870333639996","distance":135999.84667723923,"elevation":1284.4383859026707,"summary_polyline":"_eiiHuk~L|CnI}It^fAdF]`FyE`CcAbElGnC~AzWdBbApnAx~EaBfNgLtZ}L|v@pDdJnN`NtKjDhCpJbMzH|EfSb[t]nTbJrK`WcQdiAPpC~GjE}AzIrVtXqHl`ArD`Iz`@lNxAlGbH`FvO^q@g[l@q@zb@wMnBcP~UgDrRzNxB~EdDlh@kB|QdH~V`Cn]tBdEjJrFCbBtn@oAjEbDdOf\\\\jCyJtf@zLb@bLvGfMrD_TpHtCvCnT|InKn[hOxKlJ|m@`JfEpC]lD|EvF~JnD`GxFdGhAvD{K{@jOnIjHlDyCfJcUEmBpDaCxkA`u@zh@jG|E~FrIzWh@~h@rZje@~BjKdAxPrPjRhGdMvPr@ZsInLhDtIcIbGIbJeHlIlCzCfVrDtEtq@hXjQxDbJ_BfDtJk@xNr@vLdBtFfMrOIjHvB~GqEf@w@tMxEry@aBti@cC|WkDs@{ChCeEpReHpMn@jHwF|FwQpj@kLfPoEfLe`@nrBkKt`@mFlH|d@vAnEhCzFaBncAzDcBxN}AnAsAtI{BdB_EtPeBjOvD~DfTrCdC`HaFfBuCdHcKlb@e@|L}HlMwNle@mEj`@ePxb@_D~NcBtZcCnMgClCgBc@_DgR[dAgA|I}JjYsIvf@cJwDsGx@eXbe@mOpPoRvM}NeC{JzD{TqBqF|LlDtBnJfRqFzJo@hGdAlFdVfXzUvk@|CqC~@zApAjt@jHvXj@fWsPn^yx@jOyp@dHhDlQ_J~KuLzd@ma@d~@}H~c@_QbMoLxUkHgJwLoHgC_G{HuEyFBsDx^ApMoElEqAxoBhEbw@~Erb@_GfAgAdIfTlS`Ab@pAyK{AnWlB^x@fD_Jn`@qJfqAxDt^iE`ImOhLqCnFeCr^JbZ|GzZDbJhIfRvH`DfBvI~DnGjCf^GrKbTpFlLtIh_@qMpGzK~MlDtGzWpDlEzLvFzB|NjH~LaK~RsFd]|Erl@cS~g@kXvd@a\\\\fcA}Cbb@gPnb@oDfZnI|KyDrN~JfNz@fEOnK|MzHhf@kLf^d[dGh@vBeDdFSxd@j@|BpBzAsD~PmIxDaHvNeAzKiHpAsI~IbJvF}@n[yZnK}Q|EhKps@hf@zOdRjLtT`N|N|XtHfLwKdOuDtj@xX|g@uDnWdNlPbDpQjMpCPhJtZhDtSrQiTz]lSdVjm@vFve@fDrL_AzV|CtBnJqAxMcH|Kj@|C_LtJo@lSlGv^p[tNeHbKs@jt@nE~CcBdD_JhF`BfFaBjg@`YrLhPjPi\\\\dEg[fLkO`JwShQcLbRw^dMo\\\\tD{CbNvT`HsLrAX~SfJhGXtFvIhJnGnNnA`VrL_Oj}@vGn`@qCt]`A|WsAdVfIhPlC]|GvUdKwAnY~BlIuCtZpAfIqB~IoH|B_KTeJxLSvLrFh@yRvCuM|LaOxJgXvGwH|MuC~RkKdUms@xR{_@pN_MfE\\\\p_@~Z`KrEnNbXpJtJrPdExB}AvUzB|k@|p@vUvOhNbQFdMvAbDlg@jo@xOx`@ha@bi@fIhBbDpRxWbWyFhMx@f]{AjByDtXaHfRcGls@{Rl^h@~_@vIfj@zBzIfPxOChCxDdG~GvYv@dO~F|N}HdDzBlQcJfj@dCxOc@dOcDhMl@rGxYfa@zOxIdQf^tUdIjMvm@vKjUzAnHxDuIpEuC~WdB`X}[bGK`FgErZf@ze@}MQjC{EbF|DpElGmHzVgFyBhZeGhNuOIyFlK"},{"id":"2024-04","name":"Paris - Compi\xe8gne","strava_route_id":"3209811034962164428","distance":151310.21288359235,"elevation":1261.9421262806807,"summary_polyline":"ab_iHi`vMpDkcBv\\\\saAlBehArGcv@{Ne`@mAyQqQnCsReEgTwVeP{a@_C^oC`PaFjC{Ga[Huw@vA{IpNmCaBsQxJsAwAu`@hJkl@jCag@iKcXqMaCVyOa@dEmUbJiJlP}a@|IeQkCsMwNkEwTaJyxAjCco@_Iue@`BqaBmH__@aF{Bof@`RsFqOkFmg@Fcv@~B}QaFig@l\\\\iJ~LpChBkL~Rf@rH{UzE}C_BcsAbHsm@qYwGcC_KRy_@jKcHcJyeCtEsg@`YlErGsxD}B}NuLgGkd@rNsRcFoHiKo]nMsEm]e|@pRTs_AyKknBeGc]?{rAcHocBwDaXcHgKnMqUy\\\\wl@fEah@o[az@tJk`@gHaBiB}CbCaEcJiBkEuP{HyD{DxB`EfUsHzT}e@sF}@uM{NkJAwIgPuh@cKhJyXrGit@hDss@~Oq}@qE}Eue@mC|Dj@lFwVrKyLz]_AxtAbBtHmB~GvKfIkElSiIvC{KfSmwAp[{LnLsW`Cao@{|A}@cTcXnIyK_Kyf@{O}QySqWgAcD{MjQ{MqIeh@nAswCwHeScPiKgf@sn@dEeo@{Eir@`AuSiK{XbB}KuCs_@kRi^iQir@`H_IrMq|@Pef@|Kmc@mIaVkXqd@uzA_a@_WqYuHgS~IoSaj@qPwv@}I{a@{[_m@kpAy`@al@qMqIm`@kD}MgLXih@iGuf@}L}a@w`As|@{AcJ{IRfBxXe[dB_]ki@aXtIsi@`g@oFjNyJjE_@`_@mRyLwJuh@cc@m`An@i`@sBi@iSlYsRtMkEbMy[`AgInVwF`DiJ|[aJgFgQ~K}{@ma@wfAiGml@eb@qKw]ua@qc@yj@bB}LwGqMuUuGaB_@ui@fQgK|Nog@uJuXoOccAoMeFwKpMeD_LcD_@yYdQyc@nKyRfbBsHpUeV`HeNgK?pMweB~v@grAkFk@bs@cB_JqS{Cu@ne@qEjOnAfq@vI`_A{@fJgc@dCqGnFwHh]iOhWyGrmAsGnMqTbLkCzXaPcWW_NwV{o@uN|GcPoUgNdAaHj]kHzA}Ql]iv@Ab\\\\deAxBxg@yFt~@}`Acd@ydAcuAaUqx@cO_Ty_@cDeJ}Jad@{y@aNkd@[g\\\\yMWaEj{AdOvuAfF`qAxNhbAu@nGkTbSyBrIAtO~MjW|DxV_RrR{Fdz@Z|o@wE|SdAlTie@xd@{o@|a@n@kIwYgLkrAqMcz@ut@_k@zeAejA_DkX`z@|t@fz@kErcBzAvDew@ry@qMqNcJpJcKiP~AuEsAkKgH}HgEb^rUtp@yDdDmE{IeA~D"},{"id":"2024-05","name":"Paris - \xc9pernon","strava_route_id":"3220716130935591282","distance":191204.61163296748,"elevation":1258.683854947469,"summary_polyline":"_l_iHqfuMxHmWnFgmB|Zay@jBsgAtGuv@hM{WfVp`@z_@eaAdj@wPpDuw@|\\\\sg@iBax@df@{iC_SuPvBmIfP|Jbg@dr@tQfCpl@eaA~MeJg@mYlPc`@tMyN|EmRbFm{@bScGmBeT~RoVfcAb@hHbFlCi]zSaGrCwQrQzCvYcUpCmN~V}DltBdaBfWrb@lEjb@bKxRiA|NeHbLjDpEyB~@dAjVoQlZy@_CwChRzBvQvHpCwHqCgByGvCc]^t`@bVjZdKr]vFbh@oAp[{X`RbFv`@?~h@bNdiBjBcEzcArWnDkDfCtGfqAzUdgBadBdYzsB|Ngg@tg@oBdd@i[n@mMrIwT`@kVsOkmAXwd@uZgKzNyZSeRxB{EdImIjZaDl[{W`fArs@ldAa\\\\vCv|@sH~PMdL`d@cFxBbi@jXm@zXpItH}i@wIoRwK_Et^kr@~COtUzE|KnQfLQxi@hiArP|DjDoa@qCgCf@e[u]qkCxAmdAnMyl@t]u[zy@nJzC}Gh\\\\vIl{@yThf@fWfBmMzNHzYkMfEpNyDzNtJvL}Ovt@s@bmA~DzLoA|J`ChJlRzSPhM~Sr[~i@rUhq@jv@vIhC|HaIh{@kAjZfHzf@mAxs@|UtWoe@tKuIxl@f}@|^bTbOph@jKfKrTpe@|XjF|BrL}AtV|k@p~@hk@sHxFwJjRMnJuJp}Ap@{@yC`g@wKAks@dFMhQkZrHa@mAtSxFfXlYbO{[z_@cVm@xX`_@hK``@uMfEw[}ObSzxAtKjTkEf]hDjgBvCvl@jRjhAoJtw@lEzyAyGzfB`IjzAlWzkAbEph@jM~k@Ijk@qj@|GcXmPwG|CkAlOml@hPka@|y@uGpoAbVbx@`R|ZttAf|@jWhoBv_@~j@cFpNnP|fAxr@taB`CvSbPz[rl@`kBnb@j|BoXn`@_TnI}cA}p@}]bOcU`d@kLpGmm@kEy[kUoUcGgWdGkr@{M_EtAmIrSai@fIqFlw@jBvOcBhJdEdOVzp@eNtsA|Axh@{Adu@{Oph@xGvk@uCb^rIfZuAdNuG{D{K_YsJ_DiUrx@_f@xJmStNsPvf@uBuHgDlAkK}WyHhL_\\\\iM~A~GaBrO{OnOecAln@ia@nEgEff@vLfe@zXpqBkDpoAfKfTzCbw@nIlg@c]vm@cnAypAeMyUsa@hqAvDzVkJlQ}Ihg@aKvWsX`TmPhqAeNhSiN`e@`MhUDrVyQXH~JbOr`@K|[jYfk@nR||@tAnW}MlOoY_Ks{AhVcB_[sg@|L{d@|jA`Fzc@w@nLaExHwFkYcN{HtEtN_EhHaEt`@qLh\\\\rd@lb@rOp\\\\kWlNcAxNuM[|A|NmDfXq^ty@RzFbG\\\\{CfnAtw@jpA`UjIxK|QoBrVsGrJsi@pM{QfMixBeQkLtCkFxcAeYtu@bAvN{Vzd@_u@br@_Mvo@aEvg@qLaG{BrKqTjJsIff@rBlIk`@vcB{ObUqDrf@oGlFaD}DvDaUcL`Qei@yLy@rPwJ~ToDhk@|DzQtJpMbEZ|IwTjMXaRhp@JhElEcDlGhF"},{"id":"2024-06","name":"Paris - Soissons","strava_route_id":"3231706113110179352","distance":184324.41959892015,"elevation":1702.8799393348136,"summary_polyline":"i|jiHgfuMiElAkPiQ_h@dAjBcRm@gLoEy@sAsnAuuAiqLk|BomCkGkOuy@c~F_Mo]q[oxBuWmrA_AwNpI}y@yK{j@gWkqGi@{DsEF|@mOsDeIkJkCmCmIqY}DdD}WmDkZuSum@p@wXrFwFl@{]ihBfOuRvOqOeBk`@sc@uf@mVoBEyChOmn@tImBi]ePkR{GmWU}j@oE{h@hBkfAm~@cl@mD_i@uLdOgNXeM|Z}Y~XsI}a@LoGzBhBlCaLh@g`@aXgW{GkUa`@}NmJy^jCe^aE}K{JkgAon@crBe^cu@m_@aOdBy[vWa\\\\r]eiAvP_\\\\n@q^`S_D}@cs@}Haw@l@o]mKwE_R|P}jAfGgPjUsXwQyFlEg\\\\sHgNjGk}@tlAuGnC_sB`H_RqGcEiIfH_ZMgb@tFoc@kPwOsd@gv@qDuW_~@wwA_AqOaKmAxEm^ap@sNuVca@qcAab@{Pcj@_L`GpGe^lMuUt^esAxPw]tFmBa@qPlHaP|I_{Ag@oq@{Fg]iSiMkOEgGgHul@k@tl@j@fGfHjODjRjLnGt[}@pU|@qUoGu[kRkLkOEgGgHqhAgHsj@ga@qKw]ua@qc@yj@bB}LwGiW{]{GvCgi@xrBcX|EmTfUwn@jTuY~A_DfNy]~]kU|@_Muc@mUiZwLxIie@rIuClKsGeCmNl[sTbHgCtOif@pBuKra@iOhWyGrmAsGnMqTbLkCzXaPcWW_NwV{o@uN|GiL_T{P?gI`^kHzA}Ql]qu@Bs\\\\{Rsk@brBcd@_k@aUqx@cO_Ty_@cDeJ}Jyd@u{@iMqb@[g\\\\yMWuBiO}DaBhRgLzIiO|]cBha@gOtd@ynAlRyXjKyDh^gp@kC{}@`DqgAyKGgZez@oE{VyMeLsB_PiF_BRyW_YscA~FmD\\\\aUzK{Fb@gMtWqRrKyRtCiQbM}HrGgV`N_UbNwm@nPPfDkUFgoBdJo@kAsEsGmEeRrJ{OyZgRsQag@mG{]{f@gGub@^gRqFgQmKt@qEaNoPkOuCySiP_Q_Lg_@qWgNs`@cFo[vGya@_U_JgQmb@]mNgXwNoLmb@ZoU|R_VzG{cAiPoUfCoIwEsAe\\\\{Rue@lL}LK_O}HcOuu@fKmg@aW}LpOwD{OaMB{N{Kwi@yo@kRy^sHwCyDcKSo^wUrE}b@ic@_LrDsDoTg@{k@{`@sZmt@ceA{YiXg`@_p@aiAas@mRad@_IH}FyM`@iJ{]wLkTfEsJmFqDoYbNq}@wGgh@gGaJmD}XmQ}g@t@eI_NvJuGb^aYz@iIwJ~Ui\\\\EsRnHdFtCkE_CvZpKgVdE|MnAcViBkLvHiHiA_]tEmRpLiRDy]dJ{DrCqWiBeP`GqLlEFhFwx@_EmQfKcLfg@hL`r@lb@xKwF`W@p]tK[nHlL|IxOwEv`@ri@zRpMvFa@tl@fnAhMhLdQfd@fTnRi@tSvEzl@`Uj_@`T|m@z[pK~OXr\\\\}QbQiA~Ma\\\\pCsa@tDWlFxMfQ}ScCcYdJhKnNn^NiSvPiAiAoMdL~BiBiHdMxJl@aEnIwB|Ji^t[dD|I{JtD{P~MlEyAqAxGwPtZrGzLoCrEtr@flA_K~AmFkC{^t^uG~J}PuIi^"},{"id":"2024-09","name":"Paris - Beaumont sur Oise","strava_route_id":"3268298904774753802","distance":168229.34803196968,"elevation":1651.8399999999997,"summary_polyline":"_fiiHan~L|DzKaHn[eEnCmC~JqLeOypAhgAqLMgJcVaRss@mw@_sB}AgN{@]aj@apCoAQ_E|GwEqHy`Aw}@kNoFiJk@ia@nLqLxIsJzP_X~}AqGvj@mB``@w^cHqJoJ_D~Cc@yHiM~DkEqHsApAtClKk_@rl@yN}SsC`GwGvCiJkH}CIuHzRX`KiBnA[xJqFnNHrDpChCP~GcJDeKoD`@tEkD~Ry\\\\`XsDfJuOfQgL~CsAaBgGFk`@{ItCuWgKkI_IuOqUsTZsJqMsEsF{\\\\oC{Ga]y^aN{YcCkKsG_JwOse@sN_SaNyK{Gbf@cMxHiDfK}J`MsOmB{LzMmT`OcInSyCbV_Ad\\\\{CjLuNqJsM}Pc`@rUsRRbEtd@tB`FsAlCsIs@b@cLwCeWiPiPuZ}JaRFaMpCFaSrEeYeDmMqCw@WeFsUhGaLfIjCxHyBnTe`@dr@eGhj@md@xRfAvVkC|G|ArPQlJ_FbKa@dRkCvAsHyGoEiR{EwHsFiAkDpCmAlEoDfAkR}OQw^_P_`AsGgLWcJnJmMbKcb@rJ{PuLmP_P}Msi@opA}`@na@sXys@|K}e@zPdB`RcNbXiu@dFsVqCwC\\\\yGkMcXk^oLoYyBwDqNiH{BqG_e@n@g@u@yKoBgGmB{@{ZmAg@jKuVzk@oEiXih@en@kYyx@W_KrCaVjFeHcXekAwCqBq@kEqfBzAsE`wA_jAiD_c@sP{l@zg@oKtScz@bh@?|IiF}w@iG_c@_B_a@yLks@{GyQqVq\\\\wLij@kFLoSdIqy@hMy]lPm`@xKys@r^sOyGqQzKcGfJiIpAwD`DYdPsBhJHjSgCzc@yGli@eD|DtFnX`MtEZz^eLp`@e@~MwD|Oo@l[`CxV}CpVcAz\\\\vQ`s@xEp\\\\cQf`@m^tHeWdLca@zGkC~FnB`HJdHmFnYrAt\\\\bHdOzAfWvH~OhAdQ~CbNw_@fu@dH~GdExN`U`TnGz]{DfZyFdAcJkGiA|AtFpGdIpDxEj@zJwBb`@dH~IhFuFhQsBzQaMfJqNvd@dAlc@{BtR{K|CeHhIuLxXaJfGq\\\\ha@sMlh@gNt_@kLti@kLnX}CpOCrIuP~`@mDhi@yUtv@yBfSbBtZnExTw@v]o`A|NaTkA_IiQi@`@`CdMwSe[{O}HwLoMm^qAhClTqDbCtCjSkA~GcCS{@lLdC|NoA`h@qPrf@iB`^sPrN}IrAmOnIgQoDmMzXmF|EyG?gHrE_M~@{NjNmHz@uYtQcC~DgDw@mGnJmK|C}FxNg]xWyI|AcBhEgAtUiExTqa@rRqGzOec@nh@{ClU~BfLcGpKjQNtHzIzIgDrGP~SxOnI~PnUvUzSjDfNp^pI~`CjLrBb[vR~SlBj_@rZ~Bd@dAaB`@ye@fCqBtETPkInGcGj\\\\~Zl[|FhTkFjQvD`MnM|CnNhGwM|N_Ozl@y^jMaBvPjDjLYUsVaDqFhF}APoKbNnAjJfGzMfRnSvLxHlAbTaBfUdIpm@jJdIrKdFhPyChLt@xP`GzPfE~E|BdL`NvJro@vQpMfPfO`JxA{JbDmDpCuJSqLtPgdAtO`BlGkBdCpAds@kJz^jYp]xQrMeWdAgJ`CsBr@hFpTvQfSh[pBxOAxVfK~TrEwClVfKrRZv@yEjGvBjFi@|LuHhFbHjJpBxGwPjCcOdDwFpCsOg@eHv@_CzHC~OkIrVs^tI_HfG_QfEsC|X_DnDnDnOwJtP{BnGiDuEuh@pg@kK|ZnN`Xf@rGio@dHaMrDsR`@_]pA_LhJ{WgC_DmEeRxF{PzXeMbEYnIdDbFmIYuLlJjCk@yQdEip@zDkJfF]`CwFwIoNo@oKf@{PrBeIpBgXbLiUtDSzBeE`FnBvEyEzBug@bPyz@aKk[iAsV{Kq^_KdFiBwCmFbAoAqAV}G}IoVqD}a@qIu^oH}Kse@{N|@}OqHsM_@uEsHqDgHgN}DwQcLySqAiH{\\\\qi@e@aPoMi`@kIwN_AkTzG_^qRcQm@iCt@yG}@gOrEcc@s@_IjBw]nJcIHqKwDuXvAaK[uFjNsZdB_NsGqFa@iKxYq]|N{^nCcCf@iFdn@c}A_AyBjAwDjCArHyQpB`C"},{"id":"2024-10","name":"Paris - Fontainebleau","strava_route_id":"3096057415697112426","distance":143119.45998829426,"elevation":1319.1099999999994,"summary_polyline":"yeiiHsm~L`D`K_Qdw@`GdEnBnVdBbAznA~`F{AxLkNf_@kKzm@dArH|QjStKjDhCpJdNjJzEdSbZf\\\\nTbJ|Udk@dc@eGpEza@|Jfk@bAGrE~JnSgChBjNfHxJzHnSjAtS|LwC|ThRtE~k@kB|QdH~V|Cj_@lOvNvh@cC|H`E|\\\\lu@lCtu@lRnId@qCzGqDvR_TjH{R|QtNzOrFfL`Kje@hGxGzAbL~JnIOrWk_AnGaJlEmWtS`Y`LhFqBxJzVb[fIlRbAlG{@xZyCg@mAtB`d@nWh^vCvB}FvEqCfPiApK`EtF~L~Mwf@hb@iGpa@wB`RbLiJp`@f@jCfBGfFmJdCgLnH{D`ErHfNvBrNdKhFtHnG~AfPaJfQeAxNqUp@eGvJuHja@jPbCIx@aEn@~IhH]jF}EpC}LsCdc@~@aG|JwRpKaCzDrFcDlMZ|HdEfH`GbDXhI|GpLlC~JgFhD_KpVlq@vi@vQ~AbRjJ}A{`@`R{oAlAgUtDiNyByIpOq[~Qa[|QqAzOaMzAmCbAeLdHgMvU_PpNeStN_GxDkEnDySvNvGrJkAJ~L~BhF|d@rVfF~Rv[xWba@xq@fA|I~EtKk@fFbGB|ApFnB~NcAlC~CbCzDxk@nNvb@vK{ApFpBxFhHbWhAlDjBvJx^zTt`@bAde@dE~_@|Ttd@bFjDlEjJnWl\\\\^sNlOqCdDyCth@idBfc@s~@D_I~A\\\\hGvl@~M`KjNuk@v@mQzEeZf]oYhDaHxCySzA_Cf]eClDiLt@{NjGuNjA}@x@nCjNhEzB}@n@sGlOcHvE~AzLdR~K}BjJqIrHmRj@oTqCoOhJsg@fNeF`EqLfGaFhFyQxCOdIhFnAoAgB{HjF}KcTw[`I_QzE}CrL_@jLDlGrB~EmFdEaAjGoInEbEve@iQva@i_@rQq@vQkGvDuDzAgInLaV`Vky@zVeMnBaEpET|RmQw@qE|AkQ_ArBVhCrAkQsBi^nFmQhBiQbHcUfCoWhGyInFaTJwPnD~BhCuA~JkM`MqX_Amu@oL{r@n@uIjRjHlYsM`p@gPnTiNrC}Hf@wLvE~ElEzKdHr@l]oEd\\\\vGjP]pMeJtBeIrEyGbA}MhGoANgJtEeJ~F{@m@aOhB_ZoFgp@hDsQHoDwAaBl@wT~S}iAbFyDpEmXu@uGzDiKV{|A}@eEqHmGCgPoBeNaIyReKyf@oD_]aBi`AnEy_@pSsh@zQ{XdGoDpLgBuCoPwAam@yLig@aHkl@^}]}Fyf@~CsKcMsIiUkzAOoKmFaMxHoJtDqUa@cNgEgSuAyPd@cu@pD{BbKo@tCyH~GqCnLdA`JyJjo@|Cpa@iEtJxAr@`BkAwFz\\\\uIXySdGb@q@yL|@yS`Gu@qCKF{BrF_@lAuB`AvOlE]vLzHh[tIlPgOnKiQtNqNdP@jOaNnLeEvKcK~E{Lv@oEw@uFlCgLzDmd@qA}GDcLxBwJzGsGjD@tEiKdFwU|ByT~C{EvGi@r]sVfImCqCkWrBogB`PgrAgB{}AqKg@gW}LsE[s`@lL{KtNmXA{NsQmNoCg@qG}Mb@{QzRyI~Cq\\\\lc@aEfBub@gYct@qQsZeOiKnBqWoFeOz@yIzEwTjTeXzDqr@}K_FuEvJkXj@cL~b@{gBeQ_O}Ze`@gJuPaVaUmMqHdEqXtNug@|JijAjWn@rM{RnIkA|EqGlNs|@`Jo_@fKcT`Yy_@nTkaCrIah@vCaElL_DlE{Gb@ox@tEoKvS{TpL|QvJa^gGyGtIsQSmB|ZuVgB}H}Bwe@uGc`@{KhEoFe@cCyDiJvDmIkBmCiFqCm@gJiQ}A`CcMCeEsAyBwD"},{"id":"2024-12","name":"Paris - Paris","strava_route_id":"3294691070231630194","distance":84762.29035962751,"elevation":502.76036105228604,"summary_polyline":"kb_iHk`vMZk]bCgUUs`@lAsQdEeQbNuTnDaMtC{W|Acv@fJkk@hFbEfLkRuHaOjCoBpPl\\\\fNi^hJ_PcAoFfHkLpMmElHLxQsHx`@eGbNOhQsOtJgXnIwj@b@k`@kAkVzFHnP~HpHvIxShK~B{_@pNvBh@gf@lLqc@bAsMMlD~ALhUcEbLiTxHgn@iAkLyFkSh[aVdWmd@{Xg`AcByUxMoDiBqSzRcWfdAj@zEfC~BrJvBzBhQTxF~CrNlXzBbNvG~GxBd@vFyC~A`AqEq^R{Z`BiBpIub@xHgOzP}g@bX|OnNjRtWdNnh@rb@b[~f@`Ev]nVm\\\\xR{_@jOkQdVnEhYwNlTP~FhE|JqHxQjXh`@ZlLdMdMnGqBgm@vIgXfBChGcg@|FarA`Iyo@a@a_@bB__@jIuk@hC{m@rHo\\\\tC_XnNkNxG_P|EqBqQkR`ByLiGaLdLsY|Hy]zDmn@bEwTh@oQbCiN`@gc@iD}l@}s@j^qDwDf@{JcAeQqAeA{DpC}@zHoErJeu@h^aMrJae@rPan@oPMoKqTxD}FyAgSuS{GmL_ThK_Kh@gOdGyRpC}DqC}Nk^gDwCuk@bc@eKjBa^~SiAxNdAvTrCnPbCm@SrH{E?kBvBvM~R{g@flAyGdUkG|e@{@~Ql^vArAnYta@|hA|EtFvIpq@|D`eAyh@fD}CtYuFhTaCrRsQbEqF|G_Gbr@yVlQ{Sc@L`HkBtG{S`GsBdZcI_CgcAc@sRpVcLjFiCzSwEl|@{EjPiOqWaNok@}FGcBuHaW_E_J~IjAhDa@rBaMtMrFjSeDdM|Cd[}I`@{CkLuRuI}KhDwSzTy@gCoNbN_DfYmBa@xE|GJbD|IhLjHjRgP}JkCdHcDpBq@mEuEsAyWyBcQ~AcN}@}KdBkMnLqGvKaExSgFldAr@~d@yKp_AqCta@oOdo@qNhT\\\\dJw`@pIsReEqF}DeNeSeHcXoEkFuBPsDpQgEhB}BsBme@ftCeL~RmCzh@"},{"id":"2025-02","name":"Paris - Mitry Claye","strava_route_id":"3317888000099665580","distance":129459.2048344865,"elevation":900.3092655273133,"summary_polyline":"geiiHel~LnCrIiOvo@kOoRqpAdgAiK@_CwA}Lac@cVrXqJqWy^km@qIwk@kGiPoMlKaAzCwBqEv@aCo@wCcF^g]mXqp@eD{DoCeHp@iDcAOoG}]uIm[|GwTeG_XqMsa@mHqJoJuRfSqDeL{^dl@{N{SuC`GiFpCoPuH_IzRmFdAcGjRoE{@gBhLc@fSwAxBl@rCeAdLgBbFy]nYiCbImFnDqGhK}LlDyLeSa_@cVwOeSqD`KaNuL{KaFCzB{WsCyA~D}KKwAvLcC~AaG{GkLsFsH}JaIoCwDcKkQmPgCwGXm_@qEoq@uHgAuDnHeNhLsKaNaZiI}Qo\\\\yDuMiIsK}Pqp@aHqO}JsMdF{LcL|DeHwTw[oXeBcJuFaLs@wM_KgCuA|@KaB~ByAZeJqBwSo_@sfBaSkDyPwMzHem@mBmK`BsDaA_DFmKgGo`@zDuy@e@oRzDqS|Cse@xIwXrCmc@~Eq_@}PwVxDu^n@qVvG{e@iAyjA{CmOuCok@r@c[_Lq\\\\aAg\\\\sWo~@QuKlFyEzI`A_Bwe@vr@_hBzGsCz@qHoEcIv@aF[oKzNkYf@oViCmv@A}j@oDwHiMkJmEmKaOgHyBcTeGoUpA}E]eCiHyZwUi`@yIuu@_IuNyZcJw]dRsIDaMmCyHiMgZtMuMhToQvDuFoDmLgVqH}u@sZi\\\\bCq\\\\EcW_c@}v@zIio@LeVdGih@kAmQ`@mJuCoI{KeLiB}F_Ekq@i`@kfAmGes@mCo|@{LkWNeDbJkMfBmTiFgAuAsFbAmCrGyCrAcQgBuCeEonAyCwXdCe}@kHk_@eH{QiBLqEeJ}QJyEua@sUeh@sYwe@e[mXgd@{NyHkHsIaU_ZcNcJyHeJaPoScv@jMwG`L]nGmHxIy@|H{JuBo[|@yc@}Kif@aOebAj@eh@hDiRCi`@zE}cAoIaPxAyANuFyCuOIie@o@kHsCmFhDwi@zGoZVuS~EG|@_c@xDyBrH|@hD}Q`LkWlZsW~Ow\\\\pb@{p@hEcV|H{CbIJvLeMxTyDdv@ifA~TaFj[Pw@bO~TjN|A`JfNlJpC}F``@{CxZ{Xh^wf@zHwQzCzEb_@em@`Z_vAjN_NbRw_@rCyRhUj@bKfHvJlM~B}YhBeAbr@_AphA~N`QyD`KsGrDbLvE|FqDlRr@|GbYzd@]vFwKlW?p_@lDtLxMxJlFdIv@rGwCxFkN`J_@vCtE~M~Yx^xPfJzhAvUjQxWvOtc@cErK}DlTWjf@gMh|@mHpJ`Lx\\\\lDzTbRx]vC``@cBvKhKvXaAlTzEpq@aEdq@tZhZlJhQbPhKvHdSr@j_@eD|r@hBx^gAnc@~Gth@kMtHiArC|AbJlDbEdTA|QxSxf@zOxK~JlCg@`TpFjo@daB@jLaCpQqT_JeGne@kVneAk@rVrAhOcEv}Bh@ft@cBde@yCxZ\\\\jCv_@}@~TcGbp@{Dm@z]sFvFq@vXtStm@lDjZYvIwCvFLjGwCbRw@zToIxRYfI{c@r~BwGkK"},{"id":"2025-04","name":"Paris - La Fert\xe9 Allais","strava_route_id":"3342408645099940962","distance":147179.13979396402,"elevation":784.8200000000004,"summary_polyline":"ab_iHi`vMPm]`C}S\\\\_p@nEqTtN{UpFeUfBsVB_p@vGkv@ba@o{@`Yy_@`OcdApEgNzNTjn@it@ze@oiC_KyLuGeClCcIfP|JkHkR}IiLKcDyJeOdB_Ttg@ag@fBFlC`IfMaDhQnIzCjLpJUbXh`@lDtJn@e]`La[~EwB`Gl@vEjEpBnItJaK|EkRfG_fAnCkSzHqDh@xFhScWxbAb@zHvEzB}\\\\xUuHfAuOdOb@hApB|WmT~Fcr@~CgEjBp@|PkH|BsStFiT|CuYlVgAhKfP~FnE`@gA_Dqc@Mi`@{A}E?gMaDs]gEaWcGsHq`@kfAsAoYm^wAz@_RjG}e@xGeUzg@glAeMwRgBO[iFhIkCsCoPeAiShAgP`^_TdKkBtk@cc@fDvCvMp\\\\bE~D`p@uL~SiKzGlLfStS|FxApTyDLnK|l@`Qdf@eQ`MsJdu@i^nEsJ|@{HzDqCpAdAbAdQg@zJpDvD|s@k^]oFiFoKgDsu@kGyKgLsm@p|@uDbL}GtDeY`Aai@uAgO`DmDjq@sLnMmOhKkFpb@}`@nCePfDsHpHtDvDmGbsB}kA|WmLl]qu@jMuHbO}d@{Gw[_D_n@aCoHz@wOpSdFfLqLpErAjF}Fzk@sMxEaEtP`InIo@V|E|An@pBcBfCsMjKgLlSmCfXgMbz@am@bHeMdEsA~EdAvA}c@jIwQj}@yU`MkJf]lFtj@rX|C~CvCvMbGeBpYpEfM|OnH~XtFbJzAi@vC~LjH{IxJ~@xNzIzMrBbJaCpS|F~[cFda@`GbLtOl_@`^nl@l_@RjHjBkCpF~@?~AsCpBm@~IrCtEtQzBxWrKlUzMjVlSxBoAtBqGnMbW`@|En^t^dZpIz\\\\rXdt@EfDtFzLy@bYsJ|LwOxGg`@zCiAh@qW}Aqh@sKgt@gCg^dAeW`K}Yz[i[dOoB~@oEnVt@hBsB|Pe@xMtDbNaFtJ_QbHiEwBiR~G}GhP`\\\\z[qm@sBeDjHsF|S_o@hN~@rNqEq@dQzIvDdHfO`a@fc@dKhUxKjLvYlf@`RpFpBrKzW~k@tV`cAdFzLfP_H|Q_[bJ{A|HiIlCpJjc@bk@lVt`C~Mz[zLbFnp@nkCz@|OxFlWnCt[lHzTwEtFmB_BsFpFmUjd@wDnZcKfZhHrHfErMIbC_FnGpB~EdB|VgIU_VkLuBfFlDzEdMhi@cArrA}FxPgDzRmMxFmRb_@eEnOqDtq@wEhTuVtYyQpa@aVva@gFz_@gBlf@iK`W`@lT{C~G{@~Wqa@jfAoM`l@aMnWmCxLyEw@oJzn@~AvaBmOhlA_CliBpCjWgIlCs]rVeIpAoCnG_B|QeFvUuEhKkDAkHjHwBfOxAxO{Dld@gCrKl@|GaFbPiMvMoLdEmNjMuPHyP|PyIfOuOpNk]wIeKyGgAkEaDVw@sImD`HqHOw@|LjCp`@gIx@IoXiQhBiCaEcP|DsEuBc@rDnGbLlGfXoDf@gf@xEoZ{Cwm@bAoA}BNeKfHgV_UqLoKvJ}ApE}Bpf@n@fDyEl@aKc@gTqK}[c]xAqGDwN_C_LdS_a@ak@oNeRwUuFrVlDvEkBdAaWz~@eLrt@cJd\\\\aJff@yK~YGbaAsFlE}JScErOwR|OgMl@zJnxBxUfRx@~TlDvQ|K~hA_AdUgV|p@eGnk@mOr~@yKsAqOvBkJpT}Q~B]tFmMqEZkB"},{"id":"2025-05","name":"Paris - Noyon","strava_route_id":"3352594167984724840","distance":154165.36549075815,"elevation":1230.0500000000002,"summary_polyline":"}zjiHyfuMuF~AyOiLQ_D_h@dAvAsARoOm@gLoEy@Uk_A}@gNsx@q|Gr@wAwYeeC}ByJ_RkXkiBctBkGkOke@wzCrAy@cXyiBwCw@aFmRq[qxBmUusAgAf@_AwNtHcl@X}Lw@uH{FuPcBkOgWkqGi@{DsEF|@mOsDeIkJkCmCmIsIX}NwEKmEvCwFXwImDkZuSum@p@wXrFwFl@{]cp@zDmRvFwc@rAuRvOqOeBk`@sc@sWeKaNgJoBEyChOmn@tIkS_EaQeIeWaD{[dGui@pVo`@y^mPsKHiDmFaLWiKrCq^KwVnLgg@|AivAuG_S}@}MLoGjB|B|CuLh@g`@aXgW{GkUeEv@uA{EeWyIyEwXsCaEjCe^aE}K{E}s@gCmPgo@ctBcK}T_KcN{FaQiVuGiGkE|AcKcEgBmBx@_\\\\oRmVr@sYgOsg@sJmLyFqFH}FNuV|LsA{AoExAwf@hXoFD_ZmHuPzAoTxGeWv@u_@nHeRHij@|e@s@lk@vFfZeBzHoBrBuQfAoM~FwFlOk]fa@wLhi@oEkHyVwPqBmEL{CeI_K}HzJyIx@oGlH{OhAaTrLeUFqWtDqImGcAgIkAc@kErHuK|AmGzDy]~Ee@lPmI[}~@tMsDyAuAaFkFmE{ETeLgDu\\\\iU_KbHmCpKeFkB^m\\\\sBq[J_\\\\oAm@aEqZ@om@{FeDy[yg@gDc@afAdc@{TxDuI`Q{B|JsH~CcKbO]uNqVqMgIJeUySgXwGsH{n@sEjBuIs\\\\sIep@aHwYkh@w`@?mo@eDwCaH[yAcEp@cBfEr@`IgCSeOiTsQcGoJcKjC|@uIaJ_KsQga@oCuWf@wm@_ByEoGwB`CmHsFcGfAcM]kPqX}IvDm[]oSpBa^{@wNh@gP`K_]aCaa@{Bj@_@kO_NgB}LqQgMqHkOtCyCvI_CO_E{JeGiDlByFrDyCKyVmDyPgOgTm@{F`NcTvCgWYuP|DyTmPqAcN`EwUqBc^oToWoDcBcC|LsfBiBqRfKuc@_Vc\\\\{R_QOcDxBsJsAyPkCgJi@{Sa@xJaBcA_e@b[yWfMgP|@iGlLo]`Maa@yMqIoGeG}ZNlSaGhOyB|RbDzJfI~DyMfImJaQcFa@{HkPeEg@qBkGkC}AsKzIcRyGa[sAcaAva@{Jie@wPaSiDmQ_DcCC{Ut@iCoIqNyBqIwCxIuFlGuWkDyMpJoGwOcOtBqNc@{X}MgEqMej@kDrBuYcAs`@j@_RcAsI\\\\wQaEsR{Bk[rAuU}@y]jDoSlG}ExBsGlGm]vWwz@zMkx@_Qc`@kNwGqFf@mBcLnGuFpKuS~DMdDbErQtHNgDWkYpBgu@wp@{JmMxCL{}@pm@_G`H_D@{G~DyAa@{Nr@Y_ELqFaIaGpAeCgAfA}Mc@gD_LeBmKyOoAv@ShGgn@gr@{L_EqSt@kPlRqI}@uOgMcQ}GmFaRiKsAmCmGY}LuHyE}J^oCvIiDdBoJlSoBwJkIq@a@gIyCmDkEiOaXqLyU}@cU{VyGfAwF{AyFxIwInBRwHvE{ESwJkAyBqEq@sKkQeBPwBfUmFnMqG|BkLgA}CnFwEnRgDlm@cFu@iGrCI|E_BdBcHh`@cLzRyD|PKnDzEdPiBnF}F|FqAnFnIbv@kC|PuAjAsBjSzKpN`Sp_@~@nn@sf@zTwFfKsVdqCfHtfAoArMcD~FsBZwDiIaM_K_GnBqDtGmEu@sQrB}_Al_@yCfKO`[{DnOiHvNuBzMoNlLyEtUg^dw@k]l|BcFnQk@zMtF~VwJ`W{QrI_CW{BnDuQoWaWal@efBcfAoBsH_HzDsYh]mKkQoFcQi@aHsBuAgCiImRvFmItLcRfJmWic@aI?r@aQ|B]nBbDpHsObDmBpF{MWkJ"},{"id":"2025-06","name":"Paris - Provins","strava_route_id":"3365008757826079628","distance":197977.97298165224,"elevation":1309.1375998331528,"summary_polyline":"ggaiHkusMjCbEfBwKxMcRmCmBq@cF_IuNzDiSNyZgKuf@cRwd@mJgh@|CgjAdC}KrNg]JoDeEyBwDwH{AkUjOkz@vN`DvMvTrOxDpG]~@`BxXeExOfFdQcQ{AsOl@qChMgRfN_f@xJ`HnL_q@`VvMr|A{oFfP|JdVn_@vPhRbo@vH|RjNfKU`KeDzKoS`Ieo@iAgLyFkSh[aVdWmd@{Xg`AcByUxMoDgAoUxQeUfcAb@zHvEzB}\\\\xUuHfAuOdOb@hApB|WmT~Fcr@~CgEjBp@|PkH|BsStFiT|CuYrh@uCcAyKCc`@{A}E?gMaDs]gEaWcGsHq`@kfAsAoYm^wAz@_RjG}e@xGeUzg@glAeMwRgBO[iFhIkCsCoPeAiShAgP`^_TdKkBtk@cc@fDvCvMp\\\\bE~D`p@uL~SiKzGlLfStS|FxApTyDLnK|l@`Qdf@eQ`MsJdu@i^nEsJl@}KxLkSdCoObGsDvLgXZkKcEiShDeFwEiTp|@uDbL}GtDeY`Aai@uAgOpJ{Gzj@eInMmOhKkFpb@}`@nCePfDsHpHtDvDmGbsB}kAzVgKn^wv@jMuHbO}d@{Gw[_D_n@aCoHz@wOpSdFfLqLpErAjF}Fzk@sMxEaEtP`InIo@V|E|An@pBcBfCsMjKgLlSmCfXgMbz@am@bHeMdEsA~EdAvA}c@jIwQj}@yU`MkJvFDbKkOPgOeAsJxA_VkR}s@}AgPjDsGlLdJrU{FjUkNtSwBT}\\\\`OsEzFRrH}PdRqWjLqHpH_MqB{X|C}_@d[zFh\\\\KxKkB~^~FtLKdc@{HfPkWzJtMdFtAfTuJdi@}NjPrLfDl\\\\nRtNbRdC`Tw@jJy\\\\lLqw@M}c@fCyTu@oL`@qTa@mCcKgIkEwKbAmYiJa]EuGvDmPg@{i@mDkRiMsFkC_]aGyPwEwt@iQmb@sMuQmIqRyBw@mXu_B_TidCTehAwB_Bn@}J|HaTbM}SbAoWeCm]\\\\{VoDyr@|l@yeB~GqGnK{CxLe\\\\}H_v@xDcUhUqFyAwS|GaFnTuBbAyFpd@uw@nAeNhFyLvC{QtZ}GzP{XbP{M~S]xRkM|TqEah@_sAkS_o@jLiPr@sEr]iP~r@o~Bc}Ai`Bqn@u]iRaA_CaQib@fV}m@ynCc`@jX{lAlK_Iwh@iPcn@sIcI{NkDgD_KhGcPlSwVjK_]rFqIfFiX`GaPvZm^mAgKnJiGxEqSoBeXfBuGuM{mA{BiN}B_AiBuGp@gJ{AqQsM_J_Hi^sIqSeQkp@n@iQs@qc@kHkqB{DwQkBwWwIuSgNax@{IsgA`IqFdE_f@EaIwG_k@g@g`@`AgZrAyEM{OjCeK|EkAnGtE~a@qt@hd@{StQzGrJuAlGxFlQ`DpJsExAdAtGiBhGmFpEh@~I}JjQmc@|`A}\\\\lh@sd@rAmD^mV`Ea[`k@yfA|Ke^zGsz@fJij@mAuT`@mGrASLuN_Cor@jC}D~AcLEyNzBmVqDs`@`BamA~Fao@vHyU`EoXt@krAxAgYzUhEhBaBtCst@mNkSuMuZwIagAmEiKqCo@wVy`AoTymAwBqFm@mPxKmUJwFsLjFcD{ReJkXsQ{nAyZqrAwf@m[yRuBcTpGeK?iNuOsCxAoNoMsJdCoZoAos@uRib@aFk_@sUkOdK}p@hCwCsGkW|PwEpJoIxHqg@h[iWfL{HrNX`SwDvIi\\\\`GwWjKqB`ByBdLgBn@ek@aGiL}N}tAtxAsV~LQ`FyLtGoIaCiXxA{MxGiKjWqOlwAwA`\\\\n@bc@aApXqQvv@NhOyBpWrEbMQbGiFfJSzGuFxJwRlG}@nL|EbIrGnk@`Tru@sAzOr@xNo@tKpQPfK}ClMFvNuCbVpBgHjn@EpWz@dW`Gh\\\\j@fQ~SvIzBiBvAvKnDlFmBpBmBbO{Evu@yEb`@qE`Jk@t\\\\_H~`@c@xm@eHtl@j@rm@cFdxBmLbz@eArdAtHpo@NzUnE~PjAzZbG`\\\\b@nv@kDfSe@`NbEza@JvMoGpKTdPeCpSqTbF{Apn@uImAuHzEtCdR~@xXcDaAuD|WwOuBiK|r@kVxPfCxMhKiDtAbL|MpBbAtItO_U~DmKzCU~BoF~FgDlA}KyFoLrKi_@fD_Eo@kGxHmE|AjCJ|E"},{"id":"2025-07","name":"Paris - Persan Beaumont","strava_route_id":"3380443430849682416","distance":193864.86359295252,"elevation":1523.4099999999994,"summary_polyline":"ozliHkhwMqEgp@h@vAh@`GcC~@s@}Wsx@q|Gr@wAyZaiCyG{P_jB{tByQwXgg@c`DlAw@e@wD_WycBuCaAcEoOm\\\\q{BmUqsAkAh@{@yNvH_l@X}Lq@oHeG_QaBkOgWkqGi@{DsEF|@mOsDeIkJkCmCmIsIX}NwEKmEvCwFXwImDkZuSum@p@wXrFwFl@{]cp@zDmRvFwc@rAuRvOqOeBk`@sc@sWeKaNgJoBEyChOmn@tImBi]ePkR{GmWU}j@oE{h@Lgv@zAcOq^eQaVuOyGgIqE__@b@_IqHrFcCpGiGw@}EpAeM|ZuF|AqElKuKrIuG_S}@}MLoGjB|B|CuLh@g`@aXgW{GkUeEv@uA{EeWyIyEwXsCaEjCe^aE}K{E}s@gCmPgo@ctBmL_WuIaL{FaQo\\\\mKcAsAzAeKiT}FpCgX{T{kBL{[vHmj@QkN{Q{`@kVsVgAkFuCeCj@qG}DsE}BaISc]oL{{@dAqo@uE}p@~J}a@eHgCu\\\\khCcOw`@uBoV}BsEkL_ImNa_Aa@_SoHqKqGrGaFs@wLyL_@eCbL_G@yAeKIiQuKyNyb@uBoSkV}s@gTgFmRyLwJuh@cc@m`AOsU~@uIsBi@?eBaMoR_KsFaKgLyHuSs@wQkFuKh@iN{@_JcQ`I_Jo@oMaIm\\\\tAmNaHo@vImUgMfCqJ}A{N`H_fDoLww@LqW}Ga\\\\|C{OaA_TnIkJcAwBqHYyAiJvEaHbI{U}HXoVeE}JyJ}JeWAaQkCwKsLaOxNmUmn@ks@wCqLwBum@cLfDsLge@iIcI_J}S}`@yRiDcPcVwL_FyPsDiWe@sQ`Bwn@cBkHeHg@iEcFuZ_M{IuImk@mPk_@JecAw]qZnCe@}HiFsGf@gMcDoF}Isd@}VkIwhAuj@}Asl@mCcMs@cWsHaEkBuSsCmHgLwAcKvBgKw@iA{KwC{BuKbFwUl@sCbCoC_KuMeCqD|AkBsDkDjKKnJgHo@gFbKuGUkCtBaGhVw@`ZkJbXgG}EmBtEy@SiMaPuGlFqkAc`AJcPuUfMe[fGoOb[tDrEuHzh@iUhm@}F~CjEhWlHfAaNxGaPX_AxGn@fSeSt{@Dr^iD`RyNbOwHfBiG`IkWxPgQJcQ}FWbIrCrHeAbCwDyCmAnGwEAhG~ZqAhLd@fGiFdCaGvXeMzvAbJfjAtHjvAbBpCKjGnIj^lObd@x[ns@]rW_FxGkDkAEpSgHnHbD~EInIzK|VhG`YSxWhF~ArB~OxMdLnEzVnFvJvRln@xKFqAzFJ~j@{AdVtB|Sx@z^yAhJoKrUaJbGaEvMkKxDmRxXyTlr@{Nj[ia@fOoLkB_QxEiI~N`BnGaBxLtE|Aq@bGyMWwDf~AzNzrAfF`qAxNpbAiAbHiT|RaCdOVlI~MjW|DxVaCvF{LpGH|IiDnN}B`c@f@jl@aFrWlCtf@jAtG~JfHk@la@jm@~o@|[veBp@|zA`_@vmDnQyIrEl@jJtYnK`u@pSdk@hQdQxWxN`KoF`Oa\\\\dLqDjO|PpU}q@fOaA`UlRzOvXvR~CxIvMdDlWdBlChCZhLyEzJbB`GzFhIrBbIzJ~W|IrU|\\\\jUjMbS|YxDdTt_@j_@l`@`n@xy@tv@dOnRbInUoAjGoOtXoEP{D|KlDxHn@|J_GfeArEb_Aw@td@jGrHlKcDlL|CLdIj|@`eBbRtXrJfH}EpNrAvCrUb_@vMdO~M|XdW|WxRtXz^t_@`SeQhOq@]bO{FxW_KxdAgKvuAkO`v@wHxPyHh[}IlL`EvEiDpPtFlJuE|IsAfKhB|@kA~KtPj_Ab@td@bLhb@DrKdBp@i@bQ~BnCpBzNvHvHbRxCN~LxClEjCpT{AtJMvPzEvXnDpl@oCx\\\\oFdUf@n^uGn@oQyQrInu@yEvF{@|n@sEt[v@hEoA`g@}A~L`QtGtC_@~BgEjD`@jAzrAiB\\\\}@dI{R`@rAbb@aAhWxBn_@dC~jAoA~MeFpMhNzKrBcDnQvIhJo@g@hAbEhHfHhAxAho@fRrSbDv`ApArA~Mdz@fPjk@n`BxDzpApq@lBi\\\\vD}EfOg@}@pTpQlk@tJdS~PnPtTt[vCvWmG|j@wAn\\\\wOtiA}AxTgS|k@kJhPiGlXiBv@?jlBwD`LeHxIfD~SlArXjLb[}ThVk@bE`CbH"},{"id":"2025-08","name":"Paris - Pontoise","strava_route_id":"3387789016022878434","distance":193856.63581398648,"elevation":2359.3500000000004,"summary_polyline":"u~giHcciM_CgAsKnnAkI|oA~AlPgFpGpAzaA`E`r@{EvEc@xHtB~GvEhAcAlIdIh|AfAMH~AkAvEbCvChDzTzJjU~@|HnD_A~DbCvDdIxL~GfHBxGxIrLpFo@rFpDzm@oCj`@_G|OyNxV_G_DuAdNgLtZ_Mds@rD|MnN`NtKjDhCpJbMzHvEpRkRt~AbXfOkDjWhAlJ_NzqAiLxa@p@t@iE|RjNvDxSu@|WtOpQ~Xg@jHr@lAwb@fh@yDfQpFzJwHYsEoD}@`EhAzHu@`Ih@`EcIPnF|C]jBuD~@uMcB{J|K}Cbe@pCvOO~O|GnQqBj^wFrIlB|DgIhNYnRdA`LeEfU~BvJwCnBxAvDqDdIbA~J_OzRwK{@cDxALvE_FvOgGfI`DtE_AvFoD_Cq@hLuD~GyDwI{EhEr@rJeIAcJzLnI~Du@bBaG_AiBpLzEhKXpGkJxBkEyCq@eDoFnJrLrWoGxPdB|BlEdb@vLrPjOlKjFhWhUtc@rKh[zOxN`ClEL|DpAs@nS``@vBfFy@tL{J|_@_T`b@uJdp@qG|RoFlZaCxC{D`RqGfHmAjUmHzi@iKeD}AxD{ExBuCg@oCtMsBk@oA~AiBmEmBNm{@nsD}b@faAnCvFrGj@|H|HtAzJjDhIdK~CrCdZdFgBbCvIp`@p`@SdL|YfHfAuGjWtKnUU`IfBzMzP~NpXxCpXI`_@gIrq@iJ~d@{C|GkK~IiIrRjHbXuDv_@}D|G}HvC{GlYsGtOcRfRpBfN|EnH^jhAfLr{Aa@pFkOf_@uYrZqAtMsMhVgb@td@cb@vZcXfa@mIhEaWdXiGh]^rGiDrF{I?gOzEaSV{H~PcPdIkDjQoJ|F_ExLiFfHoF`fA|AjXmG~F{BvJaKxAsJ~GmJ_@{EtG}HzCoCvFkISaIbJrAkIeD_GmAl@wDeIoIlJmM_OUyVaBEiBrDoB_IsJ_J_`@h{@_TzO_Cpt@{ChPzEhTkp@jKei@uGiBwBaGjOwArK_KcJaHxFaRrGkq@zj@~B`BzCoCae@}lBoHaOmNoEaVxEaFeM_a@ig@gMwFeJ{@_KiK{EiQaQsLs@kBbBsH{GuEgEhDyBfJgEeC}r@gk@cGkMwNyFqGeLgGgVcG`FeF`Me|@tLmRrMyM|EJ`a@mBtR}FnNkA`Lq\\\\btAbA|L}@fJsGnJaHu@sEuZ}NwQkGuYeVwIcBcC{IbOgNxl@qElGcKrEaA|MsCrIuVr\\\\kSnGwOuQaPmGsM|Pc[xIsm@bXuIfIiHdNsRdOaN}Ns[|@sj@}Dyi@oFkGuGkMdCkP_[cV}G_LqGuIsJcQeAsSyIcKyKkNu@c^sMMwFoG~E}I_CcIaHeUtW_b@zJqUsIoWoAiWgUuJcAoX}JkMeAiJnJwBiHiXqb@cBBgKuJcLy@uJkK{WsEuNsMgOsEmRm@{SgJoFdBuH}BcC{AtCyHiAsBwMjGyDmEiR`CqG_AmVy]{MmIyH{RcWePyIiKqB}NoPcBwA~AuApJ}H}M{JO~B_`@iTzBoFmAaC{ByAiO_o@|Vq^zVg@eJ}Kah@e[seAqKqaBxBsa@lEiKqEoO`@oCaF{l@_SaUyEsMq\\\\mRcVqEqUwRi\\\\uI_MiOeMoUwOkM}Vc`@qcA_k@kCoKoG{JoBiKx@uEeAiIaEwK}Msy@gSm`@sAaLdCnB|BuBdCeTs@}VrCei@jN{|@bMkU_Fqg@hZeJzDiInHcF~HpAkAuLxNie@d@mQ|@cDpHeGsC}T`@oKpGwYrHkJdH_QdEuS~@iOsKqJuB}GhCcVqSmCaSqNoBkMeNuRuC}ImIwHmTiEaFmJCwGdS_p@jRs`@lHzA~KsJO{AgIgB}BkFpAkNxNi]fSeVfGaM~DiCbGtAhNkIfRsBxIuR}KcJsJsRuc@}^sAgDjFmLnUyTxJgDl[aUjMaBvPjDzLg@e@eVcDwDV{AnE}@XeLeD_\\\\{BgG`CwQqAo[lE{M`@sTe@sn@kEys@xEc@fDoHjHk@pBiHN}GcDi]fBc^dB{FlOgTfC{]nTc~@vAuPxOcXtFkd@~DcCm@yAsHbDsC}Ft[gYnFkIxEgBpUEVgPuPyAl@gOzAiFyCkEnGcGrK{C|PkOpLgR`]ePhNoLza@mEb[}Vvk@mLpk@a\\\\nQePrMgFbg@hP`M`BlKdO`ObJv^v^fRtBfAaYlTgDjFp\\\\|OvUdD|Mk@bf@lIba@\\\\zLaDps@bAx[hLxp@rI|ZzFbCnAtG`Ek@~EnChLyFpCaUjCsFnSmIrgAzCrYwiAhYkOhTuCdY~EnBy@vBsGzMpDfK}IhG}NIkKhCoDtRa@`MeHdCiFvJ{C~Dj@jDhLjEj@vMpSxTkIjBnCXhNbCdBzPuKfE`I]qAdA]`R}@tNlFtWp[`m@nKzZrL|i@bCdEbLbAtNrMlJ|CzFvDfw@pP~qAdMpb@r@vLfG?bF|MyDdUnGva@xClEtAvKUtPbCpOdA|^dUbXtDxNwV|`@|WvIfGpGWsCt_@dLnKFf^`H~[TxAqXuDqDKaD~D}GxNgd@|B]zFdDZeHzCgElEVvApBtCyTjQPpNmJzAeDpDmUrByDb@yWbCcQvOaUqA{YpBg@~FyU~BH"},{"id":"2025-09","name":"Est-Ouest Side Story","strava_route_id":"3398575524295861534","distance":184016.81336385256,"elevation":1513.87,"summary_polyline":"kb_iHk`vMZk]bCgUUs`@lAsQdEeQrQy\\\\`CaMjBuZkKqNv@u_@uTol@lOwK~LkO{CeK~LgNmAeRjNuTfN_f@xJ`HnL_q@xU|M|F{TvNVpn@it@ze@oiC_KyL_G{BvBmIfP|JdVn_@|OtQtQfCtl@e|@C_D~MeJg@mYdBsArMc^hMeN|EmRbFm{@bScGgAoUxQeUfcAb@zHvEzB}\\\\xUuHfAuOdOb@hApB|WmT~Fcr@~CgEjBp@|PkH|BsStFiT|CuYrh@uCgA}l@{A}E?gMaDs]gEaWcGsHq`@kfAsAoYm^wAz@_RjG}e@xGeUzg@glAeMwRgBO[iFhIkCsCoPeAiShAgP`^_TdKkBtk@cc@fDvCvMp\\\\bE~D`p@uL~SiKzGlLfStS|FxApTyDLnK|l@`Qdf@eQ`MsJdu@i^nEsJ|@{HzDqCpAdAbAdQg@zJpDvD|s@k^lBh]vZrCl|@xt@hNuAbC}C~LmE|Cp@pDkDrh@rc@bMp[nMdG~`@|EhB`JpDh@~CkFpKpDAsCoBpA`BfAn@mAeBqIFkOfHqz@rCkMpKaQrGwq@rJyn@pb@zAlXylA|M{PrSce@`@yEzDkDfK{SzH_Ufv@{t@`Boa@bUeb@pDqOpX{PlMe@xBgX~LoUbPeq@lYet@b[{^tH~CjGsD|MbX`~@xa@SbV|@~G`BcDlEvUq@|AtFtCbBpDdX`K`Tli@|dAp`Bp^tTxZxt@hHd[`_@~\\\\xPbKeIr]tBtQtBXpEyFpE_AteAjVqLt^oAjJyGdJ}CvOoHdNkHl\\\\~a@trFpKzc@yBlIeCzB?bDeElLz@vYpFhOnVpZjGhVxT|N`Cw@j@zK|D|RuCtXcCxeAyb@rdA}@xq@iJfx@sGvWcEdAyZb[cDoBsRtEyS^gHnCaF`JaJ~DcD~EiL^cJgByBfAkGn[cO~KiFxSaGnGoRf^_B`a@hJvHjBpHuLt~@zJxp@^pVfAnAT|FsBhGxGhIxH~AkCnt@zLn@jRvFnSxOoIzc@_AvThCzEwAdHfAtP{@dPdHfg@hNlf@nAxOzInVxLnJhJIiMzw@}Anp@j@jZpKsDfGsHzQ}Grv@_LnKdyBxUfRx@~TlDvQ|K~hAo@rRwVns@eGnk@mOr~@fQpI`e@jEuAfVJpLvDvMiApUbu@xHS|\\\\qDfe@uLbn@yElBsB|KmK|LgFm@_Szn@}Kl`AKp_@gGbg@uJcCpAhWkA~IuJxWfH|SQvFvBtJ_JjKaE|PoAt\\\\fCbK_Br^hAnOiE|GiAdSrL`t@~@lu@aMpX_KjMiCtA}BaDyAhCZnMoF`TiGxIgCnWoRrw@dBp`@kB`Mm@pU{FnHiInE\\\\vQmMhk@gIqDoF^eLmG_Njb@qIvO{AfIaJ|GcOvD}N\\\\wa@h_@we@hQoEcEkGnIkM~HuE_C_IOqPd@{E|CaI~PbTv[kF|KfBzHoAnAeIiFyCNiFxQgG`FaEpLgNdFiJrg@pCnOk@nTsHlRkJpIcMrBcJcPkGwCoOdHg@hGyB~@oHyC~DgLqBcMkIpEUtJkSq^eE_DmBbAa^}e@aP|CyPh`@in@tZrG~|@v@h^UxJsDrQ`AxQ[`KiBRBlGgc@r~@uh@hdBeDxCoLhAeC|BF|LlBdLo@nMwIzBi~@`cAma@v\\\\mWzf@{T`{@_AfSqL`SgSeH_OXoFwAsEdAmBkPiKgH}Nu\\\\m_@qVeUgT}a@{QfAeI|IiRn@y]fCwRgAqOsCcIbAyVmPoKcBeCW{HuAmCmLmGsHeByDbPeGlJmp@h^{[q@qPyC}Il@yJgU{s@uf@gC~BcAzL_FhRiHtLgKlFgHxJiDBmNoSaMfBgF}@gGrBmNgKia@oFmIiPIuJaOiS_BwPj@yNwCiJsJrAkPuDur@mXsDuEcCuTmAgBeJiAuGvGaGLwKnIqJaFi@`KaDyAeK^kZeg@WeJoDaNcYub@Bmg@iLq[eIqF}@}CeCfCk\\\\}CuiA_u@_Lf@}LqQiQoGkCpCkEpQwI`AeMiKkm@{IcCjMyAv[qJhMaDiCmDiVk\\\\qQoOlSy_@oQqCw}@}]gw@sHeDsh@nBwLeIuBeEaCo]eH_WjB}QeDmh@yB_FmSqNn@{y@rAyB`A}T}C{@qB}D_C{Sia@gk@iUkUcK}Q}Mk@uGe_AmKmA}A{EwQH{KgEqHI}@ec@gAuDdA_U"},{"id":"2026-01","name":"Paris - Tournan","strava_route_id":"3443500888048454516","distance":113264.6258241287,"elevation":686.2600000000001,"summary_polyline":"_c_iHozuMn@gc@bCgUa@s`@xAsQdEeQrQy\\\\`CaMjBuZkKqNlAeXkAqKcg@}nAnTsE`SfFxBaAjMaOoAwQlK}N|N_f@~D`CvAkBhDrAnL_q@xU|MhB{IfHn@ElCzBF`@yG|t@}{@ze@oiC_KyL_G{BpDqMeA{EmNqMcCqHyJgDmEcGjFb@v@qTxg@fMjFuFz@jCbZeYHwE`Hn@^aCjIbEzCjL|Ia@}Ce[dDeMsFkS`MuMaB_FxJcKjVbDvCvH|FFnMhk@xOxY|EmRbFm{@bScGiBqSzRcWfcAb@zHvEzB}\\\\xUuHvAgPtNt@hApB|WmT~Fcr@~CgEjBp@|PkH|BsStFiT|CuYlVgAjKhP|FlE`@gA_Dqc@Mi`@{A}E?gMaDs]gEaWcGsHq`@kfAsAoYm^wAz@_RjG}e@xGeUzg@glAeMwRgBO[iFhIkCsCoPeAiShAgP`^_TdKkBtk@cc@fDvC|Nj^|DpCxRqCfOeG~Ji@~SiKzGlLfStS|FxAbNoDcKsm@g[eo@FmKeJkt@~SqDfUfAzDkHbd@tApQ_D~I|Cd@iM~c@rKnIaErErBfF{Fxf@yJfTiArF_SWmBoBr@oCrFyBiFeDkn@uB}LI_OkHg_@}l@a_Aew@myAqFoDgAeFxCeK~M_LbGsVvMy@nAkIpHsR~EgLhLgMxT}n@uEiOxFoHgCuFrE{]W{SpE_Rr@sPmAuNaWcvAaBiYoGa_@a@aPzAy{@bDcPyBaIjFqPwDa^~@w@g@}JtJ_j@lFmBrCsGjTm_AbI_RdGaFCmCzE_BhDpD~E?zDkH|HVxIeDbIjCpJtXnIeHlYy`@dj@mfAbCmRqIaHx@uZvIsgAwDcZp@ot@vBwAjBoIxu@jCpEiC`Gt@dCiD_AgPfC}`@h@sdA{Dsb@kFiIkF_Cs@kE{Akb@jBwYsA_ZVc}@iHsYwH_x@]{QfBm[gGuUiAo\\\\sBcPjAkSuAg[pEy]_FsD{CsIoGm@eDjDsKxAF~DeVlRoRm@gC|Aoh@lz@sAxe@uTzg@eCpMqCrBaFqB{ApGeCjZdGhOR`LrDvXa@jNjAnSnKn_@nCjEQhF|BnI_E`EzDj\\\\_FtDgM`\\\\{PtYoDnPkGbKaEr{@f@vZhItUaEzE{Nq@wEbE|@dK`D|EPdLvK`y@\\\\lb@qEA}@dTjC|OxAn\\\\{Cb]cClJs@rZ}Nja@gPnXLzRiL~_BuBpWwBn@e@dDp@vKgB`Eyv@io@oo@_RcGfUkI]qFvWlQbIpJ|XvYj_@wIzWsNnUcx@n`@u_@nZgHvPuh@~a@kPzEuBnCaIp@o@~Ft@`LrQjmA|_@jnAzNfTgXxt@eVtUks@xVcZ|GuyAafAiBaHTgJlCqOpEiFPoG}R_MeIfl@LrJsClRoDnJyKzDcBxMnR_@fBzEaDdJ"},{"id":"2026-02","name":"Paris - Les Essarts le Roi","strava_route_id":"3454507718884710446","distance":126885.35465724421,"elevation":991.5,"summary_polyline":"u~giHcciM_CeAoB`QmR|mCue@|n@hAvW|Lf{@a@zC|A~ByLjz@rKdUEdCjJnI~G|W`PvPAlDtBxAhDzTnKhUsCoHrCnHv@fShBzExWbY|_@pD~Czo@qCt\\\\l_@hTr^kBtNl^r_@uNrWiFOgEzQyIpJv_@_Iwa@q@~@zWbrAtMxf@jDn[pY`gAzFjb@z^zp@jOxJlP~CxIbVlTlWrG|o@Y|d@~@|Md`@d{@|@nmAm^ntB`FxGwEbHiApJxOrIoHz`@_Fl|@zOr_EtGbXWbEkEd`@c\\\\po@i]ruAil@jhB}AbAo[{DeIf@_aA~j@DrMhDhDe@dKkJfKqNwAiVx]kGpNgHpc@}GvQeSpTkLvZn@rN}N|FcIbYgBhIpExv@kAjFyIxCaGc@sMsHyPeD}GZ{GiEqg@kKaJuIhAuIwBmM{HzAeGwI}e@sRaCbBwCcFsAjA{j@lbCgIrBiJXaOqDka@gh@aKiRkNiHaFmH{@Cq@hE}AHqc@sELvRbIfORhJbEpIfEnVjDsB~FbQvEj[vIaDfHhChDvEvF~f@fB`^lAjC|FlAiLxk@qw@~}@v@zNyDpRlD|FsBzG`@dl@_M~eAzDbi@~@pv@wBdEcYxPoTb_@xAlD`FQ`Y`o@tUva@lMtIUjJ}CbDt@xDlE_CvDrFwJpNfGxTiLhMm^zKyh@Uc^zJiAuCwOjQuOzHwy@lXQbDoCC{GxIsR~MyK|N}UfP`V|i@xEl@xPzNfSdJnW`UtJv\\\\d_@fc@pF~OdMdQ|G~DdNtRrEhPj@xQbDrUkI`F_ExLiFfHoF`fA|AjXaBVsBnFdNhKhh@xy@`W`f@lHtC`RnR|HtPtGx@nRd^nX~L~PtCzQjQ|n@yHfOl\\\\zCv@jLiBlK~HzUk@r^`CzJ~C`MoJfDzCnY_Dng@jl@vh@pR`_@z`@zHjBrH~PdC]~QwRrIeDxQqCnWBrNvHpQ|R~GlOnV`[hDzJ|PbVhNne@rF`DjWrErN~IlGvNtCrQjReCrS@xUkIrOoAx\\\\{OfGtGxMhFpQgBhL~CbA_Ak@aDfByKnIaJrItL}DzM~JfNz@fE[|JrKxH~h@wKf^d[dGh@bEuDri@f@f[lVdHgEdDvUpDKnGbHW_\\\\wF}BzG_]vCm\\\\~IbJbDCb^s\\\\nK}Q|EhK|j@x_@pO{g@`RqS|A_FiAmMl@}\\\\mk@gn@mI}WzDwHsBmK{Vel@}OsGsECxB{i@|IyhAnn@cbDTkIwD}i@vK_UvIeXfFuEtIkBtB{DjB{i@m@wIvCa\\\\}WtMeOuTiH}FucAuVmOl@np@ssDgKmEyDwH_F}x@gK`Ex}@unCvTrNz@oLQxD|V_UjJnElXeyAmKyx@}]g_AYqFv@mAyHwEaWnXj@^"},{"id":"2026-03","name":"Paris - La Fert\xe9 sous Jouarre","strava_route_id":"3463493922374429098","distance":137944.89774082683,"elevation":1416.4200000000005,"summary_polyline":"ic_iH{zuMx@{b@`C}SS}a@lAsQdEeQ~K}PrFyPhDw^Lcs@lGgs@zMiYsPs[yDgBwHzDf@}d@GdUiJEqQrDoLsBqNkT_Gm`@wAmh@lAaLJwbA~J}|@KaXkMw\\\\yPgI~@cEaDy@kAiFoJuDuDmLaEeAuDfBmSmPqZi|A?iPeIqq@Bud@qB}VHkn@}Bmm@bHgHyA}Rn@eWgHNoLkcB_AudA~Ggs@a@eD~Jy|B}Fgt@g@qY|Cop@m@kKl@ms@zEy|@iAaJj@aS{B}NwLgGcKdFqG}r@nG_oAxGqOjAiSy@kGl@ed@pMox@pH_MhTqs@tF__@xVeR`a@u@da@gRjP{m@oAoM`L}Nxp@eaCq@qOfF}BmD{SdBmTE_ZwMkxAnFePbHqi@vCeC~AeHfAJkD}bAb@uFsVivCuRux@aC}CFuEwGe]xDoh@rBeHjG}DqFog@pKat@bAaSt]gjAmIkDLaUfBaKoMwBbPuXfD}PhJy{@U}g@oDc_@ea@yCmCsAcBsF{TlF{IvQsGsDyAsNX_ZmAqSrA_PjJwc@e^sn@{DyRyA}TqFmEb`@wd@jPaj@jXmn@jFWqJ_PwBsMuDq@wSsi@c@{KyOuT|@sIuF@i@{G{DiJViGsJg@mMzCoYxRwJpLabA}oAcHyCxCgLbAsi@bNiy@oAoPh@uZwAwS@}XtQwWpLiEtCeZlLoe@aDwRnBiK]mHwCm\\\\qCiFc@wSoBoEc@eLzBgGxBcU}Ba_@dCaIsEkRrCmTyNad@qRuPgByStB{VeAwEoH_E_QgUy]eLuLyUwDeNwDyEoQ_hAyKkQwPck@wAsKRcJ_E}BsEo\\\\mNqQfBmTyI{BsXyWiFyLeRqDkA{B}Cua@zCmCjAqTySsStBwI{JoJoL_\\\\uDs@cCcHb@oHnLuHDmDiL{A{F`C_FzIyCdNm@cX}A|@cFtVuLyE}CmFyK{BrEiPPwVdJak@YqBsAe@oKxGmIcAYyJuK}_@AiKoCaNyLaLw@_KqBuDgI|EkDwHgHaFOuI_YaTaPe[cJmd@sJgQ|B_[sFeL|A}G_E_IsBer@gCcQm@uSBs}@bDu[yJiZoHuI_CqH`BoQsS_dAiEsf@j@g^jBqGuF{EuWtQeO~FHbD_Mt]mHvCsE`G}B`MgCbEa@tZsDRyH`Hc`@tN_b@eEwOhOo@nIlCzQyCpCv@bSxCtFhAfp@aDto@zAtYg@b_@`IbJpV|J{RrWmj@fTcLn@}BnEqCtRkGlGuRe@eRuLuGkMw@oKpAqKfLcM}OmZeGuBwL`EsTva@{EgaAydA{fAs~ArBoHmEc^nfAdPdTTnGaMnQo@lFnKd]`XrWtF~BqJbDkGhR}JxEoHnMyWfCyKgDgFZcGjJ{KnGmCvF_RddAoXrv@oWdZs^O{FpCuq@xdAyErZdApHkAhJxAbCj^bHxBvL{DzSgFxH}CbOcMvQeAdMdEj_AzIj_@Xlm@lArG`e@hm@`XxTzu@lRhJmB~JnJ~R|@vGbDtV{EzIlIlTpEnQlMzKw@hHjQ|\\\\gYzVus@jJtDpLh[fLxMjNwE~A_FD}TxAoI{@}Up@gAlEhE`FbW~F\\\\dI~LhO`MhYhKzYvFv]`k@~AtUld@v_@~KbRfHdCpZ`ZhP`GzLlLhN`AtGlFnJ|LkJzRvBfP"},{"id":"2026-04","name":"Paris - \xc9tampes","strava_route_id":"3476804516278805000","distance":144919.1209091253,"elevation":1104.3000000000002,"summary_polyline":"w~giHubiM}BsAoB`QiR`oCmEfFpCzrAaRzp@mUp`BnYfObCpg@}DzO~AxDvLbeAfDpL{Lxz@eStb@`@hGeD~x@hEnKxEzYdF|IcChEvF|LxEuCcAtIvMFpG{GpKfHtIF|FtDnUfZjI]hLkFnClLbZf\\\\nTbJ|Udk@bBtMQfHbGva@g@dDfDtD~@k@dCpIbAz@tCsHlP~CxI_EhFnKvS{B|AzMdIhLfHhRjAtS|LwC~SpPtAvE|C~f@kB|QdH~VbBvZrC|GrJ|FJvMlAzDhDp@jCwE|CrAjQhr@s@fVt{@|_@f}@lg@~FwY~Av@rE~WtCTzFyG~AwFv@sVnCwOjm@zIfEpC]lD|EvF~JnD`GxFdGhAvD{K{@jOnIjHw@`MzU`QdUrXjGiNhNel@x`@jV|f@jF|E~FrIzWh@~h@rZje@dEd]rPjRzGvMrJq@zCzAv@y@EaHnLhDnX{gAjYs[le@kz@rCuCjEfAjEgAzIyGlRmAdFiC|KhB~ErIfHt|A{N~bALhNkIlu@bEpa@KhTlJzP~Oj@hOpD`OlKrFyBfF|@`MgBlNnSxFw@lQfE`IzOxHza@fNjOuAjIdKtDuIln@\\\\rs@gB~XlDjDhEuAxFrB`KgBzC`JjXhPr@hDo@vIlSj@jC`RjAte@|LjKlE`Aod@vhCt^rE|k@}AbRf`@zWdTfHjLhJpXZpGiBlKlBpHtEtFfOtBbBh_@vQbl@{A|FDjFjG}A~D{MlHvAdC~C|Gt`@fEdIyEpr@f@jTpmAnvA|Qr]r@dHjNfIpB~HzK|HwBhGxJlTfTdTtWrSzKzCls@yz@jQhk@bUb^lQdb@fNfHbGdIlK{JfHnHjDfIpCdPLzMwC`Hz@bD|^_EfLt@bFoDzb@yB|OeDfPTgE`b@~BvGeAhV~M|OjJ^nLpHjx@|OxTtVzPjLlL~SdBpGkWlNcAxNsD}BaH`B|A|NmDfXsJ~NoFlWmKfQRzFbG\\\\{CfnAz^~g@xWjg@zJzGdIn@jRjZCbO_AlBZhXtEj\\\\jOb_@j@zWo@xYhAxGu@`GrRxI~Snr@AtGuBdJ_MjNqAdGfAdPnDlH_A~FzApIo@ju@sGh\\\\~P|LnD|KtI|HjFn@xIjt@nQr[rCfVAuBcAzH_IrMmBlM?xJtGfB|DnGwFnPba@rd@|M|Wha@m^vN}@~D}B{@yCzJ_PfL_`@bMom@pL{PiCwOdKaFpCuFdY}TxHqMpElAtFuGlLeBf`@eRzB_@nXxHjYeHxZzUtj@oIhQdEhWjf@lV~Z~ELIkItCeDpj@qBzr@}XbNyVsCsHhKeYdKsMvBoShIsSA_CkBl@aMoT~E_Ada@{hAjb@caApDrAxDkMfP{UxIu[pg@aaAgEkDpHsc@oGef@wAsChCeHsI_o@mBoCvE}FtC}J{C_L}Ss[kWciAuNud@qWqc@aE{X|AmLgCah@uHoo@yVin@SwWgTuSxBoHhAcPpL}O~[ys@rMca@`DgWtOua@|GcjAN_j@fJc_@rCwa@|Gyh@vG}b@hDmI`@m]v^u|Dm@yX`F{e@xL{t@nAaZ[oN~@yE_DcOmBeXgJmFkMqSwQpBkKuZgEkE_Fm@eOjFkIkGiH}LmImXqJ{DaGiHwDwQoEuHu[sQiPaUqKaZwAo]iEaMsFmF_YkHgAsDtAeIuG{DmKkX_U}MdMeWfAqNs@qa@nMg|@h@{UwAktAnGk_@nB{]cLavAhB}DvH}B_Iad@iOaViJg^eSqf@|JiYiJy@gFvKo@vHhDdL"},{"id":"2026-05","name":"Paris - Coulommiers","strava_route_id":"3486672022877179902","distance":157324.79473192475,"elevation":1374.6299999999999,"summary_polyline":"q{jiHqfuMaFvAyOiLQ_D_h@dAvAsARoOm@gLoEy@Uk_A}@gNsx@q|Gr@wAwYeeC}ByJ_RkXkiBctBkGkOke@wzCrAy@cXyiBwCw@aFoRq[oxBmUusAgAf@_AwNtHcl@X}Lw@uH{FuPcBkOgWkqGi@qDaFh@jAyPsDeIkJkCmCmIqIV_OuEKmEvCwFXwIwCeWkT{p@p@wXrFwFl@{]cp@zDmRvFib@hA_@iDzC{YbBee@i@gt@bEw}BsAiOj@sVrUybA|Gkh@iaBsp@ui@`GuVaI{Oq@{KsFi`@pC}M|Di[mCaY\\\\eGkCuAsQ}w@g~B_Cu]mTqn@_CePmIpDyCsMsNpI_KWySxCiWyFiQiGaMyNaI}Eg[cAiVuGiGkE|AcKoEkBaB|@_\\\\oRmVr@sYgOsg@sJmLyFoNXuV`MsAsEu@iWaIaLaNeq@oXcn@f@gJ{AeLoEyAe{@~B_RqGcEiIfH_ZMgb@tFoc@kPwOsd@gv@qDuW_~@wwA_AqOaKmANcIhEiTuVyBkXyJuVca@_WaGqk@_ZsEqMaE_VmBaC_FYwFjFnCcOyJ{NuN}c@ca@l]kEcLiEmj@Gu\\\\~Eqg@zEsJmAmKjA}U_w@qaBq`@oaBuCgc@gIqU_Osr@uMmUqF_A}BkEz@Ao@eSp@kPbQcKbMq\\\\`AyHyJ}YcGs[s@_PoEyLGuGeM_FjKeVfRwGbXwS~y@yTpHZ`Eq\\\\dZaQxQbAt@fCk@vFvJfMtDqSbDwC`GmNc@wOrCyK`UaTzEeN~MwP|FcQlXuPrGbD|QfBjNhTx_@tKzW|SjAmMtIiA}@P|@QxBsc@zKj@nDwDvDw_@hEuV`D_GlQsEjLrCpTa@|_@x^bDl@jK}SnNgCjDya@q@}PbLmPcBqRbA__AqB_MWiTtHI|MvHtK}NrMlGbE_@bKwQsHuUImGtAiCxg@hHzN`JXfE|H|A|aAgM|HXrNhIhKsNhDnJjBj@Pch@|BgGdQaKdBgHR_UbI{HNcDyDaIIaDnTa`@}C_OzDsDBkBoFwBhPgScD}IfX}~@fDsRdAaSfBsFpb@vl@n[`Xzu@lRhJmB~JnJzQsUh`@o_AvFcB|K_MdJi[}EoM?qHzOpFlGgCzGsMrFeE~GgAjXsZv[?`HgTxGgHFm_@mDwTcAkS}A}FeJiJzCiH?yDoNyMcIe[nRcMpRe[zHma@~To[lFkOtE}d@Cwv@z@_Jk@iMhPpPzFpBV{B~DuCJaJtr@ib@pA}E[aWfA}JjOjKzUpG~HsLpCuR|BoEbLo@fi@mS`TmXpK~@|KrHjAsAdXtElLbNbFhLbIhs@jExBfDxHhF^pGzH|TdEpGpG|Nse@nUoc@zXdA~JnRrI~b@vPt[p^|Yr[vNhNnCxIwCdO`AxNqNxMV~PbE`CwQoD_VhBy[bHab@lHcVrBiApFmX|Dog@dR~@tJvDbGyVxAM`QxOzGeDxCyFlInZrF{HnLeC~OpDzEzFb^~NzXs@dLhy@tDmM~EoG`Vhh@v_@zSfS`WvRlKhTbG_Aba@qNnd@xA~J|^mWlQHtj@tGbI~SxF|XfIjJdSx@``@hLpO~ItHtTvKhLm@eFnHxPhJfe@nBx|@oBj_@hQ~IbAnq@]`FiD`DgTtq@qCroAwOz^gHbK_C~XvCbBjGs@lExCpEoBdBt@pHh^yB|ZjDtQvHpNlPfOrMtTxDfNdCxZnCfIy@z\\\\}BzPt@nDoApXmRLqHrDeH~IuO`JkZbXwIpKc@lIlBd[gBlOtBhFeAnv@rBlSdGbIhDhN}A~ViHxCGjC"},{"id":"2026-06","name":"Paris - Longchamp","strava_route_id":"3496772225804948654","distance":163744.45484458483,"elevation":1938.99,"summary_polyline":"u~giHcciMwCWeUp~CelA~}AaRjEca@pk@yZdXsDf@cd@jj@eGgIub@tVm\\\\vMaAw@eBdFgVlYuYfScHhXsVrRug@hy@{l@vm@bA~DuEfFgL|J}`@~Mcm@vb@qRYgF~[_S{W_ZoAkGyCkB~Oj@~KkApP}FnGrAfSoK}DiBnAsBxHqFyTiHf@__@m]iDzJq]_Xkb@h~AwTlGyOdp@ibAus@sm@ku@mH}EeFtRoDvFcE}GwDnAiFyEyIlFcMW}LmFwHm@uH_IiP_HaB_Fs@qQwNaZmD}PeJqFoKoO_E_Qs@aVsENgMyD{LhEmJuF~@nZaOhdAyMUkChGkBa@sDdG_KbDkAvHlBl`@q@|GsLfTyXby@uF|I`AvSeFnToR_Jk[cCgIbSqHhHa_@cHsKn]i@xGjCdIeBtCYjHkIxGaM~QgEfOqIfOwK`H_LiC{P~XoO`NeWwBiJrCiTwQ_DNiMtY{K~NZdL_BzJqHxH}Fn@gCdMgJnBeKu@{QxK{Qnl@eAzIVzPhElJvCnQlCd@|CnHhGrUhArV`Kj[cPxz@{Btg@wExEaFoB{BdEuDRmK|RwGrj@PtUv\\\\bj@vCrBhNfAhCxD~FnOdIx^tY~p@v@hOhD`ItBt^gUpc@a\\\\zbAwGfA_DvDqGlSeCvK}AbViPje@aOr|@n@tIqClGEdKiPv_@sDvDwJxB{VlA}AzAg@fHoHrHkBzF}CiCkB~@gBvJ}HlMuFtBeGeD_F`CoFxJaNxCHpQaBpLnA~POf\\\\cBlJGnS_Jt`@~I~VxHv{@`HjP`CpY|Abv@e@rSiGvMXtG`Ch@nD{CtFYzBzCv@xKpEpAvDiGxDf@nGeCdKiQt@eHpAUfLf@lKrSpJnBxGmE~E~B`HcCtU^bIcRzEkBnFjK|@jEcDzEoBdYhKzKhLm@bAtFeKxMxElMsCx]dBdVcC|XsBnHsRp[lAbLfIdKpMl\\\\vVb[xErL|CzSlDmBhHpKdJzc@`N`^hNv\\\\dMjP|\\\\vt@fKrc@GtVnVxYfDrOfClb@dFzJzHfD|Cq@Y`FoBbAqCjLsBxTrCpZe@tM`Dpt@hJ`^Rbj@|CbRtBtb@nC|IcRr@NvbApEdOs@tKbAhDlJ\\\\~BlE|RlMxAtM|Pzo@tGn`AkJri@uTp`@oDnUqAvWhCdOrMtQjDdCvRmGfMrQp`@~G`LjM~FlCv]lGvKmFjX~DvAyKHsT~BoGk@oJdC_SG}IoF}ImFk@ToBiFcW}NwQkGuYeVwIcBcC`HsJ|Kw\\\\lSu[dH{DpJrAvQ}Bd`@mb@xJyEqG_TzCkVz@gZeAq^`@ob@nQ_SfPv@zXsUx\\\\qShIuLbAy\\\\~K{HdQ_SlGyYrPs^~]lCfHzDpVyCdEmExDsZfD{FvC`CzOnd@vP~SzDlZpG`IlGTdQoPpC]|z@bPvE~Dbc@{@CyFph@_A~b@hWfa@mQtk@eKhP@nGuZnEiA|EmGxA_ZbDyB`V|i@xEl@xPzNfSdJnW`UtJv\\\\d_@fc@pF~OdMdQ|G~DjLvOlGfSj@xQbDrUnEgRbPeIzH_QlT_@zOaFlEl@hFsFQsHjEaYzIoJYeFdEa_@|HqQtB}b@sA}]Iyv@uCwu@HqYxG}RGaVbTyFgKeJaSmEkZkc@mE~Bu@yD|MkWTiFi@_HcLq`@fEqBhBsHzIxAtMwEaD{`A`BkW]}GvKxJ~Kq\\\\fB{NbZ{b@pg@koAvNiM~KeRhA}dAq`@q`@cCwIeFfBsCeZeK_DkDiIuA{J}H}HeIuA}AmE|b@gaAxz@irD`Cu@nBzE|DcAnCsMkD}YlKeg@zT_aCrRcLlKuNra@y~@|DiB~B}J_GmJg@mG~[wu@xNmOpF}XxYsp@dCwqCak@AsUwRyCoSoF_OpA{DbG[l@sF}Hc`@iCuFnRoLeBuHiHcHoBcRXoRfIiNmB}DvFsI|By^iHaQN_PqCwOjDcf@nJsH@oCbFy@jMbBmF}BZmBx_@n@~FoJfGEzLdI[sFzFMp@wBaBwOXsX`DaAQ{BvJsZ@gvAaJcJrH{bAsVuX|A{I_HkEQqCbQeiAyJcWwDkB~O}f@{Eo^gG_FaAyJiDF}@ec@gAuDfB_VnF{St@oP"}]');


var $4f623c79aafe472c$exports = {};
/* @preserve
 * Leaflet 1.7.1, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2019 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($4f623c79aafe472c$exports);
})($4f623c79aafe472c$exports, function(exports1) {
    'use strict';
    var version = "1.7.1";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        /*eslint-disable */ obj._leaflet_id = obj._leaflet_id || ++lastId;
        return obj._leaflet_id;
    /* eslint-enable */ }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, digits?: Number): Number
    // Returns the number `num` rounded to `digits` decimals, or to 6 decimals by default.
    function formatNum(num, digits) {
        var pow = Math.pow(10, digits === undefined ? 6 : digits);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_-]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        extend: extend,
        create: create,
        bind: bind,
        lastId: lastId,
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) {
            extend(NewClass, props.statics);
            delete props.statics;
        }
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
            delete props.includes;
        }
        // merge options
        if (proto.options) props.options = extend(create(proto.options), props.options);
        // mix given properties into the prototype
        extend(proto, props);
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        extend(this.prototype, props);
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!types) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context) {
            this._events = this._events || {};
            /* get/init listeners for type */ var typeListeners = this._events[type];
            if (!typeListeners) {
                typeListeners = [];
                this._events[type] = typeListeners;
            }
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            }, listeners = typeListeners;
            // check if fn already there
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return;
            }
            listeners.push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (!fn) {
                // Set all removed listeners to noop so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (context === this) context = undefined;
            if (listeners) // find fn and remove it
            for(i = 0, len = listeners.length; i < len; i++){
                var l = listeners[i];
                if (l.ctx !== context) continue;
                if (l.fn === fn) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    l.fn = falseFn;
                    if (this._firingCount) /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                    listeners.splice(i, 1);
                    return;
                }
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide an data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        l.fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        listens: function(type, propagate) {
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) return true;
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, propagate)) return true;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            if (typeof types === 'object') {
                for(var type in types)this.once(type, types[type], fn);
                return this;
            }
            var handler = bind(function() {
                this.off(types, fn, context).off(types, handler, context);
            }, this);
            // add a listener that's executed once and removed after that
            return this.on(types, fn, context).on(types, handler, context);
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        extend: function(point) {
            point = toPoint(point);
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = point.clone();
                this.max = point.clone();
            } else {
                this.min.x = Math.min(point.x, this.min.x);
                this.max.x = Math.max(point.x, this.max.x);
                this.min.y = Math.min(point.y, this.min.y);
                this.max.y = Math.max(point.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return new Point((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return new Point(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return new Point(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        isValid: function() {
            return !!(this.min && this.max);
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see http://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style$1 = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style$1;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style$1;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style$1;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touch: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // This does not necessarily mean that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas,
        svg: svg,
        vml: vml
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler, id) {
        if (type === 'touchstart') _addPointerStart(obj, handler, id);
        else if (type === 'touchmove') _addPointerMove(obj, handler, id);
        else if (type === 'touchend') _addPointerEnd(obj, handler, id);
        return this;
    }
    function removePointerListener(obj, type, id) {
        var handler = obj['_leaflet_' + type + id];
        if (type === 'touchstart') obj.removeEventListener(POINTER_DOWN, handler, false);
        else if (type === 'touchmove') obj.removeEventListener(POINTER_MOVE, handler, false);
        else if (type === 'touchend') {
            obj.removeEventListener(POINTER_UP, handler, false);
            obj.removeEventListener(POINTER_CANCEL, handler, false);
        }
        return this;
    }
    function _addPointerStart(obj, handler, id) {
        var onDown = bind(function(e) {
            // IE10 specific: MsTouch needs preventDefault. See #2000
            if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
            _handlePointer(e, handler);
        });
        obj['_leaflet_touchstart' + id] = onDown;
        obj.addEventListener(POINTER_DOWN, onDown, false);
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _handlePointer(e, handler) {
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _addPointerMove(obj, handler, id) {
        var onMove = function(e) {
            // don't fire touch moves when mouse isn't down
            if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse') && e.buttons === 0) return;
            _handlePointer(e, handler);
        };
        obj['_leaflet_touchmove' + id] = onMove;
        obj.addEventListener(POINTER_MOVE, onMove, false);
    }
    function _addPointerEnd(obj, handler, id) {
        var onUp = function(e) {
            _handlePointer(e, handler);
        };
        obj['_leaflet_touchend' + id] = onUp;
        obj.addEventListener(POINTER_UP, onUp, false);
        obj.addEventListener(POINTER_CANCEL, onUp, false);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   */ var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
    var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
    var _pre = '_leaflet_';
    // inspired by Zepto touch code by Thomas Fuchs
    function addDoubleTapListener(obj, handler, id) {
        var last, touch$$1, doubleTap = false, delay = 250;
        function onTouchStart(e) {
            if (pointer) {
                if (!e.isPrimary) return;
                if (e.pointerType === 'mouse') return;
                 // mouse fires native dblclick
            } else if (e.touches.length > 1) return;
            var now = Date.now(), delta = now - (last || now);
            touch$$1 = e.touches ? e.touches[0] : e;
            doubleTap = delta > 0 && delta <= delay;
            last = now;
        }
        function onTouchEnd(e) {
            if (doubleTap && !touch$$1.cancelBubble) {
                if (pointer) {
                    if (e.pointerType === 'mouse') return;
                    // work around .type being readonly with MSPointer* events
                    var newTouch = {}, prop, i;
                    for(i in touch$$1){
                        prop = touch$$1[i];
                        newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
                    }
                    touch$$1 = newTouch;
                }
                touch$$1.type = 'dblclick';
                touch$$1.button = 0;
                handler(touch$$1);
                last = null;
            }
        }
        obj[_pre + _touchstart + id] = onTouchStart;
        obj[_pre + _touchend + id] = onTouchEnd;
        obj[_pre + 'dblclick' + id] = handler;
        obj.addEventListener(_touchstart, onTouchStart, passiveEvents ? {
            passive: false
        } : false);
        obj.addEventListener(_touchend, onTouchEnd, passiveEvents ? {
            passive: false
        } : false);
        // On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
        // the browser doesn't fire touchend/pointerup events but does fire
        // native dblclicks. See #4127.
        // Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
        obj.addEventListener('dblclick', handler, false);
        return this;
    }
    function removeDoubleTapListener(obj, id) {
        var touchstart = obj[_pre + _touchstart + id], touchend = obj[_pre + _touchend + id], dblclick = obj[_pre + 'dblclick' + id];
        obj.removeEventListener(_touchstart, touchstart, passiveEvents ? {
            passive: false
        } : false);
        obj.removeEventListener(_touchend, touchend, passiveEvents ? {
            passive: false
        } : false);
        obj.removeEventListener('dblclick', dblclick, false);
        return this;
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outline;
        element.style.outline = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outline = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        disableTextSelection: disableTextSelection,
        enableTextSelection: enableTextSelection,
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function off(obj, types, fn, context) {
        if (typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else if (types) {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        } else {
            for(var j in obj[eventsKey])removeOne(obj, j, obj[eventsKey][j]);
            delete obj[eventsKey];
        }
        return this;
    }
    function browserFiresNativeDblClick() {
        // See https://github.com/w3c/pointerevents/issues/171
        if (pointer) return !(edge || safari);
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        addPointerListener(obj, type, handler, id);
        else if (touch && type === 'dblclick' && !browserFiresNativeDblClick()) addDoubleTapListener(obj, handler, id);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else if ('attachEvent' in obj) obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''), handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, id);
        else if (touch && type === 'dblclick' && !browserFiresNativeDblClick()) removeDoubleTapListener(obj, id);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else if ('detachEvent' in obj) obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        skipped(e);
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick', stopPropagation);
        addOne(el, 'click', fakeStop);
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    // Chrome on Win scrolls double the pixels as in other platforms (see #4538),
    // and Firefox scrolls device pixels, not CSS pixels
    var wheelPxFactor = win && chrome ? 2 * window.devicePixelRatio : gecko ? window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    var skipEvents = {};
    function fakeStop(e) {
        // fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
        skipEvents[e.type] = true;
    }
    function skipped(e) {
        var events = skipEvents[e.type];
        // reset when checking, as it's only used in map container and propagates outside of the map
        skipEvents[e.type] = false;
        return events;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        fakeStop: fakeStop,
        skipped: skipped,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var fx = new L.PosAnimation();
   * fx.run(el, [300, 500], 0.5);
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && any3d && !mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this.off('moveend', this._panInsideMaxBounds);
            } else if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // `padding`, `paddingTopLeft` and `paddingTopRight` options to fit
        // the display to more restricted bounds, like [`fitBounds`](#map-fitbounds).
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), center = this.getCenter(), pixelCenter = this.project(center), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), halfPixelBounds = pixelBounds.getSize().divideBy(2), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]);
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var diff = pixelCenter.subtract(pixelPoint), newCenter = toPoint(pixelPoint.x + diff.x, pixelPoint.y + diff.y);
                if (pixelPoint.x < paddedBounds.min.x || pixelPoint.x > paddedBounds.max.x) {
                    newCenter.x = pixelCenter.x - diff.x;
                    if (diff.x > 0) newCenter.x += halfPixelBounds.x - paddingTL.x;
                    else newCenter.x -= halfPixelBounds.x - paddingBR.x;
                }
                if (pixelPoint.y < paddedBounds.min.y || pixelPoint.y > paddedBounds.max.y) {
                    newCenter.y = pixelCenter.y - diff.y;
                    if (diff.y > 0) newCenter.y += halfPixelBounds.y - paddingTL.y;
                    else newCenter.y -= halfPixelBounds.y - paddingBR.y;
                }
                this.panTo(this.unproject(newCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter;
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && any3d;
            addClass(container, 'leaflet-container' + (touch ? ' leaflet-touch' : '') + (retina ? ' leaflet-retina' : '') + (ielt9 ? ' leaflet-oldie' : '') + (safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, false)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            // @event zoom: Event
            // Fired repeatedly during any change in zoom level, including zoom
            // and fly animations.
            if (zoomChanged || data && data.pinch) this.fire('zoom', data);
            // @event move: Event
            // Fired repeatedly during any movement of the map, including pan and
            // fly animations.
            return this.fire('move', data);
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map has changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing (e.g. user stopped
            // dragging the map).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove$$1) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove$$1 ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (any3d && this.options.transform3DLimit) (remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) targets = [
                this
            ];
            return targets;
        },
        _handleDOMEvent: function(e) {
            if (!this._loaded || skipped(e)) return;
            var type = e.type;
            if (type === 'mousedown' || type === 'keypress' || type === 'keyup' || type === 'keydown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(e.target || e.srcElement);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, targets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, targets);
            }
            if (e._stopped) return;
            // Find the layer the event is propagating from and its parents.
            targets = (targets || []).concat(this._findEventTargets(e, type));
            if (!targets.length) return;
            var target = targets[0];
            if (type === 'contextmenu' && target.listens(type, true)) preventDefault(e);
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(var i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (offset.round().equals([
                0,
                0
            ])) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom);
            // This anim frame should prevent an obscure iOS webkit tile loading race condition.
            requestAnimFrame(function() {
                this._moveEnd(true);
            }, this);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                if (!android) on(container, {
                    mouseenter: this.expand,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            if (touch) {
                on(link, 'click', stop);
                on(link, 'click', this.expand, this);
            } else on(link, 'focus', this.expand, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('div');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expand: function() {
            // Backward compatibility, remove me in 1.1.
            return this.expand();
        },
        _collapse: function() {
            // Backward compatibility, remove me in 1.1.
            return this.collapse();
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '+'
            // The text set on the 'zoom in' button.
            zoomInText: '+',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '&#x2212;'
            // The text set on the 'zoom out' button.
            zoomOutText: '&#x2212;',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            if (this._disabled || map._zoom === map.getMinZoom()) addClass(this._zoomOutButton, className);
            if (this._disabled || map._zoom === map.getMaxZoom()) addClass(this._zoomInButton, className);
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            return this._container;
        },
        // @method setPrefix(prefix: String): this
        // Sets the text before the attributions.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' | ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = touch ? 'touchstart mousedown' : 'mousedown';
    var END = {
        mousedown: 'mouseup',
        touchstart: 'touchend',
        pointerdown: 'touchend',
        MSPointerDown: 'touchend'
    };
    var MOVE = {
        mousedown: 'mousemove',
        touchstart: 'touchmove',
        pointerdown: 'touchmove',
        MSPointerDown: 'touchmove'
    };
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline$$1, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline$$1;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag();
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore simulated events, since we handle both touch and
            // mouse explicitly; otherwise we risk getting duplicates of
            // touch events, see #4315.
            // Also ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (e._simulated || !this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            on(document, MOVE[e.type], this._onMove, this);
            on(document, END[e.type], this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore simulated events, since we handle both touch and
            // mouse explicitly; otherwise we risk getting duplicates of
            // touch events, see #4315.
            // Also ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (e._simulated || !this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                this._startPos = getPosition(this._element).subtract(offset);
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            cancelAnimFrame(this._animRequest);
            this._lastEvent = e;
            this._animRequest = requestAnimFrame(this._updatePosition, this, true);
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function(e) {
            // Ignore simulated events, since we handle both touch and
            // mouse explicitly; otherwise we risk getting duplicates of
            // touch events, see #4315.
            // Also ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (e._simulated || !this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function() {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            for(var i in MOVE){
                off(document, MOVE[i], this._onMove, this);
                off(document, END[i], this._onUp, this);
            }
            enableImageDrag();
            enableTextSelection();
            if (this._moved && this._moving) {
                // ensure drag is not fired after dragend
                cancelAnimFrame(this._animRequest);
                // @event dragend: DragEndEvent
                // Fired when the drag ends.
                this.fire('dragend', {
                    distance: this._newPos.distanceTo(this._startPos)
                });
            }
            this._moving = false;
            Draggable._dragging = false;
        }
    });
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    var LineUtil = {
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat
    };
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    var PolyUtil = {
        clipPolygon: clipPolygon
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            if (this.getAttribution && map.attributionControl) map.attributionControl.addAttribution(this.getAttribution());
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            if (layer.getAttribution && this.attributionControl) this.attributionControl.removeAttribution(layer.getAttribution());
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return !!layer && stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            if (!layer) return false;
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ]
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (!IconDefault.imagePath) IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            if (path === null || path.indexOf('url') !== 0) path = '';
            else path = path.replace(/^url\(["']?/, '').replace(/marker-icon\.png["']?\)$/, '');
            return path;
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            title: '',
            // @option alt: String = ''
            // Text for the `alt` attribute of the icon image (useful for accessibility).
            alt: '',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) icon.tabIndex = '0';
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            var i, halfDist, segDist, dist, p1, p2, ratio, points = this._rings[0], len = points.length;
            if (!len) return null;
            // polyline centroid algorithm; only uses the first ring if there are multiple
            for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
            // The line is so small in the current view that all points are on the same pixel.
            if (halfDist === 0) return this._map.layerPointToLatLng(points[0]);
            for(i = 0, dist = 0; i < len - 1; i++){
                p1 = points[i];
                p2 = points[i + 1];
                segDist = p1.distanceTo(p2);
                dist += segDist;
                if (dist > halfDist) {
                    ratio = (dist - halfDist) / segDist;
                    return this._map.layerPointToLatLng([
                        p2.x - ratio * (p2.x - p1.x),
                        p2.y - ratio * (p2.y - p1.y)
                    ]);
                }
            }
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            var i, j, p1, p2, f, area, x, y, center, points = this._rings[0], len = points.length;
            if (!len) return null;
            // polygon centroid algorithm; only uses the first ring if there are multiple
            area = x = y = 0;
            for(i = 0, j = len - 1; i < len; j = i++){
                p1 = points[i];
                p2 = points[j];
                f = p1.y * p2.x - p2.y * p1.x;
                x += (p1.x + p2.x) * f;
                y += (p1.y + p2.y) * f;
                area += f * 3;
            }
            if (area === 0) // Polygon is so small that all points are on same pixel.
            center = points[0];
            else center = [
                x / area,
                y / area
            ];
            return this._map.layerPointToLatLng(center);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var layer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (layer) layers.push(layer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    function latLngToCoords(latlng, precision) {
        precision = typeof precision === 'number' ? precision : 6;
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)coords.push(levelsDeep ? latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed) coords.push(coords[0]);
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number): Object
    // `precision` is the number of decimal places for coordinates.
    // The default value is 6 places.
    // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number): Object
    // `precision` is the number of decimal places for coordinates.
    // The default value is 6 places.
    // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number): Object
    // `precision` is the number of decimal places for coordinates.
    // The default value is 6 places.
    // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number): Object
    // `precision` is the number of decimal places for coordinates.
    // The default value is 6 places.
    // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number): Object
        // `precision` is the number of decimal places for coordinates.
        // The default value is 6 places.
        // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. Browser compatibility- https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position. Useful to control the anchor
            // of the popup when opening it on some overlays.
            offset: [
                0,
                7
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: '',
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane'
        },
        initialize: function(options, source) {
            setOptions(this, options);
            this._source = source;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
        },
        // @namespace Popup
        // @method getLatLng: LatLng
        // Returns the geographical point of popup.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the popup will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the popup.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the popup.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the popup is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this popup in front of other popups (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this popup to the back of other popups (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        _prepareOpen: function(parent, layer, latlng) {
            if (!(layer instanceof Layer)) {
                latlng = layer;
                layer = parent;
            }
            if (layer instanceof FeatureGroup) for(var id in parent._layers){
                layer = parent._layers[id];
                break;
            }
            if (!latlng) {
                if (layer.getCenter) latlng = layer.getCenter();
                else if (layer.getLatLng) latlng = layer.getLatLng();
                else throw new Error('Unable to get source layer LatLng.');
            }
            // set overlay source to this layer
            this._source = layer;
            // update the overlay (content, layout, ect...)
            this.update();
            return latlng;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the popup in case the height of the popup changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   * Here's a more complicated way to open a popup on a map:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
        openOn: function(map) {
            map.openPopup(this);
            return this;
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this._close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _close: function() {
            if (this._map) this._map.closePopup(this);
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.href = '#close';
                closeButton.innerHTML = '&#215;';
                on(closeButton, 'click', this._onCloseButtonClick, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) map.fire('autopanstart').panBy([
                dx,
                dy
            ]);
        },
        _onCloseButtonClick: function(e) {
            this._close();
            stop(e);
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            if (!(popup instanceof Popup)) popup = new Popup(options).setContent(popup);
            if (latlng) popup.setLatLng(latlng);
            if (this.hasLayer(popup)) return this;
            if (this._popup && this._popup.options.autoClose) this.closePopup();
            this._popup = popup;
            return this.addLayer(popup);
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            if (!popup || popup === this._popup) {
                popup = this._popup;
                this._popup = null;
            }
            if (popup) this.removeLayer(popup);
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            if (content instanceof Popup) {
                setOptions(content, options);
                this._popup = content;
                content._source = this;
            } else {
                if (!this._popup || options) this._popup = new Popup(options, this);
                this._popup.setContent(content);
            }
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(layer, latlng) {
            if (this._popup && this._map) {
                latlng = this._popup._prepareOpen(this, layer, latlng);
                // open the popup on the map
                this._map.openPopup(this._popup, latlng);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup._close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function(target) {
            if (this._popup) {
                if (this._popup._map) this.closePopup();
                else this.openPopup(target);
            }
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            var layer = e.layer || e.target;
            if (!this._popup) return;
            if (!this._map) return;
            // prevent map click
            stop(e);
            // if this inherits from Path its a vector and we can just
            // open the popup at the new location
            if (layer instanceof Path) {
                this.openPopup(e.layer || e.target, e.latlng);
                return;
            }
            // otherwise treat it like a marker and figure out
            // if we should toggle it open/closed
            if (this._map.hasLayer(this._popup) && this._popup._source === layer) this.closePopup();
            else this.openPopup(layer, e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option interactive: Boolean = false
            // If true, the tooltip will listen to the feature events.
            interactive: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) // @namespace Layer
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip bound to this layer is opened.
            this._source.fire('tooltipopen', {
                tooltip: this
            }, true);
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) // @namespace Layer
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip bound to this layer is closed.
            this._source.fire('tooltipclose', {
                tooltip: this
            }, true);
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (touch && !this.options.permanent) events.preclick = this._close;
            return events;
        },
        _close: function() {
            if (this._map) this._map.closeTooltip(this);
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            if (!(tooltip instanceof Tooltip)) tooltip = new Tooltip(options).setContent(tooltip);
            if (latlng) tooltip.setLatLng(latlng);
            if (this.hasLayer(tooltip)) return this;
            return this.addLayer(tooltip);
        },
        // @method closeTooltip(tooltip?: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            if (tooltip) this.removeLayer(tooltip);
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (content instanceof Tooltip) {
                setOptions(content, options);
                this._tooltip = content;
                content._source = this;
            } else {
                if (!this._tooltip || options) this._tooltip = new Tooltip(options, this);
                this._tooltip.setContent(content);
            }
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove$$1) {
            if (!remove$$1 && this._tooltipHandlersAdded) return;
            var onOff = remove$$1 ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
                if (touch) events.click = this._openTooltip;
            } else events.add = this._openTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove$$1;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(layer, latlng) {
            if (this._tooltip && this._map) {
                latlng = this._tooltip._prepareOpen(this, layer, latlng);
                // open the tooltip on the map
                this._map.openTooltip(this._tooltip, latlng);
                // Tooltip container may not be defined if not permanent and never
                // opened.
                if (this._tooltip.options.interactive && this._tooltip._container) {
                    addClass(this._tooltip._container, 'leaflet-clickable');
                    this.addInteractiveTarget(this._tooltip._container);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) {
                this._tooltip._close();
                if (this._tooltip.options.interactive && this._tooltip._container) {
                    removeClass(this._tooltip._container, 'leaflet-clickable');
                    this.removeInteractiveTarget(this._tooltip._container);
                }
            }
            return this;
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function(target) {
            if (this._tooltip) {
                if (this._tooltip._map) this.closeTooltip();
                else this.openTooltip(target);
            }
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _openTooltip: function(e) {
            var layer = e.layer || e.target;
            if (!this._tooltip || !this._map) return;
            this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView();
            this._update();
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
            // without this hack, tiles disappear after zoom on Chrome for Android
            // https://github.com/Leaflet/Leaflet/issues/2078
            if (android && !android23) tile.style.WebkitBackfaceVisibility = 'hidden';
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom--;
                } else {
                    options.zoomOffset--;
                    options.minZoom++;
                }
                options.minZoom = Math.max(0, options.minZoom);
            }
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            // for https://github.com/Leaflet/Leaflet/issues/137
            if (!android) this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            /*
  		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
  		 http://www.w3.org/TR/WCAG20-TECHS/H67
  		*/ tile.alt = '';
            /*
  		 Set role="presentation" to force screen readers to ignore this
  		 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
  		*/ tile.setAttribute('role', 'presentation');
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    remove(tile);
                    delete this._tiles[i];
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            // unless we're on Android's stock browser,
            // see https://github.com/Leaflet/Leaflet/issues/137
            if (!androidStock) tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1,
            // @option tolerance: Number = 0
            // How much to extend click tolerance round a path/object on the map
            tolerance: 0
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                if (this._zoomAnimated) addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), position = getPosition(this._container), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), destCenterPoint = this._map.project(center, zoom), centerOffset = destCenterPoint.subtract(currentCenterPoint), topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
            if (any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type !== 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            if (clickedLayer) {
                fakeStop(e);
                this._fireEvent([
                    clickedLayer
                ], e);
            }
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            if (this._hoveredLayer) this._fireEvent([
                this._hoveredLayer
            ], e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas$1(options) {
        return canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
            return function(name) {
                return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
            };
        }
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create$2 = vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.zoomstart = this._onZoomStart;
            return events;
        },
        _initContainer: function() {
            this._container = create$2('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create$2('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _onZoomStart: function() {
            // Drag-then-pinch interactions might mess up the center and zoom.
            // In this case, the easiest way to prevent this is re-do the renderer
            //   bounds and padding when the zooming starts.
            this._update();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create$2('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg$1(options) {
        return svg || vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas$1(options) || svg$1(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create$2;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) this._finish();
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map be draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default unless running on old Android devices.
        inertia: !android23,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    map.panBy(offset);
                    if (map.options.maxBounds) map.panInsideBounds(map.options.maxBounds);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tap: Boolean = true
        // Enables mobile hacks for supporting instant taps (fixing 200ms click
        // delay on iOS/Android) and touch holds (fired as `contextmenu` events).
        tap: true,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var Tap = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            if (!e.touches) return;
            preventDefault(e);
            this._fireClick = true;
            // don't simulate click or track longpress if more than 1 touch
            if (e.touches.length > 1) {
                this._fireClick = false;
                clearTimeout(this._holdTimeout);
                return;
            }
            var first = e.touches[0], el = first.target;
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            // if touching a link, highlight it
            if (el.tagName && el.tagName.toLowerCase() === 'a') addClass(el, 'leaflet-active');
            // simulate long hold but setting a timeout
            this._holdTimeout = setTimeout(bind(function() {
                if (this._isTapValid()) {
                    this._fireClick = false;
                    this._onUp();
                    this._simulateEvent('contextmenu', first);
                }
            }, this), 1000);
            this._simulateEvent('mousedown', first);
            on(document, {
                touchmove: this._onMove,
                touchend: this._onUp
            }, this);
        },
        _onUp: function(e) {
            clearTimeout(this._holdTimeout);
            off(document, {
                touchmove: this._onMove,
                touchend: this._onUp
            }, this);
            if (this._fireClick && e && e.changedTouches) {
                var first = e.changedTouches[0], el = first.target;
                if (el && el.tagName && el.tagName.toLowerCase() === 'a') removeClass(el, 'leaflet-active');
                this._simulateEvent('mouseup', first);
                // simulate click if the touch didn't move too much
                if (this._isTapValid()) this._simulateEvent('click', first);
            }
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
            this._simulateEvent('mousemove', first);
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = document.createEvent('MouseEvents');
            simulatedEvent._simulated = true;
            e.target._simulatedClick = true;
            simulatedEvent.initMouseEvent(type, true, true, window, 1, e.screenX, e.screenY, e.clientX, e.clientY, false, false, false, false, 0, null);
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tap: Handler
    // Mobile touch hacks (quick tap and touch hold) handler.
    if (touch && (!pointer || safari)) Map.addInitHook('addHandler', 'tap', Tap);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers except for old Androids.
        touchZoom: touch && !android23,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            });
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.Tap = Tap;
    Map.TouchZoom = TouchZoom;
    exports1.version = version;
    exports1.Control = Control;
    exports1.control = control;
    exports1.Browser = Browser;
    exports1.Evented = Evented;
    exports1.Mixin = Mixin;
    exports1.Util = Util;
    exports1.Class = Class;
    exports1.Handler = Handler;
    exports1.extend = extend;
    exports1.bind = bind;
    exports1.stamp = stamp;
    exports1.setOptions = setOptions;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.PosAnimation = PosAnimation;
    exports1.Draggable = Draggable;
    exports1.LineUtil = LineUtil;
    exports1.PolyUtil = PolyUtil;
    exports1.Point = Point;
    exports1.point = toPoint;
    exports1.Bounds = Bounds;
    exports1.bounds = toBounds;
    exports1.Transformation = Transformation;
    exports1.transformation = toTransformation;
    exports1.Projection = index;
    exports1.LatLng = LatLng;
    exports1.latLng = toLatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.latLngBounds = toLatLngBounds;
    exports1.CRS = CRS;
    exports1.GeoJSON = GeoJSON;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.layerGroup = layerGroup;
    exports1.FeatureGroup = FeatureGroup;
    exports1.featureGroup = featureGroup;
    exports1.ImageOverlay = ImageOverlay;
    exports1.imageOverlay = imageOverlay;
    exports1.VideoOverlay = VideoOverlay;
    exports1.videoOverlay = videoOverlay;
    exports1.SVGOverlay = SVGOverlay;
    exports1.svgOverlay = svgOverlay;
    exports1.DivOverlay = DivOverlay;
    exports1.Popup = Popup;
    exports1.popup = popup;
    exports1.Tooltip = Tooltip;
    exports1.tooltip = tooltip;
    exports1.Icon = Icon;
    exports1.icon = icon;
    exports1.DivIcon = DivIcon;
    exports1.divIcon = divIcon;
    exports1.Marker = Marker;
    exports1.marker = marker;
    exports1.TileLayer = TileLayer;
    exports1.tileLayer = tileLayer;
    exports1.GridLayer = GridLayer;
    exports1.gridLayer = gridLayer;
    exports1.SVG = SVG;
    exports1.svg = svg$1;
    exports1.Renderer = Renderer;
    exports1.Canvas = Canvas;
    exports1.canvas = canvas$1;
    exports1.Path = Path;
    exports1.CircleMarker = CircleMarker;
    exports1.circleMarker = circleMarker;
    exports1.Circle = Circle;
    exports1.circle = circle;
    exports1.Polyline = Polyline;
    exports1.polyline = polyline;
    exports1.Polygon = Polygon;
    exports1.polygon = polygon;
    exports1.Rectangle = Rectangle;
    exports1.rectangle = rectangle;
    exports1.Map = Map;
    exports1.map = createMap;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});



var $1b4d2fde3b33d442$exports = {};
/*
 * Utility functions to decode/encode numbers and array's of numbers
 * to/from strings (Google maps polyline encoding)
 *
 * Extends the L.Polyline and L.Polygon object with methods to convert
 * to and create from these strings.
 *
 * Jan Pieter Waagmeester <jieter@jieter.nl>
 *
 * Original code from:
 * http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/
 * (which is down as of december 2014)
 */ (function() {
    'use strict';
    var defaultOptions = function(options) {
        if (typeof options === 'number') // Legacy
        options = {
            precision: options
        };
        else options = options || {};
        options.precision = options.precision || 5;
        options.factor = options.factor || Math.pow(10, options.precision);
        options.dimension = options.dimension || 2;
        return options;
    };
    var PolylineUtil = {
        encode: function(points, options) {
            options = defaultOptions(options);
            var flatPoints = [];
            for(var i = 0, len = points.length; i < len; ++i){
                var point = points[i];
                if (options.dimension === 2) {
                    flatPoints.push(point.lat || point[0]);
                    flatPoints.push(point.lng || point[1]);
                } else for(var dim = 0; dim < options.dimension; ++dim)flatPoints.push(point[dim]);
            }
            return this.encodeDeltas(flatPoints, options);
        },
        decode: function(encoded, options) {
            options = defaultOptions(options);
            var flatPoints = this.decodeDeltas(encoded, options);
            var points = [];
            for(var i = 0, len = flatPoints.length; i + (options.dimension - 1) < len;){
                var point = [];
                for(var dim = 0; dim < options.dimension; ++dim)point.push(flatPoints[i++]);
                points.push(point);
            }
            return points;
        },
        encodeDeltas: function(numbers, options) {
            options = defaultOptions(options);
            var lastNumbers = [];
            for(var i = 0, len = numbers.length; i < len;)for(var d = 0; d < options.dimension; ++d, ++i){
                var num = numbers[i].toFixed(options.precision);
                var delta = num - (lastNumbers[d] || 0);
                lastNumbers[d] = num;
                numbers[i] = delta;
            }
            return this.encodeFloats(numbers, options);
        },
        decodeDeltas: function(encoded, options) {
            options = defaultOptions(options);
            var lastNumbers = [];
            var numbers = this.decodeFloats(encoded, options);
            for(var i = 0, len = numbers.length; i < len;)for(var d = 0; d < options.dimension; ++d, ++i)numbers[i] = Math.round((lastNumbers[d] = numbers[i] + (lastNumbers[d] || 0)) * options.factor) / options.factor;
            return numbers;
        },
        encodeFloats: function(numbers, options) {
            options = defaultOptions(options);
            for(var i = 0, len = numbers.length; i < len; ++i)numbers[i] = Math.round(numbers[i] * options.factor);
            return this.encodeSignedIntegers(numbers);
        },
        decodeFloats: function(encoded, options) {
            options = defaultOptions(options);
            var numbers = this.decodeSignedIntegers(encoded);
            for(var i = 0, len = numbers.length; i < len; ++i)numbers[i] /= options.factor;
            return numbers;
        },
        encodeSignedIntegers: function(numbers) {
            for(var i = 0, len = numbers.length; i < len; ++i){
                var num = numbers[i];
                numbers[i] = num < 0 ? ~(num << 1) : num << 1;
            }
            return this.encodeUnsignedIntegers(numbers);
        },
        decodeSignedIntegers: function(encoded) {
            var numbers = this.decodeUnsignedIntegers(encoded);
            for(var i = 0, len = numbers.length; i < len; ++i){
                var num = numbers[i];
                numbers[i] = num & 1 ? ~(num >> 1) : num >> 1;
            }
            return numbers;
        },
        encodeUnsignedIntegers: function(numbers) {
            var encoded = '';
            for(var i = 0, len = numbers.length; i < len; ++i)encoded += this.encodeUnsignedInteger(numbers[i]);
            return encoded;
        },
        decodeUnsignedIntegers: function(encoded) {
            var numbers = [];
            var current = 0;
            var shift = 0;
            for(var i = 0, len = encoded.length; i < len; ++i){
                var b = encoded.charCodeAt(i) - 63;
                current |= (b & 0x1f) << shift;
                if (b < 0x20) {
                    numbers.push(current);
                    current = 0;
                    shift = 0;
                } else shift += 5;
            }
            return numbers;
        },
        encodeSignedInteger: function(num) {
            num = num < 0 ? ~(num << 1) : num << 1;
            return this.encodeUnsignedInteger(num);
        },
        // This function is very similar to Google's, but I added
        // some stuff to deal with the double slash issue.
        encodeUnsignedInteger: function(num) {
            var value, encoded = '';
            while(num >= 0x20){
                value = (0x20 | num & 0x1f) + 63;
                encoded += String.fromCharCode(value);
                num >>= 5;
            }
            value = num + 63;
            encoded += String.fromCharCode(value);
            return encoded;
        }
    };
    // Export Node module
    if (typeof $1b4d2fde3b33d442$exports === 'object') $1b4d2fde3b33d442$exports = PolylineUtil;
    // Inject functionality into Leaflet
    if (typeof L === 'object') {
        if (!L.Polyline.prototype.fromEncoded) L.Polyline.fromEncoded = function(encoded, options) {
            return L.polyline(PolylineUtil.decode(encoded), options);
        };
        if (!L.Polygon.prototype.fromEncoded) L.Polygon.fromEncoded = function(encoded, options) {
            return L.polygon(PolylineUtil.decode(encoded), options);
        };
        var encodeMixin = {
            encodePath: function() {
                return PolylineUtil.encode(this.getLatLngs());
            }
        };
        if (!L.Polyline.prototype.encodePath) L.Polyline.include(encodeMixin);
        if (!L.Polygon.prototype.encodePath) L.Polygon.include(encodeMixin);
        L.PolylineUtil = PolylineUtil;
    }
})();


const $daf32513618c89b7$var$map = L.map("map");
const $daf32513618c89b7$var$DEFAULT_PATH_OPTIONS = {
    renderer: L.canvas({
        padding: 0.5,
        tolerance: 10
    })
};
const $daf32513618c89b7$var$USER_TRACE_STYLE = {
    color: "#3388ff",
    weight: 2,
    opacity: 0.75,
    ...$daf32513618c89b7$var$DEFAULT_PATH_OPTIONS
};
const $daf32513618c89b7$var$UNFOCUSED_SEGMENT_STYLE = {
    weight: 2,
    opacity: 0.5,
    ...$daf32513618c89b7$var$DEFAULT_PATH_OPTIONS
};
const $daf32513618c89b7$var$FOCUSED_SEGMENT_STYLE = {
    weight: 4,
    opacity: 1,
    ...$daf32513618c89b7$var$DEFAULT_PATH_OPTIONS
};
const $daf32513618c89b7$var$COVERED_SEGMENT_STYLE = {
    color: "#3388ff",
    ...$daf32513618c89b7$var$UNFOCUSED_SEGMENT_STYLE
};
const $daf32513618c89b7$var$UNCOVERED_SEGMENT_STYLE = {
    color: "#ee6352",
    ...$daf32513618c89b7$var$UNFOCUSED_SEGMENT_STYLE
};
const $daf32513618c89b7$var$DEFAULT_BOUNDS = L.latLngBounds([
    [
        49.898,
        3.96
    ],
    [
        46.982,
        -0.705
    ]
]);
$daf32513618c89b7$var$map.fitBounds($daf32513618c89b7$var$DEFAULT_BOUNDS);
// const TILES_PATTERN = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
// const ATTRIBUTION = "© <a href='https://www.openstreetmap.org'>OpenStreetMap</a> contributors";
const $daf32513618c89b7$var$TILES_PATTERN = "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png";
const $daf32513618c89b7$var$ATTRIBUTION = "\xa9 <a href='https://www.openstreetmap.org'>OpenStreetMap</a> contributors, \xa9 <a href='https://carto.com/attribution'>CARTO</a>";
const $daf32513618c89b7$var$tileLayer = L.tileLayer($daf32513618c89b7$var$TILES_PATTERN, {
    maxZoom: 18,
    attribution: $daf32513618c89b7$var$ATTRIBUTION
});
$daf32513618c89b7$var$tileLayer.addTo($daf32513618c89b7$var$map);
var $dddd206524c23065$exports = {};
$dddd206524c23065$exports = import.meta.resolve("eMHMP");


const $daf32513618c89b7$var$finishIcon = L.icon({
    iconUrl: new URL($dddd206524c23065$exports).toString(),
    iconSize: [
        15,
        15
    ]
});
const $daf32513618c89b7$var$state = {
    challenges: [],
    challengesLayers: {},
    userTracesLayer: null,
    focusedChallenge: null
};
$daf32513618c89b7$var$withLoading($daf32513618c89b7$var$loadChallenges());
async function $daf32513618c89b7$var$loadChallenges() {
    $daf32513618c89b7$var$state.challenges = (0, (/*@__PURE__*/$parcel$interopDefault($4e7af9fc52322521$exports)));
    $daf32513618c89b7$var$state.challenges.forEach((challenge)=>$daf32513618c89b7$var$state.challengesLayers[challenge.id] = $daf32513618c89b7$var$buildChallengeLayer(challenge));
    $daf32513618c89b7$var$render();
    return $daf32513618c89b7$var$loadUserPolylines();
}
async function $daf32513618c89b7$var$loadUserPolylines() {
    if (!(0, $605b91011dda62b7$export$2e2bcd8739ae039).hasStravaAccess()) return;
    const userPolylines = await (0, $605b91011dda62b7$export$2e2bcd8739ae039).getRidesPolylines();
    $daf32513618c89b7$var$state.userTracesLayer = $daf32513618c89b7$var$buildUserTracesLayer(userPolylines);
    $daf32513618c89b7$var$render();
    return $daf32513618c89b7$var$loadChallengesCoverage(userPolylines);
}
async function $daf32513618c89b7$var$loadChallengesCoverage(userPolylines) {
    const mathWorker = await $daf32513618c89b7$var$getMathWorker(userPolylines);
    await Promise.all($daf32513618c89b7$var$state.challenges.map((challenge)=>$daf32513618c89b7$var$loadChallengeCoverage(challenge, mathWorker)));
}
function $daf32513618c89b7$var$loadChallengeCoverage(challenge, mathWorker) {
    return new Promise((resolve)=>{
        const trackPoints = L.PolylineUtil.decode(challenge.summary_polyline);
        const id = Math.random();
        function eventHandler({ data: data }) {
            if (data.id === id) {
                mathWorker.removeEventListener("message", eventHandler);
                if ($daf32513618c89b7$var$state.challengesLayers[challenge.id]) $daf32513618c89b7$var$state.challengesLayers[challenge.id].remove();
                const { result: result } = data;
                challenge.coveredDistance = result.coveredDistance;
                challenge.computedDistance = result.computedDistance;
                $daf32513618c89b7$var$state.challengesLayers[challenge.id] = $daf32513618c89b7$var$buildChallengeLayer(challenge, result);
                $daf32513618c89b7$var$render();
                resolve();
            }
        }
        mathWorker.addEventListener("message", eventHandler);
        mathWorker.postMessage({
            func: "classifySegmentsCoverage",
            id: id,
            trackPoints: trackPoints
        });
    });
}
function $daf32513618c89b7$var$render() {
    Object.values($daf32513618c89b7$var$state.challengesLayers).forEach((layer)=>layer.remove());
    const displayedChallenges = $daf32513618c89b7$var$state.challenges.filter((0, $16ccedfa4f561b29$export$2e2bcd8739ae039).matchFilter);
    displayedChallenges.forEach($daf32513618c89b7$var$renderChallenge);
    (0, $16ccedfa4f561b29$export$2e2bcd8739ae039).showChallengesDetails(displayedChallenges);
    (0, $16ccedfa4f561b29$export$2e2bcd8739ae039).showChallengeDetails($daf32513618c89b7$var$state.focusedChallenge);
    if ($daf32513618c89b7$var$state.userTracesLayer) {
        $daf32513618c89b7$var$state.userTracesLayer.remove();
        if ((0, $16ccedfa4f561b29$export$2e2bcd8739ae039).userTracesEnabled()) $daf32513618c89b7$var$state.userTracesLayer.addTo($daf32513618c89b7$var$map);
    }
}
function $daf32513618c89b7$var$renderChallenge(challenge) {
    const layer = $daf32513618c89b7$var$state.challengesLayers[challenge.id];
    if (layer) {
        const style = challenge == $daf32513618c89b7$var$state.focusedChallenge ? $daf32513618c89b7$var$FOCUSED_SEGMENT_STYLE : $daf32513618c89b7$var$UNFOCUSED_SEGMENT_STYLE;
        layer.setStyle(style);
        layer.addTo($daf32513618c89b7$var$map);
    }
}
function $daf32513618c89b7$var$buildChallengeLayer(challenge, coverage = {}) {
    const trackPoints = L.PolylineUtil.decode(challenge.summary_polyline);
    const uncoveredSegments = coverage.uncoveredSegments || [
        trackPoints
    ];
    const coveredSegments = coverage.coveredSegments || [];
    const uncoveredLayers = uncoveredSegments.map((segment)=>L.polyline(segment, $daf32513618c89b7$var$UNCOVERED_SEGMENT_STYLE));
    const coveredLayers = coveredSegments.map((segment)=>L.polyline(segment, $daf32513618c89b7$var$COVERED_SEGMENT_STYLE));
    const clickHandler = (event)=>{
        L.DomEvent.stopPropagation(event);
        $daf32513618c89b7$var$focusChallenge(challenge);
    };
    const finishMarker = L.marker(trackPoints[trackPoints.length - 1], {
        icon: $daf32513618c89b7$var$finishIcon
    });
    const layers = uncoveredLayers.concat(coveredLayers).concat([
        finishMarker
    ]);
    const featureGroup = L.featureGroup(layers);
    featureGroup.on("click", clickHandler);
    return featureGroup;
}
var $6bdd611d3f12c2f3$exports = {};
var $7f9a692fa1406bf9$exports = {};
"use strict";
$7f9a692fa1406bf9$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $6bdd611d3f12c2f3$var$url = new URL(import.meta.resolve("4KNc0"));
$6bdd611d3f12c2f3$exports = $7f9a692fa1406bf9$exports($6bdd611d3f12c2f3$var$url.toString(), $6bdd611d3f12c2f3$var$url.origin, true);


function $daf32513618c89b7$var$getMathWorker(userPolylines) {
    return new Promise((resolve)=>{
        const mathWorker = new Worker($6bdd611d3f12c2f3$exports);
        function initEventHandler() {
            mathWorker.removeEventListener("message", initEventHandler);
            resolve(mathWorker);
        }
        mathWorker.addEventListener("message", initEventHandler);
        mathWorker.postMessage({
            func: "loadUserPolylines",
            polylines: userPolylines
        });
    });
}
function $daf32513618c89b7$var$buildUserTracesLayer(userPolylines) {
    return L.featureGroup(userPolylines.map((p)=>L.polyline(p, $daf32513618c89b7$var$USER_TRACE_STYLE)));
}
function $daf32513618c89b7$var$focusChallenge(challenge) {
    $daf32513618c89b7$var$state.focusedChallenge = challenge;
    $daf32513618c89b7$var$render();
}
$daf32513618c89b7$var$map.on("click", ()=>$daf32513618c89b7$var$focusChallenge(null));
(0, $16ccedfa4f561b29$export$2e2bcd8739ae039).onFilterChanged($daf32513618c89b7$var$render);
(0, $16ccedfa4f561b29$export$2e2bcd8739ae039).onShowUserTracesChanged($daf32513618c89b7$var$render);
function $daf32513618c89b7$var$withLoading(promise) {
    const loadingElt = document.getElementById("loading");
    loadingElt.style.display = "block";
    return promise.finally(()=>loadingElt.style.display = "none");
}


//# sourceMappingURL=ccmap.gitlab.io.2525b643.js.map
